import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: string;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type AddFundsTransferData = {
  amountInCents: Scalars['Int'];
  breweryInvoiceNumber: Scalars['String'];
  destinationId: Scalars['Int'];
  retailerInvoiceNumber: Scalars['String'];
  sourceId: Scalars['Int'];
  statementDescriptor: Scalars['String'];
};

export type AddOrganizationAndDistributorData = {
  feePerPackageInCents: Scalars['Int'];
  name: Scalars['String'];
};

export type AddOrganizationAndLogisticsPartnerData = {
  name: Scalars['String'];
};

export type AddProducerData = {
  fein?: InputMaybe<Scalars['String']>;
  globalBreweryId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  rating?: InputMaybe<Scalars['Float']>;
};

export type AddTransferForOrderData = {
  amountInCents: Scalars['Int'];
  breweryInvoiceNumber: Scalars['String'];
  destinationId: Scalars['Int'];
  orderId: Scalars['Int'];
  sourceId: Scalars['Int'];
  statementDescriptor: Scalars['String'];
};

export type Address = {
  __typename: 'Address';
  address1: Scalars['String'];
  address2: Maybe<Scalars['String']>;
  city: Scalars['String'];
  company: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  phone: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type AddressUpdateData = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type AdjustmentItem = {
  __typename: 'AdjustmentItem';
  adjustmentReason: AdjustmentReason;
  adjustmentReasonId: Scalars['Int'];
  id: Scalars['Int'];
  notes: Maybe<Scalars['String']>;
  orderId: Scalars['Int'];
  orderItem: OrderItem;
  product: Product;
  productId: Scalars['Int'];
  total: Scalars['Int'];
  units: Scalars['Int'];
  wholesaleTotal: Scalars['Int'];
};

export type AdjustmentItemInput = {
  adjustmentReasonId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  units: Scalars['Int'];
};

export type AdjustmentReason = {
  __typename: 'AdjustmentReason';
  adjustmentType: AdjustmentType;
  id: Scalars['Int'];
  label: Scalars['String'];
};

export enum AdjustmentType {
  Delivery = 'delivery',
  Freight = 'freight'
}

export type AdminDashboardStatistics = {
  __typename: 'AdminDashboardStatistics';
  breweriesOnboarded: Scalars['Int'];
  distributorsOnboarded: Scalars['Int'];
  retailersOnboarded: Scalars['Int'];
  totalPayments: Scalars['Int'];
};

export type AssignDistributorToProducerInput = {
  distributorId: Scalars['Int'];
  producerId: Scalars['Int'];
  regionId: Scalars['Int'];
};

export type AssignRegionDeliveryPartnerInput = {
  deliveryPartnerId: Scalars['Int'];
  regionId: Scalars['Int'];
};

export type AuditLog = {
  __typename: 'AuditLog';
  changes: Maybe<Scalars['JSONObject']>;
  id: Scalars['Int'];
  message: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  snapshot: Maybe<Scalars['JSONObject']>;
  user: Maybe<User>;
};

export type AutocompleteResponse = {
  __typename: 'AutocompleteResponse';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type BalanceAccount = FundsAccount & {
  __typename: 'BalanceAccount';
  balance: Scalars['Int'];
  business: Business;
  createdAt: Scalars['DateTime'];
  dwollaFundingSource: Maybe<DwollaFundingSource>;
  id: Scalars['Int'];
  label: Scalars['String'];
  removedAt: Maybe<Scalars['DateTime']>;
  type: FundsAccountType;
};

export type BankAccount = FundsAccount & {
  __typename: 'BankAccount';
  business: Business;
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  dwollaFundingSource: Maybe<DwollaFundingSource>;
  /** Indicates whether this bank account has been authorized for on-demand transfers. */
  hasOnDemandAuthorization: Scalars['Boolean'];
  id: Scalars['Int'];
  /** The official name of the banking institution. */
  institutionName: Maybe<Scalars['String']>;
  isVerified: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  /** The last 2-4 alphanumeric characteorecrs of an account's official account number. */
  mask: Scalars['String'];
  /** The name of the account, either assigned by the user or by the financial institution itself. */
  name: Maybe<Scalars['String']>;
  needsReverification: Scalars['Boolean'];
  plaidItem: Maybe<PlaidItem>;
  removedAt: Maybe<Scalars['DateTime']>;
  type: FundsAccountType;
};

export type BankAccountOnboardingStep = OnboardingStep & {
  __typename: 'BankAccountOnboardingStep';
  bankAccount: Maybe<BankAccount>;
  step: OnboardingStepType;
};

export type BeerStyle = {
  __typename: 'BeerStyle';
  code: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  notes: Maybe<Scalars['String']>;
};

export type BeneficialOwnerOnboardingStep = OnboardingStep & {
  __typename: 'BeneficialOwnerOnboardingStep';
  customerType: DwollaCustomerType;
  dwollaCustomer: DwollaCustomer;
  step: OnboardingStepType;
};

export type BeverageAdvisors = Business & {
  __typename: 'BeverageAdvisors';
  address: Maybe<Address>;
  /** Default, active balance account. */
  balanceAccount: Maybe<BalanceAccount>;
  /** Default, active bank account. */
  bankAccount: Maybe<BankAccount>;
  bankAccounts: Array<BankAccount>;
  businessType: BusinessType;
  completedOnboardingAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  dwollaCustomer: Maybe<DwollaCustomer>;
  /** External Funds Account used for manual transfers outside of our system. */
  externalFundsAccount: Maybe<ExternalFundsAccount>;
  fein: Maybe<Scalars['String']>;
  fundsTransfers: Array<FundsTransfer>;
  /** Identifier for this entity and it's parent business entity */
  id: Scalars['Int'];
  name: Scalars['String'];
  onboarding: Maybe<Onboarding>;
  organization: Organization;
  organizationId: Scalars['Int'];
  validBalanceAccount: Maybe<BalanceAccount>;
  validBalanceAccounts: Array<BalanceAccount>;
  validBankAccount: Maybe<BankAccount>;
  validBankAccounts: Array<BankAccount>;
};

export type Business = {
  address: Maybe<Address>;
  /** Default, active balance account. */
  balanceAccount: Maybe<BalanceAccount>;
  /** Default, active bank account. */
  bankAccount: Maybe<BankAccount>;
  bankAccounts: Array<BankAccount>;
  businessType: BusinessType;
  completedOnboardingAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  dwollaCustomer: Maybe<DwollaCustomer>;
  /** External Funds Account used for manual transfers outside of our system. */
  externalFundsAccount: Maybe<ExternalFundsAccount>;
  fein: Maybe<Scalars['String']>;
  fundsTransfers: Array<FundsTransfer>;
  /** Identifier for this entity and it's parent business entity */
  id: Scalars['Int'];
  name: Scalars['String'];
  onboarding: Maybe<Onboarding>;
  organization: Organization;
  organizationId: Scalars['Int'];
  validBalanceAccount: Maybe<BalanceAccount>;
  validBalanceAccounts: Array<BalanceAccount>;
  validBankAccount: Maybe<BankAccount>;
  validBankAccounts: Array<BankAccount>;
};

export enum BusinessType {
  BeverageAdvisors = 'beverage_advisors',
  Distributor = 'distributor',
  LogisticsPartner = 'logistics_partner',
  Producer = 'producer',
  Retailer = 'retailer'
}

export type Carrier = {
  __typename: 'Carrier';
  displayName: Scalars['String'];
  id: Scalars['Int'];
};

export type CheckResult = {
  __typename: 'CheckResult';
  data: Maybe<Scalars['JSONObject']>;
  description: Scalars['String'];
  hideOnPass: Scalars['Boolean'];
  passed: Scalars['Boolean'];
};

export type CloudinaryImage = {
  id: Scalars['Int'];
  rawUrl: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  type: CloudinaryImageType;
};

export enum CloudinaryImageType {
  Product = 'product'
}

export type CompleteOnboardingStep = OnboardingStep & {
  __typename: 'CompleteOnboardingStep';
  bankAccount: BankAccount;
  canCompleteOnboarding: Scalars['Boolean'];
  dwollaCustomer: DwollaCustomer;
  dwollaCustomerType: DwollaCustomerType;
  step: OnboardingStepType;
};

export enum ContainerLabel {
  Bottle = 'bottle',
  Can = 'can',
  Keg = 'keg'
}

export enum ContainerVolumeUnit {
  Gal = 'gal',
  L = 'l',
  Ml = 'ml',
  Oz = 'oz'
}

export type DeleteDistributorFromProducerInput = {
  distributorId: Scalars['Int'];
  producerId: Scalars['Int'];
  regionId: Scalars['Int'];
};

export type DeliveryAgingReportFilterInput = {
  regionId?: InputMaybe<Scalars['Int']>;
};

export enum DeliveryStatus {
  Delivered = 'delivered',
  NotDelivered = 'not_delivered'
}

export enum DistributionModel {
  DirectToRetail = 'direct_to_retail',
  ThreeTier = 'three_tier'
}

export type Distributor = Business & {
  __typename: 'Distributor';
  address: Maybe<Address>;
  /** Default, active balance account. */
  balanceAccount: Maybe<BalanceAccount>;
  /** Default, active bank account. */
  bankAccount: Maybe<BankAccount>;
  bankAccounts: Array<BankAccount>;
  businessType: BusinessType;
  canDelete: Scalars['Boolean'];
  completedOnboardingAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  dwollaCustomer: Maybe<DwollaCustomer>;
  /** External Funds Account used for manual transfers outside of our system. */
  externalFundsAccount: Maybe<ExternalFundsAccount>;
  feePerPackageInCents: Scalars['Int'];
  fein: Maybe<Scalars['String']>;
  fundsTransfers: Array<FundsTransfer>;
  /** Identifier for this entity and it's parent business entity */
  id: Scalars['Int'];
  integrations: Array<DistributorIntegration>;
  name: Scalars['String'];
  onboarding: Maybe<Onboarding>;
  organization: Organization;
  organizationId: Scalars['Int'];
  producerAssignments: Array<DistributorProducerAssignment>;
  retailerAssignments: Array<DistributorRetailerAssignment>;
  validBalanceAccount: Maybe<BalanceAccount>;
  validBalanceAccounts: Array<BalanceAccount>;
  validBankAccount: Maybe<BankAccount>;
  validBankAccounts: Array<BankAccount>;
};

export type DistributorIntegration = {
  __typename: 'DistributorIntegration';
  integration: DistributorIntegrationType;
};

export enum DistributorIntegrationType {
  Encompass_8 = 'encompass_8'
}

export type DistributorProducerAssignment = {
  __typename: 'DistributorProducerAssignment';
  distributor: Distributor;
  distributorId: Scalars['Int'];
  id: Scalars['String'];
  producer: Producer;
  producerId: Scalars['Int'];
  regionV2: RegionV2;
};

export type DistributorPurchaseOrder = FulfillmentOrder & Order & {
  __typename: 'DistributorPurchaseOrder';
  adjustmentItems: Array<AdjustmentItem>;
  adjustmentTotalInCents: Scalars['Int'];
  adjustmentUnitsTotal: Scalars['Int'];
  amountInCents: Scalars['Int'];
  auditLogs: Array<AuditLog>;
  balanceTransferProposal: Maybe<TransferProposal>;
  balanceTransferStatus: LedgerStatus;
  balanceTransfers: Array<FundsTransfer>;
  bankDepositsLedger: Ledger;
  buyer: Business;
  buyerName: Scalars['String'];
  canSendBalanceTransfer: ValidationResult;
  cancelledAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  deletedAt: Maybe<Scalars['DateTime']>;
  deliveredAt: Maybe<Scalars['DateTime']>;
  deliverySLT: ServiceLevelTarget;
  deliveryStatus: DeliveryStatus;
  deliveryStepSLT: ServiceLevelTarget;
  distributionModel: DistributionModel;
  distributorFee: Scalars['Int'];
  documents: Array<OrderDocument>;
  enabledFeatures: OrderEnabledFeatures;
  finalOrderTotalInCents: Scalars['Int'];
  freightSLT: ServiceLevelTarget;
  freightStepSLT: ServiceLevelTarget;
  id: Scalars['Int'];
  invoice: Maybe<Invoice>;
  items: Array<OrderItem>;
  number: Scalars['String'];
  packageSummary: Array<PackageSummaryItem>;
  paymentSLT: ServiceLevelTarget;
  paymentStatus: LedgerStatus;
  paymentStepSLT: ServiceLevelTarget;
  payments: Array<FundsTransfer>;
  paymentsLedger: Ledger;
  placedOn: Maybe<Scalars['DateTime']>;
  preSale: PreSale;
  producerPurchaseOrder: ProducerPurchaseOrder;
  regionV2: RegionV2;
  retailerSalesOrders: Array<RetailerSalesOrder>;
  seller: Business;
  shippingAddress: Maybe<Address>;
  totalPaymentDue: Scalars['Int'];
  trackingInformation: Maybe<TrackingInformation>;
  type: OrderType;
};

export type DistributorPurchaseOrderTransferResult = {
  __typename: 'DistributorPurchaseOrderTransferResult';
  fundsTransfer: FundsTransfer;
  order: DistributorPurchaseOrder;
};

export type DistributorRetailerAssignment = {
  __typename: 'DistributorRetailerAssignment';
  distributor: Distributor;
  distributorId: Scalars['Int'];
  retailer: Retailer;
  retailerId: Scalars['Int'];
};

export enum DocumentType {
  BillOfLading = 'bill_of_lading',
  Invoice = 'invoice',
  Other = 'other',
  ProofOfDelivery = 'proof_of_delivery'
}

export type DwollaCustomer = {
  __typename: 'DwollaCustomer';
  beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus;
  business: Maybe<Business>;
  businessEntityId: Scalars['Int'];
  createdAt: Scalars['String'];
  email: Scalars['String'];
  fundingSources: Array<Maybe<DwollaFundingSource>>;
  id: Scalars['String'];
  requiresBeneficialOwnershipCertification: Scalars['Boolean'];
  status: DwollaCustomerVerificationStatus;
  type: DwollaCustomerType;
};

export enum DwollaCustomerBeneficialOwnerCertificationStatus {
  Certified = 'certified',
  Recertify = 'recertify',
  Uncertified = 'uncertified'
}

export enum DwollaCustomerType {
  Business = 'business',
  Personal = 'personal',
  ReceiveOnly = 'receiveOnly',
  Unverified = 'unverified'
}

export enum DwollaCustomerVerificationStatus {
  Deactivated = 'deactivated',
  Document = 'document',
  Retry = 'retry',
  Suspended = 'suspended',
  Unverified = 'unverified',
  Verified = 'verified'
}

export type DwollaEmailNotification = {
  __typename: 'DwollaEmailNotification';
  /** The Dwolla Webhook Topic sent by Dwolla */
  dwollaWebhookTopic: Scalars['String'];
  /** Email address of the sender */
  from: Scalars['String'];
  /** Identifier for this entity */
  id: Scalars['Int'];
  /** Number of times this notification has been retried */
  retryCount: Maybe<Scalars['Int']>;
  /** Static date when the notification was first attempted */
  sentAt: Maybe<Scalars['DateTime']>;
  /** The Dwolla Webhook Topic sent by Dwolla */
  status: Status;
  /** Email address of the recipient */
  to: Scalars['String'];
  toDwollaCustomer: Maybe<DwollaCustomer>;
  /** Dwolla ID of customer being sent the notification */
  toDwollaCustomerId: Scalars['String'];
  /** Dynamic date set after each retry or update */
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type DwollaFundingSource = {
  __typename: 'DwollaFundingSource';
  id: Scalars['String'];
};

export enum DwollaFundingSourceType {
  Balance = 'balance',
  Bank = 'bank'
}

export type DwollaOnboardingStep = OnboardingStep & {
  __typename: 'DwollaOnboardingStep';
  customerType: DwollaCustomerType;
  dwollaCustomer: Maybe<DwollaCustomer>;
  step: OnboardingStepType;
};

export type DwollaTransfer = {
  __typename: 'DwollaTransfer';
  createdAt: Scalars['DateTime'];
  destinationId: Maybe<Scalars['String']>;
  failureCode: Maybe<Scalars['String']>;
  failureDescription: Maybe<Scalars['String']>;
  failureExplanation: Maybe<Scalars['String']>;
  id: Scalars['String'];
  links: Maybe<Scalars['JSONObject']>;
  sourceId: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type DwollaWebhook = {
  __typename: 'DwollaWebhook';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  receivedAt: Scalars['String'];
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
  status: DwollaWebhookStatus;
  topic: Scalars['String'];
  updatedAt: Scalars['String'];
};

export enum DwollaWebhookStatus {
  Failed = 'failed',
  Pending = 'pending',
  Processed = 'processed'
}

export type ExternalFundsAccount = FundsAccount & {
  __typename: 'ExternalFundsAccount';
  business: Business;
  createdAt: Scalars['DateTime'];
  dwollaFundingSource: Maybe<DwollaFundingSource>;
  id: Scalars['Int'];
  label: Scalars['String'];
  removedAt: Maybe<Scalars['DateTime']>;
  type: FundsAccountType;
};

export type FreightAgingReportFilterInput = {
  regionId?: InputMaybe<Scalars['Int']>;
};

export enum FreightShipmentStatus {
  Cancelled = 'cancelled',
  Delivered = 'delivered',
  InTransit = 'in_transit',
  Scheduled = 'scheduled'
}

/** Enhances the Order interface type with fulfillment specific meta-data */
export type FulfillmentOrder = {
  adjustmentItems: Array<AdjustmentItem>;
  adjustmentTotalInCents: Scalars['Int'];
  adjustmentUnitsTotal: Scalars['Int'];
  amountInCents: Scalars['Int'];
  auditLogs: Array<AuditLog>;
  balanceTransferStatus: LedgerStatus;
  balanceTransfers: Array<FundsTransfer>;
  bankDepositsLedger: Ledger;
  buyer: Business;
  buyerName: Scalars['String'];
  cancelledAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  deletedAt: Maybe<Scalars['DateTime']>;
  deliveredAt: Maybe<Scalars['DateTime']>;
  deliverySLT: ServiceLevelTarget;
  deliveryStatus: DeliveryStatus;
  deliveryStepSLT: ServiceLevelTarget;
  distributionModel: DistributionModel;
  documents: Array<OrderDocument>;
  enabledFeatures: OrderEnabledFeatures;
  finalOrderTotalInCents: Scalars['Int'];
  freightSLT: ServiceLevelTarget;
  freightStepSLT: ServiceLevelTarget;
  id: Scalars['Int'];
  invoice: Maybe<Invoice>;
  items: Array<OrderItem>;
  number: Scalars['String'];
  packageSummary: Array<PackageSummaryItem>;
  paymentSLT: ServiceLevelTarget;
  paymentStatus: LedgerStatus;
  paymentStepSLT: ServiceLevelTarget;
  payments: Array<FundsTransfer>;
  paymentsLedger: Ledger;
  placedOn: Maybe<Scalars['DateTime']>;
  preSale: PreSale;
  regionV2: RegionV2;
  seller: Business;
  shippingAddress: Maybe<Address>;
  totalPaymentDue: Scalars['Int'];
  trackingInformation: Maybe<TrackingInformation>;
  type: OrderType;
};

export type FundsAccount = {
  business: Business;
  createdAt: Scalars['DateTime'];
  dwollaFundingSource: Maybe<DwollaFundingSource>;
  id: Scalars['Int'];
  label: Scalars['String'];
  removedAt: Maybe<Scalars['DateTime']>;
  type: FundsAccountType;
};

export enum FundsAccountType {
  Balance = 'balance',
  Bank = 'bank',
  External = 'external'
}

export type FundsTransfer = {
  __typename: 'FundsTransfer';
  amount: Scalars['Int'];
  breweryInvoiceNumber: Scalars['String'];
  createdAt: Scalars['DateTime'];
  destination: FundsAccount;
  destinationAccountType: Maybe<FundsAccountType>;
  dwollaTransfers: Array<DwollaTransfer>;
  id: Scalars['Int'];
  invoice: Maybe<Invoice>;
  isFee: Scalars['Boolean'];
  isPayment: Scalars['Boolean'];
  orderId: Maybe<Scalars['Int']>;
  retailerInvoiceNumber: Maybe<Scalars['String']>;
  settlementMetadata: Maybe<Scalars['JSONObject']>;
  settlementRejectionResponse: Maybe<Scalars['JSONObject']>;
  settlementStrategy: Maybe<Scalars['String']>;
  source: FundsAccount;
  statementDescriptor: Maybe<Scalars['String']>;
  status: FundsTransferStatus;
};

export enum FundsTransferStatus {
  Cancelled = 'cancelled',
  Failed = 'failed',
  Initiated = 'initiated',
  Pending = 'pending',
  Processed = 'processed',
  Rejected = 'rejected'
}

export enum FundsTransferStatusType {
  Incomplete = 'incomplete',
  NotPaid = 'notPaid',
  Paid = 'paid',
  Pending = 'pending'
}

export type GlobalSearchResult = {
  __typename: 'GlobalSearchResult';
  freightShipments: Array<TrackingInformation>;
  logisticsPartners: Array<LogisticsPartner>;
  producerPurchaseOrders: Array<ProducerPurchaseOrder>;
  producers: Array<Producer>;
  retailerSalesOrders: Array<RetailerSalesOrder>;
  retailers: Array<Retailer>;
  totalResults: Scalars['Int'];
};

export enum ImportCsvCarrier {
  Ffe = 'FFE',
  Fedex = 'Fedex'
}

export type ImportReport = {
  __typename: 'ImportReport';
  failedRowIds: Array<Scalars['String']>;
  successfulRowIds: Array<Scalars['String']>;
};

export enum ImportReportType {
  Cost = 'Cost',
  Tracking = 'Tracking'
}

export type Invoice = {
  __typename: 'Invoice';
  createdAt: Scalars['DateTime'];
  externalAmountInCents: Maybe<Scalars['Int']>;
  externalInvoiceId: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  number: Scalars['String'];
};

export type InvoiceUpdateData = {
  externalAmountInCents?: InputMaybe<Scalars['Int']>;
  externalInvoiceId?: InputMaybe<Scalars['String']>;
};

export type Ledger = {
  __typename: 'Ledger';
  balance: Scalars['Int'];
  completedTotal: Scalars['Int'];
  due: Scalars['Int'];
  id: Scalars['Int'];
  pendingTotal: Scalars['Int'];
  status: LedgerStatus;
  total: Scalars['Int'];
  transfers: Array<Maybe<FundsTransfer>>;
};

export enum LedgerStatus {
  NotPaid = 'not_paid',
  Paid = 'paid',
  PartiallyPaid = 'partially_paid',
  PendingPaid = 'pending_paid'
}

export type License = {
  __typename: 'License';
  createdAt: Scalars['DateTime'];
  currentLicensePeriod: LicensePeriod;
  documentUrl: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  licensePeriods: Array<LicensePeriod>;
  number: Scalars['String'];
  producer: Producer;
  producerId: Scalars['Int'];
  stateV2: StateV2;
  title: Scalars['String'];
};

export type LicenseAndLicensePeriodInput = {
  documentUrl?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  number: Scalars['String'];
  startDate: Scalars['DateTime'];
  stateV2Id: Scalars['Int'];
  title: Scalars['String'];
};

export type LicenseNotification = {
  __typename: 'LicenseNotification';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  licenseId: Scalars['Int'];
  licensePeriodId: Scalars['Int'];
  notificationType: NotificationType;
};

export type LicenseNotificationInput = {
  licenseId: Scalars['Int'];
  licensePeriodId: Scalars['Int'];
  notificationType: NotificationType;
};

export type LicensePeriod = {
  __typename: 'LicensePeriod';
  createdAt: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  id: Scalars['Int'];
  license: License;
  licenseId: Scalars['Int'];
  startDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type LicensePeriodInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type LogisticsPartner = Business & {
  __typename: 'LogisticsPartner';
  address: Maybe<Address>;
  /** Default, active balance account. */
  balanceAccount: Maybe<BalanceAccount>;
  /** Default, active bank account. */
  bankAccount: Maybe<BankAccount>;
  bankAccounts: Array<BankAccount>;
  businessType: BusinessType;
  canDelete: Scalars['Boolean'];
  completedOnboardingAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  dwollaCustomer: Maybe<DwollaCustomer>;
  /** External Funds Account used for manual transfers outside of our system. */
  externalFundsAccount: Maybe<ExternalFundsAccount>;
  fein: Maybe<Scalars['String']>;
  fundsTransfers: Array<FundsTransfer>;
  /** Identifier for this entity and it's parent business entity */
  id: Scalars['Int'];
  name: Scalars['String'];
  onboarding: Maybe<Onboarding>;
  organization: Organization;
  organizationId: Scalars['Int'];
  validBalanceAccount: Maybe<BalanceAccount>;
  validBalanceAccounts: Array<BalanceAccount>;
  validBankAccount: Maybe<BankAccount>;
  validBankAccounts: Array<BankAccount>;
};

export type LogisticsPartnersFilterData = {
  logisticsPartnerId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  regionV2Id?: InputMaybe<Scalars['Int']>;
};

export enum Models {
  Product = 'product'
}

export type Mutation = {
  __typename: 'Mutation';
  UpdateDistributorDetails: Distributor;
  addBankAccountViaPlaid: BankAccount;
  addFeePaymentForOrder: FundsTransfer;
  addFirstRetailerLocation: Organization;
  /** @deprecated Please use endpoint addFundsTransferForOrder instead */
  addFundsTransfer: FundsTransfer;
  addLicenseAndCurrentPeriod: License;
  addLicenseNotification: LicenseNotification;
  addLicensePeriod: Maybe<LicensePeriod>;
  addLocation: Retailer;
  addOffer: Offer;
  addOfferWindow: OfferWindow;
  addOrderDocument: OrderDocument;
  addOrganizationAndDistributor: Distributor;
  addOrganizationAndLogisticsPartner: LogisticsPartner;
  addPODDocument: OrderDocument;
  addPlatformFee: Maybe<PackageTypePlatformFee>;
  addPresaleImportJobs: Array<Maybe<PreSaleImportJob>>;
  addProducer: Organization;
  addProducerPlatformFee: Maybe<ProducerPlatformFee>;
  addProduct: Product;
  addProductImage: ProductImage;
  addRetailerSalesOrder: Maybe<RetailerSalesOrder>;
  addSandboxProducer: Producer;
  addSandboxRetailer: Retailer;
  addTracking: Order;
  addTransferForOrder: FundsTransfer;
  agreeToTermsOfService: Maybe<User>;
  assignDeliveryPartner: RegionV2;
  assignDistributorToProducer: Maybe<DistributorProducerAssignment>;
  assignRetailerToDistributor: Maybe<DistributorRetailerAssignment>;
  authorizeOnDemandTransfers: Maybe<BankAccount>;
  cancelPreSaleOrder: Maybe<PreSaleOrder>;
  cancelProducerPurchaseOrder: ProducerPurchaseOrder;
  cancelRetailerSalesOrder: Maybe<RetailerSalesOrder>;
  certifyBeneficialOwnership: Maybe<DwollaCustomer>;
  cloneOfferWindow: OfferWindow;
  collectPlatformFee: ProducerPurchaseOrderTransferResult;
  completeOnboarding: Business;
  createBeerStyle: Maybe<BeerStyle>;
  createBeerStyleForProduct: Maybe<Product>;
  createDwollaEmailNotification: DwollaEmailNotification;
  createKuebixShipment: ProducerPurchaseOrder;
  createOrUpdateAddress: Order;
  createOrUpdateBusinessAddress: Business;
  createPlaidSandboxPublicToken: Maybe<PlaidPublicToken>;
  createPreSaleOrder: Maybe<PreSaleOrder>;
  createProductPackageType: Maybe<ProductPackageType>;
  deleteDistributor: Distributor;
  deleteDistributorProducerAssignment: Maybe<DistributorProducerAssignment>;
  deleteLicense: Maybe<License>;
  deleteLogisticsPartner: LogisticsPartner;
  deleteOrder: Order;
  deleteOrderDocument: OrderDocument;
  deletePODDocument: OrderDocument;
  deleteProducer: Producer;
  deleteProduct: Product;
  deleteProductFromPurchaseOrder: Order;
  deleteProductPackageType: Maybe<ProductPackageType>;
  deleteRetailer: Retailer;
  editProduct: Product;
  generateFulfillmentOrders: PreSale;
  inviteGlobalAdmin: User;
  inviteUser: User;
  markPlatformFeePaid: ProducerPurchaseOrderTransferResult;
  refreshPlaidItem: PlaidItem;
  refreshPlatformFee: ProducerPurchaseOrder;
  /** Register a new retailer organization and add the calling user to that organization. */
  registerRetailerOrganization: Organization;
  removeBankAccount: Maybe<BankAccount>;
  removeOffer: Offer;
  removeOfferWindow: OfferWindow;
  removePreSale: Maybe<PreSale>;
  resetSkipBeneficialOwnersStep: Business;
  runSandboxSimulations: SandboxSimulation;
  sendAdjustmentsPayment: ProducerPurchaseOrderTransferResult;
  sendBalanceTransfer: ProducerPurchaseOrderTransferResult;
  sendDistributorBalanceTransfer: DistributorPurchaseOrderTransferResult;
  sendDistributorPayment: ProducerPurchaseOrderTransferResult;
  sendRetailerPayment: Maybe<SendPaymentResult>;
  skipBeneficialOwnersStep: Business;
  syncBeverageAdvisors: Business;
  syncDwollaCustomer: Maybe<DwollaCustomer>;
  syncFundsTransfer: FundsTransfer;
  updateBusinessEntity: Business;
  updateDistributorProducerAssignment: Maybe<DistributorProducerAssignment>;
  updateDwollaCustomer: Maybe<DwollaCustomer>;
  updateInvoice: Invoice;
  updateLicenseAndCurrentPeriod: License;
  updateOffer: Offer;
  updateOfferWindow: OfferWindow;
  updateOrder: Order;
  updateOrderDocument: OrderDocument;
  updateOrganization: Organization;
  updatePlatformFee: Maybe<PackageTypePlatformFee>;
  updatePreSaleProducerFulfillmentExclusion: Array<PreSaleProductMetadata>;
  updatePreSaleProductFulfillmentExclusion: Maybe<PreSaleProductMetadata>;
  updateProducer: Producer;
  updateProducerPlatformFee: Maybe<ProducerPlatformFee>;
  updateProducerPurchaseOrder: ProducerPurchaseOrder;
  updateShippingCostFromCSV: ImportReport;
  updateTracking: Order;
  updateTrackingInfoFromCSV: ImportReport;
  upsertDwollaCustomer: Maybe<DwollaCustomer>;
};


export type MutationUpdateDistributorDetailsArgs = {
  data: UpdateDistributorDetailsData;
  id: Scalars['Int'];
};


export type MutationAddBankAccountViaPlaidArgs = {
  businessEntityId: Scalars['Int'];
  plaidPublicToken: Scalars['String'];
  selectedAccountId: Scalars['String'];
};


export type MutationAddFeePaymentForOrderArgs = {
  data: AddTransferForOrderData;
};


export type MutationAddFirstRetailerLocationArgs = {
  forceDwollaBusinessCustomer: Scalars['Boolean'];
  locationName: Scalars['String'];
  organizationName: Scalars['String'];
  region: Scalars['Int'];
};


export type MutationAddFundsTransferArgs = {
  data: AddFundsTransferData;
};


export type MutationAddLicenseAndCurrentPeriodArgs = {
  data: LicenseAndLicensePeriodInput;
  producerId: Scalars['Int'];
};


export type MutationAddLicenseNotificationArgs = {
  data: LicenseNotificationInput;
};


export type MutationAddLicensePeriodArgs = {
  data: LicensePeriodInput;
  licenseId: Scalars['Int'];
};


export type MutationAddLocationArgs = {
  data: RetailLocationInput;
};


export type MutationAddOfferArgs = {
  data: OfferCreateInput;
};


export type MutationAddOfferWindowArgs = {
  data: OfferWindowCreateInput;
};


export type MutationAddOrderDocumentArgs = {
  data: OrderDocumentCreateData;
};


export type MutationAddOrganizationAndDistributorArgs = {
  data: AddOrganizationAndDistributorData;
};


export type MutationAddOrganizationAndLogisticsPartnerArgs = {
  data: AddOrganizationAndLogisticsPartnerData;
};


export type MutationAddPodDocumentArgs = {
  data: OrderPodDocumentCreateData;
};


export type MutationAddPlatformFeeArgs = {
  data: PlatformFeeCreateInput;
};


export type MutationAddPresaleImportJobsArgs = {
  endDate: Scalars['DateTime'];
  regions: Array<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};


export type MutationAddProducerArgs = {
  data: AddProducerData;
};


export type MutationAddProducerPlatformFeeArgs = {
  data: ProducerPlatformFeeCreateInput;
};


export type MutationAddProductArgs = {
  data: ProductInput;
};


export type MutationAddProductImageArgs = {
  data: ProductImageInput;
};


export type MutationAddRetailerSalesOrderArgs = {
  data: RetailerOrderAddData;
};


export type MutationAddSandboxProducerArgs = {
  type: SandboxProducerType;
};


export type MutationAddSandboxRetailerArgs = {
  type: SandboxRetailerType;
};


export type MutationAddTrackingArgs = {
  data: TrackingInfoInput;
  orderId: Scalars['Int'];
};


export type MutationAddTransferForOrderArgs = {
  data: AddTransferForOrderData;
};


export type MutationAgreeToTermsOfServiceArgs = {
  userId: Scalars['Int'];
  version?: Scalars['String'];
};


export type MutationAssignDeliveryPartnerArgs = {
  data: AssignRegionDeliveryPartnerInput;
};


export type MutationAssignDistributorToProducerArgs = {
  data: AssignDistributorToProducerInput;
};


export type MutationAssignRetailerToDistributorArgs = {
  distributorId: Scalars['Int'];
  retailerId: Scalars['Int'];
};


export type MutationAuthorizeOnDemandTransfersArgs = {
  bankAccountId: Scalars['Int'];
};


export type MutationCancelPreSaleOrderArgs = {
  orderId: Scalars['Int'];
};


export type MutationCancelProducerPurchaseOrderArgs = {
  id: Scalars['Int'];
};


export type MutationCancelRetailerSalesOrderArgs = {
  orderId: Scalars['Int'];
};


export type MutationCertifyBeneficialOwnershipArgs = {
  dwollaCustomerId: Scalars['String'];
};


export type MutationCloneOfferWindowArgs = {
  data: OfferWindowCloneInput;
  originalOfferWindowId: Scalars['Int'];
};


export type MutationCollectPlatformFeeArgs = {
  id: Scalars['Int'];
};


export type MutationCompleteOnboardingArgs = {
  id: Scalars['Int'];
};


export type MutationCreateBeerStyleArgs = {
  code: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  url: InputMaybe<Scalars['String']>;
};


export type MutationCreateBeerStyleForProductArgs = {
  code: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  url: InputMaybe<Scalars['String']>;
};


export type MutationCreateDwollaEmailNotificationArgs = {
  data: CreateDwollaEmailNotificationData;
};


export type MutationCreateKuebixShipmentArgs = {
  orderId: Scalars['Int'];
};


export type MutationCreateOrUpdateAddressArgs = {
  data: AddressUpdateData;
  id: Scalars['Int'];
};


export type MutationCreateOrUpdateBusinessAddressArgs = {
  data: AddressUpdateData;
  id: Scalars['Int'];
};


export type MutationCreatePlaidSandboxPublicTokenArgs = {
  institutionID?: Scalars['String'];
};


export type MutationCreatePreSaleOrderArgs = {
  preSaleId: Scalars['Int'];
  storeId: Scalars['Int'];
};


export type MutationCreateProductPackageTypeArgs = {
  data: ProductPackageTypeInput;
};


export type MutationDeleteDistributorArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteDistributorProducerAssignmentArgs = {
  data: DeleteDistributorFromProducerInput;
};


export type MutationDeleteLicenseArgs = {
  licenseId: Scalars['Int'];
};


export type MutationDeleteLogisticsPartnerArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteOrderArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteOrderDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationDeletePodDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteProducerArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteProductArgs = {
  productId: Scalars['Int'];
};


export type MutationDeleteProductFromPurchaseOrderArgs = {
  orderId: Scalars['Int'];
  productId: Scalars['Int'];
};


export type MutationDeleteProductPackageTypeArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRetailerArgs = {
  id: Scalars['Int'];
};


export type MutationEditProductArgs = {
  data: UpdateProductInput;
};


export type MutationGenerateFulfillmentOrdersArgs = {
  id: Scalars['Int'];
};


export type MutationInviteGlobalAdminArgs = {
  email: Scalars['String'];
  fullName: Scalars['String'];
};


export type MutationInviteUserArgs = {
  email: Scalars['String'];
  fullName: Scalars['String'];
  organizationId: Scalars['Int'];
};


export type MutationMarkPlatformFeePaidArgs = {
  invoiceNumber: Scalars['String'];
  orderId: Scalars['Int'];
  paymentDate: Scalars['String'];
};


export type MutationRefreshPlaidItemArgs = {
  id: Scalars['Int'];
};


export type MutationRefreshPlatformFeeArgs = {
  id: Scalars['Int'];
};


export type MutationRegisterRetailerOrganizationArgs = {
  data: RegisterRetailerOrganizationData;
};


export type MutationRemoveBankAccountArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};


export type MutationRemoveOfferArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveOfferWindowArgs = {
  id: Scalars['Int'];
};


export type MutationRemovePreSaleArgs = {
  id: Scalars['Int'];
};


export type MutationResetSkipBeneficialOwnersStepArgs = {
  businessId: Scalars['Int'];
};


export type MutationSendAdjustmentsPaymentArgs = {
  orderId: Scalars['Int'];
};


export type MutationSendBalanceTransferArgs = {
  orderId: Scalars['Int'];
};


export type MutationSendDistributorBalanceTransferArgs = {
  orderId: Scalars['Int'];
};


export type MutationSendDistributorPaymentArgs = {
  orderId: Scalars['Int'];
};


export type MutationSendRetailerPaymentArgs = {
  orderId: Scalars['Int'];
};


export type MutationSkipBeneficialOwnersStepArgs = {
  businessId: Scalars['Int'];
};


export type MutationSyncDwollaCustomerArgs = {
  dwollaCustomerId: Scalars['String'];
};


export type MutationSyncFundsTransferArgs = {
  fundsTransferId: Scalars['Int'];
};


export type MutationUpdateBusinessEntityArgs = {
  data: UpdateBusinessEntityData;
  id: Scalars['Int'];
};


export type MutationUpdateDistributorProducerAssignmentArgs = {
  data: UpdateDistributorToProducerInput;
};


export type MutationUpdateDwollaCustomerArgs = {
  data: UpdateDwollaCustomerInput;
};


export type MutationUpdateInvoiceArgs = {
  data: InvoiceUpdateData;
  id: Scalars['Int'];
};


export type MutationUpdateLicenseAndCurrentPeriodArgs = {
  data: LicenseAndLicensePeriodInput;
  licenseId: Scalars['Int'];
};


export type MutationUpdateOfferArgs = {
  data: OfferUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateOfferWindowArgs = {
  data: OfferWindowUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateOrderArgs = {
  data: OrderUpdateData;
  id: Scalars['Int'];
};


export type MutationUpdateOrderDocumentArgs = {
  data: OrderDocumentUpdateData;
  id: Scalars['Int'];
};


export type MutationUpdateOrganizationArgs = {
  data: UpdateOrganizationData;
  id: Scalars['Int'];
};


export type MutationUpdatePlatformFeeArgs = {
  data: PlatformFeeUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdatePreSaleProducerFulfillmentExclusionArgs = {
  data: UpdatePreSaleProducerFulfillmentExclusionInput;
};


export type MutationUpdatePreSaleProductFulfillmentExclusionArgs = {
  data: UpdatePreSaleProductFulfillmentExclusionInput;
};


export type MutationUpdateProducerArgs = {
  data: UpdateProducerData;
  id: Scalars['Int'];
};


export type MutationUpdateProducerPlatformFeeArgs = {
  data: ProducerPlatformFeeUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateProducerPurchaseOrderArgs = {
  data: ProducerPurchaseOrderUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateShippingCostFromCsvArgs = {
  remoteFileId: Scalars['Int'];
};


export type MutationUpdateTrackingArgs = {
  data: TrackingInfoInput;
  trackingId: Scalars['Int'];
};


export type MutationUpdateTrackingInfoFromCsvArgs = {
  company: ImportCsvCarrier;
  remoteFileId: Scalars['Int'];
};


export type MutationUpsertDwollaCustomerArgs = {
  businessEntityId: Scalars['Int'];
  customerId: Scalars['String'];
};

export enum NotificationType {
  ExpirationWarning_30Days = 'expiration_warning_30_days',
  PreSaleOrderItemsCancelled = 'pre_sale_order_items_cancelled',
  SalesOrderPaymentSent = 'sales_order_payment_sent'
}

export type Offer = {
  __typename: 'Offer';
  canDelete: Scalars['Boolean'];
  canUpdate: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  earliestPickup: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  netPrice: Scalars['Int'];
  offerWindow: OfferWindow;
  platformPrice: Scalars['Int'];
  product: Product;
  quantity: Scalars['Int'];
  shopifyLink: Maybe<Scalars['String']>;
  shopifyProductId: Maybe<Scalars['BigInt']>;
  wholesalePrice: Scalars['Int'];
};

export type OfferCreateInput = {
  earliestPickup?: InputMaybe<Scalars['DateTime']>;
  offerWindowId: Scalars['Int'];
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type OfferSearchFilters = {
  after?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['DateTime']>;
  producerId?: InputMaybe<Scalars['Int']>;
  productName?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['Int']>;
};

export type OfferUpdateInput = {
  earliestPickup?: InputMaybe<Scalars['DateTime']>;
  quantity: Scalars['Int'];
};

export type OfferWindow = {
  __typename: 'OfferWindow';
  canDelete: Scalars['Boolean'];
  canUpdate: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  end: Scalars['DateTime'];
  id: Scalars['Int'];
  offers: Array<Offer>;
  regionV2: RegionV2;
  start: Scalars['DateTime'];
};

export type OfferWindowCloneInput = {
  end: Scalars['DateTime'];
  regionId: Scalars['Int'];
  start: Scalars['DateTime'];
};

export type OfferWindowCreateInput = {
  end: Scalars['DateTime'];
  regionId: Scalars['Int'];
  start: Scalars['DateTime'];
};

export type OfferWindowSearchFilters = {
  after?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['DateTime']>;
  regionId?: InputMaybe<Scalars['Int']>;
};

export type OfferWindowUpdateInput = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type OffsetPaginationInput = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
};

export type Onboarding = {
  __typename: 'Onboarding';
  currentStep: OnboardingStep;
  /** Returns the businessEntityId for caching purposes. */
  id: Scalars['Int'];
  steps: Array<OnboardingStepType>;
};

export type OnboardingStep = {
  step: OnboardingStepType;
};

export enum OnboardingStepType {
  BankAccount = 'bankAccount',
  BeneficialOwner = 'beneficialOwner',
  Complete = 'complete',
  Dwolla = 'dwolla'
}

/** Provides core order fields to order subtypes */
export type Order = {
  adjustmentItems: Array<AdjustmentItem>;
  adjustmentTotalInCents: Scalars['Int'];
  adjustmentUnitsTotal: Scalars['Int'];
  amountInCents: Scalars['Int'];
  auditLogs: Array<AuditLog>;
  balanceTransferStatus: LedgerStatus;
  balanceTransfers: Array<FundsTransfer>;
  bankDepositsLedger: Ledger;
  buyer: Business;
  buyerName: Scalars['String'];
  cancelledAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  deletedAt: Maybe<Scalars['DateTime']>;
  deliveredAt: Maybe<Scalars['DateTime']>;
  deliverySLT: ServiceLevelTarget;
  deliveryStatus: DeliveryStatus;
  deliveryStepSLT: ServiceLevelTarget;
  distributionModel: DistributionModel;
  documents: Array<OrderDocument>;
  enabledFeatures: OrderEnabledFeatures;
  finalOrderTotalInCents: Scalars['Int'];
  freightSLT: ServiceLevelTarget;
  freightStepSLT: ServiceLevelTarget;
  id: Scalars['Int'];
  invoice: Maybe<Invoice>;
  items: Array<OrderItem>;
  number: Scalars['String'];
  packageSummary: Array<PackageSummaryItem>;
  paymentSLT: ServiceLevelTarget;
  paymentStatus: LedgerStatus;
  paymentStepSLT: ServiceLevelTarget;
  payments: Array<FundsTransfer>;
  paymentsLedger: Ledger;
  placedOn: Maybe<Scalars['DateTime']>;
  preSale: Maybe<PreSale>;
  regionV2: RegionV2;
  seller: Business;
  shippingAddress: Maybe<Address>;
  totalPaymentDue: Scalars['Int'];
  trackingInformation: Maybe<TrackingInformation>;
  type: OrderType;
};

export enum OrderActionType {
  CreateChildRetailSaleOrder = 'CreateChildRetailSaleOrder',
  CreateKuebixShipment = 'CreateKuebixShipment',
  CreatePdf = 'CreatePDF',
  CreatePdfBundle = 'CreatePDFBundle',
  DeleteOrder = 'DeleteOrder',
  DeleteOrderItems = 'DeleteOrderItems',
  EditAdjustmentItems = 'EditAdjustmentItems',
  EditOrder = 'EditOrder',
  EditOrderItems = 'EditOrderItems',
  MakeFeePayment = 'MakeFeePayment',
  MakePayment = 'MakePayment',
  ViewAdjustments = 'ViewAdjustments'
}

export type OrderAutocompleteResponse = {
  __typename: 'OrderAutocompleteResponse';
  externalInvoiceId: Scalars['String'];
  id: Scalars['Int'];
  orderNumber: Scalars['String'];
};

export type OrderDocument = {
  __typename: 'OrderDocument';
  createdAt: Scalars['DateTime'];
  creator: User;
  documentType: DocumentType;
  fileUrl: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  notes: Maybe<Scalars['String']>;
  order: Order;
};

export type OrderDocumentCreateData = {
  documentType: DocumentType;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  orderId: Scalars['Int'];
  remoteFileId: Scalars['Int'];
};

export type OrderDocumentUpdateData = {
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export type OrderEnabledFeatures = {
  __typename: 'OrderEnabledFeatures';
  canCreateChildRetailSaleOrder: Scalars['Boolean'];
  canCreateKuebixShipment: Scalars['Boolean'];
  canCreatePDF: Scalars['Boolean'];
  canCreatePDFBundle: Scalars['Boolean'];
  canDeleteOrder: Scalars['Boolean'];
  canDeleteOrderItems: Scalars['Boolean'];
  canEditAdjustmentItems: Scalars['Boolean'];
  canEditOrder: Scalars['Boolean'];
  canEditOrderItems: Scalars['Boolean'];
  canMakeFeePayment: Scalars['Boolean'];
  canMakePayment: Scalars['Boolean'];
  canViewAdjustments: Scalars['Boolean'];
};

export type OrderItem = {
  __typename: 'OrderItem';
  finalQuantity: Scalars['Float'];
  finalQuantityDisplay: Scalars['String'];
  finalTotal: Scalars['Int'];
  finalWholesaleTotal: Scalars['Int'];
  hasAdjustmentItems: Scalars['Boolean'];
  offerId: Maybe<Scalars['Int']>;
  orderId: Scalars['Int'];
  price: Scalars['Int'];
  pricePerUnit: Scalars['Int'];
  product: Product;
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
  total: Scalars['Int'];
  totalUnits: Scalars['Int'];
  wholesalePrice: Scalars['Int'];
  wholesalePricePerUnit: Scalars['Int'];
  wholesaleTotal: Scalars['Int'];
};

export type OrderItemInput = {
  offerId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Int'];
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type OrderPodDocumentCreateData = {
  deliveryDate: Scalars['DateTime'];
  name: Scalars['String'];
  orderId: Scalars['Int'];
  remoteFileId: Scalars['Int'];
};

export enum OrderType {
  DistributorPurchaseOrder = 'distributor_purchase_order',
  ProducerPurchaseOrder = 'producer_purchase_order',
  RetailerPreSaleOrder = 'retailer_pre_sale_order',
  RetailerSalesOrder = 'retailer_sales_order'
}

export type OrderUpdateData = {
  adjustmentItems?: InputMaybe<Array<AdjustmentItemInput>>;
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  deliveredAt?: InputMaybe<Scalars['DateTime']>;
  invoice?: InputMaybe<InvoiceUpdateData>;
  items?: InputMaybe<Array<OrderItemInput>>;
  number?: InputMaybe<Scalars['String']>;
  placedOn?: InputMaybe<Scalars['DateTime']>;
};

export type Organization = {
  __typename: 'Organization';
  businessType: BusinessType;
  businesses: Array<Business>;
  createdAt: Scalars['DateTime'];
  email: Maybe<Scalars['String']>;
  fundsTransfers: Array<FundsTransfer>;
  id: Scalars['Int'];
  locations: Array<Retailer>;
  memberships: Array<OrganizationMembership>;
  name: Scalars['String'];
};


export type OrganizationFundsTransfersArgs = {
  monthFilter: InputMaybe<Scalars['String']>;
};

export type OrganizationInput = {
  businessType: BusinessType;
  name: Scalars['String'];
};

export type OrganizationMembership = {
  __typename: 'OrganizationMembership';
  createdAt: Scalars['DateTime'];
  organization: Organization;
  organizationId: Scalars['Int'];
  user: User;
  userId: Scalars['Int'];
};

export type PackageSummaryItem = {
  __typename: 'PackageSummaryItem';
  packageType: ProductPackageType;
  totalQuantity: Scalars['Int'];
  totalWeight: Scalars['Float'];
};

export type PackageTypePlatformFee = {
  __typename: 'PackageTypePlatformFee';
  amount: Scalars['Int'];
  id: Scalars['Int'];
  packageType: ProductPackageType;
  regionV2: RegionV2;
};

export type PaginatedLogisticsPartners = {
  __typename: 'PaginatedLogisticsPartners';
  results: Array<LogisticsPartner>;
  total: Scalars['Int'];
};

export type PaginatedOfferWindows = {
  __typename: 'PaginatedOfferWindows';
  results: Array<OfferWindow>;
  total: Scalars['Int'];
};

export type PaginatedOffers = {
  __typename: 'PaginatedOffers';
  results: Array<Offer>;
  total: Scalars['Int'];
};

export type PaginatedPaginatedPreSaleOrders = {
  __typename: 'PaginatedPaginatedPreSaleOrders';
  results: Array<PreSaleOrder>;
  total: Scalars['Int'];
};

export type PaginatedPreSales = {
  __typename: 'PaginatedPreSales';
  results: Array<PreSale>;
  total: Scalars['Int'];
};

export type PaginatedProducerPurchaseOrders = {
  __typename: 'PaginatedProducerPurchaseOrders';
  results: Array<ProducerPurchaseOrder>;
  total: Scalars['Int'];
};

export type PaginatedProducerSalesByRegionResult = {
  __typename: 'PaginatedProducerSalesByRegionResult';
  results: Array<ProducerSalesByRegion>;
  total: Scalars['Int'];
};

export type PaginatedProducers = {
  __typename: 'PaginatedProducers';
  results: Array<Producer>;
  total: Scalars['Int'];
};

export type PaginatedProducts = {
  __typename: 'PaginatedProducts';
  results: Array<Product>;
  total: Scalars['Int'];
};

export type PaginatedRetailerSalesOrders = {
  __typename: 'PaginatedRetailerSalesOrders';
  results: Array<RetailerSalesOrder>;
  total: Scalars['Int'];
};

export type PaginatedRetailers = {
  __typename: 'PaginatedRetailers';
  results: Array<Retailer>;
  total: Scalars['Int'];
};

export type PaymentAgingReportFilterInput = {
  regionId?: InputMaybe<Scalars['Int']>;
};

export enum PaymentStatusType {
  Incomplete = 'incomplete',
  NotPaid = 'notPaid',
  Paid = 'paid',
  Pending = 'pending'
}

export type PlaidItem = {
  __typename: 'PlaidItem';
  bankAccount: Maybe<BankAccount>;
  bankAccountId: Scalars['Int'];
  id: Scalars['Int'];
  itemId: Scalars['String'];
  /** Plaid Link token for updating an existing Item */
  linkToken: PlaidLinkToken;
  /** Verification status of the selected Account for this Plaid Item */
  verificationStatus: Maybe<PlaidVerificationStatus>;
};

export type PlaidLinkToken = {
  __typename: 'PlaidLinkToken';
  expiration: Scalars['String'];
  linkToken: Scalars['String'];
};

/**
 * Create a valid public_token for an arbitrary institution ID, initial products,
 *      and test credentials. The created public_token maps to a new Sandbox Item
 */
export type PlaidPublicToken = {
  __typename: 'PlaidPublicToken';
  publicToken: Maybe<Scalars['String']>;
  requestId: Maybe<Scalars['String']>;
};

/**
 * The current verification status of an Auth Item initiated through
 * Automated or Manual micro-deposits.
 *
 * - *null*: The Item was instantly verified and micro-despoit verification was not required
 * - *pending_automatic_verification*: The Item is pending automatic verification
 * - *pending_manual_verification*: The Item is pending manual micro-deposit
 *   verification. Items remain in this state until the user successfully verifies
 *   the two amounts.
 * - *automatically_verified*: The Item has successfully been automatically verified
 * - *manually_verified*: The Item has successfully been manually verified
 * - *verification_expired*: Plaid was unable to automatically verify the deposit
 *   within 7 calendar days and will no longer attempt to validate the Item.
 *   Users may retry by submitting their information again through Link.
 * - *verification_failed*: The Item failed manual micro-deposit verification
 *   because the user exhausted all 3 verification attempts. Users may retry
 *   by submitting their information again through Link.
 */
export enum PlaidVerificationStatus {
  AutomaticallyVerified = 'automatically_verified',
  ManuallyVerified = 'manually_verified',
  PendingAutomaticVerification = 'pending_automatic_verification',
  PendingManualVerification = 'pending_manual_verification',
  VerificationExpired = 'verification_expired',
  VerificationFailed = 'verification_failed'
}

export type PlatformFeeCreateInput = {
  amount: Scalars['Int'];
  packageTypeId: Scalars['Int'];
  regionId: Scalars['Int'];
};

export type PlatformFeeUpdateInput = {
  amount: Scalars['Int'];
};

export type PlatformFeesBreakdownResult = {
  __typename: 'PlatformFeesBreakdownResult';
  finalQuantity: Scalars['Float'];
  finalTotal: Scalars['Int'];
  globalPlatformFee: Scalars['Int'];
  packageTypeName: Scalars['String'];
  platformFeesTotal: Scalars['Int'];
  producerPlatformFee: Maybe<Scalars['Int']>;
  productName: Scalars['String'];
};

export type PreSale = {
  __typename: 'PreSale';
  createdAt: Scalars['DateTime'];
  end: Scalars['DateTime'];
  id: Scalars['Int'];
  number: Scalars['String'];
  orderCount: Scalars['Int'];
  orders: Array<PreSaleOrder>;
  preSaleProducerSummary: Array<PreSaleProducerSummary>;
  preSaleProducts: Array<PreSaleProduct>;
  purchaseOrders: Array<ProducerPurchaseOrder>;
  regionV2: RegionV2;
  start: Scalars['DateTime'];
  status: PreSaleStatus;
};

export type PreSaleImportJob = {
  __typename: 'PreSaleImportJob';
  createdAt: Scalars['DateTime'];
  end: Scalars['DateTime'];
  failureReason: Maybe<Scalars['JSONObject']>;
  id: Scalars['Int'];
  preSaleId: Maybe<Scalars['Int']>;
  regionV2: RegionV2;
  start: Scalars['DateTime'];
  status: PreSaleImportJobStatus;
};

export enum PreSaleImportJobStatus {
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending'
}

/** Enhances the Order interface type with pre-sale order specific meta-data */
export type PreSaleOrder = Order & {
  __typename: 'PreSaleOrder';
  adjustmentItems: Array<AdjustmentItem>;
  adjustmentTotalInCents: Scalars['Int'];
  adjustmentUnitsTotal: Scalars['Int'];
  amountInCents: Scalars['Int'];
  auditLogs: Array<AuditLog>;
  balanceTransferStatus: LedgerStatus;
  balanceTransfers: Array<FundsTransfer>;
  bankDepositsLedger: Ledger;
  buyer: Business;
  buyerName: Scalars['String'];
  canCancel: ValidationResult;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledItems: Array<PreSaleOrderCancelledItem>;
  cancelledTotal: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt: Maybe<Scalars['DateTime']>;
  deliveredAt: Maybe<Scalars['DateTime']>;
  deliverySLT: ServiceLevelTarget;
  deliveryStatus: DeliveryStatus;
  deliveryStepSLT: ServiceLevelTarget;
  distributionModel: DistributionModel;
  documents: Array<OrderDocument>;
  enabledFeatures: OrderEnabledFeatures;
  estimatedFulfillmentTotal: Scalars['Int'];
  finalOrderTotalInCents: Scalars['Int'];
  freightSLT: ServiceLevelTarget;
  freightStepSLT: ServiceLevelTarget;
  id: Scalars['Int'];
  invoice: Maybe<Invoice>;
  items: Array<OrderItem>;
  number: Scalars['String'];
  packageSummary: Array<PackageSummaryItem>;
  paymentSLT: ServiceLevelTarget;
  paymentStatus: LedgerStatus;
  paymentStepSLT: ServiceLevelTarget;
  payments: Array<FundsTransfer>;
  paymentsLedger: Ledger;
  placedOn: Maybe<Scalars['DateTime']>;
  preSale: PreSale;
  regionV2: RegionV2;
  seller: Business;
  shippingAddress: Maybe<Address>;
  shopifyId: Maybe<Scalars['BigInt']>;
  totalPaymentDue: Scalars['Int'];
  trackingInformation: Maybe<TrackingInformation>;
  type: OrderType;
};

export type PreSaleOrderCancelledItem = {
  __typename: 'PreSaleOrderCancelledItem';
  exclusionReason: Maybe<ProductFulfillmentExclusionReason>;
  item: OrderItem;
};

export type PreSaleProducerSummary = {
  __typename: 'PreSaleProducerSummary';
  exclusionReason: Maybe<ProductFulfillmentExclusionReason>;
  isExcluded: Scalars['Boolean'];
  packageTypes: Array<PreSaleProducerSummaryPackageType>;
  producer: Scalars['String'];
  producerId: Scalars['Int'];
  totalUnits: Scalars['Int'];
};

export type PreSaleProducerSummaryPackageType = {
  __typename: 'PreSaleProducerSummaryPackageType';
  count: Scalars['Int'];
  packageType: Scalars['String'];
};

export type PreSaleProduct = {
  __typename: 'PreSaleProduct';
  excludeFromFulfillment: Scalars['Boolean'];
  preSaleId: Scalars['Int'];
  product: Product;
  productFulfillmentExclusionReason: Maybe<ProductFulfillmentExclusionReason>;
  quantity: Scalars['Int'];
  totalInCents: Scalars['Int'];
};

export type PreSaleProductMetadata = {
  __typename: 'PreSaleProductMetadata';
  excludeFromFulfillment: Scalars['Boolean'];
  exclusionReasonId: Maybe<Scalars['Int']>;
  preSaleId: Scalars['Int'];
  producerId: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
};

export enum PreSaleStatus {
  FulfillmentOrdersCreated = 'fulfillment_orders_created',
  FulfillmentOrdersNotCreated = 'fulfillment_orders_not_created'
}

export type PreSalesFilterData = {
  preSaleDateRange?: InputMaybe<Array<Scalars['DateTime']>>;
  regionV2Id?: InputMaybe<Scalars['Int']>;
};

export type Producer = Business & {
  __typename: 'Producer';
  address: Maybe<Address>;
  /** Default, active balance account. */
  balanceAccount: Maybe<BalanceAccount>;
  /** Default, active bank account. */
  bankAccount: Maybe<BankAccount>;
  bankAccounts: Array<BankAccount>;
  businessType: BusinessType;
  canDelete: Scalars['Boolean'];
  completedOnboardingAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  distributorAssignments: Array<DistributorProducerAssignment>;
  dwollaCustomer: Maybe<DwollaCustomer>;
  /** External Funds Account used for manual transfers outside of our system. */
  externalFundsAccount: Maybe<ExternalFundsAccount>;
  fein: Maybe<Scalars['String']>;
  fundsTransfers: Array<FundsTransfer>;
  /** The global identifier for this brewery within the Tavour Beer Community service. */
  globalBreweryId: Maybe<Scalars['Int']>;
  /** Identifier for this entity and it's parent business entity */
  id: Scalars['Int'];
  licenses: Array<License>;
  name: Scalars['String'];
  onboarding: Maybe<Onboarding>;
  organization: Organization;
  organizationId: Scalars['Int'];
  purchaseOrders: PaginatedProducerPurchaseOrders;
  rating: Maybe<Scalars['Float']>;
  validBalanceAccount: Maybe<BalanceAccount>;
  validBalanceAccounts: Array<BalanceAccount>;
  validBankAccount: Maybe<BankAccount>;
  validBankAccounts: Array<BankAccount>;
};


export type ProducerPurchaseOrdersArgs = {
  filters: InputMaybe<ProducerPurchaseOrdersFilterInput>;
  pagination: OffsetPaginationInput;
  sort: InputMaybe<ProducerPurchaseOrdersSortInput>;
};

export enum ProducerInvoiceStatus {
  Missing = 'missing',
  Reconciled = 'reconciled',
  Unreconciled = 'unreconciled'
}

export type ProducerPlatformFee = {
  __typename: 'ProducerPlatformFee';
  amount: Scalars['Int'];
  id: Scalars['Int'];
  packageType: ProductPackageType;
  producer: Producer;
  regionV2: RegionV2;
};

export type ProducerPlatformFeeCreateInput = {
  amount: Scalars['Int'];
  packageTypeId: Scalars['Int'];
  producerId: Scalars['Int'];
  regionId: Scalars['Int'];
};

export type ProducerPlatformFeeUpdateInput = {
  amount: Scalars['Int'];
};

export type ProducerPreSaleUnitsSold = {
  __typename: 'ProducerPreSaleUnitsSold';
  date: Scalars['String'];
  friendlyName: Scalars['String'];
  producer: Scalars['String'];
  units: Scalars['Int'];
};

export type ProducerPurchaseOrder = FulfillmentOrder & Order & {
  __typename: 'ProducerPurchaseOrder';
  adjustmentItems: Array<AdjustmentItem>;
  adjustmentPaymentsLedger: Ledger;
  adjustmentTotalInCents: Scalars['Int'];
  adjustmentUnitsTotal: Scalars['Int'];
  adjustmentsPaymentProposal: Maybe<TransferProposal>;
  amountInCents: Scalars['Int'];
  auditLogs: Array<AuditLog>;
  balanceTransferProposal: Maybe<TransferProposal>;
  balanceTransferStatus: LedgerStatus;
  balanceTransfers: Array<FundsTransfer>;
  bankDepositsLedger: Ledger;
  buyer: Business;
  buyerName: Scalars['String'];
  canCancel: ValidationResult;
  canCollectPlatformFee: ValidationResult;
  canSendAdjustmentsPayment: ValidationResult;
  canSendBalanceTransfer: ValidationResult;
  canSendDistributorPayment: ValidationResult;
  cancelledAt: Maybe<Scalars['DateTime']>;
  collectPlatformFeeProposal: Maybe<TransferProposal>;
  createdAt: Scalars['DateTime'];
  deletedAt: Maybe<Scalars['DateTime']>;
  deliveredAt: Maybe<Scalars['DateTime']>;
  /** The number of delivered retailer sales orders under this purchase order */
  deliveredRetailOrdersCount: Scalars['Int'];
  deliverySLT: ServiceLevelTarget;
  deliveryStatus: DeliveryStatus;
  deliveryStepSLT: ServiceLevelTarget;
  distributionModel: DistributionModel;
  distributorPaymentProposal: Maybe<TransferProposal>;
  distributorPaymentsLedger: Maybe<Ledger>;
  distributorPurchaseOrder: Maybe<DistributorPurchaseOrder>;
  documents: Array<OrderDocument>;
  earliestPickup: Maybe<Scalars['DateTime']>;
  enabledFeatures: OrderEnabledFeatures;
  feeStatus: LedgerStatus;
  feesPayments: Array<FundsTransfer>;
  finalOrderTotalInCents: Scalars['Int'];
  freightSLT: ServiceLevelTarget;
  freightStepSLT: ServiceLevelTarget;
  id: Scalars['Int'];
  invoice: Maybe<Invoice>;
  items: Array<OrderItem>;
  missingPlatformFeeConfiguration: Maybe<Scalars['Boolean']>;
  number: Scalars['String'];
  packageSummary: Array<PackageSummaryItem>;
  /** The number of paid (pending or fully) retailer sales orders under this purchase order */
  paidRetailOrdersCount: Scalars['Int'];
  paymentSLT: ServiceLevelTarget;
  paymentStatus: LedgerStatus;
  paymentStepSLT: ServiceLevelTarget;
  payments: Array<FundsTransfer>;
  paymentsLedger: Ledger;
  placedOn: Maybe<Scalars['DateTime']>;
  /**
   * Platform fee for this order, using either the overridden
   * or calculated platform fee.
   */
  platformFee: Scalars['Int'];
  /** Platform fee as calculated by the system. */
  platformFeeCalculated: Scalars['Int'];
  platformFeeLedger: Ledger;
  /** Manually supplied platform fee that overrides the calculated platform fee. */
  platformFeeOverride: Maybe<Scalars['Int']>;
  platformFeesBreakdown: Array<PlatformFeesBreakdownResult>;
  preSale: PreSale;
  producerInvoiceStatus: ProducerInvoiceStatus;
  regionV2: RegionV2;
  /** The number of retailer sales orders under this purchase order */
  retailOrdersCount: Scalars['Int'];
  retailerSalesOrders: Array<RetailerSalesOrder>;
  seller: Business;
  shippingAddress: Maybe<Address>;
  totalPaymentDue: Scalars['Int'];
  trackingInformation: Maybe<TrackingInformation>;
  type: OrderType;
};

export type ProducerPurchaseOrderTransferResult = {
  __typename: 'ProducerPurchaseOrderTransferResult';
  fundsTransfer: FundsTransfer;
  order: ProducerPurchaseOrder;
};

export type ProducerPurchaseOrderUpdateInput = {
  platformFeeOverride?: InputMaybe<Scalars['Int']>;
};

export type ProducerPurchaseOrdersFilterInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  producerId?: InputMaybe<Scalars['Int']>;
  regionId?: InputMaybe<Scalars['Int']>;
};

export type ProducerPurchaseOrdersSortInput = {
  columnName: Scalars['String'];
  /** The direction to sort items in */
  sortDirection: SortDirection;
};

export type ProducerRegionPlatformFee = {
  __typename: 'ProducerRegionPlatformFee';
  packageType: ProductPackageType;
  platformFee: Maybe<ProducerPlatformFee>;
};

export type ProducerSalesByRegion = {
  __typename: 'ProducerSalesByRegion';
  order_count: Scalars['Int'];
  retailer_email: Scalars['String'];
  retailer_name: Scalars['String'];
  retailer_region: Scalars['String'];
  total_ordered: Scalars['Float'];
};

export type ProducerSalesByRegionFilters = {
  producerId: Scalars['Int'];
  regionId?: InputMaybe<Scalars['Int']>;
};

export type ProducerSalesOrderUnitsFulfilled = {
  __typename: 'ProducerSalesOrderUnitsFulfilled';
  date: Scalars['String'];
  friendlyName: Scalars['String'];
  producer: Scalars['String'];
  units: Scalars['Int'];
};

export type ProducersFilterData = {
  name?: InputMaybe<Scalars['String']>;
  producerId?: InputMaybe<Scalars['Int']>;
};

export type Product = {
  __typename: 'Product';
  abv: Maybe<Scalars['Float']>;
  beerStyle: Maybe<BeerStyle>;
  breweryNetPrice: Maybe<Scalars['Int']>;
  canDelete: Scalars['Boolean'];
  canOfferProduct: ValidationResult;
  createdAt: Scalars['DateTime'];
  description: Maybe<Scalars['String']>;
  globalProductId: Maybe<Scalars['BigInt']>;
  id: Scalars['Int'];
  isOfferable: Scalars['Boolean'];
  name: Scalars['String'];
  packageDate: Maybe<Scalars['DateTime']>;
  packageType: ProductPackageType;
  packageTypeId: Scalars['Int'];
  producer: Producer;
  producerId: Scalars['Int'];
  productImage: Maybe<ProductImage>;
  rating: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};

export type ProductFulfillmentExclusionReason = {
  __typename: 'ProductFulfillmentExclusionReason';
  id: Scalars['Int'];
  label: Scalars['String'];
};

export type ProductImage = CloudinaryImage & {
  __typename: 'ProductImage';
  id: Scalars['Int'];
  product: Product;
  rawUrl: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  type: CloudinaryImageType;
};

export type ProductImageInput = {
  cloudinaryImageId: Scalars['Int'];
  productId: Scalars['Int'];
};

export type ProductInput = {
  abv?: InputMaybe<Scalars['Float']>;
  beerStyleId?: InputMaybe<Scalars['Int']>;
  breweryNetPrice?: InputMaybe<Scalars['Int']>;
  cloudinaryImageId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  packageDate?: InputMaybe<Scalars['String']>;
  packageTypeId: Scalars['Int'];
  producerId: Scalars['Int'];
  rating?: InputMaybe<Scalars['Float']>;
};

export type ProductPackageType = {
  __typename: 'ProductPackageType';
  canDelete: Scalars['Boolean'];
  containerLabel: ContainerLabel;
  containerStreetName: Maybe<Scalars['String']>;
  containerVolume: Scalars['Float'];
  containerVolumeUnit: ContainerVolumeUnit;
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  id: Scalars['Int'];
  platformFees: Array<PackageTypePlatformFee>;
  units: Scalars['Int'];
  weight: Scalars['Float'];
};

export type ProductPackageTypeInput = {
  containerLabel: ContainerLabel;
  containerStreetName?: InputMaybe<Scalars['String']>;
  containerVolume: Scalars['Float'];
  containerVolumeUnit: ContainerVolumeUnit;
  units: Scalars['Int'];
  weight: Scalars['Float'];
};

export type ProductsFilterData = {
  name?: InputMaybe<Scalars['String']>;
  producerId?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename: 'Query';
  ProductFulfillmentExclusionReasons: Array<ProductFulfillmentExclusionReason>;
  adjustmentReasons: Array<AdjustmentReason>;
  adminDashboardStatistics: Maybe<AdminDashboardStatistics>;
  allCarriers: Array<Carrier>;
  autocomplete: Array<Maybe<AutocompleteResponse>>;
  beerStyles: Array<BeerStyle>;
  beverageAdvisors: BeverageAdvisors;
  business: Business;
  canOfferProduct: ValidationResult;
  deliveryAgingReport: PaginatedProducerPurchaseOrders;
  deliverySLT: ServiceLevelTarget;
  deliveryStepSLT: ServiceLevelTarget;
  distributor: Distributor;
  distributors: Array<Distributor>;
  dwollaEmailNotification: DwollaEmailNotification;
  dwollaEmailNotifications: Array<DwollaEmailNotification>;
  dwollaWebhooks: Array<DwollaWebhook>;
  freightAgingReport: PaginatedProducerPurchaseOrders;
  freightSLT: ServiceLevelTarget;
  freightStepSLT: ServiceLevelTarget;
  fundsAccountsEligibleToReceive: Array<FundsAccount>;
  fundsAccountsEligibleToSend: Array<FundsAccount>;
  fundsTransfer: FundsTransfer;
  fundsTransfers: Array<FundsTransfer>;
  getOfferableProduct: Product;
  getRetailerSalesOrders: Maybe<PaginatedRetailerSalesOrders>;
  getShopifyUrlWithLoginToken: Maybe<ShopifyUrlWithLoginTokenResponse>;
  globalSearch: GlobalSearchResult;
  invoice: Invoice;
  license: License;
  licenseNotification: Maybe<LicenseNotification>;
  logisticsPartner: LogisticsPartner;
  logisticsPartners: Array<LogisticsPartner>;
  offer: Offer;
  offerWindow: OfferWindow;
  order: Order;
  orderDocument: OrderDocument;
  organization: Organization;
  organizations: Array<Organization>;
  paginatedPreSales: Maybe<PaginatedPreSales>;
  paginatedProducerPurchaseOrders: PaginatedProducerPurchaseOrders;
  paginatedProducerSalesByRegion: Maybe<PaginatedProducerSalesByRegionResult>;
  paginatedProducers: PaginatedProducers;
  paginatedRetailers: PaginatedRetailers;
  paymentAgingReport: PaginatedProducerPurchaseOrders;
  paymentSLT: ServiceLevelTarget;
  paymentStepSLT: ServiceLevelTarget;
  plaidItem: PlaidItem;
  plaidLinkToken: PlaidLinkToken;
  preSale: PreSale;
  preSaleImportJob: PreSaleImportJob;
  preSaleImportJobs: Array<PreSaleImportJob>;
  preSaleOrder: PreSaleOrder;
  producer: Producer;
  producerPreSaleUnitsSold: Array<ProducerPreSaleUnitsSold>;
  producerPurchaseOrder: ProducerPurchaseOrder;
  producerRegionPlatformFees: Array<ProducerRegionPlatformFee>;
  producerSalesOrderUnitsFulfilled: Array<ProducerSalesOrderUnitsFulfilled>;
  producers: Array<Producer>;
  product: Product;
  productPackageType: ProductPackageType;
  productPackageTypes: Array<ProductPackageType>;
  region: RegionV2;
  regionPlatformFees: Array<RegionPlatformFee>;
  regions: Array<RegionV2>;
  retailer: Retailer;
  retailerSalesOrder: RetailerSalesOrder;
  retailerSalesOrderQueries: RetailerSalesOrderQueries;
  retailers: Array<Retailer>;
  searchOfferWindows: PaginatedOfferWindows;
  searchOffers: PaginatedOffers;
  searchProducts: PaginatedProducts;
  states: Array<StateV2>;
  statesWhereRegionExists: Array<StateV2>;
  whoAmI: Maybe<User>;
};


export type QueryAutocompleteArgs = {
  field: InputMaybe<Scalars['String']>;
  model: Models;
  query: Scalars['String'];
};


export type QueryBusinessArgs = {
  id: Scalars['Int'];
};


export type QueryCanOfferProductArgs = {
  offerWindowId: InputMaybe<Scalars['Int']>;
  productId: Scalars['Int'];
};


export type QueryDeliveryAgingReportArgs = {
  filters: InputMaybe<DeliveryAgingReportFilterInput>;
  pagination: OffsetPaginationInput;
};


export type QueryDistributorArgs = {
  id: Scalars['Int'];
};


export type QueryDwollaEmailNotificationArgs = {
  id: Scalars['Int'];
};


export type QueryDwollaEmailNotificationsArgs = {
  dwollaCustomerID: Scalars['String'];
};


export type QueryFreightAgingReportArgs = {
  filters: InputMaybe<FreightAgingReportFilterInput>;
  pagination: OffsetPaginationInput;
};


export type QueryFundsTransferArgs = {
  id: Scalars['Int'];
};


export type QueryFundsTransfersArgs = {
  monthFilter: InputMaybe<Scalars['String']>;
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetOfferableProductArgs = {
  productId: Scalars['Int'];
};


export type QueryGetRetailerSalesOrdersArgs = {
  filters: InputMaybe<RetailerSalesOrdersFilters>;
  pagination: OffsetPaginationInput;
};


export type QueryGetShopifyUrlWithLoginTokenArgs = {
  organizationId: Scalars['Int'];
  path: InputMaybe<Scalars['String']>;
};


export type QueryGlobalSearchArgs = {
  query: Scalars['String'];
};


export type QueryInvoiceArgs = {
  id: Scalars['Int'];
};


export type QueryLicenseArgs = {
  licenseId: Scalars['Int'];
};


export type QueryLicenseNotificationArgs = {
  licenseId: Scalars['Int'];
  licensePeriodId: Scalars['Int'];
  notificationType: NotificationType;
};


export type QueryLogisticsPartnerArgs = {
  id: Scalars['Int'];
};


export type QueryOfferArgs = {
  id: Scalars['Int'];
};


export type QueryOfferWindowArgs = {
  id: Scalars['Int'];
};


export type QueryOrderArgs = {
  id: Scalars['Int'];
};


export type QueryOrderDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryOrganizationArgs = {
  id: Scalars['Int'];
};


export type QueryPaginatedPreSalesArgs = {
  filters: InputMaybe<PreSalesFilterData>;
  pagination: OffsetPaginationInput;
};


export type QueryPaginatedProducerPurchaseOrdersArgs = {
  filters: InputMaybe<ProducerPurchaseOrdersFilterInput>;
  pagination: OffsetPaginationInput;
  sort: InputMaybe<ProducerPurchaseOrdersSortInput>;
};


export type QueryPaginatedProducerSalesByRegionArgs = {
  filters: ProducerSalesByRegionFilters;
  pagination: OffsetPaginationInput;
};


export type QueryPaginatedProducersArgs = {
  filters: InputMaybe<ProducersFilterData>;
  pagination: OffsetPaginationInput;
};


export type QueryPaginatedRetailersArgs = {
  filters: InputMaybe<RetailersFilterData>;
  pagination: OffsetPaginationInput;
};


export type QueryPaymentAgingReportArgs = {
  filters: InputMaybe<PaymentAgingReportFilterInput>;
  pagination: OffsetPaginationInput;
};


export type QueryPaymentSltArgs = {
  distributionModel: DistributionModel;
};


export type QueryPaymentStepSltArgs = {
  distributionModel: DistributionModel;
};


export type QueryPlaidItemArgs = {
  id: Scalars['Int'];
};


export type QueryPreSaleArgs = {
  id: Scalars['Int'];
};


export type QueryPreSaleImportJobArgs = {
  id: Scalars['Int'];
};


export type QueryPreSaleOrderArgs = {
  id: Scalars['Int'];
};


export type QueryProducerArgs = {
  id: Scalars['Int'];
};


export type QueryProducerPreSaleUnitsSoldArgs = {
  producerId: Scalars['Int'];
};


export type QueryProducerPurchaseOrderArgs = {
  id: Scalars['Int'];
};


export type QueryProducerRegionPlatformFeesArgs = {
  producerId: Scalars['Int'];
  regionId: Scalars['Int'];
};


export type QueryProducerSalesOrderUnitsFulfilledArgs = {
  producerId: Scalars['Int'];
};


export type QueryProductArgs = {
  id: Scalars['Int'];
};


export type QueryProductPackageTypeArgs = {
  id: Scalars['Int'];
};


export type QueryRegionArgs = {
  id: Scalars['Int'];
};


export type QueryRegionPlatformFeesArgs = {
  id: Scalars['Int'];
};


export type QueryRetailerArgs = {
  id: Scalars['Int'];
};


export type QueryRetailerSalesOrderArgs = {
  id: Scalars['Int'];
};


export type QuerySearchOfferWindowsArgs = {
  filters: InputMaybe<OfferWindowSearchFilters>;
  pagination: OffsetPaginationInput;
};


export type QuerySearchOffersArgs = {
  filters: InputMaybe<OfferSearchFilters>;
  pagination: OffsetPaginationInput;
};


export type QuerySearchProductsArgs = {
  filters: InputMaybe<ProductsFilterData>;
  pagination: OffsetPaginationInput;
};

export type RegionPlatformFee = {
  __typename: 'RegionPlatformFee';
  packageType: ProductPackageType;
  platformFee: Maybe<PackageTypePlatformFee>;
};

export type RegionV2 = {
  __typename: 'RegionV2';
  abbreviation: Scalars['String'];
  deliveryPartner: Maybe<Business>;
  friendlyName: Scalars['String'];
  id: Scalars['Int'];
  platformFees: Array<PackageTypePlatformFee>;
  shopifyIdentifier: Scalars['String'];
  state: StateV2;
};

export type RegisterRetailerOrganizationData = {
  businessName: Scalars['String'];
  forceDwollaBusinessCustomer: Scalars['Boolean'];
  organizationName: Scalars['String'];
  regionId: Scalars['Int'];
};

export type RetailLocationInput = {
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  regionId: Scalars['Int'];
};

export type Retailer = Business & {
  __typename: 'Retailer';
  address: Maybe<Address>;
  /** Default, active balance account. */
  balanceAccount: Maybe<BalanceAccount>;
  /** Default, active bank account. */
  bankAccount: Maybe<BankAccount>;
  bankAccounts: Array<BankAccount>;
  businessType: BusinessType;
  canDelete: Scalars['Boolean'];
  completedOnboardingAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  distributorAssignments: Array<DistributorRetailerAssignment>;
  dwollaCustomer: Maybe<DwollaCustomer>;
  /** External Funds Account used for manual transfers outside of our system. */
  externalFundsAccount: Maybe<ExternalFundsAccount>;
  fein: Maybe<Scalars['String']>;
  fundsTransfers: Array<FundsTransfer>;
  /** Identifier for this entity and it's parent business entity */
  id: Scalars['Int'];
  isAssignedToDistributor: Scalars['Boolean'];
  name: Scalars['String'];
  onboarding: Maybe<Onboarding>;
  organization: Organization;
  organizationId: Scalars['Int'];
  preSaleOrders: PaginatedPaginatedPreSaleOrders;
  regionV2: RegionV2;
  salesOrders: PaginatedRetailerSalesOrders;
  validBalanceAccount: Maybe<BalanceAccount>;
  validBalanceAccounts: Array<BalanceAccount>;
  validBankAccount: Maybe<BankAccount>;
  validBankAccounts: Array<BankAccount>;
};


export type RetailerIsAssignedToDistributorArgs = {
  distributorId: Scalars['Int'];
};


export type RetailerPreSaleOrdersArgs = {
  pagination: OffsetPaginationInput;
};


export type RetailerSalesOrdersArgs = {
  pagination: OffsetPaginationInput;
};

export type RetailerOrderAddData = {
  buyerId: Scalars['Int'];
  number: Scalars['String'];
  purchaseOrderId: Scalars['Int'];
};

export type RetailerOrderDeliveryAgingReportFilterInput = {
  regionId?: InputMaybe<Scalars['Int']>;
};

export type RetailerSalesOrder = FulfillmentOrder & Order & {
  __typename: 'RetailerSalesOrder';
  adjustmentItems: Array<AdjustmentItem>;
  adjustmentTotalInCents: Scalars['Int'];
  adjustmentUnitsTotal: Scalars['Int'];
  amountInCents: Scalars['Int'];
  auditLogs: Array<AuditLog>;
  balanceTransferStatus: LedgerStatus;
  balanceTransfers: Array<FundsTransfer>;
  bankDepositsLedger: Ledger;
  buyer: Business;
  buyerName: Scalars['String'];
  canCancel: ValidationResult;
  canSendPayment: ValidationResult;
  cancelledAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  deletedAt: Maybe<Scalars['DateTime']>;
  deliveredAt: Maybe<Scalars['DateTime']>;
  deliverySLT: ServiceLevelTarget;
  deliveryStatus: DeliveryStatus;
  deliveryStepSLT: ServiceLevelTarget;
  distributionModel: DistributionModel;
  distributorPurchaseOrder: Maybe<DistributorPurchaseOrder>;
  documents: Array<OrderDocument>;
  enabledFeatures: OrderEnabledFeatures;
  finalOrderTotalInCents: Scalars['Int'];
  freightSLT: ServiceLevelTarget;
  freightStepSLT: ServiceLevelTarget;
  id: Scalars['Int'];
  invoice: Maybe<Invoice>;
  items: Array<OrderItem>;
  number: Scalars['String'];
  packageSummary: Array<PackageSummaryItem>;
  paymentSLT: ServiceLevelTarget;
  paymentStatus: LedgerStatus;
  paymentStepSLT: ServiceLevelTarget;
  payments: Array<FundsTransfer>;
  paymentsLedger: Ledger;
  placedOn: Maybe<Scalars['DateTime']>;
  preSale: PreSale;
  producerPurchaseOrder: ProducerPurchaseOrder;
  regionV2: RegionV2;
  seller: Business;
  sendPaymentProposal: Maybe<TransferProposal>;
  shippingAddress: Maybe<Address>;
  totalPaymentDue: Scalars['Int'];
  trackingInformation: Maybe<TrackingInformation>;
  type: OrderType;
};

export type RetailerSalesOrderQueries = {
  __typename: 'RetailerSalesOrderQueries';
  deliveryAgingReport: PaginatedRetailerSalesOrders;
};


export type RetailerSalesOrderQueriesDeliveryAgingReportArgs = {
  filters: InputMaybe<RetailerOrderDeliveryAgingReportFilterInput>;
  pagination: OffsetPaginationInput;
};

export type RetailerSalesOrdersFilters = {
  retailerId: Scalars['Int'];
};

export type RetailersFilterData = {
  regionId?: InputMaybe<Scalars['Int']>;
  retailerId?: InputMaybe<Scalars['Int']>;
};

export enum SandboxProducerType {
  BreweryWithFundingSource = 'brewery_with_funding_source',
  BreweryWithPostSettlementFailableFundingSource = 'brewery_with_post_settlement_failable_funding_source',
  NewBrewery = 'new_brewery',
  OnboardingBankAccountBrewery = 'onboarding_bank_account_brewery'
}

export enum SandboxRetailerType {
  NewRetailer = 'new_retailer',
  NewRetailerWithFundingSource = 'new_retailer_with_funding_source'
}

export type SandboxSimulation = {
  __typename: 'SandboxSimulation';
  total: Scalars['Int'];
};

export type SendPaymentResult = {
  __typename: 'SendPaymentResult';
  fundsTransfer: FundsTransfer;
  order: Order;
};

export type ServiceLevelTarget = {
  __typename: 'ServiceLevelTarget';
  target: Scalars['Int'];
  warn: Scalars['Int'];
};

export type ShopifyUrlWithLoginTokenResponse = {
  __typename: 'ShopifyUrlWithLoginTokenResponse';
  shopifyUrlWithLoginToken: Maybe<Scalars['String']>;
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type StateV2 = {
  __typename: 'StateV2';
  distributionModel: DistributionModel;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum Status {
  Failed = 'failed',
  Pending = 'pending',
  Successful = 'successful'
}

export type TrackingInfoInput = {
  actualCostInCents?: InputMaybe<Scalars['Int']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  carrierId: Scalars['Int'];
  deliveredAt?: InputMaybe<Scalars['DateTime']>;
  estimatedArrivalDate?: InputMaybe<Scalars['DateTime']>;
  estimatedCostInCents?: InputMaybe<Scalars['Int']>;
  estimatedPickupDate?: InputMaybe<Scalars['DateTime']>;
  freightInvoiceNumber?: InputMaybe<Scalars['String']>;
  freightTrailerNumber?: InputMaybe<Scalars['String']>;
  palletCount?: InputMaybe<Scalars['Int']>;
  pickedUpAt?: InputMaybe<Scalars['DateTime']>;
  trackingLink?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type TrackingInformation = {
  __typename: 'TrackingInformation';
  actualCostInCents: Maybe<Scalars['Int']>;
  cancelledAt: Maybe<Scalars['DateTime']>;
  carrier: Carrier;
  deliveredAt: Maybe<Scalars['DateTime']>;
  estimatedArrivalDate: Maybe<Scalars['DateTime']>;
  estimatedCostInCents: Maybe<Scalars['Int']>;
  estimatedPickupDate: Maybe<Scalars['DateTime']>;
  freightInvoiceNumber: Maybe<Scalars['String']>;
  freightTrailerNumber: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  kuebixShipmentId: Maybe<Scalars['String']>;
  /** @deprecated Use deliveredAt */
  landingDate: Maybe<Scalars['DateTime']>;
  order: Order;
  orderId: Scalars['Int'];
  palletCount: Maybe<Scalars['Int']>;
  pickedUpAt: Maybe<Scalars['DateTime']>;
  status: FreightShipmentStatus;
  trackingLink: Maybe<Scalars['String']>;
  trackingNumber: Maybe<Scalars['String']>;
};

export type TransferProposal = {
  __typename: 'TransferProposal';
  amount: Scalars['Int'];
  breweryInvoiceNumber: Scalars['String'];
  destination: FundsAccount;
  settlementStrategy: Maybe<Scalars['String']>;
  source: FundsAccount;
  statementDescriptor: Maybe<Scalars['String']>;
};

export type UpdateBusinessEntityData = {
  fein?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UpdateDistributorDetailsData = {
  feePerPackageInCents: Scalars['Int'];
};

export type UpdateDistributorToProducerInput = {
  distributorId: Scalars['Int'];
  newDistributorId: Scalars['Int'];
  producerId: Scalars['Int'];
  regionId: Scalars['Int'];
};

export type UpdateDwollaCustomerInput = {
  dwollaCustomerId: Scalars['String'];
  email: Scalars['String'];
};

export type UpdateOrganizationData = {
  name: Scalars['String'];
};

export type UpdatePreSaleProducerFulfillmentExclusionInput = {
  excludeFromFulfillment: Scalars['Boolean'];
  exclusionReasonId?: InputMaybe<Scalars['Int']>;
  preSaleId: Scalars['Int'];
  producerId: Scalars['Int'];
};

export type UpdatePreSaleProductFulfillmentExclusionInput = {
  excludeFromFulfillment: Scalars['Boolean'];
  exclusionReasonId?: InputMaybe<Scalars['Int']>;
  preSaleId: Scalars['Int'];
  productId: Scalars['Int'];
};

export type UpdateProducerData = {
  fein?: InputMaybe<Scalars['String']>;
  globalBreweryId: Scalars['Int'];
  name: Scalars['String'];
  rating: Scalars['Float'];
};

export type UpdateProductInput = {
  abv?: InputMaybe<Scalars['Float']>;
  beerStyleId?: InputMaybe<Scalars['Int']>;
  breweryNetPrice?: InputMaybe<Scalars['Int']>;
  cloudinaryImageId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  packageDate?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Float']>;
};

export type User = {
  __typename: 'User';
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  hasAgreedToTermsOfService: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isGlobalAdmin: Scalars['Boolean'];
  organization: Maybe<Organization>;
  organizations: Array<Organization>;
};

export type ValidationResult = {
  __typename: 'ValidationResult';
  checks: Array<CheckResult>;
  description: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CreateDwollaEmailNotificationData = {
  dwollaWebhookTopic: Scalars['String'];
  from: Scalars['String'];
  retryCount?: InputMaybe<Scalars['Int']>;
  status: Status;
  to: Scalars['String'];
  toDwollaCustomerId: Scalars['String'];
};

export type AdminDashboardStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminDashboardStatisticsQuery = { __typename: 'Query', adminDashboardStatistics: { __typename: 'AdminDashboardStatistics', breweriesOnboarded: number, retailersOnboarded: number, distributorsOnboarded: number, totalPayments: number } | null };

export type AdminDeleteDistributorMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminDeleteDistributorMutation = { __typename: 'Mutation', deleteDistributor: { __typename: 'Distributor', id: number, name: string } };

export type AdminDistributorQueryVariables = Exact<{
  distributorId: Scalars['Int'];
}>;


export type AdminDistributorQuery = { __typename: 'Query', distributor: { __typename: 'Distributor', id: number, displayName: string, completedOnboardingAt: any | null, canDelete: boolean, feePerPackageInCents: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, createdAt: any }, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, requiresBeneficialOwnershipCertification: boolean } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, removedAt: any | null, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, itemId: string, verificationStatus: PlaidVerificationStatus | null } | null } | null } };

export type AdminDistributorDisplayFragment = { __typename: 'Distributor', id: number, displayName: string, organizationId: number };

export type AdminDistributorsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminDistributorsQuery = { __typename: 'Query', distributors: Array<{ __typename: 'Distributor', id: number, displayName: string, organizationId: number }> };

export type AdminDeliveryPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminDeliveryPartnersQuery = { __typename: 'Query', distributors: Array<{ __typename: 'Distributor', id: number, displayName: string }>, logisticsPartners: Array<{ __typename: 'LogisticsPartner', id: number, displayName: string }> };

export type AdminAddPlatformFeeMutationVariables = Exact<{
  data: PlatformFeeCreateInput;
}>;


export type AdminAddPlatformFeeMutation = { __typename: 'Mutation', addPlatformFee: { __typename: 'PackageTypePlatformFee', id: number, amount: number } | null };

export type AdminRegionPlatformFeesQueryVariables = Exact<{
  regionId: Scalars['Int'];
}>;


export type AdminRegionPlatformFeesQuery = { __typename: 'Query', regionPlatformFees: Array<{ __typename: 'RegionPlatformFee', packageType: { __typename: 'ProductPackageType', id: number, displayName: string }, platformFee: { __typename: 'PackageTypePlatformFee', id: number, amount: number } | null }> };

export type AdminUpdatePlatformFeeMutationVariables = Exact<{
  id: Scalars['Int'];
  data: PlatformFeeUpdateInput;
}>;


export type AdminUpdatePlatformFeeMutation = { __typename: 'Mutation', updatePlatformFee: { __typename: 'PackageTypePlatformFee', id: number, amount: number } | null };

export type PlatformFeeDetailsFragment = { __typename: 'PackageTypePlatformFee', id: number, amount: number };

export type AdminRegionAssignDeliveryDriverMutationVariables = Exact<{
  data: AssignRegionDeliveryPartnerInput;
}>;


export type AdminRegionAssignDeliveryDriverMutation = { __typename: 'Mutation', assignDeliveryPartner: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } | null } };

export type AdminRegionDeliveryPartnerDetailsFragment = { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } | null };

export type AdminRegionDeliveryPartnerDetailsQueryVariables = Exact<{
  regionId: Scalars['Int'];
}>;


export type AdminRegionDeliveryPartnerDetailsQuery = { __typename: 'Query', region: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } | null } };

export type AdminRegionDetailsFragment = { __typename: 'RegionV2', id: number, friendlyName: string, abbreviation: string, shopifyIdentifier: string, state: { __typename: 'StateV2', id: number, name: string }, deliveryPartner: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } | null };

export type AdminRegionDetailsQueryVariables = Exact<{
  regionId: Scalars['Int'];
}>;


export type AdminRegionDetailsQuery = { __typename: 'Query', region: { __typename: 'RegionV2', id: number, friendlyName: string, abbreviation: string, shopifyIdentifier: string, state: { __typename: 'StateV2', id: number, name: string }, deliveryPartner: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } | null } };

export type AdminRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminRegionsQuery = { __typename: 'Query', regions: Array<{ __typename: 'RegionV2', id: number, friendlyName: string, state: { __typename: 'StateV2', id: number, name: string } }> };

export type AdminRegionsTableRowDataFragment = { __typename: 'RegionV2', id: number, friendlyName: string, state: { __typename: 'StateV2', id: number, name: string } };

export type InviteGlobalAdminMutationVariables = Exact<{
  email: Scalars['String'];
  fullName: Scalars['String'];
}>;


export type InviteGlobalAdminMutation = { __typename: 'Mutation', inviteGlobalAdmin: { __typename: 'User', id: number, createdAt: any, isGlobalAdmin: boolean } };

export type SyncBeverageAdvisorsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncBeverageAdvisorsMutation = { __typename: 'Mutation', syncBeverageAdvisors: { __typename: 'BeverageAdvisors', id: number } | { __typename: 'Distributor', id: number } | { __typename: 'LogisticsPartner', id: number } | { __typename: 'Producer', id: number } | { __typename: 'Retailer', id: number } };

export type AdminGlobalSearchQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type AdminGlobalSearchQuery = { __typename: 'Query', globalSearch: { __typename: 'GlobalSearchResult', totalResults: number, producerPurchaseOrders: Array<{ __typename: 'ProducerPurchaseOrder', id: number, number: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }>, retailerSalesOrders: Array<{ __typename: 'RetailerSalesOrder', id: number, number: string, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }>, freightShipments: Array<{ __typename: 'TrackingInformation', id: number, orderId: number, trackingNumber: string | null }>, producers: Array<{ __typename: 'Producer', id: number, displayName: string, address: { __typename: 'Address', id: number | null, city: string, state: string } | null }>, logisticsPartners: Array<{ __typename: 'LogisticsPartner', id: number, displayName: string }>, retailers: Array<{ __typename: 'Retailer', id: number, displayName: string, address: { __typename: 'Address', id: number | null, city: string, state: string } | null }> } };

export type FreightShipmentSearchResultFragment = { __typename: 'TrackingInformation', id: number, orderId: number, trackingNumber: string | null };

export type LogisticsPartnerSearchResultFragment = { __typename: 'LogisticsPartner', id: number, displayName: string };

export type ProducerPurchaseOrderSearchResultFragment = { __typename: 'ProducerPurchaseOrder', id: number, number: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } };

export type ProducerSearchResultFragment = { __typename: 'Producer', id: number, displayName: string, address: { __typename: 'Address', id: number | null, city: string, state: string } | null };

export type RetailerSalesOrderSearchResultFragment = { __typename: 'RetailerSalesOrder', id: number, number: string, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } };

export type RetailerSearchResultFragment = { __typename: 'Retailer', id: number, displayName: string, address: { __typename: 'Address', id: number | null, city: string, state: string } | null };

export type AdminDeleteLogisticsPartnerMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminDeleteLogisticsPartnerMutation = { __typename: 'Mutation', deleteLogisticsPartner: { __typename: 'LogisticsPartner', id: number, name: string } };

export type AdminLogisticsPartnerQueryVariables = Exact<{
  logisticsPartnerId: Scalars['Int'];
}>;


export type AdminLogisticsPartnerQuery = { __typename: 'Query', logisticsPartner: { __typename: 'LogisticsPartner', id: number, displayName: string, completedOnboardingAt: any | null, canDelete: boolean, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, createdAt: any } } };

export type AdminLogisticsPartnerDisplayFragment = { __typename: 'LogisticsPartner', id: number, displayName: string, organizationId: number };

export type AdminLogisticsPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminLogisticsPartnersQuery = { __typename: 'Query', logisticsPartners: Array<{ __typename: 'LogisticsPartner', id: number, displayName: string, organizationId: number }> };

export type AddOfferMutationVariables = Exact<{
  data: OfferCreateInput;
}>;


export type AddOfferMutation = { __typename: 'Mutation', addOffer: { __typename: 'Offer', id: number, netPrice: number, platformPrice: number, wholesalePrice: number, quantity: number, canDelete: boolean, canUpdate: boolean, shopifyProductId: string | null, shopifyLink: string | null, earliestPickup: any | null, offerWindow: { __typename: 'OfferWindow', id: number }, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, canOfferProduct: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } } };

export type CanOfferProductQueryVariables = Exact<{
  productId: Scalars['Int'];
  offerWindowId: InputMaybe<Scalars['Int']>;
}>;


export type CanOfferProductQuery = { __typename: 'Query', canOfferProduct: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } };

export type AdminOfferWindowOfferFragment = { __typename: 'Offer', id: number, netPrice: number, platformPrice: number, wholesalePrice: number, quantity: number, canDelete: boolean, canUpdate: boolean, shopifyProductId: string | null, shopifyLink: string | null, earliestPickup: any | null, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, canOfferProduct: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } };

export type AdminOfferWindowOffersFragment = { __typename: 'OfferWindow', id: number, start: any, end: any, canUpdate: boolean, canDelete: boolean, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } };

export type AdminOfferWindowOffersQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminOfferWindowOffersQuery = { __typename: 'Query', offerWindow: { __typename: 'OfferWindow', id: number, start: any, end: any, canUpdate: boolean, canDelete: boolean, offers: Array<{ __typename: 'Offer', id: number, netPrice: number, platformPrice: number, wholesalePrice: number, quantity: number, canDelete: boolean, canUpdate: boolean, shopifyProductId: string | null, shopifyLink: string | null, earliestPickup: any | null, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, canOfferProduct: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type DeleteOfferMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteOfferMutation = { __typename: 'Mutation', removeOffer: { __typename: 'Offer', id: number, offerWindow: { __typename: 'OfferWindow', id: number, offers: Array<{ __typename: 'Offer', id: number, netPrice: number, platformPrice: number, wholesalePrice: number, quantity: number, canDelete: boolean, canUpdate: boolean, shopifyProductId: string | null, shopifyLink: string | null, earliestPickup: any | null, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, canOfferProduct: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> } } };

export type UpdateOfferMutationVariables = Exact<{
  id: Scalars['Int'];
  data: OfferUpdateInput;
}>;


export type UpdateOfferMutation = { __typename: 'Mutation', updateOffer: { __typename: 'Offer', id: number, offerWindow: { __typename: 'OfferWindow', id: number, offers: Array<{ __typename: 'Offer', id: number, netPrice: number, platformPrice: number, wholesalePrice: number, quantity: number, canDelete: boolean, canUpdate: boolean, shopifyProductId: string | null, shopifyLink: string | null, earliestPickup: any | null, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, canOfferProduct: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> } } };

export type DeleteOfferWindowMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteOfferWindowMutation = { __typename: 'Mutation', removeOfferWindow: { __typename: 'OfferWindow', id: number } };

export type UpdateOfferWindowMutationVariables = Exact<{
  id: Scalars['Int'];
  data: OfferWindowUpdateInput;
}>;


export type UpdateOfferWindowMutation = { __typename: 'Mutation', updateOfferWindow: { __typename: 'OfferWindow', id: number, start: any, end: any, canUpdate: boolean, canDelete: boolean, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type AddOfferWindowMutationVariables = Exact<{
  data: OfferWindowCreateInput;
}>;


export type AddOfferWindowMutation = { __typename: 'Mutation', addOfferWindow: { __typename: 'OfferWindow', id: number } };

export type AdminOfferWindowSearchQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: InputMaybe<OfferWindowSearchFilters>;
}>;


export type AdminOfferWindowSearchQuery = { __typename: 'Query', searchOfferWindows: { __typename: 'PaginatedOfferWindows', total: number, results: Array<{ __typename: 'OfferWindow', id: number, start: any, end: any, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } }> } };

export type AdminOfferWindowTableDataFragment = { __typename: 'OfferWindow', id: number, start: any, end: any, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } };

export type CloneOfferWindowMutationVariables = Exact<{
  originalOfferWindowId: Scalars['Int'];
  data: OfferWindowCloneInput;
}>;


export type CloneOfferWindowMutation = { __typename: 'Mutation', cloneOfferWindow: { __typename: 'OfferWindow', id: number } };

export type AdminPackagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminPackagesQuery = { __typename: 'Query', productPackageTypes: Array<{ __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel, containerVolume: number, containerVolumeUnit: ContainerVolumeUnit, containerStreetName: string | null, createdAt: any, weight: number, canDelete: boolean }> };

export type AddProductMutationVariables = Exact<{
  data: ProductInput;
}>;


export type AddProductMutation = { __typename: 'Mutation', addProduct: { __typename: 'Product', id: number, name: string } };

export type AdminDeleteProductMutationVariables = Exact<{
  productId: Scalars['Int'];
}>;


export type AdminDeleteProductMutation = { __typename: 'Mutation', deleteProduct: { __typename: 'Product', id: number, name: string } };

export type AdminProductQueryVariables = Exact<{
  productId: Scalars['Int'];
}>;


export type AdminProductQuery = { __typename: 'Query', product: { __typename: 'Product', id: number, createdAt: any, updatedAt: any, name: string, packageDate: any | null, abv: number | null, canDelete: boolean, description: string | null, rating: number | null, breweryNetPrice: number | null, canOfferProduct: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string }, beerStyle: { __typename: 'BeerStyle', id: number, name: string } | null, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } };

export type AdminProductDetailsFragment = { __typename: 'Product', id: number, createdAt: any, updatedAt: any, name: string, packageDate: any | null, abv: number | null, canDelete: boolean, description: string | null, rating: number | null, breweryNetPrice: number | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string }, beerStyle: { __typename: 'BeerStyle', id: number, name: string } | null, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null };

export type AdminProductsQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: InputMaybe<ProductsFilterData>;
}>;


export type AdminProductsQuery = { __typename: 'Query', searchProducts: { __typename: 'PaginatedProducts', total: number, results: Array<{ __typename: 'Product', id: number, createdAt: any, updatedAt: any, name: string, packageDate: any | null, abv: number | null, canDelete: boolean, description: string | null, rating: number | null, breweryNetPrice: number | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string }, beerStyle: { __typename: 'BeerStyle', id: number, name: string } | null, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null }> } };

export type DwollaCustomerBillingInfoFragment = { __typename: 'DwollaCustomer', id: string, email: string, status: DwollaCustomerVerificationStatus };

export type UpdateProductMutationVariables = Exact<{
  data: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename: 'Mutation', editProduct: { __typename: 'Product', id: number, name: string, packageDate: any | null, abv: number | null, description: string | null, breweryNetPrice: number | null, beerStyle: { __typename: 'BeerStyle', name: string, id: number } | null, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } };

export type AddTransferForOrderMutationVariables = Exact<{
  data: AddTransferForOrderData;
}>;


export type AddTransferForOrderMutation = { __typename: 'Mutation', addTransferForOrder: { __typename: 'FundsTransfer', id: number, amount: number, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } };

export type AdminOrderBalanceTransfersQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminOrderBalanceTransfersQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, number: string, balanceTransferStatus: LedgerStatus, amountInCents: number, canSendBalanceTransfer: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } } | { __typename: 'PreSaleOrder', id: number, number: string, balanceTransferStatus: LedgerStatus, amountInCents: number, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } } | { __typename: 'ProducerPurchaseOrder', id: number, number: string, balanceTransferStatus: LedgerStatus, amountInCents: number, canSendBalanceTransfer: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } } | { __typename: 'RetailerSalesOrder', id: number, number: string, balanceTransferStatus: LedgerStatus, amountInCents: number, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } } };

type OrderBalanceTransferBalances_DistributorPurchaseOrder_Fragment = { __typename: 'DistributorPurchaseOrder', id: number, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } };

type OrderBalanceTransferBalances_PreSaleOrder_Fragment = { __typename: 'PreSaleOrder', id: number, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } };

type OrderBalanceTransferBalances_ProducerPurchaseOrder_Fragment = { __typename: 'ProducerPurchaseOrder', id: number, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } };

type OrderBalanceTransferBalances_RetailerSalesOrder_Fragment = { __typename: 'RetailerSalesOrder', id: number, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } };

export type OrderBalanceTransferBalancesFragment = OrderBalanceTransferBalances_DistributorPurchaseOrder_Fragment | OrderBalanceTransferBalances_PreSaleOrder_Fragment | OrderBalanceTransferBalances_ProducerPurchaseOrder_Fragment | OrderBalanceTransferBalances_RetailerSalesOrder_Fragment;

export type SendBalanceTransferMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type SendBalanceTransferMutation = { __typename: 'Mutation', sendBalanceTransfer: { __typename: 'ProducerPurchaseOrderTransferResult', order: { __typename: 'ProducerPurchaseOrder', id: number, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, balanceTransferProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendBalanceTransfer: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } } };

export type SendBalanceTransferDetailsFragment = { __typename: 'ProducerPurchaseOrder', bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, balanceTransferProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendBalanceTransfer: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } };

export type SendBalanceTransferDataQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type SendBalanceTransferDataQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, balanceTransferProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendBalanceTransfer: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } | { __typename: 'PreSaleOrder', id: number } | { __typename: 'ProducerPurchaseOrder', id: number, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, balanceTransferProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendBalanceTransfer: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } | { __typename: 'RetailerSalesOrder', id: number } };

export type SendDistributorBalanceTransferMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type SendDistributorBalanceTransferMutation = { __typename: 'Mutation', sendDistributorBalanceTransfer: { __typename: 'DistributorPurchaseOrderTransferResult', order: { __typename: 'DistributorPurchaseOrder', id: number, bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, balanceTransferProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendBalanceTransfer: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } } };

export type SendDistributorBalanceTransferDetailsFragment = { __typename: 'DistributorPurchaseOrder', bankDepositsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, balanceTransferProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendBalanceTransfer: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } };

export type AddOrderDocumentMutationVariables = Exact<{
  data: OrderDocumentCreateData;
}>;


export type AddOrderDocumentMutation = { __typename: 'Mutation', addOrderDocument: { __typename: 'OrderDocument', id: number, order: { __typename: 'DistributorPurchaseOrder', id: number, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }> } | { __typename: 'PreSaleOrder', id: number, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }> } | { __typename: 'ProducerPurchaseOrder', id: number, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }> } | { __typename: 'RetailerSalesOrder', id: number, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }> } } };

export type AdminOrderDocumentsQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminOrderDocumentsQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, distributorFee: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } | { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } | { __typename: 'ProducerPurchaseOrder', id: number, platformFee: number, earliestPickup: any | null, producerInvoiceStatus: ProducerInvoiceStatus, deliveryStatus: DeliveryStatus, feeStatus: LedgerStatus, retailOrdersCount: number, deliveredRetailOrdersCount: number, paidRetailOrdersCount: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus } | null, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus } | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } | { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, deliveryStatus: DeliveryStatus, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } };

export type DeleteOrderDocumentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteOrderDocumentMutation = { __typename: 'Mutation', deleteOrderDocument: { __typename: 'OrderDocument', id: number, order: { __typename: 'DistributorPurchaseOrder', id: number, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }> } | { __typename: 'PreSaleOrder', id: number, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }> } | { __typename: 'ProducerPurchaseOrder', id: number, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }> } | { __typename: 'RetailerSalesOrder', id: number, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }> } } };

export type DeletePodDocumentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePodDocumentMutation = { __typename: 'Mutation', deletePODDocument: { __typename: 'OrderDocument', id: number, order: { __typename: 'DistributorPurchaseOrder', id: number, distributorFee: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } | { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } | { __typename: 'ProducerPurchaseOrder', id: number, platformFee: number, earliestPickup: any | null, producerInvoiceStatus: ProducerInvoiceStatus, deliveryStatus: DeliveryStatus, feeStatus: LedgerStatus, retailOrdersCount: number, deliveredRetailOrdersCount: number, paidRetailOrdersCount: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus } | null, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus } | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } | { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, deliveryStatus: DeliveryStatus, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } } };

export type AdminOrderAuditLogsQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminOrderAuditLogsQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, auditLogs: Array<{ __typename: 'AuditLog', id: number, occurredAt: any, changes: any | null, snapshot: any | null, message: string, user: { __typename: 'User', id: number, email: string } | null }> } | { __typename: 'PreSaleOrder', id: number, auditLogs: Array<{ __typename: 'AuditLog', id: number, occurredAt: any, changes: any | null, snapshot: any | null, message: string, user: { __typename: 'User', id: number, email: string } | null }> } | { __typename: 'ProducerPurchaseOrder', id: number, auditLogs: Array<{ __typename: 'AuditLog', id: number, occurredAt: any, changes: any | null, snapshot: any | null, message: string, user: { __typename: 'User', id: number, email: string } | null }> } | { __typename: 'RetailerSalesOrder', id: number, auditLogs: Array<{ __typename: 'AuditLog', id: number, occurredAt: any, changes: any | null, snapshot: any | null, message: string, user: { __typename: 'User', id: number, email: string } | null }> } };

export type AdjustmentReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdjustmentReasonsQuery = { __typename: 'Query', adjustmentReasons: Array<{ __typename: 'AdjustmentReason', id: number, label: string }> };

export type AdminAdjustmentItemFragment = { __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } };

export type AdminOrderItemFragment = { __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } };

export type AdminOrderItemsQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminOrderItemsQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, number: string, distributorFee: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, enabledFeatures: { __typename: 'OrderEnabledFeatures', canEditOrderItems: boolean, canEditAdjustmentItems: boolean, canViewAdjustments: boolean, canDeleteOrderItems: boolean }, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'PreSaleOrder', id: number, number: string, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, enabledFeatures: { __typename: 'OrderEnabledFeatures', canEditOrderItems: boolean, canEditAdjustmentItems: boolean, canViewAdjustments: boolean, canDeleteOrderItems: boolean }, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'ProducerPurchaseOrder', id: number, number: string, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, enabledFeatures: { __typename: 'OrderEnabledFeatures', canEditOrderItems: boolean, canEditAdjustmentItems: boolean, canViewAdjustments: boolean, canDeleteOrderItems: boolean }, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'RetailerSalesOrder', id: number, number: string, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, enabledFeatures: { __typename: 'OrderEnabledFeatures', canEditOrderItems: boolean, canEditAdjustmentItems: boolean, canViewAdjustments: boolean, canDeleteOrderItems: boolean }, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } };

type AdminOrderItemsData_DistributorPurchaseOrder_Fragment = { __typename: 'DistributorPurchaseOrder', distributorFee: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> };

type AdminOrderItemsData_PreSaleOrder_Fragment = { __typename: 'PreSaleOrder', type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> };

type AdminOrderItemsData_ProducerPurchaseOrder_Fragment = { __typename: 'ProducerPurchaseOrder', type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> };

type AdminOrderItemsData_RetailerSalesOrder_Fragment = { __typename: 'RetailerSalesOrder', type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> };

export type AdminOrderItemsDataFragment = AdminOrderItemsData_DistributorPurchaseOrder_Fragment | AdminOrderItemsData_PreSaleOrder_Fragment | AdminOrderItemsData_ProducerPurchaseOrder_Fragment | AdminOrderItemsData_RetailerSalesOrder_Fragment;

export type DeleteProductFromPurchaseOrderMutationVariables = Exact<{
  orderId: Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type DeleteProductFromPurchaseOrderMutation = { __typename: 'Mutation', deleteProductFromPurchaseOrder: { __typename: 'DistributorPurchaseOrder', id: number, distributorFee: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'PreSaleOrder', id: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'ProducerPurchaseOrder', id: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'RetailerSalesOrder', id: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } };

export type AdminOrderItemsUpdateMutationVariables = Exact<{
  id: Scalars['Int'];
  data: OrderUpdateData;
}>;


export type AdminOrderItemsUpdateMutation = { __typename: 'Mutation', updateOrder: { __typename: 'DistributorPurchaseOrder', id: number, distributorFee: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'PreSaleOrder', id: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'ProducerPurchaseOrder', id: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'RetailerSalesOrder', id: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } };

export type AddPodDocumentMutationVariables = Exact<{
  data: OrderPodDocumentCreateData;
}>;


export type AddPodDocumentMutation = { __typename: 'Mutation', addPODDocument: { __typename: 'OrderDocument', id: number, order: { __typename: 'DistributorPurchaseOrder', id: number, distributorFee: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } | { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } | { __typename: 'ProducerPurchaseOrder', id: number, platformFee: number, earliestPickup: any | null, producerInvoiceStatus: ProducerInvoiceStatus, deliveryStatus: DeliveryStatus, feeStatus: LedgerStatus, retailOrdersCount: number, deliveredRetailOrdersCount: number, paidRetailOrdersCount: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus } | null, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus } | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } | { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, deliveryStatus: DeliveryStatus, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any, notes: string | null, fileUrl: string, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number } } } };

export type AdminOrderOverviewQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminOrderOverviewQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, distributorFee: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> } | { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, canCancel: { __typename: 'ValidationResult', isValid: boolean }, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> } | { __typename: 'ProducerPurchaseOrder', id: number, platformFee: number, earliestPickup: any | null, producerInvoiceStatus: ProducerInvoiceStatus, deliveryStatus: DeliveryStatus, feeStatus: LedgerStatus, retailOrdersCount: number, deliveredRetailOrdersCount: number, paidRetailOrdersCount: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, canCancel: { __typename: 'ValidationResult', isValid: boolean }, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus } | null, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus } | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> } | { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, deliveryStatus: DeliveryStatus, canCancel: { __typename: 'ValidationResult', isValid: boolean }, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> } };

type AdminOrderSummary_DistributorPurchaseOrder_Fragment = { __typename: 'DistributorPurchaseOrder', distributorFee: number, id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> };

type AdminOrderSummary_PreSaleOrder_Fragment = { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> };

type AdminOrderSummary_ProducerPurchaseOrder_Fragment = { __typename: 'ProducerPurchaseOrder', platformFee: number, earliestPickup: any | null, producerInvoiceStatus: ProducerInvoiceStatus, deliveryStatus: DeliveryStatus, feeStatus: LedgerStatus, retailOrdersCount: number, deliveredRetailOrdersCount: number, paidRetailOrdersCount: number, id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus } | null, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus } | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> };

type AdminOrderSummary_RetailerSalesOrder_Fragment = { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, deliveryStatus: DeliveryStatus, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> };

export type AdminOrderSummaryFragment = AdminOrderSummary_DistributorPurchaseOrder_Fragment | AdminOrderSummary_PreSaleOrder_Fragment | AdminOrderSummary_ProducerPurchaseOrder_Fragment | AdminOrderSummary_RetailerSalesOrder_Fragment;

export type AdminOrderPaymentsQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminOrderPaymentsQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, number: string, amountInCents: number, enabledFeatures: { __typename: 'OrderEnabledFeatures', canMakePayment: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } } | { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, enabledFeatures: { __typename: 'OrderEnabledFeatures', canMakePayment: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } } | { __typename: 'ProducerPurchaseOrder', id: number, number: string, amountInCents: number, canSendAdjustmentsPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canMakePayment: boolean }, adjustmentPaymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, distributorPaymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus } | null, canSendDistributorPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } | { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, canSendPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canMakePayment: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } } };

export type DistributorPaymentBalancesFragment = { __typename: 'ProducerPurchaseOrder', distributorPaymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus } | null, canSendDistributorPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } };

type OrderPaymentBalances_DistributorPurchaseOrder_Fragment = { __typename: 'DistributorPurchaseOrder', id: number, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } };

type OrderPaymentBalances_PreSaleOrder_Fragment = { __typename: 'PreSaleOrder', id: number, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } };

type OrderPaymentBalances_ProducerPurchaseOrder_Fragment = { __typename: 'ProducerPurchaseOrder', id: number, adjustmentPaymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } };

type OrderPaymentBalances_RetailerSalesOrder_Fragment = { __typename: 'RetailerSalesOrder', id: number, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } };

export type OrderPaymentBalancesFragment = OrderPaymentBalances_DistributorPurchaseOrder_Fragment | OrderPaymentBalances_PreSaleOrder_Fragment | OrderPaymentBalances_ProducerPurchaseOrder_Fragment | OrderPaymentBalances_RetailerSalesOrder_Fragment;

export type SendAdjustmentsPaymentMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type SendAdjustmentsPaymentMutation = { __typename: 'Mutation', sendAdjustmentsPayment: { __typename: 'ProducerPurchaseOrderTransferResult', order: { __typename: 'ProducerPurchaseOrder', id: number, adjustmentPaymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, adjustmentsPaymentProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendAdjustmentsPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } } };

export type SendAdjustmentsPaymentDataQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type SendAdjustmentsPaymentDataQuery = { __typename: 'Query', producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, adjustmentPaymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, adjustmentsPaymentProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendAdjustmentsPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } };

export type SendAdjustmentsPaymentDetailsFragment = { __typename: 'ProducerPurchaseOrder', adjustmentPaymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, adjustmentsPaymentProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendAdjustmentsPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } };

export type SendDistributorPaymentMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type SendDistributorPaymentMutation = { __typename: 'Mutation', sendDistributorPayment: { __typename: 'ProducerPurchaseOrderTransferResult', order: { __typename: 'ProducerPurchaseOrder', id: number, distributorPaymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } | null, distributorPaymentProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendDistributorPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } } };

export type SendDistributorPaymentDataQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type SendDistributorPaymentDataQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number } | { __typename: 'PreSaleOrder', id: number } | { __typename: 'ProducerPurchaseOrder', id: number, distributorPaymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } | null, distributorPaymentProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendDistributorPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } | { __typename: 'RetailerSalesOrder', id: number } };

export type SendDistributorPaymentDetailsFragment = { __typename: 'ProducerPurchaseOrder', distributorPaymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } | null, distributorPaymentProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendDistributorPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } };

export type SendRetailerPaymentMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type SendRetailerPaymentMutation = { __typename: 'Mutation', sendRetailerPayment: { __typename: 'SendPaymentResult', order: { __typename: 'DistributorPurchaseOrder', id: number } | { __typename: 'PreSaleOrder', id: number } | { __typename: 'ProducerPurchaseOrder', id: number } | { __typename: 'RetailerSalesOrder', id: number, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, sendPaymentProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } } | null };

export type SendRetailerPaymentDataQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type SendRetailerPaymentDataQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number } | { __typename: 'PreSaleOrder', id: number } | { __typename: 'ProducerPurchaseOrder', id: number } | { __typename: 'RetailerSalesOrder', id: number, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, sendPaymentProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } };

export type SendRetailerPaymentDetailsFragment = { __typename: 'RetailerSalesOrder', paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, sendPaymentProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canSendPayment: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } };

export type AdminRetailerOrderSummaryFragment = { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, createdAt: any, deliveredAt: any | null, paymentStatus: LedgerStatus, cancelledAt: any | null, deliveryStatus: DeliveryStatus, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } };

export type AdminOrderRetailerOrdersQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminOrderRetailerOrdersQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, retailerSalesOrders: Array<{ __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, createdAt: any, deliveredAt: any | null, paymentStatus: LedgerStatus, cancelledAt: any | null, deliveryStatus: DeliveryStatus, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }> } | { __typename: 'PreSaleOrder', id: number } | { __typename: 'ProducerPurchaseOrder', id: number, retailerSalesOrders: Array<{ __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, createdAt: any, deliveredAt: any | null, paymentStatus: LedgerStatus, cancelledAt: any | null, deliveryStatus: DeliveryStatus, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }> } | { __typename: 'RetailerSalesOrder', id: number } };

export type AddRetailerSalesOrderMutationVariables = Exact<{
  data: RetailerOrderAddData;
}>;


export type AddRetailerSalesOrderMutation = { __typename: 'Mutation', addRetailerSalesOrder: { __typename: 'RetailerSalesOrder', id: number, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, retailerSalesOrders: Array<{ __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, createdAt: any, deliveredAt: any | null, paymentStatus: LedgerStatus, cancelledAt: any | null, deliveryStatus: DeliveryStatus, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }>, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', id: number, retailerSalesOrders: Array<{ __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, createdAt: any, deliveredAt: any | null, paymentStatus: LedgerStatus, cancelledAt: any | null, deliveryStatus: DeliveryStatus, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }> } | null } } | null };

export type AdminOrderRouterQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminOrderRouterQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, type: OrderType, number: string, amountInCents: number, createdAt: any, cancelledAt: any | null, distributionModel: DistributionModel, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, number: string, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } | null }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreateChildRetailSaleOrder: boolean } } | { __typename: 'PreSaleOrder', id: number, type: OrderType, number: string, amountInCents: number, createdAt: any, cancelledAt: any | null, distributionModel: DistributionModel, preSale: { __typename: 'PreSale', id: number, number: string }, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } | null }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreateChildRetailSaleOrder: boolean } } | { __typename: 'ProducerPurchaseOrder', platformFee: number, id: number, type: OrderType, number: string, amountInCents: number, createdAt: any, cancelledAt: any | null, distributionModel: DistributionModel, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', id: number, number: string } | null, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', id: number, externalInvoiceId: string | null } | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } | null }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreateChildRetailSaleOrder: boolean } } | { __typename: 'RetailerSalesOrder', id: number, type: OrderType, number: string, amountInCents: number, createdAt: any, cancelledAt: any | null, distributionModel: DistributionModel, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, number: string, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', id: number, number: string } | null, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } | null }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreateChildRetailSaleOrder: boolean } } };

export type AdminOrderShippingQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminOrderShippingQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, number: string, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean }, seller: { __typename: 'BeverageAdvisors', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Distributor', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'LogisticsPartner', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Producer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Retailer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } }, buyer: { __typename: 'BeverageAdvisors', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Distributor', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'LogisticsPartner', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Producer', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Retailer', id: number, organization: { __typename: 'Organization', email: string | null } }, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null, packageSummary: Array<{ __typename: 'PackageSummaryItem', totalQuantity: number, totalWeight: number, packageType: { __typename: 'ProductPackageType', id: number, displayName: string } }> } | { __typename: 'PreSaleOrder', id: number, number: string, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean }, seller: { __typename: 'BeverageAdvisors', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Distributor', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'LogisticsPartner', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Producer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Retailer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } }, buyer: { __typename: 'BeverageAdvisors', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Distributor', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'LogisticsPartner', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Producer', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Retailer', id: number, organization: { __typename: 'Organization', email: string | null } }, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null, packageSummary: Array<{ __typename: 'PackageSummaryItem', totalQuantity: number, totalWeight: number, packageType: { __typename: 'ProductPackageType', id: number, displayName: string } }> } | { __typename: 'ProducerPurchaseOrder', id: number, number: string, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean }, seller: { __typename: 'BeverageAdvisors', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Distributor', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'LogisticsPartner', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Producer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Retailer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } }, buyer: { __typename: 'BeverageAdvisors', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Distributor', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'LogisticsPartner', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Producer', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Retailer', id: number, organization: { __typename: 'Organization', email: string | null } }, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null, packageSummary: Array<{ __typename: 'PackageSummaryItem', totalQuantity: number, totalWeight: number, packageType: { __typename: 'ProductPackageType', id: number, displayName: string } }> } | { __typename: 'RetailerSalesOrder', id: number, number: string, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean }, seller: { __typename: 'BeverageAdvisors', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Distributor', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'LogisticsPartner', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Producer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Retailer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', email: string | null } }, buyer: { __typename: 'BeverageAdvisors', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Distributor', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'LogisticsPartner', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Producer', id: number, organization: { __typename: 'Organization', email: string | null } } | { __typename: 'Retailer', id: number, organization: { __typename: 'Organization', email: string | null } }, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null, packageSummary: Array<{ __typename: 'PackageSummaryItem', totalQuantity: number, totalWeight: number, packageType: { __typename: 'ProductPackageType', id: number, displayName: string } }> } };

export type AdminPackageSummaryTableDataFragment = { __typename: 'PackageSummaryItem', totalQuantity: number, totalWeight: number, packageType: { __typename: 'ProductPackageType', id: number, displayName: string } };

export type CreateKuebixShipmentMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type CreateKuebixShipmentMutation = { __typename: 'Mutation', createKuebixShipment: { __typename: 'ProducerPurchaseOrder', id: number, trackingInformation: { __typename: 'TrackingInformation', id: number, kuebixShipmentId: string | null } | null } };

export type UpdateOrderAddressMutationVariables = Exact<{
  data: AddressUpdateData;
  orderId: Scalars['Int'];
}>;


export type UpdateOrderAddressMutation = { __typename: 'Mutation', createOrUpdateAddress: { __typename: 'DistributorPurchaseOrder', id: number, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'PreSaleOrder', id: number, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'ProducerPurchaseOrder', id: number, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'RetailerSalesOrder', id: number, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } };

export type AddFeePaymentForOrderMutationVariables = Exact<{
  data: AddTransferForOrderData;
}>;


export type AddFeePaymentForOrderMutation = { __typename: 'Mutation', addFeePaymentForOrder: { __typename: 'FundsTransfer', isFee: boolean, id: number, amount: number, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } };

export type AdminPlatformFeeFieldsFragment = { __typename: 'ProducerPurchaseOrder', missingPlatformFeeConfiguration: boolean | null, platformFeeCalculated: number, platformFeeOverride: number | null, platformFee: number, feesPayments: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }>, canCollectPlatformFee: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, platformFeeLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus } };

export type AdminOrderPlatformFeesQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminOrderPlatformFeesQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, number: string, amountInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, enabledFeatures: { __typename: 'OrderEnabledFeatures', canMakePayment: boolean, canMakeFeePayment: boolean }, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } | { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, enabledFeatures: { __typename: 'OrderEnabledFeatures', canMakePayment: boolean, canMakeFeePayment: boolean }, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } | { __typename: 'ProducerPurchaseOrder', id: number, number: string, amountInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, missingPlatformFeeConfiguration: boolean | null, platformFeeCalculated: number, platformFeeOverride: number | null, platformFee: number, platformFeesBreakdown: Array<{ __typename: 'PlatformFeesBreakdownResult', productName: string, packageTypeName: string, finalQuantity: number, producerPlatformFee: number | null, globalPlatformFee: number, platformFeesTotal: number, finalTotal: number }>, enabledFeatures: { __typename: 'OrderEnabledFeatures', canMakePayment: boolean, canMakeFeePayment: boolean }, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, feesPayments: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }>, canCollectPlatformFee: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> }, platformFeeLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus } } | { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, enabledFeatures: { __typename: 'OrderEnabledFeatures', canMakePayment: boolean, canMakeFeePayment: boolean }, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type AdminRefreshPlatformFeeMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminRefreshPlatformFeeMutation = { __typename: 'Mutation', refreshPlatformFee: { __typename: 'ProducerPurchaseOrder', id: number, platformFee: number, platformFeeCalculated: number, platformFeeOverride: number | null } };

export type CollectPlatformFeeMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type CollectPlatformFeeMutation = { __typename: 'Mutation', collectPlatformFee: { __typename: 'ProducerPurchaseOrderTransferResult', order: { __typename: 'ProducerPurchaseOrder', id: number, platformFeeLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, collectPlatformFeeProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canCollectPlatformFee: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } } };

export type CollectPlatformFeeDataQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type CollectPlatformFeeDataQuery = { __typename: 'Query', producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, platformFeeLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, collectPlatformFeeProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canCollectPlatformFee: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } };

export type CollectPlatformFeeDetailsFragment = { __typename: 'ProducerPurchaseOrder', platformFeeLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, collectPlatformFeeProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canCollectPlatformFee: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } };

export type FeePaymentFieldsFragment = { __typename: 'FundsTransfer', isFee: boolean, id: number, amount: number, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } };

export type MarkPlatformFeePaidMutationVariables = Exact<{
  orderId: Scalars['Int'];
  paymentDate: Scalars['String'];
  invoiceNumber: Scalars['String'];
}>;


export type MarkPlatformFeePaidMutation = { __typename: 'Mutation', markPlatformFeePaid: { __typename: 'ProducerPurchaseOrderTransferResult', order: { __typename: 'ProducerPurchaseOrder', id: number, platformFeeLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> }, collectPlatformFeeProposal: { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null, canCollectPlatformFee: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } } };

export type PlatformFeeBalancesFragment = { __typename: 'ProducerPurchaseOrder', platformFee: number, platformFeeLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus } };

export type UpdatePlatformFeeMutationVariables = Exact<{
  id: Scalars['Int'];
  platformFeeOverride: InputMaybe<Scalars['Int']>;
}>;


export type UpdatePlatformFeeMutation = { __typename: 'Mutation', updateProducerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, platformFee: number, platformFeeCalculated: number, platformFeeOverride: number | null, platformFeeLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus } } };

export type CancelPreSaleOrderMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type CancelPreSaleOrderMutation = { __typename: 'Mutation', cancelPreSaleOrder: { __typename: 'PreSaleOrder', id: number, cancelledAt: any | null, canCancel: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } | null };

export type CancelProducerPurchaseOrderMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type CancelProducerPurchaseOrderMutation = { __typename: 'Mutation', cancelProducerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, canCancel: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } };

export type CancelSalesOrderMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type CancelSalesOrderMutation = { __typename: 'Mutation', cancelRetailerSalesOrder: { __typename: 'RetailerSalesOrder', id: number, cancelledAt: any | null, canCancel: { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> } } | null };

export type DeleteOrderMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteOrderMutation = { __typename: 'Mutation', deleteOrder: { __typename: 'DistributorPurchaseOrder', id: number } | { __typename: 'PreSaleOrder', id: number } | { __typename: 'ProducerPurchaseOrder', id: number } | { __typename: 'RetailerSalesOrder', id: number } };

export type AdminOrderTransferQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type AdminOrderTransferQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, invoice: { __typename: 'Invoice', id: number, externalInvoiceId: string | null, externalAmountInCents: number | null } | null }, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } } | { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } } | { __typename: 'ProducerPurchaseOrder', platformFee: number, id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, invoice: { __typename: 'Invoice', id: number, externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } } | { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, invoice: { __typename: 'Invoice', id: number, externalInvoiceId: string | null, externalAmountInCents: number | null } | null }, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } } };

type AdminOrderTransferDetails_DistributorPurchaseOrder_Fragment = { __typename: 'DistributorPurchaseOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, invoice: { __typename: 'Invoice', id: number, externalInvoiceId: string | null, externalAmountInCents: number | null } | null }, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } };

type AdminOrderTransferDetails_PreSaleOrder_Fragment = { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } };

type AdminOrderTransferDetails_ProducerPurchaseOrder_Fragment = { __typename: 'ProducerPurchaseOrder', platformFee: number, id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, invoice: { __typename: 'Invoice', id: number, externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } };

type AdminOrderTransferDetails_RetailerSalesOrder_Fragment = { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, invoice: { __typename: 'Invoice', id: number, externalInvoiceId: string | null, externalAmountInCents: number | null } | null }, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType, validBankAccount: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } };

export type AdminOrderTransferDetailsFragment = AdminOrderTransferDetails_DistributorPurchaseOrder_Fragment | AdminOrderTransferDetails_PreSaleOrder_Fragment | AdminOrderTransferDetails_ProducerPurchaseOrder_Fragment | AdminOrderTransferDetails_RetailerSalesOrder_Fragment;

export type BeverageAdvisorsQueryVariables = Exact<{ [key: string]: never; }>;


export type BeverageAdvisorsQuery = { __typename: 'Query', beverageAdvisors: { __typename: 'BeverageAdvisors', id: number, displayName: string, fein: string | null, businessType: BusinessType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus } | null, validBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null, validBalanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } };

export type UpdateOrderMutationVariables = Exact<{
  id: Scalars['Int'];
  data: OrderUpdateData;
}>;


export type UpdateOrderMutation = { __typename: 'Mutation', updateOrder: { __typename: 'DistributorPurchaseOrder', distributorFee: number, id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> } | { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> } | { __typename: 'ProducerPurchaseOrder', platformFee: number, earliestPickup: any | null, producerInvoiceStatus: ProducerInvoiceStatus, deliveryStatus: DeliveryStatus, feeStatus: LedgerStatus, retailOrdersCount: number, deliveredRetailOrdersCount: number, paidRetailOrdersCount: number, id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus } | null, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus } | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> } | { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, adjustmentTotalInCents: number, finalOrderTotalInCents: number, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, cancelledAt: any | null, deliveredAt: any | null, deliveryStatus: DeliveryStatus, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, displayName: string, businessType: BusinessType }, preSale: { __typename: 'PreSale', id: number, number: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean, canDeleteOrder: boolean, canEditOrder: boolean, canEditOrderItems: boolean, canViewAdjustments: boolean, canCreatePDFBundle: boolean }, paymentsLedger: { __typename: 'Ledger', id: number, total: number }, documents: Array<{ __typename: 'OrderDocument', id: number, name: string, documentType: DocumentType, createdAt: any }> } };

export type UpdateOrderDataQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateOrderDataQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, type: OrderType, number: string, cancelledAt: any | null, deliveredAt: any | null, placedOn: any | null, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null } | { __typename: 'PreSaleOrder', id: number, type: OrderType, number: string, cancelledAt: any | null, deliveredAt: any | null, placedOn: any | null, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null } | { __typename: 'ProducerPurchaseOrder', id: number, type: OrderType, number: string, cancelledAt: any | null, deliveredAt: any | null, placedOn: any | null, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null } | { __typename: 'RetailerSalesOrder', id: number, type: OrderType, number: string, cancelledAt: any | null, deliveredAt: any | null, placedOn: any | null, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null } };

export type AddTrackingMutationVariables = Exact<{
  data: TrackingInfoInput;
  orderId: Scalars['Int'];
}>;


export type AddTrackingMutation = { __typename: 'Mutation', addTracking: { __typename: 'DistributorPurchaseOrder', id: number, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null } | { __typename: 'PreSaleOrder', id: number, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null } | { __typename: 'ProducerPurchaseOrder', id: number, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null } | { __typename: 'RetailerSalesOrder', id: number, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null } };

export type AllCarriersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCarriersQuery = { __typename: 'Query', allCarriers: Array<{ __typename: 'Carrier', displayName: string, id: number }> };

export type UpdateTrackingMutationVariables = Exact<{
  trackingId: Scalars['Int'];
  data: TrackingInfoInput;
}>;


export type UpdateTrackingMutation = { __typename: 'Mutation', updateTracking: { __typename: 'DistributorPurchaseOrder', trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null } | { __typename: 'PreSaleOrder', trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null } | { __typename: 'ProducerPurchaseOrder', trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null } | { __typename: 'RetailerSalesOrder', trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null } };

export type TrackingInformationDetailsFragment = { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } };

export type PreSaleImportJobQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PreSaleImportJobQuery = { __typename: 'Query', preSaleImportJob: { __typename: 'PreSaleImportJob', id: number, createdAt: any, start: any, end: any, status: PreSaleImportJobStatus, failureReason: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type AdminAddPresaleImportJobsMutationVariables = Exact<{
  regions: Array<Scalars['Int']> | Scalars['Int'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type AdminAddPresaleImportJobsMutation = { __typename: 'Mutation', addPresaleImportJobs: Array<{ __typename: 'PreSaleImportJob', id: number } | null> };

export type PreSaleImportJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type PreSaleImportJobsQuery = { __typename: 'Query', preSaleImportJobs: Array<{ __typename: 'PreSaleImportJob', id: number, createdAt: any, start: any, end: any, status: PreSaleImportJobStatus, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } }> };

export type PreSaleImportJobDetailsFragment = { __typename: 'PreSaleImportJob', id: number, createdAt: any, start: any, end: any, status: PreSaleImportJobStatus, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } };

export type PreSaleDisplayFragment = { __typename: 'PreSale', id: number, number: string, start: any, end: any, status: PreSaleStatus, orderCount: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } };

export type AddPreSaleOrderMutationVariables = Exact<{
  preSaleId: Scalars['Int'];
  storeId: Scalars['Int'];
}>;


export type AddPreSaleOrderMutation = { __typename: 'Mutation', createPreSaleOrder: { __typename: 'PreSaleOrder', id: number, preSale: { __typename: 'PreSale', id: number, orders: Array<{ __typename: 'PreSaleOrder', id: number, shopifyId: string | null, number: string, amountInCents: number, createdAt: any, cancelledAt: any | null, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }> } } | null };

export type AdminPreSaleOrdersQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminPreSaleOrdersQuery = { __typename: 'Query', preSale: { __typename: 'PreSale', id: number, number: string, start: any, end: any, status: PreSaleStatus, orderCount: number, orders: Array<{ __typename: 'PreSaleOrder', id: number, shopifyId: string | null, number: string, amountInCents: number, createdAt: any, cancelledAt: any | null, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type PreSaleOrderTableDataFragment = { __typename: 'PreSaleOrder', id: number, shopifyId: string | null, number: string, amountInCents: number, createdAt: any, cancelledAt: any | null, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } };

export type AdminPreSaleQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminPreSaleQuery = { __typename: 'Query', preSale: { __typename: 'PreSale', id: number, number: string, start: any, end: any, status: PreSaleStatus, orderCount: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type AdminPreSaleOrderItemsQueryVariables = Exact<{
  orderId: Scalars['Int'];
  preSaleId: Scalars['Int'];
}>;


export type AdminPreSaleOrderItemsQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, number: string, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, enabledFeatures: { __typename: 'OrderEnabledFeatures', canEditOrderItems: boolean, canDeleteOrderItems: boolean }, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> } | { __typename: 'PreSaleOrder', id: number, number: string, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, enabledFeatures: { __typename: 'OrderEnabledFeatures', canEditOrderItems: boolean, canDeleteOrderItems: boolean }, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> } | { __typename: 'ProducerPurchaseOrder', id: number, number: string, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, enabledFeatures: { __typename: 'OrderEnabledFeatures', canEditOrderItems: boolean, canDeleteOrderItems: boolean }, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> } | { __typename: 'RetailerSalesOrder', id: number, number: string, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, enabledFeatures: { __typename: 'OrderEnabledFeatures', canEditOrderItems: boolean, canDeleteOrderItems: boolean }, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> }, preSale: { __typename: 'PreSale', id: number, number: string, start: any, end: any, status: PreSaleStatus, orderCount: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

type AdminPreSaleOrderItemsData_DistributorPurchaseOrder_Fragment = { __typename: 'DistributorPurchaseOrder', type: OrderType, amountInCents: number, finalOrderTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> };

type AdminPreSaleOrderItemsData_PreSaleOrder_Fragment = { __typename: 'PreSaleOrder', type: OrderType, amountInCents: number, finalOrderTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> };

type AdminPreSaleOrderItemsData_ProducerPurchaseOrder_Fragment = { __typename: 'ProducerPurchaseOrder', type: OrderType, amountInCents: number, finalOrderTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> };

type AdminPreSaleOrderItemsData_RetailerSalesOrder_Fragment = { __typename: 'RetailerSalesOrder', type: OrderType, amountInCents: number, finalOrderTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> };

export type AdminPreSaleOrderItemsDataFragment = AdminPreSaleOrderItemsData_DistributorPurchaseOrder_Fragment | AdminPreSaleOrderItemsData_PreSaleOrder_Fragment | AdminPreSaleOrderItemsData_ProducerPurchaseOrder_Fragment | AdminPreSaleOrderItemsData_RetailerSalesOrder_Fragment;

export type AdminPreSaleOrderItemFragment = { __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } };

export type AdminPreSaleOrderItemsUpdateMutationVariables = Exact<{
  id: Scalars['Int'];
  data: OrderUpdateData;
}>;


export type AdminPreSaleOrderItemsUpdateMutation = { __typename: 'Mutation', updateOrder: { __typename: 'DistributorPurchaseOrder', id: number, distributorFee: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'PreSaleOrder', id: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'ProducerPurchaseOrder', id: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } | { __typename: 'RetailerSalesOrder', id: number, type: OrderType, amountInCents: number, finalOrderTotalInCents: number, adjustmentTotalInCents: number, items: Array<{ __typename: 'OrderItem', productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }>, adjustmentItems: Array<{ __typename: 'AdjustmentItem', id: number, productId: number, units: number, total: number, wholesaleTotal: number, adjustmentReasonId: number, notes: string | null, orderItem: { __typename: 'OrderItem', pricePerUnit: number, wholesalePricePerUnit: number, productId: number, quantity: number, price: number, wholesalePrice: number, orderId: number, offerId: number | null, totalUnits: number, total: number, wholesaleTotal: number, finalQuantity: number, finalTotal: number, finalWholesaleTotal: number, finalQuantityDisplay: string, hasAdjustmentItems: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }, adjustmentReason: { __typename: 'AdjustmentReason', id: number, label: string } }> } };

export type AdminPreSaleProducerSummaryQueryVariables = Exact<{
  preSaleId: Scalars['Int'];
}>;


export type AdminPreSaleProducerSummaryQuery = { __typename: 'Query', preSale: { __typename: 'PreSale', id: number, preSaleProducerSummary: Array<{ __typename: 'PreSaleProducerSummary', producer: string, producerId: number, isExcluded: boolean, totalUnits: number, exclusionReason: { __typename: 'ProductFulfillmentExclusionReason', id: number, label: string } | null, packageTypes: Array<{ __typename: 'PreSaleProducerSummaryPackageType', count: number, packageType: string }> }> } };

export type AdminPreSaleProducerSummaryDisplayFragment = { __typename: 'PreSaleProducerSummary', producer: string, producerId: number, isExcluded: boolean, totalUnits: number, exclusionReason: { __typename: 'ProductFulfillmentExclusionReason', id: number, label: string } | null, packageTypes: Array<{ __typename: 'PreSaleProducerSummaryPackageType', count: number, packageType: string }> };

export type AdminPreSaleProducerSummaryPackageTypesFragment = { __typename: 'PreSaleProducerSummary', packageTypes: Array<{ __typename: 'PreSaleProducerSummaryPackageType', count: number, packageType: string }> };

export type AdminPreSaleProductsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminPreSaleProductsQuery = { __typename: 'Query', preSale: { __typename: 'PreSale', id: number, number: string, start: any, end: any, status: PreSaleStatus, orderCount: number, preSaleProducts: Array<{ __typename: 'PreSaleProduct', preSaleId: number, quantity: number, totalInCents: number, excludeFromFulfillment: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null }, productFulfillmentExclusionReason: { __typename: 'ProductFulfillmentExclusionReason', id: number, label: string } | null }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type AdminPreSalePurchaseOrdersQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminPreSalePurchaseOrdersQuery = { __typename: 'Query', preSale: { __typename: 'PreSale', id: number, number: string, start: any, end: any, status: PreSaleStatus, orderCount: number, purchaseOrders: Array<{ __typename: 'ProducerPurchaseOrder', id: number, number: string, amountInCents: number, createdAt: any, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, buyerName: string, deliveredAt: any | null, cancelledAt: any | null, feeStatus: LedgerStatus, producerInvoiceStatus: ProducerInvoiceStatus, deliveryStatus: DeliveryStatus, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus, estimatedArrivalDate: any | null } | null, preSale: { __typename: 'PreSale', regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } }, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus } | null }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type GenerateFulfillmentOrdersMutationVariables = Exact<{
  preSaleId: Scalars['Int'];
}>;


export type GenerateFulfillmentOrdersMutation = { __typename: 'Mutation', generateFulfillmentOrders: { __typename: 'PreSale', id: number, number: string, start: any, end: any, status: PreSaleStatus, orderCount: number, purchaseOrders: Array<{ __typename: 'ProducerPurchaseOrder', id: number, number: string, amountInCents: number, createdAt: any, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, buyerName: string, deliveredAt: any | null, cancelledAt: any | null, feeStatus: LedgerStatus, producerInvoiceStatus: ProducerInvoiceStatus, deliveryStatus: DeliveryStatus, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus, estimatedArrivalDate: any | null } | null, preSale: { __typename: 'PreSale', regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } }, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus } | null }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type PresaleProductDisplayFragment = { __typename: 'PreSaleProduct', preSaleId: number, quantity: number, totalInCents: number, excludeFromFulfillment: boolean, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null }, productFulfillmentExclusionReason: { __typename: 'ProductFulfillmentExclusionReason', id: number, label: string } | null };

export type PreSalesQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: InputMaybe<PreSalesFilterData>;
}>;


export type PreSalesQuery = { __typename: 'Query', paginatedPreSales: { __typename: 'PaginatedPreSales', total: number, results: Array<{ __typename: 'PreSale', id: number, number: string, start: any, end: any, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } }> } | null };

export type PreSalesDisplayFragment = { __typename: 'PreSale', id: number, number: string, start: any, end: any, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } };

export type AdminDeleteProducerMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminDeleteProducerMutation = { __typename: 'Mutation', deleteProducer: { __typename: 'Producer', id: number, name: string } };

export type AdminProducerQueryVariables = Exact<{
  producerId: Scalars['Int'];
}>;


export type AdminProducerQuery = { __typename: 'Query', producer: { __typename: 'Producer', id: number, displayName: string, globalBreweryId: number | null, fein: string | null, canDelete: boolean, organization: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, createdAt: any } } };

export type AdminProducerDetailsFragment = { __typename: 'Producer', id: number, displayName: string, globalBreweryId: number | null, rating: number | null, fein: string | null, completedOnboardingAt: any | null, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, createdAt: any }, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, requiresBeneficialOwnershipCertification: boolean } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, removedAt: any | null, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, itemId: string, verificationStatus: PlaidVerificationStatus | null } | null } | null };

export type AdminProducerDetailsQueryVariables = Exact<{
  producerId: Scalars['Int'];
}>;


export type AdminProducerDetailsQuery = { __typename: 'Query', producer: { __typename: 'Producer', id: number, displayName: string, globalBreweryId: number | null, rating: number | null, fein: string | null, completedOnboardingAt: any | null, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, createdAt: any }, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, requiresBeneficialOwnershipCertification: boolean } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, removedAt: any | null, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, itemId: string, verificationStatus: PlaidVerificationStatus | null } | null } | null } };

export type AdminProducerDistributionQueryVariables = Exact<{
  producerId: Scalars['Int'];
}>;


export type AdminProducerDistributionQuery = { __typename: 'Query', producer: { __typename: 'Producer', id: number, distributorAssignments: Array<{ __typename: 'DistributorProducerAssignment', id: string, distributorId: number, producerId: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } }> } };

export type AdminProducerLicensesQueryVariables = Exact<{
  producerId: Scalars['Int'];
}>;


export type AdminProducerLicensesQuery = { __typename: 'Query', producer: { __typename: 'Producer', id: number, licenses: Array<{ __typename: 'License', id: number, title: string, number: string, createdAt: any, documentUrl: string | null, stateV2: { __typename: 'StateV2', id: number, name: string }, currentLicensePeriod: { __typename: 'LicensePeriod', startDate: any, endDate: any } }> } };

export type AdminAddProducerPlatformFeeMutationVariables = Exact<{
  data: ProducerPlatformFeeCreateInput;
}>;


export type AdminAddProducerPlatformFeeMutation = { __typename: 'Mutation', addProducerPlatformFee: { __typename: 'ProducerPlatformFee', id: number, amount: number } | null };

export type AdminProducerRegionPlatformFeesQueryVariables = Exact<{
  producerId: Scalars['Int'];
  regionId: Scalars['Int'];
}>;


export type AdminProducerRegionPlatformFeesQuery = { __typename: 'Query', producerRegionPlatformFees: Array<{ __typename: 'ProducerRegionPlatformFee', packageType: { __typename: 'ProductPackageType', id: number, displayName: string }, platformFee: { __typename: 'ProducerPlatformFee', id: number, amount: number } | null }> };

export type AdminUpdateProducerPlatformFeeMutationVariables = Exact<{
  id: Scalars['Int'];
  data: ProducerPlatformFeeUpdateInput;
}>;


export type AdminUpdateProducerPlatformFeeMutation = { __typename: 'Mutation', updateProducerPlatformFee: { __typename: 'ProducerPlatformFee', id: number, amount: number } | null };

export type ProducerPlatformFeeDetailsFragment = { __typename: 'ProducerPlatformFee', id: number, amount: number };

export type AssignDistributorToProducerMutationVariables = Exact<{
  data: AssignDistributorToProducerInput;
}>;


export type AssignDistributorToProducerMutation = { __typename: 'Mutation', assignDistributorToProducer: { __typename: 'DistributorProducerAssignment', id: string, distributorId: number, producerId: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } | null };

export type DeleteDistributorProducerAssignmentMutationVariables = Exact<{
  data: DeleteDistributorFromProducerInput;
}>;


export type DeleteDistributorProducerAssignmentMutation = { __typename: 'Mutation', deleteDistributorProducerAssignment: { __typename: 'DistributorProducerAssignment', id: string, distributorId: number, producerId: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } | null };

export type UpdateDistributorProducerAssignmentMutationVariables = Exact<{
  data: UpdateDistributorToProducerInput;
}>;


export type UpdateDistributorProducerAssignmentMutation = { __typename: 'Mutation', updateDistributorProducerAssignment: { __typename: 'DistributorProducerAssignment', id: string, distributorId: number, producerId: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } | null };

export type AdminProducersQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: InputMaybe<ProducersFilterData>;
}>;


export type AdminProducersQuery = { __typename: 'Query', paginatedProducers: { __typename: 'PaginatedProducers', total: number, results: Array<{ __typename: 'Producer', id: number, displayName: string }> } };

export type AdminProducersTableDataFragment = { __typename: 'Producer', id: number, displayName: string };

export type DistributorProducerAssignmentFragment = { __typename: 'DistributorProducerAssignment', id: string, distributorId: number, producerId: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } };

export type AdminPurchaseOrdersQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: InputMaybe<ProducerPurchaseOrdersFilterInput>;
  sort: InputMaybe<ProducerPurchaseOrdersSortInput>;
}>;


export type AdminPurchaseOrdersQuery = { __typename: 'Query', paginatedProducerPurchaseOrders: { __typename: 'PaginatedProducerPurchaseOrders', total: number, results: Array<{ __typename: 'ProducerPurchaseOrder', id: number, number: string, amountInCents: number, createdAt: any, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, buyerName: string, deliveredAt: any | null, cancelledAt: any | null, feeStatus: LedgerStatus, producerInvoiceStatus: ProducerInvoiceStatus, deliveryStatus: DeliveryStatus, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus, estimatedArrivalDate: any | null } | null, preSale: { __typename: 'PreSale', regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } }, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus } | null }> } };

export type DeliveryAgingReportQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: InputMaybe<DeliveryAgingReportFilterInput>;
}>;


export type DeliveryAgingReportQuery = { __typename: 'Query', deliveryAgingReport: { __typename: 'PaginatedProducerPurchaseOrders', total: number, results: Array<{ __typename: 'ProducerPurchaseOrder', id: number, number: string, placedOn: any | null, retailOrdersCount: number, deliveredRetailOrdersCount: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', id: number, externalAmountInCents: number | null, externalInvoiceId: string | null } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus, estimatedArrivalDate: any | null, deliveredAt: any | null } | null }> }, deliverySLT: { __typename: 'ServiceLevelTarget', target: number, warn: number }, deliveryStepSLT: { __typename: 'ServiceLevelTarget', target: number, warn: number } };

export type DeliveryAgingReportResultFragment = { __typename: 'ProducerPurchaseOrder', id: number, number: string, placedOn: any | null, retailOrdersCount: number, deliveredRetailOrdersCount: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', id: number, externalAmountInCents: number | null, externalInvoiceId: string | null } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus, estimatedArrivalDate: any | null, deliveredAt: any | null } | null };

export type FreightAgingReportQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: InputMaybe<FreightAgingReportFilterInput>;
}>;


export type FreightAgingReportQuery = { __typename: 'Query', freightAgingReport: { __typename: 'PaginatedProducerPurchaseOrders', total: number, results: Array<{ __typename: 'ProducerPurchaseOrder', id: number, number: string, placedOn: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', id: number, externalAmountInCents: number | null, externalInvoiceId: string | null } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, estimatedArrivalDate: any | null } | null }> }, freightSLT: { __typename: 'ServiceLevelTarget', target: number, warn: number }, freightStepSLT: { __typename: 'ServiceLevelTarget', target: number, warn: number } };

export type FreightAgingReportResultFragment = { __typename: 'ProducerPurchaseOrder', id: number, number: string, placedOn: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', id: number, externalAmountInCents: number | null, externalInvoiceId: string | null } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, estimatedArrivalDate: any | null } | null };

export type PaymentAgingReportQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: InputMaybe<PaymentAgingReportFilterInput>;
}>;


export type PaymentAgingReportQuery = { __typename: 'Query', paymentAgingReport: { __typename: 'PaginatedProducerPurchaseOrders', total: number, results: Array<{ __typename: 'ProducerPurchaseOrder', id: number, number: string, placedOn: any | null, deliveredAt: any | null, deliveryStatus: DeliveryStatus, retailOrdersCount: number, paidRetailOrdersCount: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', id: number, externalAmountInCents: number | null, externalInvoiceId: string | null } | null, paymentsLedger: { __typename: 'Ledger', id: number, status: LedgerStatus }, paymentSLT: { __typename: 'ServiceLevelTarget', target: number, warn: number }, paymentStepSLT: { __typename: 'ServiceLevelTarget', target: number, warn: number } }> } };

export type PaymentAgingReportResultFragment = { __typename: 'ProducerPurchaseOrder', id: number, number: string, placedOn: any | null, deliveredAt: any | null, deliveryStatus: DeliveryStatus, retailOrdersCount: number, paidRetailOrdersCount: number, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', id: number, externalAmountInCents: number | null, externalInvoiceId: string | null } | null, paymentsLedger: { __typename: 'Ledger', id: number, status: LedgerStatus }, paymentSLT: { __typename: 'ServiceLevelTarget', target: number, warn: number }, paymentStepSLT: { __typename: 'ServiceLevelTarget', target: number, warn: number } };

export type RetailerSalesOrderDeliveryAgingReportQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: InputMaybe<RetailerOrderDeliveryAgingReportFilterInput>;
}>;


export type RetailerSalesOrderDeliveryAgingReportQuery = { __typename: 'Query', retailerSalesOrderQueries: { __typename: 'RetailerSalesOrderQueries', deliveryAgingReport: { __typename: 'PaginatedRetailerSalesOrders', total: number, results: Array<{ __typename: 'RetailerSalesOrder', id: number, number: string, placedOn: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, trackingInformation: { __typename: 'TrackingInformation', id: number, deliveredAt: any | null } | null } }> } }, deliverySLT: { __typename: 'ServiceLevelTarget', target: number, warn: number }, deliveryStepSLT: { __typename: 'ServiceLevelTarget', target: number, warn: number } };

export type RetailerSalesOrderDeliveryAgingReportResultFragment = { __typename: 'RetailerSalesOrder', id: number, number: string, placedOn: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', id: number, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, trackingInformation: { __typename: 'TrackingInformation', id: number, deliveredAt: any | null } | null } };

export type AdminDeleteRetailerMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminDeleteRetailerMutation = { __typename: 'Mutation', deleteRetailer: { __typename: 'Retailer', id: number, name: string } };

export type AdminRetailerQueryVariables = Exact<{
  retailerId: Scalars['Int'];
}>;


export type AdminRetailerQuery = { __typename: 'Query', retailer: { __typename: 'Retailer', id: number, displayName: string, canDelete: boolean, completedOnboardingAt: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, createdAt: any }, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, requiresBeneficialOwnershipCertification: boolean } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, removedAt: any | null, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, itemId: string, verificationStatus: PlaidVerificationStatus | null } | null } | null } };

export type AdminRetailerDetailsFragment = { __typename: 'Retailer', id: number, displayName: string, canDelete: boolean, completedOnboardingAt: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, createdAt: any }, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, requiresBeneficialOwnershipCertification: boolean } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, removedAt: any | null, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, itemId: string, verificationStatus: PlaidVerificationStatus | null } | null } | null };

export type AdminRetailerDetailsQueryVariables = Exact<{
  retailerId: Scalars['Int'];
}>;


export type AdminRetailerDetailsQuery = { __typename: 'Query', retailer: { __typename: 'Retailer', id: number, displayName: string, canDelete: boolean, completedOnboardingAt: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, createdAt: any }, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, requiresBeneficialOwnershipCertification: boolean } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, removedAt: any | null, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, itemId: string, verificationStatus: PlaidVerificationStatus | null } | null } | null } };

export type AdminRetailerSalesOrdersQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: RetailerSalesOrdersFilters;
}>;


export type AdminRetailerSalesOrdersQuery = { __typename: 'Query', getRetailerSalesOrders: { __typename: 'PaginatedRetailerSalesOrders', total: number, results: Array<{ __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, createdAt: any, deliveredAt: any | null, paymentStatus: LedgerStatus, cancelledAt: any | null, deliveryStatus: DeliveryStatus, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }> } | null };

export type AdminRetailerSalesOrdersTableDataFragment = { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, createdAt: any, deliveredAt: any | null, paymentStatus: LedgerStatus, cancelledAt: any | null, deliveryStatus: DeliveryStatus, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, buyer: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } };

export type AdminRetailersQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: InputMaybe<RetailersFilterData>;
}>;


export type AdminRetailersQuery = { __typename: 'Query', paginatedRetailers: { __typename: 'PaginatedRetailers', total: number, results: Array<{ __typename: 'Retailer', id: number, displayName: string, canDelete: boolean, completedOnboardingAt: any | null, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string }, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, organization: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, createdAt: any }, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, requiresBeneficialOwnershipCertification: boolean } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, removedAt: any | null, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, itemId: string, verificationStatus: PlaidVerificationStatus | null } | null } | null }> } };

export type ImportReportDisplayFragment = { __typename: 'ImportReport', failedRowIds: Array<string>, successfulRowIds: Array<string> };

export type UpdateShippingCostFromCsvMutationVariables = Exact<{
  remoteFileId: Scalars['Int'];
}>;


export type UpdateShippingCostFromCsvMutation = { __typename: 'Mutation', updateShippingCostFromCSV: { __typename: 'ImportReport', failedRowIds: Array<string>, successfulRowIds: Array<string> } };

export type UpdateTrackingInfoFromCsvMutationVariables = Exact<{
  remoteFileId: Scalars['Int'];
  company: ImportCsvCarrier;
}>;


export type UpdateTrackingInfoFromCsvMutation = { __typename: 'Mutation', updateTrackingInfoFromCSV: { __typename: 'ImportReport', failedRowIds: Array<string>, successfulRowIds: Array<string> } };

export type AdminFundsTransferFieldsFragment = { __typename: 'FundsTransfer', id: number, breweryInvoiceNumber: string, retailerInvoiceNumber: string | null, amount: number, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, settlementRejectionResponse: any | null, settlementStrategy: string | null, settlementMetadata: any | null, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, dwollaTransfers: Array<{ __typename: 'DwollaTransfer', id: string, failureCode: string | null, failureDescription: string | null, failureExplanation: string | null, sourceId: string | null, destinationId: string | null, createdAt: any, links: any | null, status: string }> };

export type AdminTransactionsQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  monthFilter: Scalars['String'];
}>;


export type AdminTransactionsQuery = { __typename: 'Query', fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, breweryInvoiceNumber: string, retailerInvoiceNumber: string | null, amount: number, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, settlementRejectionResponse: any | null, settlementStrategy: string | null, settlementMetadata: any | null, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, dwollaTransfers: Array<{ __typename: 'DwollaTransfer', id: string, failureCode: string | null, failureDescription: string | null, failureExplanation: string | null, sourceId: string | null, destinationId: string | null, createdAt: any, links: any | null, status: string }> }> };

export type AdminTransferQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminTransferQuery = { __typename: 'Query', fundsTransfer: { __typename: 'FundsTransfer', id: number, breweryInvoiceNumber: string, retailerInvoiceNumber: string | null, amount: number, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, settlementRejectionResponse: any | null, settlementStrategy: string | null, settlementMetadata: any | null, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, dwollaTransfers: Array<{ __typename: 'DwollaTransfer', id: string, failureCode: string | null, failureDescription: string | null, failureExplanation: string | null, sourceId: string | null, destinationId: string | null, createdAt: any, links: any | null, status: string }> } };

export type SyncFundsTransferMutationVariables = Exact<{
  fundsTransferId: Scalars['Int'];
}>;


export type SyncFundsTransferMutation = { __typename: 'Mutation', syncFundsTransfer: { __typename: 'FundsTransfer', id: number, amount: number, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } };

export type AddFundsTransferMutationVariables = Exact<{
  data: AddFundsTransferData;
}>;


export type AddFundsTransferMutation = { __typename: 'Mutation', addFundsTransfer: { __typename: 'FundsTransfer', id: number, amount: number, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } };

export type AutocompleteFromFundsAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AutocompleteFromFundsAccountsQuery = { __typename: 'Query', fundsAccountsEligibleToSend: Array<{ __typename: 'BalanceAccount', balance: number, id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, name: string, displayName: string, businessType: BusinessType, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, name: string, displayName: string, businessType: BusinessType, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, name: string, displayName: string, businessType: BusinessType, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } }> };

export type AutocompleteToFundsAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AutocompleteToFundsAccountsQuery = { __typename: 'Query', fundsAccountsEligibleToReceive: Array<{ __typename: 'BalanceAccount', balance: number, id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, name: string, displayName: string, businessType: BusinessType, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, name: string, displayName: string, businessType: BusinessType, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, name: string, displayName: string, businessType: BusinessType, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } }> };

export type AddSandboxProducerMutationVariables = Exact<{
  type: SandboxProducerType;
}>;


export type AddSandboxProducerMutation = { __typename: 'Mutation', addSandboxProducer: { __typename: 'Producer', id: number, organization: { __typename: 'Organization', id: number } } };

export type AddSandboxRetailerMutationVariables = Exact<{
  type: SandboxRetailerType;
}>;


export type AddSandboxRetailerMutation = { __typename: 'Mutation', addSandboxRetailer: { __typename: 'Retailer', id: number, organization: { __typename: 'Organization', id: number } } };

export type RunDwollaSandboxSimulationsMutationVariables = Exact<{ [key: string]: never; }>;


export type RunDwollaSandboxSimulationsMutation = { __typename: 'Mutation', runSandboxSimulations: { __typename: 'SandboxSimulation', total: number } };

export type DwollaWebhooksQueryVariables = Exact<{ [key: string]: never; }>;


export type DwollaWebhooksQuery = { __typename: 'Query', dwollaWebhooks: Array<{ __typename: 'DwollaWebhook', id: string, createdAt: string, receivedAt: string, updatedAt: string, topic: string, status: DwollaWebhookStatus, resourceId: string, resourceType: string }> };

export type ProductQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProductQuery = { __typename: 'Query', product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } };

export type ProductDisplayFragment = { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null };

export type AdminProducerPurchaseOrderTableRowFragment = { __typename: 'ProducerPurchaseOrder', id: number, number: string, amountInCents: number, createdAt: any, paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus, buyerName: string, deliveredAt: any | null, cancelledAt: any | null, feeStatus: LedgerStatus, producerInvoiceStatus: ProducerInvoiceStatus, deliveryStatus: DeliveryStatus, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, status: FreightShipmentStatus, estimatedArrivalDate: any | null } | null, preSale: { __typename: 'PreSale', regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } }, distributorPurchaseOrder: { __typename: 'DistributorPurchaseOrder', paymentStatus: LedgerStatus, balanceTransferStatus: LedgerStatus } | null };

export type AdminSyncDwollaCustomerMutationVariables = Exact<{
  dwollaCustomerId: Scalars['String'];
}>;


export type AdminSyncDwollaCustomerMutation = { __typename: 'Mutation', syncDwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, requiresBeneficialOwnershipCertification: boolean } | null };

export type AutoCompleteBeerStylesFragment = { __typename: 'BeerStyle', id: number, name: string };

export type AutoCompleteBeerStylesQueryVariables = Exact<{ [key: string]: never; }>;


export type AutoCompleteBeerStylesQuery = { __typename: 'Query', beerStyles: Array<{ __typename: 'BeerStyle', id: number, name: string }> };

export type InviteUserToOrganizationMutationVariables = Exact<{
  email: Scalars['String'];
  fullName: Scalars['String'];
  organizationId: Scalars['Int'];
}>;


export type InviteUserToOrganizationMutation = { __typename: 'Mutation', inviteUser: { __typename: 'User', id: number, createdAt: any, isGlobalAdmin: boolean } };

export type RetailerOrderStatusDataFragment = { __typename: 'RetailerSalesOrder', cancelledAt: any | null, deliveryStatus: DeliveryStatus, paymentStatus: LedgerStatus };

export type AdminBankAccountDetailsFragment = { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, removedAt: any | null, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, itemId: string, verificationStatus: PlaidVerificationStatus | null } | null };

export type AdminDwollaCustomerDetailsFragment = { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, requiresBeneficialOwnershipCertification: boolean };

export type LedgerDetailsFragment = { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus };

export type ServiceLevelTargetDetailsFragment = { __typename: 'ServiceLevelTarget', target: number, warn: number };

export type TransferProposalDetailsFragment = { __typename: 'TransferProposal', amount: number, statementDescriptor: string | null, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } };

export type DistributorBalanceAccountQueryVariables = Exact<{
  businessEntityId: Scalars['Int'];
}>;


export type DistributorBalanceAccountQuery = { __typename: 'Query', business: { __typename: 'BeverageAdvisors', id: number, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } };

export type DistributorFundsTransferFieldsFragment = { __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, retailerInvoiceNumber: string | null, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } };

export type DistributorTransactionsQueryVariables = Exact<{
  businessId: Scalars['Int'];
}>;


export type DistributorTransactionsQuery = { __typename: 'Query', business: { __typename: 'BeverageAdvisors', id: number, fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, retailerInvoiceNumber: string | null, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }> } | { __typename: 'Distributor', id: number, fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, retailerInvoiceNumber: string | null, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }> } | { __typename: 'LogisticsPartner', id: number, fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, retailerInvoiceNumber: string | null, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }> } | { __typename: 'Producer', id: number, fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, retailerInvoiceNumber: string | null, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }> } | { __typename: 'Retailer', id: number, fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, retailerInvoiceNumber: string | null, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }> } };

export type BusinessActiveBankAccountsQueryVariables = Exact<{
  businessEntityId: Scalars['Int'];
}>;


export type BusinessActiveBankAccountsQuery = { __typename: 'Query', business: { __typename: 'BeverageAdvisors', id: number, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, mask: string, institutionName: string | null, hasOnDemandAuthorization: boolean, isVerified: boolean | null, needsReverification: boolean, business: { __typename: 'BeverageAdvisors', id: number } | { __typename: 'Distributor', id: number } | { __typename: 'LogisticsPartner', id: number } | { __typename: 'Producer', id: number } | { __typename: 'Retailer', id: number }, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null } | { __typename: 'Distributor', id: number, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, mask: string, institutionName: string | null, hasOnDemandAuthorization: boolean, isVerified: boolean | null, needsReverification: boolean, business: { __typename: 'BeverageAdvisors', id: number } | { __typename: 'Distributor', id: number } | { __typename: 'LogisticsPartner', id: number } | { __typename: 'Producer', id: number } | { __typename: 'Retailer', id: number }, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null } | { __typename: 'LogisticsPartner', id: number, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, mask: string, institutionName: string | null, hasOnDemandAuthorization: boolean, isVerified: boolean | null, needsReverification: boolean, business: { __typename: 'BeverageAdvisors', id: number } | { __typename: 'Distributor', id: number } | { __typename: 'LogisticsPartner', id: number } | { __typename: 'Producer', id: number } | { __typename: 'Retailer', id: number }, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null } | { __typename: 'Producer', id: number, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, mask: string, institutionName: string | null, hasOnDemandAuthorization: boolean, isVerified: boolean | null, needsReverification: boolean, business: { __typename: 'BeverageAdvisors', id: number } | { __typename: 'Distributor', id: number } | { __typename: 'LogisticsPartner', id: number } | { __typename: 'Producer', id: number } | { __typename: 'Retailer', id: number }, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null } | { __typename: 'Retailer', id: number, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, mask: string, institutionName: string | null, hasOnDemandAuthorization: boolean, isVerified: boolean | null, needsReverification: boolean, business: { __typename: 'BeverageAdvisors', id: number } | { __typename: 'Distributor', id: number } | { __typename: 'LogisticsPartner', id: number } | { __typename: 'Producer', id: number } | { __typename: 'Retailer', id: number }, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null } };

export type RemoveBankAccountMutationVariables = Exact<{
  id: Scalars['Int'];
  force: InputMaybe<Scalars['Boolean']>;
}>;


export type RemoveBankAccountMutation = { __typename: 'Mutation', removeBankAccount: { __typename: 'BankAccount', id: number, removedAt: any | null, business: { __typename: 'BeverageAdvisors', bankAccount: { __typename: 'BankAccount', id: number, removedAt: any | null } | null } | { __typename: 'Distributor', bankAccount: { __typename: 'BankAccount', id: number, removedAt: any | null } | null } | { __typename: 'LogisticsPartner', bankAccount: { __typename: 'BankAccount', id: number, removedAt: any | null } | null } | { __typename: 'Producer', bankAccount: { __typename: 'BankAccount', id: number, removedAt: any | null } | null } | { __typename: 'Retailer', bankAccount: { __typename: 'BankAccount', id: number, removedAt: any | null } | null } } | null };

export type OnboardingAuthorizeOnDemandTransfersMutationVariables = Exact<{
  bankAccountId: Scalars['Int'];
}>;


export type OnboardingAuthorizeOnDemandTransfersMutation = { __typename: 'Mutation', authorizeOnDemandTransfers: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean, business: { __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } } | null };

export type CertifyBeneficialOwnershipMutationVariables = Exact<{
  dwollaCustomerId: Scalars['String'];
}>;


export type CertifyBeneficialOwnershipMutation = { __typename: 'Mutation', certifyBeneficialOwnership: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, business: { __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | null } | null };

export type OnboardingSyncDwollaCustomerMutationVariables = Exact<{
  dwollaCustomerId: Scalars['String'];
}>;


export type OnboardingSyncDwollaCustomerMutation = { __typename: 'Mutation', syncDwollaCustomer: { __typename: 'DwollaCustomer', id: string, business: { __typename: 'BeverageAdvisors', id: number, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Distributor', id: number, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'LogisticsPartner', id: number, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Producer', id: number, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Retailer', id: number, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | null } | null };

export type SkipBeneficialOwnerStepMutationVariables = Exact<{
  businessId: Scalars['Int'];
}>;


export type SkipBeneficialOwnerStepMutation = { __typename: 'Mutation', skipBeneficialOwnersStep: { __typename: 'BeverageAdvisors', id: number } | { __typename: 'Distributor', id: number } | { __typename: 'LogisticsPartner', id: number } | { __typename: 'Producer', id: number } | { __typename: 'Retailer', id: number } };

export type ResetSkipBeneficialOwnersStepMutationVariables = Exact<{
  businessId: Scalars['Int'];
}>;


export type ResetSkipBeneficialOwnersStepMutation = { __typename: 'Mutation', resetSkipBeneficialOwnersStep: { __typename: 'BeverageAdvisors', id: number } | { __typename: 'Distributor', id: number } | { __typename: 'LogisticsPartner', id: number } | { __typename: 'Producer', id: number } | { __typename: 'Retailer', id: number } };

export type OnboardingQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type OnboardingQuery = { __typename: 'Query', business: { __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, organizationId: number, businessType: BusinessType, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, organizationId: number, businessType: BusinessType, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, organizationId: number, businessType: BusinessType, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null, organizationId: number, businessType: BusinessType, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, organizationId: number, businessType: BusinessType, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } };

export type OnboardingBankAccountStepFieldsFragment = { __typename: 'BankAccountOnboardingStep', bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null };

export type OnboardingBeneficialOwnersStepFieldsFragment = { __typename: 'BeneficialOwnerOnboardingStep', customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } };

export type OnboardingCompleteStepFieldsFragment = { __typename: 'CompleteOnboardingStep', dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } };

export type OnboardingDwollaStepFieldsFragment = { __typename: 'DwollaOnboardingStep', customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null };

export type OnboardingFieldsFragment = { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } };

export type CompleteOnboardingMutationVariables = Exact<{
  businessEntityId: Scalars['Int'];
}>;


export type CompleteOnboardingMutation = { __typename: 'Mutation', completeOnboarding: { __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, organizationId: number } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, organizationId: number } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, organizationId: number } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null, organizationId: number } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, organizationId: number } };

export type ProducerDashboardDataQueryVariables = Exact<{
  producerId: Scalars['Int'];
}>;


export type ProducerDashboardDataQuery = { __typename: 'Query', producerPreSaleUnitsSold: Array<{ __typename: 'ProducerPreSaleUnitsSold', date: string, producer: string, friendlyName: string, units: number }> };

export type ProducerPreSaleUnitsSoldQueryVariables = Exact<{
  producerId: Scalars['Int'];
}>;


export type ProducerPreSaleUnitsSoldQuery = { __typename: 'Query', producerPreSaleUnitsSold: Array<{ __typename: 'ProducerPreSaleUnitsSold', date: string, producer: string, friendlyName: string, units: number }> };

export type PaginatedProducerSalesByRegionQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: ProducerSalesByRegionFilters;
}>;


export type PaginatedProducerSalesByRegionQuery = { __typename: 'Query', paginatedProducerSalesByRegion: { __typename: 'PaginatedProducerSalesByRegionResult', total: number, results: Array<{ __typename: 'ProducerSalesByRegion', retailer_name: string, retailer_region: string, retailer_email: string, order_count: number, total_ordered: number }> } | null };

export type ProducerSalesByRegionFragment = { __typename: 'ProducerSalesByRegion', retailer_name: string, retailer_region: string, retailer_email: string, order_count: number, total_ordered: number };

export type ProducerSalesOrderUnitsFulfilledQueryVariables = Exact<{
  producerId: Scalars['Int'];
}>;


export type ProducerSalesOrderUnitsFulfilledQuery = { __typename: 'Query', producerSalesOrderUnitsFulfilled: Array<{ __typename: 'ProducerSalesOrderUnitsFulfilled', date: string, producer: string, friendlyName: string, units: number }> };

export type ProducerLicenseFieldsFragment = { __typename: 'License', title: string, documentUrl: string | null, createdAt: any, stateV2: { __typename: 'StateV2', name: string, id: number }, currentLicensePeriod: { __typename: 'LicensePeriod', startDate: any, endDate: any } };

export type ProducerLicensesQueryVariables = Exact<{
  producerId: Scalars['Int'];
}>;


export type ProducerLicensesQuery = { __typename: 'Query', producer: { __typename: 'Producer', licenses: Array<{ __typename: 'License', title: string, documentUrl: string | null, createdAt: any, stateV2: { __typename: 'StateV2', name: string, id: number }, currentLicensePeriod: { __typename: 'LicensePeriod', startDate: any, endDate: any } }> } };

export type ProducerOfferSearchQueryVariables = Exact<{
  pagination: OffsetPaginationInput;
  filters: InputMaybe<OfferSearchFilters>;
}>;


export type ProducerOfferSearchQuery = { __typename: 'Query', searchOffers: { __typename: 'PaginatedOffers', total: number, results: Array<{ __typename: 'Offer', id: number, quantity: number, platformPrice: number, wholesalePrice: number, earliestPickup: any | null, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null }, offerWindow: { __typename: 'OfferWindow', start: any, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } }> } };

export type ProducerOfferTableDataFragment = { __typename: 'Offer', id: number, quantity: number, platformPrice: number, wholesalePrice: number, earliestPickup: any | null, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null }, offerWindow: { __typename: 'OfferWindow', start: any, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type ProducerPurchaseOrderDocumentsQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type ProducerPurchaseOrderDocumentsQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } } | { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } } | { __typename: 'ProducerPurchaseOrder', id: number, platformFee: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } } | { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, documents: Array<{ __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } }>, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } } };

export type ProducerPurchaseOrderItemFragment = { __typename: 'OrderItem', quantity: number, price: number, wholesalePrice: number, orderId: number, total: number, wholesaleTotal: number, finalQuantity: number, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } };

export type ProducerPurchaseOrderItemsQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type ProducerPurchaseOrderItemsQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, number: string, type: OrderType, amountInCents: number, items: Array<{ __typename: 'OrderItem', quantity: number, price: number, wholesalePrice: number, orderId: number, total: number, wholesaleTotal: number, finalQuantity: number, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> } | { __typename: 'PreSaleOrder', id: number, number: string, type: OrderType, amountInCents: number, items: Array<{ __typename: 'OrderItem', quantity: number, price: number, wholesalePrice: number, orderId: number, total: number, wholesaleTotal: number, finalQuantity: number, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> } | { __typename: 'ProducerPurchaseOrder', id: number, number: string, type: OrderType, amountInCents: number, items: Array<{ __typename: 'OrderItem', quantity: number, price: number, wholesalePrice: number, orderId: number, total: number, wholesaleTotal: number, finalQuantity: number, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> } | { __typename: 'RetailerSalesOrder', id: number, number: string, type: OrderType, amountInCents: number, items: Array<{ __typename: 'OrderItem', quantity: number, price: number, wholesalePrice: number, orderId: number, total: number, wholesaleTotal: number, finalQuantity: number, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> } };

type ProducerPurchaseOrderItemsData_DistributorPurchaseOrder_Fragment = { __typename: 'DistributorPurchaseOrder', type: OrderType, amountInCents: number, items: Array<{ __typename: 'OrderItem', quantity: number, price: number, wholesalePrice: number, orderId: number, total: number, wholesaleTotal: number, finalQuantity: number, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> };

type ProducerPurchaseOrderItemsData_PreSaleOrder_Fragment = { __typename: 'PreSaleOrder', type: OrderType, amountInCents: number, items: Array<{ __typename: 'OrderItem', quantity: number, price: number, wholesalePrice: number, orderId: number, total: number, wholesaleTotal: number, finalQuantity: number, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> };

type ProducerPurchaseOrderItemsData_ProducerPurchaseOrder_Fragment = { __typename: 'ProducerPurchaseOrder', type: OrderType, amountInCents: number, items: Array<{ __typename: 'OrderItem', quantity: number, price: number, wholesalePrice: number, orderId: number, total: number, wholesaleTotal: number, finalQuantity: number, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> };

type ProducerPurchaseOrderItemsData_RetailerSalesOrder_Fragment = { __typename: 'RetailerSalesOrder', type: OrderType, amountInCents: number, items: Array<{ __typename: 'OrderItem', quantity: number, price: number, wholesalePrice: number, orderId: number, total: number, wholesaleTotal: number, finalQuantity: number, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> };

export type ProducerPurchaseOrderItemsDataFragment = ProducerPurchaseOrderItemsData_DistributorPurchaseOrder_Fragment | ProducerPurchaseOrderItemsData_PreSaleOrder_Fragment | ProducerPurchaseOrderItemsData_ProducerPurchaseOrder_Fragment | ProducerPurchaseOrderItemsData_RetailerSalesOrder_Fragment;

export type ProducerPurchaseOrderOverviewQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type ProducerPurchaseOrderOverviewQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } } | { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } } | { __typename: 'ProducerPurchaseOrder', id: number, platformFee: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } } | { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } } };

export type ProducerPurchaseOrderPackageSummaryTableDataFragment = { __typename: 'PackageSummaryItem', totalQuantity: number, totalWeight: number, packageType: { __typename: 'ProductPackageType', id: number, displayName: string } };

export type ProducerPurchaseOrderShippingQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type ProducerPurchaseOrderShippingQuery = { __typename: 'Query', order: { __typename: 'DistributorPurchaseOrder', id: number, number: string, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean }, seller: { __typename: 'BeverageAdvisors', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Distributor', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'LogisticsPartner', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Producer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Retailer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null }, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null, packageSummary: Array<{ __typename: 'PackageSummaryItem', totalQuantity: number, totalWeight: number, packageType: { __typename: 'ProductPackageType', id: number, displayName: string } }> } | { __typename: 'PreSaleOrder', id: number, number: string, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean }, seller: { __typename: 'BeverageAdvisors', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Distributor', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'LogisticsPartner', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Producer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Retailer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null }, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null, packageSummary: Array<{ __typename: 'PackageSummaryItem', totalQuantity: number, totalWeight: number, packageType: { __typename: 'ProductPackageType', id: number, displayName: string } }> } | { __typename: 'ProducerPurchaseOrder', id: number, number: string, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean }, seller: { __typename: 'BeverageAdvisors', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Distributor', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'LogisticsPartner', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Producer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Retailer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null }, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null, packageSummary: Array<{ __typename: 'PackageSummaryItem', totalQuantity: number, totalWeight: number, packageType: { __typename: 'ProductPackageType', id: number, displayName: string } }> } | { __typename: 'RetailerSalesOrder', id: number, number: string, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean }, seller: { __typename: 'BeverageAdvisors', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Distributor', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'LogisticsPartner', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Producer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Retailer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null }, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, trackingInformation: { __typename: 'TrackingInformation', id: number, trackingNumber: string | null, trackingLink: string | null, estimatedPickupDate: any | null, estimatedArrivalDate: any | null, estimatedCostInCents: number | null, palletCount: number | null, deliveredAt: any | null, actualCostInCents: number | null, freightTrailerNumber: string | null, freightInvoiceNumber: string | null, status: FreightShipmentStatus, pickedUpAt: any | null, cancelledAt: any | null, kuebixShipmentId: string | null, carrier: { __typename: 'Carrier', id: number, displayName: string } } | null, packageSummary: Array<{ __typename: 'PackageSummaryItem', totalQuantity: number, totalWeight: number, packageType: { __typename: 'ProductPackageType', id: number, displayName: string } }> } };

type ProducerPurchaseOrderSummary_DistributorPurchaseOrder_Fragment = { __typename: 'DistributorPurchaseOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } };

type ProducerPurchaseOrderSummary_PreSaleOrder_Fragment = { __typename: 'PreSaleOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } };

type ProducerPurchaseOrderSummary_ProducerPurchaseOrder_Fragment = { __typename: 'ProducerPurchaseOrder', platformFee: number, id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } };

type ProducerPurchaseOrderSummary_RetailerSalesOrder_Fragment = { __typename: 'RetailerSalesOrder', id: number, number: string, amountInCents: number, createdAt: any, deletedAt: any | null, buyerName: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string, deliveryPartner: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } | null }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, buyer: { __typename: 'BeverageAdvisors', id: number, businessType: BusinessType } | { __typename: 'Distributor', id: number, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, businessType: BusinessType } | { __typename: 'Producer', id: number, businessType: BusinessType } | { __typename: 'Retailer', id: number, businessType: BusinessType }, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, enabledFeatures: { __typename: 'OrderEnabledFeatures', canCreatePDF: boolean } };

export type ProducerPurchaseOrderSummaryFragment = ProducerPurchaseOrderSummary_DistributorPurchaseOrder_Fragment | ProducerPurchaseOrderSummary_PreSaleOrder_Fragment | ProducerPurchaseOrderSummary_ProducerPurchaseOrder_Fragment | ProducerPurchaseOrderSummary_RetailerSalesOrder_Fragment;

export type ProducerPurchaseOrderTableRowFragment = { __typename: 'ProducerPurchaseOrder', id: number, number: string, amountInCents: number, createdAt: any, buyerName: string, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, preSale: { __typename: 'PreSale', regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type ProducerPurchaseOrdersQueryVariables = Exact<{
  id: Scalars['Int'];
  filters: ProducerPurchaseOrdersFilterInput;
  sort: ProducerPurchaseOrdersSortInput;
  pagination: OffsetPaginationInput;
}>;


export type ProducerPurchaseOrdersQuery = { __typename: 'Query', producer: { __typename: 'Producer', id: number, organizationId: number, purchaseOrders: { __typename: 'PaginatedProducerPurchaseOrders', total: number, results: Array<{ __typename: 'ProducerPurchaseOrder', id: number, number: string, amountInCents: number, createdAt: any, buyerName: string, seller: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string }, invoice: { __typename: 'Invoice', externalInvoiceId: string | null, externalAmountInCents: number | null } | null, preSale: { __typename: 'PreSale', regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } }> } } };

export type ProducerBalanceAccountQueryVariables = Exact<{
  businessEntityId: Scalars['Int'];
}>;


export type ProducerBalanceAccountQuery = { __typename: 'Query', business: { __typename: 'BeverageAdvisors', id: number, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } };

export type ProducerFundsTransferFieldsFragment = { __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } };

export type ProducerTransactionsQueryVariables = Exact<{
  businessId: Scalars['Int'];
}>;


export type ProducerTransactionsQuery = { __typename: 'Query', business: { __typename: 'BeverageAdvisors', id: number, fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }> } | { __typename: 'Distributor', id: number, fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }> } | { __typename: 'LogisticsPartner', id: number, fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }> } | { __typename: 'Producer', id: number, fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }> } | { __typename: 'Retailer', id: number, fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, breweryInvoiceNumber: string, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }> } };

export type RegisterRetailerMutationVariables = Exact<{
  data: RegisterRetailerOrganizationData;
}>;


export type RegisterRetailerMutation = { __typename: 'Mutation', registerRetailerOrganization: { __typename: 'Organization', id: number, businessType: BusinessType } };

export type RetailerAppRootQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type RetailerAppRootQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: number, name: string, locations: Array<{ __typename: 'Retailer', id: number, name: string }> } };

export type StorePreSaleOrderQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type StorePreSaleOrderQuery = { __typename: 'Query', preSaleOrder: { __typename: 'PreSaleOrder', id: number, number: string, placedOn: any | null, amountInCents: number, cancelledAt: any | null, cancelledTotal: number, estimatedFulfillmentTotal: number, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, items: Array<{ __typename: 'OrderItem', quantity: number, price: number, total: number, product: { __typename: 'Product', id: number, name: string, description: string | null, abv: number | null, packageDate: any | null, rating: number | null, beerStyle: { __typename: 'BeerStyle', name: string } | null, packageType: { __typename: 'ProductPackageType', id: number, displayName: string }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null, producer: { __typename: 'Producer', id: number, displayName: string } } }>, cancelledItems: Array<{ __typename: 'PreSaleOrderCancelledItem', item: { __typename: 'OrderItem', quantity: number, price: number, total: number, product: { __typename: 'Product', id: number, name: string, description: string | null, abv: number | null, packageDate: any | null, rating: number | null, beerStyle: { __typename: 'BeerStyle', name: string } | null, packageType: { __typename: 'ProductPackageType', id: number, displayName: string }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null, producer: { __typename: 'Producer', id: number, displayName: string } } }, exclusionReason: { __typename: 'ProductFulfillmentExclusionReason', id: number, label: string } | null }> } };

export type StorePreSaleOrderCancelledItemFragment = { __typename: 'PreSaleOrderCancelledItem', item: { __typename: 'OrderItem', quantity: number, price: number, total: number, product: { __typename: 'Product', id: number, name: string, description: string | null, abv: number | null, packageDate: any | null, rating: number | null, beerStyle: { __typename: 'BeerStyle', name: string } | null, packageType: { __typename: 'ProductPackageType', id: number, displayName: string }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null, producer: { __typename: 'Producer', id: number, displayName: string } } }, exclusionReason: { __typename: 'ProductFulfillmentExclusionReason', id: number, label: string } | null };

export type StorePreSaleOrderItemFragment = { __typename: 'OrderItem', quantity: number, price: number, total: number, product: { __typename: 'Product', id: number, name: string, description: string | null, abv: number | null, packageDate: any | null, rating: number | null, beerStyle: { __typename: 'BeerStyle', name: string } | null, packageType: { __typename: 'ProductPackageType', id: number, displayName: string }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null, producer: { __typename: 'Producer', id: number, displayName: string } } };

export type StorePreSaleOrderSummaryFragment = { __typename: 'PreSaleOrder', id: number, placedOn: any | null, cancelledAt: any | null, number: string, finalOrderTotalInCents: number };

export type StorePreSaleOrdersQueryVariables = Exact<{
  storeId: Scalars['Int'];
  pagination: OffsetPaginationInput;
}>;


export type StorePreSaleOrdersQuery = { __typename: 'Query', retailer: { __typename: 'Retailer', id: number, name: string, preSaleOrders: { __typename: 'PaginatedPaginatedPreSaleOrders', total: number, results: Array<{ __typename: 'PreSaleOrder', id: number, placedOn: any | null, cancelledAt: any | null, number: string, finalOrderTotalInCents: number }> } } };

export type StoreRouterQueryVariables = Exact<{
  storeId: Scalars['Int'];
}>;


export type StoreRouterQuery = { __typename: 'Query', retailer: { __typename: 'Retailer', id: number, name: string, organization: { __typename: 'Organization', id: number, name: string } } };

export type StoreSalesOrderQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type StoreSalesOrderQuery = { __typename: 'Query', retailerSalesOrder: { __typename: 'RetailerSalesOrder', id: number, number: string, placedOn: any | null, cancelledAt: any | null, amountInCents: number, adjustmentTotalInCents: number, finalOrderTotalInCents: number, shippingAddress: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null, items: Array<{ __typename: 'OrderItem', quantity: number, price: number, total: number, finalQuantity: number, finalTotal: number, product: { __typename: 'Product', id: number, name: string, description: string | null, abv: number | null, packageDate: any | null, rating: number | null, beerStyle: { __typename: 'BeerStyle', name: string } | null, packageType: { __typename: 'ProductPackageType', id: number, displayName: string }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null, producer: { __typename: 'Producer', id: number, displayName: string } } }>, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } } };

export type StoreSalesOrderItemFragment = { __typename: 'OrderItem', quantity: number, price: number, total: number, finalQuantity: number, finalTotal: number, product: { __typename: 'Product', id: number, name: string, description: string | null, abv: number | null, packageDate: any | null, rating: number | null, beerStyle: { __typename: 'BeerStyle', name: string } | null, packageType: { __typename: 'ProductPackageType', id: number, displayName: string }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null, producer: { __typename: 'Producer', id: number, displayName: string } } };

export type StoreSalesOrderPaymentBalancesFragment = { __typename: 'RetailerSalesOrder', id: number, paymentsLedger: { __typename: 'Ledger', id: number, due: number, balance: number, total: number, pendingTotal: number, completedTotal: number, status: LedgerStatus, transfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } } | null> } };

export type StoreSalesOrderSummaryFragment = { __typename: 'RetailerSalesOrder', id: number, placedOn: any | null, cancelledAt: any | null, deliveredAt: any | null, number: string, amountInCents: number, finalOrderTotalInCents: number, deliveryStatus: DeliveryStatus, paymentStatus: LedgerStatus, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', trackingInformation: { __typename: 'TrackingInformation', estimatedArrivalDate: any | null } | null, seller: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } } };

export type StoreSalesOrdersQueryVariables = Exact<{
  storeId: Scalars['Int'];
  pagination: OffsetPaginationInput;
}>;


export type StoreSalesOrdersQuery = { __typename: 'Query', retailer: { __typename: 'Retailer', id: number, name: string, salesOrders: { __typename: 'PaginatedRetailerSalesOrders', total: number, results: Array<{ __typename: 'RetailerSalesOrder', id: number, placedOn: any | null, cancelledAt: any | null, deliveredAt: any | null, number: string, amountInCents: number, finalOrderTotalInCents: number, deliveryStatus: DeliveryStatus, paymentStatus: LedgerStatus, producerPurchaseOrder: { __typename: 'ProducerPurchaseOrder', trackingInformation: { __typename: 'TrackingInformation', estimatedArrivalDate: any | null } | null, seller: { __typename: 'BeverageAdvisors', displayName: string } | { __typename: 'Distributor', displayName: string } | { __typename: 'LogisticsPartner', displayName: string } | { __typename: 'Producer', displayName: string } | { __typename: 'Retailer', displayName: string } } }> } } };

export type StoreSettingsQueryVariables = Exact<{
  storeId: Scalars['Int'];
}>;


export type StoreSettingsQuery = { __typename: 'Query', retailer: { __typename: 'Retailer', id: number, name: string, completedOnboardingAt: any | null, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, email: string, status: DwollaCustomerVerificationStatus } | null, bankAccount: { __typename: 'BankAccount', id: number, mask: string, institutionName: string | null, name: string | null, hasOnDemandAuthorization: boolean, removedAt: any | null, needsReverification: boolean, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null } };

export type StoresPageQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type StoresPageQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: number, locations: Array<{ __typename: 'Retailer', id: number, name: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } }> } };

export type RetailerFundsTransferFieldsFragment = { __typename: 'FundsTransfer', id: number, amount: number, statementDescriptor: string | null, retailerInvoiceNumber: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } };

export type RetailerTransactionsQueryVariables = Exact<{
  organizationEntityId: Scalars['Int'];
  monthFilter: Scalars['String'];
}>;


export type RetailerTransactionsQuery = { __typename: 'Query', organization: { __typename: 'Organization', fundsTransfers: Array<{ __typename: 'FundsTransfer', id: number, amount: number, statementDescriptor: string | null, retailerInvoiceNumber: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } }> } };

export type BankAccountDisplayInfoFragment = { __typename: 'BankAccount', id: number, mask: string, institutionName: string | null, name: string | null, hasOnDemandAuthorization: boolean, needsReverification: boolean, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null, business: { __typename: 'BeverageAdvisors', id: number } | { __typename: 'Distributor', id: number } | { __typename: 'LogisticsPartner', id: number } | { __typename: 'Producer', id: number } | { __typename: 'Retailer', id: number } };

export type AddressFragment = { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string };

export type AuthorizeOnDemandTransfersMutationVariables = Exact<{
  bankAccountId: Scalars['Int'];
}>;


export type AuthorizeOnDemandTransfersMutation = { __typename: 'Mutation', authorizeOnDemandTransfers: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null };

export type BankAccountFieldsFragment = { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null, hasOnDemandAuthorization: boolean, isVerified: boolean | null, needsReverification: boolean, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null, business: { __typename: 'BeverageAdvisors', id: number, bankAccount: { __typename: 'BankAccount', id: number } | null } | { __typename: 'Distributor', id: number, bankAccount: { __typename: 'BankAccount', id: number } | null } | { __typename: 'LogisticsPartner', id: number, bankAccount: { __typename: 'BankAccount', id: number } | null } | { __typename: 'Producer', id: number, bankAccount: { __typename: 'BankAccount', id: number } | null } | { __typename: 'Retailer', id: number, bankAccount: { __typename: 'BankAccount', id: number } | null } };

export type AddBankAccountViaPlaidMutationVariables = Exact<{
  businessId: Scalars['Int'];
  plaidPublicToken: Scalars['String'];
  selectedAccountId: Scalars['String'];
}>;


export type AddBankAccountViaPlaidMutation = { __typename: 'Mutation', addBankAccountViaPlaid: { __typename: 'BankAccount', id: number, mask: string, name: string | null, institutionName: string | null, hasOnDemandAuthorization: boolean, isVerified: boolean | null, needsReverification: boolean, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null, business: { __typename: 'BeverageAdvisors', id: number, bankAccount: { __typename: 'BankAccount', id: number } | null } | { __typename: 'Distributor', id: number, bankAccount: { __typename: 'BankAccount', id: number } | null } | { __typename: 'LogisticsPartner', id: number, bankAccount: { __typename: 'BankAccount', id: number } | null } | { __typename: 'Producer', id: number, bankAccount: { __typename: 'BankAccount', id: number } | null } | { __typename: 'Retailer', id: number, bankAccount: { __typename: 'BankAccount', id: number } | null } } };

export type BillingInfoQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type BillingInfoQuery = { __typename: 'Query', organization: { __typename: 'Organization', businesses: Array<{ __typename: 'BeverageAdvisors', id: number, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, email: string, status: DwollaCustomerVerificationStatus } | null } | { __typename: 'Distributor', id: number, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, email: string, status: DwollaCustomerVerificationStatus } | null } | { __typename: 'LogisticsPartner', id: number, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, email: string, status: DwollaCustomerVerificationStatus } | null } | { __typename: 'Producer', id: number, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, email: string, status: DwollaCustomerVerificationStatus } | null } | { __typename: 'Retailer', id: number, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, email: string, status: DwollaCustomerVerificationStatus } | null }> } };

export type AdminAddProducerMutationVariables = Exact<{
  data: AddProducerData;
}>;


export type AdminAddProducerMutation = { __typename: 'Mutation', addProducer: { __typename: 'Organization', id: number, name: string, createdAt: any } };

export type AdminUpdateProducerMutationVariables = Exact<{
  id: Scalars['Int'];
  data: UpdateProducerData;
}>;


export type AdminUpdateProducerMutation = { __typename: 'Mutation', updateProducer: { __typename: 'Producer', id: number, displayName: string, globalBreweryId: number | null, fein: string | null, rating: number | null } };

export type UpdateProducerDataQueryVariables = Exact<{
  producerId: Scalars['Int'];
}>;


export type UpdateProducerDataQuery = { __typename: 'Query', producer: { __typename: 'Producer', id: number, name: string, globalBreweryId: number | null, rating: number | null, fein: string | null } };

export type AdminUpdateBusinessEntityMutationVariables = Exact<{
  id: Scalars['Int'];
  data: UpdateBusinessEntityData;
}>;


export type AdminUpdateBusinessEntityMutation = { __typename: 'Mutation', updateBusinessEntity: { __typename: 'BeverageAdvisors', id: number, displayName: string, fein: string | null } | { __typename: 'Distributor', id: number, displayName: string, fein: string | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, fein: string | null } | { __typename: 'Producer', id: number, displayName: string, fein: string | null } | { __typename: 'Retailer', id: number, displayName: string, fein: string | null } };

export type UpdateBusinessAddressMutationVariables = Exact<{
  data: AddressUpdateData;
  businessEntityId: Scalars['Int'];
}>;


export type UpdateBusinessAddressMutation = { __typename: 'Mutation', createOrUpdateBusinessAddress: { __typename: 'BeverageAdvisors', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Distributor', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'LogisticsPartner', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Producer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } | { __typename: 'Retailer', id: number, address: { __typename: 'Address', address1: string, address2: string | null, city: string, company: string | null, id: number | null, name: string, phone: string | null, state: string, zip: string } | null } };

export type AdminAddOrganizationAndDistributorMutationVariables = Exact<{
  data: AddOrganizationAndDistributorData;
}>;


export type AdminAddOrganizationAndDistributorMutation = { __typename: 'Mutation', addOrganizationAndDistributor: { __typename: 'Distributor', id: number } };

export type AdminUpdateDistributorDetailsMutationVariables = Exact<{
  id: Scalars['Int'];
  data: UpdateDistributorDetailsData;
}>;


export type AdminUpdateDistributorDetailsMutation = { __typename: 'Mutation', UpdateDistributorDetails: { __typename: 'Distributor', id: number, feePerPackageInCents: number } };

export type AutocompleteDistributorFragment = { __typename: 'Distributor', id: number, displayName: string };

export type AutocompleteDistributorsQueryVariables = Exact<{ [key: string]: never; }>;


export type AutocompleteDistributorsQuery = { __typename: 'Query', distributors: Array<{ __typename: 'Distributor', id: number, displayName: string }> };

type AutocompleteFundsAccount_BalanceAccount_Fragment = { __typename: 'BalanceAccount', balance: number, id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, name: string, displayName: string, businessType: BusinessType, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

type AutocompleteFundsAccount_BankAccount_Fragment = { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, name: string, displayName: string, businessType: BusinessType, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

type AutocompleteFundsAccount_ExternalFundsAccount_Fragment = { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Distributor', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Producer', id: number, name: string, displayName: string, businessType: BusinessType } | { __typename: 'Retailer', id: number, name: string, displayName: string, businessType: BusinessType, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } } };

export type AutocompleteFundsAccountFragment = AutocompleteFundsAccount_BalanceAccount_Fragment | AutocompleteFundsAccount_BankAccount_Fragment | AutocompleteFundsAccount_ExternalFundsAccount_Fragment;

export type FundsTransferDetailsFragment = { __typename: 'FundsTransfer', id: number, amount: number, status: FundsTransferStatus, statementDescriptor: string | null, createdAt: any, orderId: number | null, isPayment: boolean, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } };

export type InvoiceQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InvoiceQuery = { __typename: 'Query', invoice: { __typename: 'Invoice', id: number, number: string, externalAmountInCents: number | null, externalInvoiceId: string | null } };

export type InvoiceDisplayFragment = { __typename: 'Invoice', id: number, number: string, externalAmountInCents: number | null, externalInvoiceId: string | null };

export type AdminAddLicenseMutationVariables = Exact<{
  producerId: Scalars['Int'];
  data: LicenseAndLicensePeriodInput;
}>;


export type AdminAddLicenseMutation = { __typename: 'Mutation', addLicenseAndCurrentPeriod: { __typename: 'License', id: number, title: string, createdAt: any } };

export type AdminDeleteLicenseMutationVariables = Exact<{
  licenseId: Scalars['Int'];
}>;


export type AdminDeleteLicenseMutation = { __typename: 'Mutation', deleteLicense: { __typename: 'License', title: string } | null };

export type LicenseFieldsFragment = { __typename: 'License', id: number, title: string, number: string, createdAt: any, documentUrl: string | null, stateV2: { __typename: 'StateV2', id: number, name: string }, currentLicensePeriod: { __typename: 'LicensePeriod', startDate: any, endDate: any } };

export type AdminRenewLicenseMutationVariables = Exact<{
  licenseId: Scalars['Int'];
  data: LicensePeriodInput;
}>;


export type AdminRenewLicenseMutation = { __typename: 'Mutation', addLicensePeriod: { __typename: 'LicensePeriod', id: number, license: { __typename: 'License', title: string } } | null };

export type AdminLicenseQueryVariables = Exact<{
  licenseId: Scalars['Int'];
}>;


export type AdminLicenseQuery = { __typename: 'Query', license: { __typename: 'License', id: number, title: string, number: string, createdAt: any, documentUrl: string | null, stateV2: { __typename: 'StateV2', name: string, id: number }, currentLicensePeriod: { __typename: 'LicensePeriod', startDate: any, endDate: any } } };

export type AdminUpdateLicenseMutationVariables = Exact<{
  licenseId: Scalars['Int'];
  data: LicenseAndLicensePeriodInput;
}>;


export type AdminUpdateLicenseMutation = { __typename: 'Mutation', updateLicenseAndCurrentPeriod: { __typename: 'License', id: number, title: string } };

export type AdminAddOrganizationAndLogisticsPartnerMutationVariables = Exact<{
  data: AddOrganizationAndLogisticsPartnerData;
}>;


export type AdminAddOrganizationAndLogisticsPartnerMutation = { __typename: 'Mutation', addOrganizationAndLogisticsPartner: { __typename: 'LogisticsPartner', id: number } };

export type AutocompleteLogisticsPartnerFragment = { __typename: 'LogisticsPartner', id: number, displayName: string };

export type AutocompleteLogisticsPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type AutocompleteLogisticsPartnersQuery = { __typename: 'Query', logisticsPartners: Array<{ __typename: 'LogisticsPartner', id: number, displayName: string }> };

export type OrderAutocompleteResponseAllFragment = { __typename: 'OrderAutocompleteResponse', id: number, externalInvoiceId: string, orderNumber: string };

export type OrderDocumentSummaryFragment = { __typename: 'OrderDocument', id: number, createdAt: any, name: string, notes: string | null, fileUrl: string, documentType: DocumentType, creator: { __typename: 'User', id: number, email: string } };

export type AdminOrganizationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminOrganizationQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: number, name: string, createdAt: any, businesses: Array<{ __typename: 'BeverageAdvisors', id: number, displayName: string, fein: string | null, businessType: BusinessType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Distributor', id: number, displayName: string, fein: string | null, businessType: BusinessType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, fein: string | null, businessType: BusinessType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Producer', id: number, displayName: string, fein: string | null, businessType: BusinessType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null } | { __typename: 'Retailer', id: number, displayName: string, fein: string | null, businessType: BusinessType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, type: DwollaCustomerType, status: DwollaCustomerVerificationStatus } | null, bankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, dwollaFundingSource: { __typename: 'DwollaFundingSource', id: string } | null, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } | null, balanceAccount: { __typename: 'BalanceAccount', id: number, balance: number } | null }> } };

export type AdminUpdateOrganizationMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
}>;


export type AdminUpdateOrganizationMutation = { __typename: 'Mutation', updateOrganization: { __typename: 'Organization', id: number, name: string } };

export type OrganizationFieldsFragment = { __typename: 'Organization', id: number, name: string, businessType: BusinessType, createdAt: any };

export type AddPackageTypeMutationVariables = Exact<{
  data: ProductPackageTypeInput;
}>;


export type AddPackageTypeMutation = { __typename: 'Mutation', createProductPackageType: { __typename: 'ProductPackageType', id: number } | null };

export type DeletePackageTypeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePackageTypeMutation = { __typename: 'Mutation', deleteProductPackageType: { __typename: 'ProductPackageType', id: number } | null };

export type PackageTypeDetailsFragment = { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel, containerVolume: number, containerVolumeUnit: ContainerVolumeUnit, containerStreetName: string | null, createdAt: any, weight: number, canDelete: boolean };

export type ProductFulfillmentExclusionReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductFulfillmentExclusionReasonsQuery = { __typename: 'Query', ProductFulfillmentExclusionReasons: Array<{ __typename: 'ProductFulfillmentExclusionReason', label: string, id: number }> };

export type UpdatePreSaleProducerFulfillmentExclusionMutationVariables = Exact<{
  data: UpdatePreSaleProducerFulfillmentExclusionInput;
}>;


export type UpdatePreSaleProducerFulfillmentExclusionMutation = { __typename: 'Mutation', updatePreSaleProducerFulfillmentExclusion: Array<{ __typename: 'PreSaleProductMetadata', preSaleId: number, producerId: number | null, excludeFromFulfillment: boolean, exclusionReasonId: number | null }> };

export type UpdatePreSaleProductFulfillmentExclusionMutationVariables = Exact<{
  data: UpdatePreSaleProductFulfillmentExclusionInput;
}>;


export type UpdatePreSaleProductFulfillmentExclusionMutation = { __typename: 'Mutation', updatePreSaleProductFulfillmentExclusion: { __typename: 'PreSaleProductMetadata', preSaleId: number, productId: number, excludeFromFulfillment: boolean, exclusionReasonId: number | null } | null };

export type AutocompleteProducerFragment = { __typename: 'Producer', id: number, displayName: string };

export type AutocompleteProducersQueryVariables = Exact<{ [key: string]: never; }>;


export type AutocompleteProducersQuery = { __typename: 'Query', producers: Array<{ __typename: 'Producer', id: number, displayName: string }> };

export type RedirectToOrganizationQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type RedirectToOrganizationQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: number, businessType: BusinessType } };

export type AdminAddFirstRetailerLocationMutationVariables = Exact<{
  organizationName: Scalars['String'];
  locationName: Scalars['String'];
  region: Scalars['Int'];
  forceDwollaBusinessCustomer: Scalars['Boolean'];
}>;


export type AdminAddFirstRetailerLocationMutation = { __typename: 'Mutation', addFirstRetailerLocation: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, createdAt: any } };

export type AutocompleteRetailerFragment = { __typename: 'Retailer', id: number, displayName: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } };

export type AutocompleteRetailersQueryVariables = Exact<{ [key: string]: never; }>;


export type AutocompleteRetailersQuery = { __typename: 'Query', retailers: Array<{ __typename: 'Retailer', id: number, displayName: string, regionV2: { __typename: 'RegionV2', id: number, friendlyName: string } }> };

export type AddLocationMutationVariables = Exact<{
  data: RetailLocationInput;
}>;


export type AddLocationMutation = { __typename: 'Mutation', addLocation: { __typename: 'Retailer', id: number, organization: { __typename: 'Organization', businesses: Array<{ __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, businessType: BusinessType }> } } };

export type AddLocationFormDataQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type AddLocationFormDataQuery = { __typename: 'Query', organization: { __typename: 'Organization', name: string } };

type FundsTransferAccount_BalanceAccount_Fragment = { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } };

type FundsTransferAccount_BankAccount_Fragment = { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } };

type FundsTransferAccount_ExternalFundsAccount_Fragment = { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } };

export type FundsTransferAccountFragment = FundsTransferAccount_BalanceAccount_Fragment | FundsTransferAccount_BankAccount_Fragment | FundsTransferAccount_ExternalFundsAccount_Fragment;

export type FundsTransferBusinessDisplayFragment = { __typename: 'FundsTransfer', id: number, amount: number, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, invoice: { __typename: 'Invoice', id: number, number: string } | null };

export type FundsTransferFieldsFragment = { __typename: 'FundsTransfer', id: number, amount: number, statementDescriptor: string | null, createdAt: any, status: FundsTransferStatus, source: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } }, destination: { __typename: 'BalanceAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'BankAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } | { __typename: 'ExternalFundsAccount', id: number, type: FundsAccountType, label: string, business: { __typename: 'BeverageAdvisors', id: number, displayName: string } | { __typename: 'Distributor', id: number, displayName: string } | { __typename: 'LogisticsPartner', id: number, displayName: string } | { __typename: 'Producer', id: number, displayName: string } | { __typename: 'Retailer', id: number, displayName: string } } };

export type UpdateDwollaCustomerMutationVariables = Exact<{
  data: UpdateDwollaCustomerInput;
}>;


export type UpdateDwollaCustomerMutation = { __typename: 'Mutation', updateDwollaCustomer: { __typename: 'DwollaCustomer', id: string, email: string } | null };

export type ValidationResultFragment = { __typename: 'ValidationResult', name: string, description: string | null, isValid: boolean, checks: Array<{ __typename: 'CheckResult', passed: boolean, hideOnPass: boolean, description: string, data: any | null }> };

export type UpsertDwollaCustomerMutationVariables = Exact<{
  customerId: Scalars['String'];
  businessEntityId: Scalars['Int'];
}>;


export type UpsertDwollaCustomerMutation = { __typename: 'Mutation', upsertDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, business: { __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | null } | null };

export type RefreshPlaidItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RefreshPlaidItemMutation = { __typename: 'Mutation', refreshPlaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null, bankAccount: { __typename: 'BankAccount', business: { __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, onboarding: { __typename: 'Onboarding', id: number, steps: Array<OnboardingStepType>, currentStep: { __typename: 'BankAccountOnboardingStep', step: OnboardingStepType, bankAccount: { __typename: 'BankAccount', id: number, hasOnDemandAuthorization: boolean } | null } | { __typename: 'BeneficialOwnerOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus, businessEntityId: number } } | { __typename: 'CompleteOnboardingStep', step: OnboardingStepType, dwollaCustomerType: DwollaCustomerType, canCompleteOnboarding: boolean, dwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string, requiresBeneficialOwnershipCertification: boolean, beneficialOwnerCertificationStatus: DwollaCustomerBeneficialOwnerCertificationStatus }, completeStepBankAccount: { __typename: 'BankAccount', id: number, name: string | null, institutionName: string | null, mask: string, plaidItem: { __typename: 'PlaidItem', id: number, verificationStatus: PlaidVerificationStatus | null } | null } } | { __typename: 'DwollaOnboardingStep', step: OnboardingStepType, customerType: DwollaCustomerType, dwollaStepDwollaCustomer: { __typename: 'DwollaCustomer', id: string, status: DwollaCustomerVerificationStatus, createdAt: string } | null } } | null } } | null } };

export type PlaidItemLinkTokenQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PlaidItemLinkTokenQuery = { __typename: 'Query', plaidItem: { __typename: 'PlaidItem', id: number, linkToken: { __typename: 'PlaidLinkToken', linkToken: string, expiration: string } } };

export type PlaidLinkTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaidLinkTokenQuery = { __typename: 'Query', plaidLinkToken: { __typename: 'PlaidLinkToken', linkToken: string, expiration: string } };

export type AutocompleteQueryVariables = Exact<{
  model: Models;
  query: Scalars['String'];
  field: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteQuery = { __typename: 'Query', autocomplete: Array<{ __typename: 'AutocompleteResponse', id: number, name: string } | null> };

export type OfferAutocompleteQueryVariables = Exact<{
  filters: InputMaybe<OfferSearchFilters>;
}>;


export type OfferAutocompleteQuery = { __typename: 'Query', searchOffers: { __typename: 'PaginatedOffers', results: Array<{ __typename: 'Offer', id: number, product: { __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null } }> } };

export type ProductAutocompleteQueryVariables = Exact<{
  filters: InputMaybe<ProductsFilterData>;
}>;


export type ProductAutocompleteQuery = { __typename: 'Query', searchProducts: { __typename: 'PaginatedProducts', results: Array<{ __typename: 'Product', id: number, name: string, packageDate: any | null, producer: { __typename: 'Producer', id: number, displayName: string }, packageType: { __typename: 'ProductPackageType', id: number, displayName: string, units: number, containerLabel: ContainerLabel }, productImage: { __typename: 'ProductImage', id: number, rawUrl: string, thumbnailUrl: string } | null }> } };

export type BusinessOnboardingStatusQueryVariables = Exact<{
  businessId: Scalars['Int'];
}>;


export type BusinessOnboardingStatusQuery = { __typename: 'Query', business: { __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null } };

export type GetShopifyUrlWithLoginTokenQueryVariables = Exact<{
  organizationId: Scalars['Int'];
  path: InputMaybe<Scalars['String']>;
}>;


export type GetShopifyUrlWithLoginTokenQuery = { __typename: 'Query', getShopifyUrlWithLoginToken: { __typename: 'ShopifyUrlWithLoginTokenResponse', shopifyUrlWithLoginToken: string | null } | null };

export type BreweryQueryVariables = Exact<{
  breweryId: Scalars['Int'];
}>;


export type BreweryQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: number, businesses: Array<{ __typename: 'BeverageAdvisors', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Distributor', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Producer', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Retailer', id: number, displayName: string, completedOnboardingAt: any | null }> } };

export type BreweryFieldsFragment = { __typename: 'Organization', id: number, businesses: Array<{ __typename: 'BeverageAdvisors', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Distributor', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Producer', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Retailer', id: number, displayName: string, completedOnboardingAt: any | null }> };

export type DistributorQueryVariables = Exact<{
  distributorId: Scalars['Int'];
}>;


export type DistributorQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: number, businesses: Array<{ __typename: 'BeverageAdvisors', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Distributor', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Producer', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Retailer', id: number, displayName: string, completedOnboardingAt: any | null }> } };

export type DistributorFieldsFragment = { __typename: 'Organization', id: number, businesses: Array<{ __typename: 'BeverageAdvisors', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Distributor', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Producer', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Retailer', id: number, displayName: string, completedOnboardingAt: any | null }> };

export type RetailerQueryVariables = Exact<{
  retailerId: Scalars['Int'];
}>;


export type RetailerQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: number, businesses: Array<{ __typename: 'BeverageAdvisors', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Distributor', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Producer', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Retailer', id: number, displayName: string, completedOnboardingAt: any | null }> } };

export type RetailerFieldsFragment = { __typename: 'Organization', id: number, businesses: Array<{ __typename: 'BeverageAdvisors', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Distributor', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'LogisticsPartner', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Producer', id: number, displayName: string, completedOnboardingAt: any | null } | { __typename: 'Retailer', id: number, displayName: string, completedOnboardingAt: any | null }> };

export type DeliveryPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type DeliveryPartnersQuery = { __typename: 'Query', logisticsPartners: Array<{ __typename: 'LogisticsPartner', id: number, displayName: string }>, distributors: Array<{ __typename: 'Distributor', id: number, displayName: string }> };

export type PackageTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type PackageTypesQuery = { __typename: 'Query', productPackageTypes: Array<{ __typename: 'ProductPackageType', id: number, displayName: string }> };

export type RegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionsQuery = { __typename: 'Query', regions: Array<{ __typename: 'RegionV2', id: number, friendlyName: string }> };

export type StatesQueryVariables = Exact<{ [key: string]: never; }>;


export type StatesQuery = { __typename: 'Query', statesWhereRegionExists: Array<{ __typename: 'StateV2', id: number, name: string }> };

type BusinessShort_BeverageAdvisors_Fragment = { __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, businessType: BusinessType };

type BusinessShort_Distributor_Fragment = { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, businessType: BusinessType };

type BusinessShort_LogisticsPartner_Fragment = { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, businessType: BusinessType };

type BusinessShort_Producer_Fragment = { __typename: 'Producer', id: number, completedOnboardingAt: any | null, businessType: BusinessType };

type BusinessShort_Retailer_Fragment = { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, businessType: BusinessType };

export type BusinessShortFragment = BusinessShort_BeverageAdvisors_Fragment | BusinessShort_Distributor_Fragment | BusinessShort_LogisticsPartner_Fragment | BusinessShort_Producer_Fragment | BusinessShort_Retailer_Fragment;

export type UserAuthFieldsFragment = { __typename: 'User', id: number, isGlobalAdmin: boolean, organization: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, businesses: Array<{ __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, businessType: BusinessType }> } | null, organizations: Array<{ __typename: 'Organization', id: number, name: string, businessType: BusinessType, businesses: Array<{ __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, businessType: BusinessType }> }> };

export type WhoAmIQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoAmIQuery = { __typename: 'Query', whoAmI: { __typename: 'User', id: number, isGlobalAdmin: boolean, organization: { __typename: 'Organization', id: number, name: string, businessType: BusinessType, businesses: Array<{ __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, businessType: BusinessType }> } | null, organizations: Array<{ __typename: 'Organization', id: number, name: string, businessType: BusinessType, businesses: Array<{ __typename: 'BeverageAdvisors', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Distributor', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'LogisticsPartner', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Producer', id: number, completedOnboardingAt: any | null, businessType: BusinessType } | { __typename: 'Retailer', id: number, completedOnboardingAt: any | null, businessType: BusinessType }> }> } | null };

export type AuditLogDetailsFragment = { __typename: 'AuditLog', id: number, occurredAt: any, changes: any | null, snapshot: any | null, message: string, user: { __typename: 'User', id: number, email: string } | null };

export const AdminDistributorDisplayFragmentDoc = gql`
    fragment AdminDistributorDisplay on Distributor {
  id
  displayName
  organizationId
}
    `;
export const PlatformFeeDetailsFragmentDoc = gql`
    fragment PlatformFeeDetails on PackageTypePlatformFee {
  id
  amount
}
    `;
export const AdminRegionDeliveryPartnerDetailsFragmentDoc = gql`
    fragment AdminRegionDeliveryPartnerDetails on RegionV2 {
  id
  friendlyName
  deliveryPartner {
    id
    displayName
  }
}
    `;
export const AdminRegionDetailsFragmentDoc = gql`
    fragment AdminRegionDetails on RegionV2 {
  id
  friendlyName
  abbreviation
  shopifyIdentifier
  state {
    id
    name
  }
  ...AdminRegionDeliveryPartnerDetails
}
    ${AdminRegionDeliveryPartnerDetailsFragmentDoc}`;
export const AdminRegionsTableRowDataFragmentDoc = gql`
    fragment AdminRegionsTableRowData on RegionV2 {
  id
  friendlyName
  state {
    id
    name
  }
}
    `;
export const FreightShipmentSearchResultFragmentDoc = gql`
    fragment FreightShipmentSearchResult on TrackingInformation {
  id
  orderId
  trackingNumber
}
    `;
export const LogisticsPartnerSearchResultFragmentDoc = gql`
    fragment LogisticsPartnerSearchResult on LogisticsPartner {
  id
  displayName
}
    `;
export const ProducerPurchaseOrderSearchResultFragmentDoc = gql`
    fragment ProducerPurchaseOrderSearchResult on ProducerPurchaseOrder {
  id
  number
  regionV2 {
    id
    friendlyName
  }
  seller {
    id
    displayName
  }
}
    `;
export const ProducerSearchResultFragmentDoc = gql`
    fragment ProducerSearchResult on Producer {
  id
  displayName
  address {
    id
    city
    state
  }
}
    `;
export const RetailerSalesOrderSearchResultFragmentDoc = gql`
    fragment RetailerSalesOrderSearchResult on RetailerSalesOrder {
  id
  number
  producerPurchaseOrder {
    id
    regionV2 {
      id
      friendlyName
    }
    seller {
      id
      displayName
    }
  }
  buyer {
    id
    displayName
  }
}
    `;
export const RetailerSearchResultFragmentDoc = gql`
    fragment RetailerSearchResult on Retailer {
  id
  displayName
  address {
    id
    city
    state
  }
}
    `;
export const AdminLogisticsPartnerDisplayFragmentDoc = gql`
    fragment AdminLogisticsPartnerDisplay on LogisticsPartner {
  id
  displayName
  organizationId
}
    `;
export const ValidationResultFragmentDoc = gql`
    fragment ValidationResult on ValidationResult {
  name
  description
  isValid
  checks {
    passed
    hideOnPass
    description
    data
  }
}
    `;
export const ProductDisplayFragmentDoc = gql`
    fragment ProductDisplay on Product {
  id
  name
  producer {
    id
    displayName
  }
  packageType {
    id
    displayName
    units
    containerLabel
  }
  productImage {
    id
    rawUrl
    thumbnailUrl
  }
  packageDate
}
    `;
export const AdminOfferWindowOfferFragmentDoc = gql`
    fragment AdminOfferWindowOffer on Offer {
  id
  netPrice
  platformPrice
  wholesalePrice
  quantity
  canDelete
  canUpdate
  shopifyProductId
  shopifyLink
  earliestPickup
  product {
    id
    canOfferProduct {
      ...ValidationResult
    }
    ...ProductDisplay
  }
}
    ${ValidationResultFragmentDoc}
${ProductDisplayFragmentDoc}`;
export const AdminOfferWindowOffersFragmentDoc = gql`
    fragment AdminOfferWindowOffers on OfferWindow {
  id
  regionV2 {
    id
    friendlyName
  }
  start
  end
  canUpdate
  canDelete
}
    `;
export const AdminOfferWindowTableDataFragmentDoc = gql`
    fragment AdminOfferWindowTableData on OfferWindow {
  id
  regionV2 {
    id
    friendlyName
  }
  start
  end
}
    `;
export const AdminProductDetailsFragmentDoc = gql`
    fragment AdminProductDetails on Product {
  id
  createdAt
  updatedAt
  name
  producer {
    id
    displayName
  }
  packageType {
    id
    displayName
  }
  packageDate
  abv
  canDelete
  description
  rating
  beerStyle {
    id
    name
  }
  productImage {
    id
    rawUrl
    thumbnailUrl
  }
  breweryNetPrice
}
    `;
export const DwollaCustomerBillingInfoFragmentDoc = gql`
    fragment DwollaCustomerBillingInfo on DwollaCustomer {
  id
  email
  status
}
    `;
export const LedgerDetailsFragmentDoc = gql`
    fragment LedgerDetails on Ledger {
  id
  due
  balance
  total
  pendingTotal
  completedTotal
  status
}
    `;
export const FundsTransferAccountFragmentDoc = gql`
    fragment FundsTransferAccount on FundsAccount {
  id
  type
  label
  business {
    id
    displayName
  }
}
    `;
export const FundsTransferDetailsFragmentDoc = gql`
    fragment FundsTransferDetails on FundsTransfer {
  id
  amount
  status
  statementDescriptor
  createdAt
  source {
    ...FundsTransferAccount
  }
  destination {
    ...FundsTransferAccount
  }
  orderId
  isPayment
}
    ${FundsTransferAccountFragmentDoc}`;
export const OrderBalanceTransferBalancesFragmentDoc = gql`
    fragment OrderBalanceTransferBalances on Order {
  id
  bankDepositsLedger {
    ...LedgerDetails
    transfers {
      ...FundsTransferDetails
    }
  }
}
    ${LedgerDetailsFragmentDoc}
${FundsTransferDetailsFragmentDoc}`;
export const TransferProposalDetailsFragmentDoc = gql`
    fragment TransferProposalDetails on TransferProposal {
  amount
  destination {
    id
    type
    label
    business {
      id
      displayName
    }
  }
  source {
    id
    type
    label
    business {
      id
      displayName
    }
  }
  statementDescriptor
}
    `;
export const SendBalanceTransferDetailsFragmentDoc = gql`
    fragment SendBalanceTransferDetails on ProducerPurchaseOrder {
  bankDepositsLedger {
    ...LedgerDetails
    transfers {
      ...FundsTransferDetails
    }
  }
  balanceTransferProposal {
    ...TransferProposalDetails
  }
  canSendBalanceTransfer {
    ...ValidationResult
  }
}
    ${LedgerDetailsFragmentDoc}
${FundsTransferDetailsFragmentDoc}
${TransferProposalDetailsFragmentDoc}
${ValidationResultFragmentDoc}`;
export const SendDistributorBalanceTransferDetailsFragmentDoc = gql`
    fragment SendDistributorBalanceTransferDetails on DistributorPurchaseOrder {
  bankDepositsLedger {
    ...LedgerDetails
    transfers {
      ...FundsTransferDetails
    }
  }
  balanceTransferProposal {
    ...TransferProposalDetails
  }
  canSendBalanceTransfer {
    ...ValidationResult
  }
}
    ${LedgerDetailsFragmentDoc}
${FundsTransferDetailsFragmentDoc}
${TransferProposalDetailsFragmentDoc}
${ValidationResultFragmentDoc}`;
export const AdminOrderItemFragmentDoc = gql`
    fragment AdminOrderItem on OrderItem {
  product {
    ...ProductDisplay
  }
  productId
  quantity
  price
  wholesalePrice
  orderId
  offerId
  totalUnits
  total
  wholesaleTotal
  finalQuantity
  finalTotal
  finalWholesaleTotal
  finalQuantityDisplay
  hasAdjustmentItems
}
    ${ProductDisplayFragmentDoc}`;
export const AdminAdjustmentItemFragmentDoc = gql`
    fragment AdminAdjustmentItem on AdjustmentItem {
  id
  productId
  units
  total
  wholesaleTotal
  orderItem {
    ...AdminOrderItem
    pricePerUnit
    wholesalePricePerUnit
  }
  adjustmentReason {
    id
    label
  }
  adjustmentReasonId
  notes
}
    ${AdminOrderItemFragmentDoc}`;
export const AdminOrderItemsDataFragmentDoc = gql`
    fragment AdminOrderItemsData on Order {
  type
  amountInCents
  finalOrderTotalInCents
  adjustmentTotalInCents
  items {
    ...AdminOrderItem
  }
  adjustmentItems {
    ...AdminAdjustmentItem
  }
  ... on DistributorPurchaseOrder {
    distributorFee
  }
}
    ${AdminOrderItemFragmentDoc}
${AdminAdjustmentItemFragmentDoc}`;
export const RetailerOrderStatusDataFragmentDoc = gql`
    fragment RetailerOrderStatusData on RetailerSalesOrder {
  cancelledAt
  deliveryStatus
  paymentStatus
}
    `;
export const AdminOrderSummaryFragmentDoc = gql`
    fragment AdminOrderSummary on Order {
  id
  number
  amountInCents
  createdAt
  deletedAt
  regionV2 {
    id
    friendlyName
  }
  invoice {
    externalInvoiceId
    externalAmountInCents
  }
  buyer {
    id
    businessType
  }
  buyerName
  seller {
    id
    displayName
    businessType
  }
  preSale {
    id
    number
  }
  adjustmentTotalInCents
  finalOrderTotalInCents
  paymentStatus
  balanceTransferStatus
  cancelledAt
  deliveredAt
  enabledFeatures {
    canCreatePDF
    canDeleteOrder
    canEditOrder
    canEditOrderItems
    canViewAdjustments
    canCreatePDFBundle
  }
  paymentsLedger {
    id
    total
  }
  ... on DistributorPurchaseOrder {
    distributorFee
  }
  ... on ProducerPurchaseOrder {
    platformFee
    earliestPickup
    producerInvoiceStatus
    deliveryStatus
    feeStatus
    retailOrdersCount
    deliveredRetailOrdersCount
    paidRetailOrdersCount
    trackingInformation {
      id
      status
    }
    distributorPurchaseOrder {
      paymentStatus
      balanceTransferStatus
    }
  }
  ... on RetailerSalesOrder {
    ...RetailerOrderStatusData
  }
  documents {
    id
    name
    documentType
    createdAt
  }
}
    ${RetailerOrderStatusDataFragmentDoc}`;
export const DistributorPaymentBalancesFragmentDoc = gql`
    fragment DistributorPaymentBalances on ProducerPurchaseOrder {
  distributorPaymentsLedger {
    ...LedgerDetails
  }
  canSendDistributorPayment {
    ...ValidationResult
  }
}
    ${LedgerDetailsFragmentDoc}
${ValidationResultFragmentDoc}`;
export const OrderPaymentBalancesFragmentDoc = gql`
    fragment OrderPaymentBalances on Order {
  id
  paymentsLedger {
    ...LedgerDetails
    transfers {
      ...FundsTransferDetails
    }
  }
  ... on ProducerPurchaseOrder {
    adjustmentPaymentsLedger {
      ...LedgerDetails
      transfers {
        ...FundsTransferDetails
      }
    }
  }
}
    ${LedgerDetailsFragmentDoc}
${FundsTransferDetailsFragmentDoc}`;
export const SendAdjustmentsPaymentDetailsFragmentDoc = gql`
    fragment SendAdjustmentsPaymentDetails on ProducerPurchaseOrder {
  adjustmentPaymentsLedger {
    ...LedgerDetails
    transfers {
      ...FundsTransferDetails
    }
  }
  adjustmentsPaymentProposal {
    ...TransferProposalDetails
  }
  canSendAdjustmentsPayment {
    ...ValidationResult
  }
}
    ${LedgerDetailsFragmentDoc}
${FundsTransferDetailsFragmentDoc}
${TransferProposalDetailsFragmentDoc}
${ValidationResultFragmentDoc}`;
export const SendDistributorPaymentDetailsFragmentDoc = gql`
    fragment SendDistributorPaymentDetails on ProducerPurchaseOrder {
  distributorPaymentsLedger {
    ...LedgerDetails
    transfers {
      ...FundsTransferDetails
    }
  }
  distributorPaymentProposal {
    ...TransferProposalDetails
  }
  canSendDistributorPayment {
    ...ValidationResult
  }
}
    ${LedgerDetailsFragmentDoc}
${FundsTransferDetailsFragmentDoc}
${TransferProposalDetailsFragmentDoc}
${ValidationResultFragmentDoc}`;
export const SendRetailerPaymentDetailsFragmentDoc = gql`
    fragment SendRetailerPaymentDetails on RetailerSalesOrder {
  paymentsLedger {
    ...LedgerDetails
    transfers {
      ...FundsTransferDetails
    }
  }
  sendPaymentProposal {
    ...TransferProposalDetails
  }
  canSendPayment {
    ...ValidationResult
  }
}
    ${LedgerDetailsFragmentDoc}
${FundsTransferDetailsFragmentDoc}
${TransferProposalDetailsFragmentDoc}
${ValidationResultFragmentDoc}`;
export const AdminPackageSummaryTableDataFragmentDoc = gql`
    fragment AdminPackageSummaryTableData on PackageSummaryItem {
  packageType {
    id
    displayName
  }
  totalQuantity
  totalWeight
}
    `;
export const PlatformFeeBalancesFragmentDoc = gql`
    fragment PlatformFeeBalances on ProducerPurchaseOrder {
  platformFeeLedger {
    ...LedgerDetails
  }
  platformFee
}
    ${LedgerDetailsFragmentDoc}`;
export const AdminPlatformFeeFieldsFragmentDoc = gql`
    fragment AdminPlatformFeeFields on ProducerPurchaseOrder {
  ...PlatformFeeBalances
  missingPlatformFeeConfiguration
  platformFeeCalculated
  platformFeeOverride
  feesPayments {
    ...FundsTransferDetails
  }
  canCollectPlatformFee {
    ...ValidationResult
  }
}
    ${PlatformFeeBalancesFragmentDoc}
${FundsTransferDetailsFragmentDoc}
${ValidationResultFragmentDoc}`;
export const CollectPlatformFeeDetailsFragmentDoc = gql`
    fragment CollectPlatformFeeDetails on ProducerPurchaseOrder {
  platformFeeLedger {
    ...LedgerDetails
    transfers {
      ...FundsTransferDetails
    }
  }
  collectPlatformFeeProposal {
    ...TransferProposalDetails
  }
  canCollectPlatformFee {
    ...ValidationResult
  }
}
    ${LedgerDetailsFragmentDoc}
${FundsTransferDetailsFragmentDoc}
${TransferProposalDetailsFragmentDoc}
${ValidationResultFragmentDoc}`;
export const FundsTransferFieldsFragmentDoc = gql`
    fragment FundsTransferFields on FundsTransfer {
  id
  amount
  statementDescriptor
  createdAt
  status
  source {
    ...FundsTransferAccount
  }
  destination {
    ...FundsTransferAccount
  }
}
    ${FundsTransferAccountFragmentDoc}`;
export const FeePaymentFieldsFragmentDoc = gql`
    fragment FeePaymentFields on FundsTransfer {
  ...FundsTransferFields
  isFee
}
    ${FundsTransferFieldsFragmentDoc}`;
export const AdminOrderTransferDetailsFragmentDoc = gql`
    fragment AdminOrderTransferDetails on Order {
  id
  number
  amountInCents
  ... on RetailerSalesOrder {
    producerPurchaseOrder {
      id
      invoice {
        id
        externalInvoiceId
        externalAmountInCents
      }
    }
  }
  ... on DistributorPurchaseOrder {
    producerPurchaseOrder {
      id
      invoice {
        id
        externalInvoiceId
        externalAmountInCents
      }
    }
  }
  ... on ProducerPurchaseOrder {
    invoice {
      id
      externalInvoiceId
      externalAmountInCents
    }
    platformFee
  }
  buyer {
    id
    displayName
    businessType
    validBankAccount {
      id
      mask
      name
      institutionName
    }
    validBalanceAccount {
      id
      balance
    }
  }
  seller {
    id
    displayName
    businessType
    validBankAccount {
      id
      mask
      name
      institutionName
    }
    validBalanceAccount {
      id
      balance
    }
  }
  adjustmentTotalInCents
  finalOrderTotalInCents
}
    `;
export const TrackingInformationDetailsFragmentDoc = gql`
    fragment TrackingInformationDetails on TrackingInformation {
  id
  trackingNumber
  trackingLink
  carrier {
    id
    displayName
  }
  estimatedPickupDate
  estimatedArrivalDate
  estimatedCostInCents
  palletCount
  deliveredAt
  actualCostInCents
  freightTrailerNumber
  freightInvoiceNumber
  status
  pickedUpAt
  deliveredAt
  cancelledAt
  kuebixShipmentId
}
    `;
export const PreSaleImportJobDetailsFragmentDoc = gql`
    fragment PreSaleImportJobDetails on PreSaleImportJob {
  id
  createdAt
  regionV2 {
    id
    friendlyName
  }
  start
  end
  status
}
    `;
export const PreSaleDisplayFragmentDoc = gql`
    fragment PreSaleDisplay on PreSale {
  id
  number
  regionV2 {
    id
    friendlyName
  }
  start
  end
  status
  orderCount
}
    `;
export const PreSaleOrderTableDataFragmentDoc = gql`
    fragment PreSaleOrderTableData on PreSaleOrder {
  id
  shopifyId
  number
  amountInCents
  createdAt
  cancelledAt
  buyer {
    id
    displayName
  }
}
    `;
export const AdminPreSaleOrderItemFragmentDoc = gql`
    fragment AdminPreSaleOrderItem on OrderItem {
  product {
    ...ProductDisplay
  }
  productId
  quantity
  price
  wholesalePrice
  orderId
  totalUnits
  total
  wholesaleTotal
  finalQuantity
  finalTotal
  finalWholesaleTotal
  finalQuantityDisplay
}
    ${ProductDisplayFragmentDoc}`;
export const AdminPreSaleOrderItemsDataFragmentDoc = gql`
    fragment AdminPreSaleOrderItemsData on Order {
  type
  amountInCents
  finalOrderTotalInCents
  items {
    ...AdminPreSaleOrderItem
  }
}
    ${AdminPreSaleOrderItemFragmentDoc}`;
export const AdminPreSaleProducerSummaryPackageTypesFragmentDoc = gql`
    fragment AdminPreSaleProducerSummaryPackageTypes on PreSaleProducerSummary {
  packageTypes {
    count
    packageType
  }
}
    `;
export const AdminPreSaleProducerSummaryDisplayFragmentDoc = gql`
    fragment AdminPreSaleProducerSummaryDisplay on PreSaleProducerSummary {
  ...AdminPreSaleProducerSummaryPackageTypes
  producer
  producerId
  isExcluded
  exclusionReason {
    id
    label
  }
  totalUnits
}
    ${AdminPreSaleProducerSummaryPackageTypesFragmentDoc}`;
export const PresaleProductDisplayFragmentDoc = gql`
    fragment PresaleProductDisplay on PreSaleProduct {
  product {
    ...ProductDisplay
  }
  preSaleId
  quantity
  totalInCents
  excludeFromFulfillment
  productFulfillmentExclusionReason {
    id
    label
  }
}
    ${ProductDisplayFragmentDoc}`;
export const PreSalesDisplayFragmentDoc = gql`
    fragment PreSalesDisplay on PreSale {
  id
  number
  regionV2 {
    id
    friendlyName
  }
  start
  end
}
    `;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  address1
  address2
  city
  company
  id
  name
  phone
  state
  zip
}
    `;
export const OrganizationFieldsFragmentDoc = gql`
    fragment OrganizationFields on Organization {
  id
  name
  businessType
  createdAt
}
    `;
export const AdminDwollaCustomerDetailsFragmentDoc = gql`
    fragment AdminDwollaCustomerDetails on DwollaCustomer {
  id
  type
  status
  beneficialOwnerCertificationStatus
  requiresBeneficialOwnershipCertification
}
    `;
export const AdminBankAccountDetailsFragmentDoc = gql`
    fragment AdminBankAccountDetails on BankAccount {
  id
  name
  institutionName
  mask
  removedAt
  dwollaFundingSource {
    id
  }
  plaidItem {
    id
    itemId
    verificationStatus
  }
}
    `;
export const AdminProducerDetailsFragmentDoc = gql`
    fragment AdminProducerDetails on Producer {
  id
  displayName
  globalBreweryId
  rating
  fein
  address {
    ...Address
  }
  completedOnboardingAt
  organization {
    ...OrganizationFields
  }
  dwollaCustomer {
    ...AdminDwollaCustomerDetails
  }
  bankAccount {
    ...AdminBankAccountDetails
  }
}
    ${AddressFragmentDoc}
${OrganizationFieldsFragmentDoc}
${AdminDwollaCustomerDetailsFragmentDoc}
${AdminBankAccountDetailsFragmentDoc}`;
export const ProducerPlatformFeeDetailsFragmentDoc = gql`
    fragment ProducerPlatformFeeDetails on ProducerPlatformFee {
  id
  amount
}
    `;
export const AdminProducersTableDataFragmentDoc = gql`
    fragment AdminProducersTableData on Producer {
  id
  displayName
}
    `;
export const DistributorProducerAssignmentFragmentDoc = gql`
    fragment DistributorProducerAssignment on DistributorProducerAssignment {
  id
  distributorId
  producerId
  regionV2 {
    id
    friendlyName
  }
}
    `;
export const DeliveryAgingReportResultFragmentDoc = gql`
    fragment DeliveryAgingReportResult on ProducerPurchaseOrder {
  id
  number
  placedOn
  regionV2 {
    id
    friendlyName
  }
  seller {
    id
    displayName
  }
  invoice {
    id
    externalAmountInCents
    externalInvoiceId
  }
  trackingInformation {
    id
    status
    estimatedArrivalDate
    deliveredAt
  }
  retailOrdersCount
  deliveredRetailOrdersCount
}
    `;
export const FreightAgingReportResultFragmentDoc = gql`
    fragment FreightAgingReportResult on ProducerPurchaseOrder {
  id
  number
  placedOn
  regionV2 {
    id
    friendlyName
  }
  seller {
    id
    displayName
  }
  invoice {
    id
    externalAmountInCents
    externalInvoiceId
  }
  trackingInformation {
    id
    estimatedArrivalDate
  }
}
    `;
export const ServiceLevelTargetDetailsFragmentDoc = gql`
    fragment ServiceLevelTargetDetails on ServiceLevelTarget {
  target
  warn
}
    `;
export const PaymentAgingReportResultFragmentDoc = gql`
    fragment PaymentAgingReportResult on ProducerPurchaseOrder {
  id
  number
  placedOn
  deliveredAt
  deliveryStatus
  regionV2 {
    id
    friendlyName
  }
  seller {
    id
    displayName
  }
  invoice {
    id
    externalAmountInCents
    externalInvoiceId
  }
  paymentsLedger {
    id
    status
  }
  retailOrdersCount
  paidRetailOrdersCount
  paymentSLT {
    ...ServiceLevelTargetDetails
  }
  paymentStepSLT {
    ...ServiceLevelTargetDetails
  }
}
    ${ServiceLevelTargetDetailsFragmentDoc}`;
export const RetailerSalesOrderDeliveryAgingReportResultFragmentDoc = gql`
    fragment RetailerSalesOrderDeliveryAgingReportResult on RetailerSalesOrder {
  id
  number
  placedOn
  regionV2 {
    id
    friendlyName
  }
  buyer {
    id
    displayName
  }
  producerPurchaseOrder {
    id
    seller {
      id
      displayName
    }
    trackingInformation {
      id
      deliveredAt
    }
  }
}
    `;
export const AdminRetailerDetailsFragmentDoc = gql`
    fragment AdminRetailerDetails on Retailer {
  id
  displayName
  regionV2 {
    id
    friendlyName
  }
  canDelete
  address {
    ...Address
  }
  completedOnboardingAt
  organization {
    ...OrganizationFields
  }
  dwollaCustomer {
    ...AdminDwollaCustomerDetails
  }
  bankAccount {
    ...AdminBankAccountDetails
  }
}
    ${AddressFragmentDoc}
${OrganizationFieldsFragmentDoc}
${AdminDwollaCustomerDetailsFragmentDoc}
${AdminBankAccountDetailsFragmentDoc}`;
export const AdminRetailerOrderSummaryFragmentDoc = gql`
    fragment AdminRetailerOrderSummary on RetailerSalesOrder {
  id
  number
  amountInCents
  adjustmentTotalInCents
  finalOrderTotalInCents
  createdAt
  deliveredAt
  buyer {
    id
    displayName
  }
  paymentStatus
  ...RetailerOrderStatusData
}
    ${RetailerOrderStatusDataFragmentDoc}`;
export const AdminRetailerSalesOrdersTableDataFragmentDoc = gql`
    fragment AdminRetailerSalesOrdersTableData on RetailerSalesOrder {
  ...AdminRetailerOrderSummary
  producerPurchaseOrder {
    seller {
      id
      displayName
    }
  }
}
    ${AdminRetailerOrderSummaryFragmentDoc}`;
export const ImportReportDisplayFragmentDoc = gql`
    fragment ImportReportDisplay on ImportReport {
  failedRowIds
  successfulRowIds
}
    `;
export const AdminFundsTransferFieldsFragmentDoc = gql`
    fragment AdminFundsTransferFields on FundsTransfer {
  id
  breweryInvoiceNumber
  retailerInvoiceNumber
  amount
  statementDescriptor
  createdAt
  status
  settlementRejectionResponse
  settlementStrategy
  settlementMetadata
  source {
    ...FundsTransferAccount
  }
  destination {
    ...FundsTransferAccount
  }
  dwollaTransfers {
    id
    failureCode
    failureDescription
    failureExplanation
    sourceId
    destinationId
    createdAt
    links
    status
  }
}
    ${FundsTransferAccountFragmentDoc}`;
export const AdminProducerPurchaseOrderTableRowFragmentDoc = gql`
    fragment AdminProducerPurchaseOrderTableRow on ProducerPurchaseOrder {
  id
  number
  amountInCents
  createdAt
  paymentStatus
  balanceTransferStatus
  buyerName
  deliveredAt
  cancelledAt
  feeStatus
  producerInvoiceStatus
  deliveryStatus
  seller {
    id
    displayName
  }
  invoice {
    externalInvoiceId
    externalAmountInCents
  }
  trackingInformation {
    id
    status
    estimatedArrivalDate
  }
  preSale {
    regionV2 {
      id
      friendlyName
    }
  }
  distributorPurchaseOrder {
    paymentStatus
    balanceTransferStatus
  }
}
    `;
export const AutoCompleteBeerStylesFragmentDoc = gql`
    fragment AutoCompleteBeerStyles on BeerStyle {
  id
  name
}
    `;
export const DistributorFundsTransferFieldsFragmentDoc = gql`
    fragment DistributorFundsTransferFields on FundsTransfer {
  id
  amount
  breweryInvoiceNumber
  retailerInvoiceNumber
  statementDescriptor
  createdAt
  status
  source {
    ...FundsTransferAccount
  }
  destination {
    ...FundsTransferAccount
  }
}
    ${FundsTransferAccountFragmentDoc}`;
export const OnboardingDwollaStepFieldsFragmentDoc = gql`
    fragment OnboardingDwollaStepFields on DwollaOnboardingStep {
  customerType
  dwollaStepDwollaCustomer: dwollaCustomer {
    id
    status
    createdAt
  }
}
    `;
export const OnboardingBeneficialOwnersStepFieldsFragmentDoc = gql`
    fragment OnboardingBeneficialOwnersStepFields on BeneficialOwnerOnboardingStep {
  dwollaCustomer {
    id
    status
    createdAt
    beneficialOwnerCertificationStatus
    businessEntityId
  }
  customerType
}
    `;
export const OnboardingBankAccountStepFieldsFragmentDoc = gql`
    fragment OnboardingBankAccountStepFields on BankAccountOnboardingStep {
  bankAccount {
    id
    hasOnDemandAuthorization
  }
}
    `;
export const OnboardingCompleteStepFieldsFragmentDoc = gql`
    fragment OnboardingCompleteStepFields on CompleteOnboardingStep {
  dwollaCustomer {
    id
    status
    createdAt
    requiresBeneficialOwnershipCertification
    beneficialOwnerCertificationStatus
  }
  dwollaCustomerType
  completeStepBankAccount: bankAccount {
    id
    name
    institutionName
    mask
    plaidItem {
      id
      verificationStatus
    }
  }
  canCompleteOnboarding
}
    `;
export const OnboardingFieldsFragmentDoc = gql`
    fragment OnboardingFields on Onboarding {
  id
  steps
  currentStep {
    step
    ... on DwollaOnboardingStep {
      ...OnboardingDwollaStepFields
    }
    ... on BeneficialOwnerOnboardingStep {
      ...OnboardingBeneficialOwnersStepFields
    }
    ... on BankAccountOnboardingStep {
      ...OnboardingBankAccountStepFields
    }
    ... on CompleteOnboardingStep {
      ...OnboardingCompleteStepFields
    }
  }
}
    ${OnboardingDwollaStepFieldsFragmentDoc}
${OnboardingBeneficialOwnersStepFieldsFragmentDoc}
${OnboardingBankAccountStepFieldsFragmentDoc}
${OnboardingCompleteStepFieldsFragmentDoc}`;
export const ProducerSalesByRegionFragmentDoc = gql`
    fragment ProducerSalesByRegion on ProducerSalesByRegion {
  retailer_name
  retailer_region
  retailer_email
  order_count
  total_ordered
}
    `;
export const ProducerLicenseFieldsFragmentDoc = gql`
    fragment ProducerLicenseFields on License {
  stateV2 {
    name
    id
  }
  title
  documentUrl
  createdAt
  currentLicensePeriod {
    startDate
    endDate
  }
}
    `;
export const ProducerOfferTableDataFragmentDoc = gql`
    fragment ProducerOfferTableData on Offer {
  id
  quantity
  platformPrice
  wholesalePrice
  earliestPickup
  product {
    ...ProductDisplay
  }
  offerWindow {
    regionV2 {
      id
      friendlyName
    }
    start
  }
}
    ${ProductDisplayFragmentDoc}`;
export const ProducerPurchaseOrderItemFragmentDoc = gql`
    fragment ProducerPurchaseOrderItem on OrderItem {
  product {
    ...ProductDisplay
  }
  quantity
  price
  wholesalePrice
  orderId
  total
  wholesaleTotal
  finalQuantity
}
    ${ProductDisplayFragmentDoc}`;
export const ProducerPurchaseOrderItemsDataFragmentDoc = gql`
    fragment ProducerPurchaseOrderItemsData on Order {
  type
  amountInCents
  items {
    ...ProducerPurchaseOrderItem
  }
}
    ${ProducerPurchaseOrderItemFragmentDoc}`;
export const ProducerPurchaseOrderPackageSummaryTableDataFragmentDoc = gql`
    fragment ProducerPurchaseOrderPackageSummaryTableData on PackageSummaryItem {
  packageType {
    id
    displayName
  }
  totalQuantity
  totalWeight
}
    `;
export const ProducerPurchaseOrderSummaryFragmentDoc = gql`
    fragment ProducerPurchaseOrderSummary on Order {
  id
  number
  amountInCents
  createdAt
  deletedAt
  regionV2 {
    id
    friendlyName
    deliveryPartner {
      displayName
    }
  }
  invoice {
    externalInvoiceId
    externalAmountInCents
  }
  buyer {
    id
    businessType
  }
  buyerName
  seller {
    id
    displayName
  }
  enabledFeatures {
    canCreatePDF
  }
  ... on ProducerPurchaseOrder {
    platformFee
  }
}
    `;
export const ProducerPurchaseOrderTableRowFragmentDoc = gql`
    fragment ProducerPurchaseOrderTableRow on ProducerPurchaseOrder {
  id
  number
  amountInCents
  createdAt
  buyerName
  seller {
    id
    displayName
  }
  invoice {
    externalInvoiceId
    externalAmountInCents
  }
  preSale {
    regionV2 {
      id
      friendlyName
    }
  }
}
    `;
export const ProducerFundsTransferFieldsFragmentDoc = gql`
    fragment ProducerFundsTransferFields on FundsTransfer {
  id
  amount
  breweryInvoiceNumber
  statementDescriptor
  createdAt
  status
  source {
    ...FundsTransferAccount
  }
  destination {
    ...FundsTransferAccount
  }
}
    ${FundsTransferAccountFragmentDoc}`;
export const StorePreSaleOrderItemFragmentDoc = gql`
    fragment StorePreSaleOrderItem on OrderItem {
  quantity
  price
  total
  product {
    id
    name
    description
    abv
    packageDate
    beerStyle {
      name
    }
    rating
    packageType {
      id
      displayName
    }
    productImage {
      id
      rawUrl
      thumbnailUrl
    }
    producer {
      id
      displayName
    }
  }
}
    `;
export const StorePreSaleOrderCancelledItemFragmentDoc = gql`
    fragment StorePreSaleOrderCancelledItem on PreSaleOrderCancelledItem {
  item {
    ...StorePreSaleOrderItem
  }
  exclusionReason {
    id
    label
  }
}
    ${StorePreSaleOrderItemFragmentDoc}`;
export const StorePreSaleOrderSummaryFragmentDoc = gql`
    fragment StorePreSaleOrderSummary on PreSaleOrder {
  id
  placedOn
  cancelledAt
  number
  finalOrderTotalInCents
}
    `;
export const StoreSalesOrderItemFragmentDoc = gql`
    fragment StoreSalesOrderItem on OrderItem {
  quantity
  price
  total
  finalQuantity
  finalTotal
  product {
    id
    name
    description
    abv
    packageDate
    beerStyle {
      name
    }
    rating
    packageType {
      id
      displayName
    }
    productImage {
      id
      rawUrl
      thumbnailUrl
    }
    producer {
      id
      displayName
    }
  }
}
    `;
export const StoreSalesOrderPaymentBalancesFragmentDoc = gql`
    fragment StoreSalesOrderPaymentBalances on RetailerSalesOrder {
  id
  paymentsLedger {
    ...LedgerDetails
    transfers {
      ...FundsTransferDetails
    }
  }
}
    ${LedgerDetailsFragmentDoc}
${FundsTransferDetailsFragmentDoc}`;
export const StoreSalesOrderSummaryFragmentDoc = gql`
    fragment StoreSalesOrderSummary on RetailerSalesOrder {
  id
  placedOn
  cancelledAt
  deliveredAt
  number
  amountInCents
  finalOrderTotalInCents
  producerPurchaseOrder {
    trackingInformation {
      estimatedArrivalDate
    }
    seller {
      displayName
    }
  }
  ...RetailerOrderStatusData
}
    ${RetailerOrderStatusDataFragmentDoc}`;
export const RetailerFundsTransferFieldsFragmentDoc = gql`
    fragment RetailerFundsTransferFields on FundsTransfer {
  id
  amount
  statementDescriptor
  retailerInvoiceNumber
  createdAt
  status
  source {
    ...FundsTransferAccount
  }
  destination {
    ...FundsTransferAccount
  }
}
    ${FundsTransferAccountFragmentDoc}`;
export const BankAccountDisplayInfoFragmentDoc = gql`
    fragment BankAccountDisplayInfo on BankAccount {
  id
  mask
  institutionName
  name
  hasOnDemandAuthorization
  plaidItem {
    id
    verificationStatus
  }
  business {
    id
  }
  needsReverification
}
    `;
export const BankAccountFieldsFragmentDoc = gql`
    fragment BankAccountFields on BankAccount {
  id
  mask
  name
  institutionName
  hasOnDemandAuthorization
  isVerified
  plaidItem {
    id
    verificationStatus
  }
  business {
    id
    bankAccount {
      id
    }
  }
  needsReverification
}
    `;
export const AutocompleteDistributorFragmentDoc = gql`
    fragment AutocompleteDistributor on Distributor {
  id
  displayName
}
    `;
export const AutocompleteFundsAccountFragmentDoc = gql`
    fragment AutocompleteFundsAccount on FundsAccount {
  id
  type
  label
  ... on BalanceAccount {
    balance
  }
  business {
    id
    name
    displayName
    businessType
    ... on Retailer {
      regionV2 {
        id
        friendlyName
      }
    }
  }
}
    `;
export const InvoiceDisplayFragmentDoc = gql`
    fragment InvoiceDisplay on Invoice {
  id
  number
  externalAmountInCents
  externalInvoiceId
}
    `;
export const LicenseFieldsFragmentDoc = gql`
    fragment LicenseFields on License {
  id
  title
  number
  createdAt
  documentUrl
  stateV2 {
    id
    name
  }
  currentLicensePeriod {
    startDate
    endDate
  }
}
    `;
export const AutocompleteLogisticsPartnerFragmentDoc = gql`
    fragment AutocompleteLogisticsPartner on LogisticsPartner {
  id
  displayName
}
    `;
export const OrderAutocompleteResponseAllFragmentDoc = gql`
    fragment OrderAutocompleteResponseAll on OrderAutocompleteResponse {
  id
  externalInvoiceId
  orderNumber
}
    `;
export const OrderDocumentSummaryFragmentDoc = gql`
    fragment OrderDocumentSummary on OrderDocument {
  id
  createdAt
  name
  notes
  fileUrl
  creator {
    id
    email
  }
  documentType
}
    `;
export const PackageTypeDetailsFragmentDoc = gql`
    fragment PackageTypeDetails on ProductPackageType {
  id
  displayName
  units
  containerLabel
  containerVolume
  containerVolumeUnit
  containerStreetName
  createdAt
  weight
  canDelete
}
    `;
export const AutocompleteProducerFragmentDoc = gql`
    fragment AutocompleteProducer on Producer {
  id
  displayName
}
    `;
export const AutocompleteRetailerFragmentDoc = gql`
    fragment AutocompleteRetailer on Retailer {
  id
  displayName
  regionV2 {
    id
    friendlyName
  }
}
    `;
export const FundsTransferBusinessDisplayFragmentDoc = gql`
    fragment FundsTransferBusinessDisplay on FundsTransfer {
  id
  amount
  statementDescriptor
  createdAt
  status
  source {
    ...FundsTransferAccount
  }
  destination {
    ...FundsTransferAccount
  }
  invoice {
    id
    number
  }
}
    ${FundsTransferAccountFragmentDoc}`;
export const BreweryFieldsFragmentDoc = gql`
    fragment BreweryFields on Organization {
  id
  businesses {
    id
    displayName
    completedOnboardingAt
  }
}
    `;
export const DistributorFieldsFragmentDoc = gql`
    fragment DistributorFields on Organization {
  id
  businesses {
    id
    displayName
    completedOnboardingAt
  }
}
    `;
export const RetailerFieldsFragmentDoc = gql`
    fragment RetailerFields on Organization {
  id
  businesses {
    id
    displayName
    completedOnboardingAt
  }
}
    `;
export const BusinessShortFragmentDoc = gql`
    fragment BusinessShort on Business {
  id
  completedOnboardingAt
  businessType
}
    `;
export const UserAuthFieldsFragmentDoc = gql`
    fragment UserAuthFields on User {
  id
  isGlobalAdmin
  organization {
    id
    name
    businessType
    businesses {
      ...BusinessShort
    }
  }
  organizations {
    id
    name
    businessType
    businesses {
      ...BusinessShort
    }
  }
}
    ${BusinessShortFragmentDoc}`;
export const AuditLogDetailsFragmentDoc = gql`
    fragment AuditLogDetails on AuditLog {
  id
  occurredAt
  changes
  snapshot
  message
  user {
    id
    email
  }
}
    `;
export const AdminDashboardStatisticsDocument = gql`
    query AdminDashboardStatistics {
  adminDashboardStatistics {
    breweriesOnboarded
    retailersOnboarded
    distributorsOnboarded
    totalPayments
  }
}
    `;

/**
 * __useAdminDashboardStatisticsQuery__
 *
 * To run a query within a React component, call `useAdminDashboardStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDashboardStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminDashboardStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<AdminDashboardStatisticsQuery, AdminDashboardStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDashboardStatisticsQuery, AdminDashboardStatisticsQueryVariables>(AdminDashboardStatisticsDocument, options);
      }
export function useAdminDashboardStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDashboardStatisticsQuery, AdminDashboardStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDashboardStatisticsQuery, AdminDashboardStatisticsQueryVariables>(AdminDashboardStatisticsDocument, options);
        }
export type AdminDashboardStatisticsQueryHookResult = ReturnType<typeof useAdminDashboardStatisticsQuery>;
export type AdminDashboardStatisticsLazyQueryHookResult = ReturnType<typeof useAdminDashboardStatisticsLazyQuery>;
export type AdminDashboardStatisticsQueryResult = Apollo.QueryResult<AdminDashboardStatisticsQuery, AdminDashboardStatisticsQueryVariables>;
export const AdminDeleteDistributorDocument = gql`
    mutation AdminDeleteDistributor($id: Int!) {
  deleteDistributor(id: $id) {
    id
    name
  }
}
    `;
export type AdminDeleteDistributorMutationFn = Apollo.MutationFunction<AdminDeleteDistributorMutation, AdminDeleteDistributorMutationVariables>;

/**
 * __useAdminDeleteDistributorMutation__
 *
 * To run a mutation, you first call `useAdminDeleteDistributorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteDistributorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteDistributorMutation, { data, loading, error }] = useAdminDeleteDistributorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteDistributorMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteDistributorMutation, AdminDeleteDistributorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteDistributorMutation, AdminDeleteDistributorMutationVariables>(AdminDeleteDistributorDocument, options);
      }
export type AdminDeleteDistributorMutationHookResult = ReturnType<typeof useAdminDeleteDistributorMutation>;
export type AdminDeleteDistributorMutationResult = Apollo.MutationResult<AdminDeleteDistributorMutation>;
export type AdminDeleteDistributorMutationOptions = Apollo.BaseMutationOptions<AdminDeleteDistributorMutation, AdminDeleteDistributorMutationVariables>;
export const AdminDistributorDocument = gql`
    query AdminDistributor($distributorId: Int!) {
  distributor(id: $distributorId) {
    id
    displayName
    address {
      ...Address
    }
    completedOnboardingAt
    organization {
      ...OrganizationFields
    }
    dwollaCustomer {
      ...AdminDwollaCustomerDetails
    }
    bankAccount {
      ...AdminBankAccountDetails
    }
    canDelete
    feePerPackageInCents
  }
}
    ${AddressFragmentDoc}
${OrganizationFieldsFragmentDoc}
${AdminDwollaCustomerDetailsFragmentDoc}
${AdminBankAccountDetailsFragmentDoc}`;

/**
 * __useAdminDistributorQuery__
 *
 * To run a query within a React component, call `useAdminDistributorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDistributorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDistributorQuery({
 *   variables: {
 *      distributorId: // value for 'distributorId'
 *   },
 * });
 */
export function useAdminDistributorQuery(baseOptions: Apollo.QueryHookOptions<AdminDistributorQuery, AdminDistributorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDistributorQuery, AdminDistributorQueryVariables>(AdminDistributorDocument, options);
      }
export function useAdminDistributorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDistributorQuery, AdminDistributorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDistributorQuery, AdminDistributorQueryVariables>(AdminDistributorDocument, options);
        }
export type AdminDistributorQueryHookResult = ReturnType<typeof useAdminDistributorQuery>;
export type AdminDistributorLazyQueryHookResult = ReturnType<typeof useAdminDistributorLazyQuery>;
export type AdminDistributorQueryResult = Apollo.QueryResult<AdminDistributorQuery, AdminDistributorQueryVariables>;
export const AdminDistributorsDocument = gql`
    query AdminDistributors {
  distributors {
    ...AdminDistributorDisplay
  }
}
    ${AdminDistributorDisplayFragmentDoc}`;

/**
 * __useAdminDistributorsQuery__
 *
 * To run a query within a React component, call `useAdminDistributorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDistributorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDistributorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminDistributorsQuery(baseOptions?: Apollo.QueryHookOptions<AdminDistributorsQuery, AdminDistributorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDistributorsQuery, AdminDistributorsQueryVariables>(AdminDistributorsDocument, options);
      }
export function useAdminDistributorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDistributorsQuery, AdminDistributorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDistributorsQuery, AdminDistributorsQueryVariables>(AdminDistributorsDocument, options);
        }
export type AdminDistributorsQueryHookResult = ReturnType<typeof useAdminDistributorsQuery>;
export type AdminDistributorsLazyQueryHookResult = ReturnType<typeof useAdminDistributorsLazyQuery>;
export type AdminDistributorsQueryResult = Apollo.QueryResult<AdminDistributorsQuery, AdminDistributorsQueryVariables>;
export const AdminDeliveryPartnersDocument = gql`
    query AdminDeliveryPartners {
  distributors {
    id
    displayName
  }
  logisticsPartners {
    id
    displayName
  }
}
    `;

/**
 * __useAdminDeliveryPartnersQuery__
 *
 * To run a query within a React component, call `useAdminDeliveryPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDeliveryPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDeliveryPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminDeliveryPartnersQuery(baseOptions?: Apollo.QueryHookOptions<AdminDeliveryPartnersQuery, AdminDeliveryPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDeliveryPartnersQuery, AdminDeliveryPartnersQueryVariables>(AdminDeliveryPartnersDocument, options);
      }
export function useAdminDeliveryPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDeliveryPartnersQuery, AdminDeliveryPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDeliveryPartnersQuery, AdminDeliveryPartnersQueryVariables>(AdminDeliveryPartnersDocument, options);
        }
export type AdminDeliveryPartnersQueryHookResult = ReturnType<typeof useAdminDeliveryPartnersQuery>;
export type AdminDeliveryPartnersLazyQueryHookResult = ReturnType<typeof useAdminDeliveryPartnersLazyQuery>;
export type AdminDeliveryPartnersQueryResult = Apollo.QueryResult<AdminDeliveryPartnersQuery, AdminDeliveryPartnersQueryVariables>;
export const AdminAddPlatformFeeDocument = gql`
    mutation AdminAddPlatformFee($data: PlatformFeeCreateInput!) {
  addPlatformFee(data: $data) {
    id
    amount
  }
}
    `;
export type AdminAddPlatformFeeMutationFn = Apollo.MutationFunction<AdminAddPlatformFeeMutation, AdminAddPlatformFeeMutationVariables>;

/**
 * __useAdminAddPlatformFeeMutation__
 *
 * To run a mutation, you first call `useAdminAddPlatformFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddPlatformFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddPlatformFeeMutation, { data, loading, error }] = useAdminAddPlatformFeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminAddPlatformFeeMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddPlatformFeeMutation, AdminAddPlatformFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddPlatformFeeMutation, AdminAddPlatformFeeMutationVariables>(AdminAddPlatformFeeDocument, options);
      }
export type AdminAddPlatformFeeMutationHookResult = ReturnType<typeof useAdminAddPlatformFeeMutation>;
export type AdminAddPlatformFeeMutationResult = Apollo.MutationResult<AdminAddPlatformFeeMutation>;
export type AdminAddPlatformFeeMutationOptions = Apollo.BaseMutationOptions<AdminAddPlatformFeeMutation, AdminAddPlatformFeeMutationVariables>;
export const AdminRegionPlatformFeesDocument = gql`
    query AdminRegionPlatformFees($regionId: Int!) {
  regionPlatformFees(id: $regionId) {
    packageType {
      id
      displayName
    }
    platformFee {
      ...PlatformFeeDetails
    }
  }
}
    ${PlatformFeeDetailsFragmentDoc}`;

/**
 * __useAdminRegionPlatformFeesQuery__
 *
 * To run a query within a React component, call `useAdminRegionPlatformFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRegionPlatformFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRegionPlatformFeesQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useAdminRegionPlatformFeesQuery(baseOptions: Apollo.QueryHookOptions<AdminRegionPlatformFeesQuery, AdminRegionPlatformFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRegionPlatformFeesQuery, AdminRegionPlatformFeesQueryVariables>(AdminRegionPlatformFeesDocument, options);
      }
export function useAdminRegionPlatformFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRegionPlatformFeesQuery, AdminRegionPlatformFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRegionPlatformFeesQuery, AdminRegionPlatformFeesQueryVariables>(AdminRegionPlatformFeesDocument, options);
        }
export type AdminRegionPlatformFeesQueryHookResult = ReturnType<typeof useAdminRegionPlatformFeesQuery>;
export type AdminRegionPlatformFeesLazyQueryHookResult = ReturnType<typeof useAdminRegionPlatformFeesLazyQuery>;
export type AdminRegionPlatformFeesQueryResult = Apollo.QueryResult<AdminRegionPlatformFeesQuery, AdminRegionPlatformFeesQueryVariables>;
export const AdminUpdatePlatformFeeDocument = gql`
    mutation AdminUpdatePlatformFee($id: Int!, $data: PlatformFeeUpdateInput!) {
  updatePlatformFee(id: $id, data: $data) {
    id
    amount
  }
}
    `;
export type AdminUpdatePlatformFeeMutationFn = Apollo.MutationFunction<AdminUpdatePlatformFeeMutation, AdminUpdatePlatformFeeMutationVariables>;

/**
 * __useAdminUpdatePlatformFeeMutation__
 *
 * To run a mutation, you first call `useAdminUpdatePlatformFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdatePlatformFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdatePlatformFeeMutation, { data, loading, error }] = useAdminUpdatePlatformFeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminUpdatePlatformFeeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePlatformFeeMutation, AdminUpdatePlatformFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePlatformFeeMutation, AdminUpdatePlatformFeeMutationVariables>(AdminUpdatePlatformFeeDocument, options);
      }
export type AdminUpdatePlatformFeeMutationHookResult = ReturnType<typeof useAdminUpdatePlatformFeeMutation>;
export type AdminUpdatePlatformFeeMutationResult = Apollo.MutationResult<AdminUpdatePlatformFeeMutation>;
export type AdminUpdatePlatformFeeMutationOptions = Apollo.BaseMutationOptions<AdminUpdatePlatformFeeMutation, AdminUpdatePlatformFeeMutationVariables>;
export const AdminRegionAssignDeliveryDriverDocument = gql`
    mutation AdminRegionAssignDeliveryDriver($data: AssignRegionDeliveryPartnerInput!) {
  assignDeliveryPartner(data: $data) {
    ...AdminRegionDeliveryPartnerDetails
  }
}
    ${AdminRegionDeliveryPartnerDetailsFragmentDoc}`;
export type AdminRegionAssignDeliveryDriverMutationFn = Apollo.MutationFunction<AdminRegionAssignDeliveryDriverMutation, AdminRegionAssignDeliveryDriverMutationVariables>;

/**
 * __useAdminRegionAssignDeliveryDriverMutation__
 *
 * To run a mutation, you first call `useAdminRegionAssignDeliveryDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRegionAssignDeliveryDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRegionAssignDeliveryDriverMutation, { data, loading, error }] = useAdminRegionAssignDeliveryDriverMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminRegionAssignDeliveryDriverMutation(baseOptions?: Apollo.MutationHookOptions<AdminRegionAssignDeliveryDriverMutation, AdminRegionAssignDeliveryDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRegionAssignDeliveryDriverMutation, AdminRegionAssignDeliveryDriverMutationVariables>(AdminRegionAssignDeliveryDriverDocument, options);
      }
export type AdminRegionAssignDeliveryDriverMutationHookResult = ReturnType<typeof useAdminRegionAssignDeliveryDriverMutation>;
export type AdminRegionAssignDeliveryDriverMutationResult = Apollo.MutationResult<AdminRegionAssignDeliveryDriverMutation>;
export type AdminRegionAssignDeliveryDriverMutationOptions = Apollo.BaseMutationOptions<AdminRegionAssignDeliveryDriverMutation, AdminRegionAssignDeliveryDriverMutationVariables>;
export const AdminRegionDeliveryPartnerDetailsDocument = gql`
    query AdminRegionDeliveryPartnerDetails($regionId: Int!) {
  region(id: $regionId) {
    ...AdminRegionDeliveryPartnerDetails
  }
}
    ${AdminRegionDeliveryPartnerDetailsFragmentDoc}`;

/**
 * __useAdminRegionDeliveryPartnerDetailsQuery__
 *
 * To run a query within a React component, call `useAdminRegionDeliveryPartnerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRegionDeliveryPartnerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRegionDeliveryPartnerDetailsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useAdminRegionDeliveryPartnerDetailsQuery(baseOptions: Apollo.QueryHookOptions<AdminRegionDeliveryPartnerDetailsQuery, AdminRegionDeliveryPartnerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRegionDeliveryPartnerDetailsQuery, AdminRegionDeliveryPartnerDetailsQueryVariables>(AdminRegionDeliveryPartnerDetailsDocument, options);
      }
export function useAdminRegionDeliveryPartnerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRegionDeliveryPartnerDetailsQuery, AdminRegionDeliveryPartnerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRegionDeliveryPartnerDetailsQuery, AdminRegionDeliveryPartnerDetailsQueryVariables>(AdminRegionDeliveryPartnerDetailsDocument, options);
        }
export type AdminRegionDeliveryPartnerDetailsQueryHookResult = ReturnType<typeof useAdminRegionDeliveryPartnerDetailsQuery>;
export type AdminRegionDeliveryPartnerDetailsLazyQueryHookResult = ReturnType<typeof useAdminRegionDeliveryPartnerDetailsLazyQuery>;
export type AdminRegionDeliveryPartnerDetailsQueryResult = Apollo.QueryResult<AdminRegionDeliveryPartnerDetailsQuery, AdminRegionDeliveryPartnerDetailsQueryVariables>;
export const AdminRegionDetailsDocument = gql`
    query AdminRegionDetails($regionId: Int!) {
  region(id: $regionId) {
    ...AdminRegionDetails
  }
}
    ${AdminRegionDetailsFragmentDoc}`;

/**
 * __useAdminRegionDetailsQuery__
 *
 * To run a query within a React component, call `useAdminRegionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRegionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRegionDetailsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useAdminRegionDetailsQuery(baseOptions: Apollo.QueryHookOptions<AdminRegionDetailsQuery, AdminRegionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRegionDetailsQuery, AdminRegionDetailsQueryVariables>(AdminRegionDetailsDocument, options);
      }
export function useAdminRegionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRegionDetailsQuery, AdminRegionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRegionDetailsQuery, AdminRegionDetailsQueryVariables>(AdminRegionDetailsDocument, options);
        }
export type AdminRegionDetailsQueryHookResult = ReturnType<typeof useAdminRegionDetailsQuery>;
export type AdminRegionDetailsLazyQueryHookResult = ReturnType<typeof useAdminRegionDetailsLazyQuery>;
export type AdminRegionDetailsQueryResult = Apollo.QueryResult<AdminRegionDetailsQuery, AdminRegionDetailsQueryVariables>;
export const AdminRegionsDocument = gql`
    query AdminRegions {
  regions {
    ...AdminRegionsTableRowData
  }
}
    ${AdminRegionsTableRowDataFragmentDoc}`;

/**
 * __useAdminRegionsQuery__
 *
 * To run a query within a React component, call `useAdminRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminRegionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminRegionsQuery, AdminRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRegionsQuery, AdminRegionsQueryVariables>(AdminRegionsDocument, options);
      }
export function useAdminRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRegionsQuery, AdminRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRegionsQuery, AdminRegionsQueryVariables>(AdminRegionsDocument, options);
        }
export type AdminRegionsQueryHookResult = ReturnType<typeof useAdminRegionsQuery>;
export type AdminRegionsLazyQueryHookResult = ReturnType<typeof useAdminRegionsLazyQuery>;
export type AdminRegionsQueryResult = Apollo.QueryResult<AdminRegionsQuery, AdminRegionsQueryVariables>;
export const InviteGlobalAdminDocument = gql`
    mutation InviteGlobalAdmin($email: String!, $fullName: String!) {
  inviteGlobalAdmin(email: $email, fullName: $fullName) {
    id
    createdAt
    isGlobalAdmin
  }
}
    `;
export type InviteGlobalAdminMutationFn = Apollo.MutationFunction<InviteGlobalAdminMutation, InviteGlobalAdminMutationVariables>;

/**
 * __useInviteGlobalAdminMutation__
 *
 * To run a mutation, you first call `useInviteGlobalAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteGlobalAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteGlobalAdminMutation, { data, loading, error }] = useInviteGlobalAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      fullName: // value for 'fullName'
 *   },
 * });
 */
export function useInviteGlobalAdminMutation(baseOptions?: Apollo.MutationHookOptions<InviteGlobalAdminMutation, InviteGlobalAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteGlobalAdminMutation, InviteGlobalAdminMutationVariables>(InviteGlobalAdminDocument, options);
      }
export type InviteGlobalAdminMutationHookResult = ReturnType<typeof useInviteGlobalAdminMutation>;
export type InviteGlobalAdminMutationResult = Apollo.MutationResult<InviteGlobalAdminMutation>;
export type InviteGlobalAdminMutationOptions = Apollo.BaseMutationOptions<InviteGlobalAdminMutation, InviteGlobalAdminMutationVariables>;
export const SyncBeverageAdvisorsDocument = gql`
    mutation SyncBeverageAdvisors {
  syncBeverageAdvisors {
    id
  }
}
    `;
export type SyncBeverageAdvisorsMutationFn = Apollo.MutationFunction<SyncBeverageAdvisorsMutation, SyncBeverageAdvisorsMutationVariables>;

/**
 * __useSyncBeverageAdvisorsMutation__
 *
 * To run a mutation, you first call `useSyncBeverageAdvisorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncBeverageAdvisorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncBeverageAdvisorsMutation, { data, loading, error }] = useSyncBeverageAdvisorsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncBeverageAdvisorsMutation(baseOptions?: Apollo.MutationHookOptions<SyncBeverageAdvisorsMutation, SyncBeverageAdvisorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncBeverageAdvisorsMutation, SyncBeverageAdvisorsMutationVariables>(SyncBeverageAdvisorsDocument, options);
      }
export type SyncBeverageAdvisorsMutationHookResult = ReturnType<typeof useSyncBeverageAdvisorsMutation>;
export type SyncBeverageAdvisorsMutationResult = Apollo.MutationResult<SyncBeverageAdvisorsMutation>;
export type SyncBeverageAdvisorsMutationOptions = Apollo.BaseMutationOptions<SyncBeverageAdvisorsMutation, SyncBeverageAdvisorsMutationVariables>;
export const AdminGlobalSearchDocument = gql`
    query AdminGlobalSearch($query: String!) {
  globalSearch(query: $query) {
    totalResults
    producerPurchaseOrders {
      ...ProducerPurchaseOrderSearchResult
    }
    retailerSalesOrders {
      ...RetailerSalesOrderSearchResult
    }
    freightShipments {
      ...FreightShipmentSearchResult
    }
    producers {
      ...ProducerSearchResult
    }
    logisticsPartners {
      ...LogisticsPartnerSearchResult
    }
    retailers {
      ...RetailerSearchResult
    }
  }
}
    ${ProducerPurchaseOrderSearchResultFragmentDoc}
${RetailerSalesOrderSearchResultFragmentDoc}
${FreightShipmentSearchResultFragmentDoc}
${ProducerSearchResultFragmentDoc}
${LogisticsPartnerSearchResultFragmentDoc}
${RetailerSearchResultFragmentDoc}`;

/**
 * __useAdminGlobalSearchQuery__
 *
 * To run a query within a React component, call `useAdminGlobalSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGlobalSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGlobalSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAdminGlobalSearchQuery(baseOptions: Apollo.QueryHookOptions<AdminGlobalSearchQuery, AdminGlobalSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGlobalSearchQuery, AdminGlobalSearchQueryVariables>(AdminGlobalSearchDocument, options);
      }
export function useAdminGlobalSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGlobalSearchQuery, AdminGlobalSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGlobalSearchQuery, AdminGlobalSearchQueryVariables>(AdminGlobalSearchDocument, options);
        }
export type AdminGlobalSearchQueryHookResult = ReturnType<typeof useAdminGlobalSearchQuery>;
export type AdminGlobalSearchLazyQueryHookResult = ReturnType<typeof useAdminGlobalSearchLazyQuery>;
export type AdminGlobalSearchQueryResult = Apollo.QueryResult<AdminGlobalSearchQuery, AdminGlobalSearchQueryVariables>;
export const AdminDeleteLogisticsPartnerDocument = gql`
    mutation AdminDeleteLogisticsPartner($id: Int!) {
  deleteLogisticsPartner(id: $id) {
    id
    name
  }
}
    `;
export type AdminDeleteLogisticsPartnerMutationFn = Apollo.MutationFunction<AdminDeleteLogisticsPartnerMutation, AdminDeleteLogisticsPartnerMutationVariables>;

/**
 * __useAdminDeleteLogisticsPartnerMutation__
 *
 * To run a mutation, you first call `useAdminDeleteLogisticsPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteLogisticsPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteLogisticsPartnerMutation, { data, loading, error }] = useAdminDeleteLogisticsPartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteLogisticsPartnerMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteLogisticsPartnerMutation, AdminDeleteLogisticsPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteLogisticsPartnerMutation, AdminDeleteLogisticsPartnerMutationVariables>(AdminDeleteLogisticsPartnerDocument, options);
      }
export type AdminDeleteLogisticsPartnerMutationHookResult = ReturnType<typeof useAdminDeleteLogisticsPartnerMutation>;
export type AdminDeleteLogisticsPartnerMutationResult = Apollo.MutationResult<AdminDeleteLogisticsPartnerMutation>;
export type AdminDeleteLogisticsPartnerMutationOptions = Apollo.BaseMutationOptions<AdminDeleteLogisticsPartnerMutation, AdminDeleteLogisticsPartnerMutationVariables>;
export const AdminLogisticsPartnerDocument = gql`
    query AdminLogisticsPartner($logisticsPartnerId: Int!) {
  logisticsPartner(id: $logisticsPartnerId) {
    id
    displayName
    address {
      ...Address
    }
    completedOnboardingAt
    organization {
      ...OrganizationFields
    }
    canDelete
  }
}
    ${AddressFragmentDoc}
${OrganizationFieldsFragmentDoc}`;

/**
 * __useAdminLogisticsPartnerQuery__
 *
 * To run a query within a React component, call `useAdminLogisticsPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLogisticsPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLogisticsPartnerQuery({
 *   variables: {
 *      logisticsPartnerId: // value for 'logisticsPartnerId'
 *   },
 * });
 */
export function useAdminLogisticsPartnerQuery(baseOptions: Apollo.QueryHookOptions<AdminLogisticsPartnerQuery, AdminLogisticsPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLogisticsPartnerQuery, AdminLogisticsPartnerQueryVariables>(AdminLogisticsPartnerDocument, options);
      }
export function useAdminLogisticsPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLogisticsPartnerQuery, AdminLogisticsPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLogisticsPartnerQuery, AdminLogisticsPartnerQueryVariables>(AdminLogisticsPartnerDocument, options);
        }
export type AdminLogisticsPartnerQueryHookResult = ReturnType<typeof useAdminLogisticsPartnerQuery>;
export type AdminLogisticsPartnerLazyQueryHookResult = ReturnType<typeof useAdminLogisticsPartnerLazyQuery>;
export type AdminLogisticsPartnerQueryResult = Apollo.QueryResult<AdminLogisticsPartnerQuery, AdminLogisticsPartnerQueryVariables>;
export const AdminLogisticsPartnersDocument = gql`
    query AdminLogisticsPartners {
  logisticsPartners {
    ...AdminLogisticsPartnerDisplay
  }
}
    ${AdminLogisticsPartnerDisplayFragmentDoc}`;

/**
 * __useAdminLogisticsPartnersQuery__
 *
 * To run a query within a React component, call `useAdminLogisticsPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLogisticsPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLogisticsPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminLogisticsPartnersQuery(baseOptions?: Apollo.QueryHookOptions<AdminLogisticsPartnersQuery, AdminLogisticsPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLogisticsPartnersQuery, AdminLogisticsPartnersQueryVariables>(AdminLogisticsPartnersDocument, options);
      }
export function useAdminLogisticsPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLogisticsPartnersQuery, AdminLogisticsPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLogisticsPartnersQuery, AdminLogisticsPartnersQueryVariables>(AdminLogisticsPartnersDocument, options);
        }
export type AdminLogisticsPartnersQueryHookResult = ReturnType<typeof useAdminLogisticsPartnersQuery>;
export type AdminLogisticsPartnersLazyQueryHookResult = ReturnType<typeof useAdminLogisticsPartnersLazyQuery>;
export type AdminLogisticsPartnersQueryResult = Apollo.QueryResult<AdminLogisticsPartnersQuery, AdminLogisticsPartnersQueryVariables>;
export const AddOfferDocument = gql`
    mutation AddOffer($data: OfferCreateInput!) {
  addOffer(data: $data) {
    ...AdminOfferWindowOffer
    offerWindow {
      id
    }
  }
}
    ${AdminOfferWindowOfferFragmentDoc}`;
export type AddOfferMutationFn = Apollo.MutationFunction<AddOfferMutation, AddOfferMutationVariables>;

/**
 * __useAddOfferMutation__
 *
 * To run a mutation, you first call `useAddOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOfferMutation, { data, loading, error }] = useAddOfferMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddOfferMutation(baseOptions?: Apollo.MutationHookOptions<AddOfferMutation, AddOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOfferMutation, AddOfferMutationVariables>(AddOfferDocument, options);
      }
export type AddOfferMutationHookResult = ReturnType<typeof useAddOfferMutation>;
export type AddOfferMutationResult = Apollo.MutationResult<AddOfferMutation>;
export type AddOfferMutationOptions = Apollo.BaseMutationOptions<AddOfferMutation, AddOfferMutationVariables>;
export const CanOfferProductDocument = gql`
    query CanOfferProduct($productId: Int!, $offerWindowId: Int) {
  canOfferProduct(productId: $productId, offerWindowId: $offerWindowId) {
    ...ValidationResult
  }
}
    ${ValidationResultFragmentDoc}`;

/**
 * __useCanOfferProductQuery__
 *
 * To run a query within a React component, call `useCanOfferProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanOfferProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanOfferProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      offerWindowId: // value for 'offerWindowId'
 *   },
 * });
 */
export function useCanOfferProductQuery(baseOptions: Apollo.QueryHookOptions<CanOfferProductQuery, CanOfferProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanOfferProductQuery, CanOfferProductQueryVariables>(CanOfferProductDocument, options);
      }
export function useCanOfferProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanOfferProductQuery, CanOfferProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanOfferProductQuery, CanOfferProductQueryVariables>(CanOfferProductDocument, options);
        }
export type CanOfferProductQueryHookResult = ReturnType<typeof useCanOfferProductQuery>;
export type CanOfferProductLazyQueryHookResult = ReturnType<typeof useCanOfferProductLazyQuery>;
export type CanOfferProductQueryResult = Apollo.QueryResult<CanOfferProductQuery, CanOfferProductQueryVariables>;
export const AdminOfferWindowOffersDocument = gql`
    query AdminOfferWindowOffers($id: Int!) {
  offerWindow(id: $id) {
    id
    ...AdminOfferWindowOffers
    offers {
      id
      ...AdminOfferWindowOffer
    }
  }
}
    ${AdminOfferWindowOffersFragmentDoc}
${AdminOfferWindowOfferFragmentDoc}`;

/**
 * __useAdminOfferWindowOffersQuery__
 *
 * To run a query within a React component, call `useAdminOfferWindowOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOfferWindowOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOfferWindowOffersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminOfferWindowOffersQuery(baseOptions: Apollo.QueryHookOptions<AdminOfferWindowOffersQuery, AdminOfferWindowOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOfferWindowOffersQuery, AdminOfferWindowOffersQueryVariables>(AdminOfferWindowOffersDocument, options);
      }
export function useAdminOfferWindowOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOfferWindowOffersQuery, AdminOfferWindowOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOfferWindowOffersQuery, AdminOfferWindowOffersQueryVariables>(AdminOfferWindowOffersDocument, options);
        }
export type AdminOfferWindowOffersQueryHookResult = ReturnType<typeof useAdminOfferWindowOffersQuery>;
export type AdminOfferWindowOffersLazyQueryHookResult = ReturnType<typeof useAdminOfferWindowOffersLazyQuery>;
export type AdminOfferWindowOffersQueryResult = Apollo.QueryResult<AdminOfferWindowOffersQuery, AdminOfferWindowOffersQueryVariables>;
export const DeleteOfferDocument = gql`
    mutation DeleteOffer($id: Int!) {
  removeOffer(id: $id) {
    id
    offerWindow {
      id
      offers {
        ...AdminOfferWindowOffer
      }
    }
  }
}
    ${AdminOfferWindowOfferFragmentDoc}`;
export type DeleteOfferMutationFn = Apollo.MutationFunction<DeleteOfferMutation, DeleteOfferMutationVariables>;

/**
 * __useDeleteOfferMutation__
 *
 * To run a mutation, you first call `useDeleteOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferMutation, { data, loading, error }] = useDeleteOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfferMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfferMutation, DeleteOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfferMutation, DeleteOfferMutationVariables>(DeleteOfferDocument, options);
      }
export type DeleteOfferMutationHookResult = ReturnType<typeof useDeleteOfferMutation>;
export type DeleteOfferMutationResult = Apollo.MutationResult<DeleteOfferMutation>;
export type DeleteOfferMutationOptions = Apollo.BaseMutationOptions<DeleteOfferMutation, DeleteOfferMutationVariables>;
export const UpdateOfferDocument = gql`
    mutation UpdateOffer($id: Int!, $data: OfferUpdateInput!) {
  updateOffer(id: $id, data: $data) {
    id
    offerWindow {
      id
      offers {
        ...AdminOfferWindowOffer
      }
    }
  }
}
    ${AdminOfferWindowOfferFragmentDoc}`;
export type UpdateOfferMutationFn = Apollo.MutationFunction<UpdateOfferMutation, UpdateOfferMutationVariables>;

/**
 * __useUpdateOfferMutation__
 *
 * To run a mutation, you first call `useUpdateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferMutation, { data, loading, error }] = useUpdateOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOfferMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfferMutation, UpdateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfferMutation, UpdateOfferMutationVariables>(UpdateOfferDocument, options);
      }
export type UpdateOfferMutationHookResult = ReturnType<typeof useUpdateOfferMutation>;
export type UpdateOfferMutationResult = Apollo.MutationResult<UpdateOfferMutation>;
export type UpdateOfferMutationOptions = Apollo.BaseMutationOptions<UpdateOfferMutation, UpdateOfferMutationVariables>;
export const DeleteOfferWindowDocument = gql`
    mutation DeleteOfferWindow($id: Int!) {
  removeOfferWindow(id: $id) {
    id
  }
}
    `;
export type DeleteOfferWindowMutationFn = Apollo.MutationFunction<DeleteOfferWindowMutation, DeleteOfferWindowMutationVariables>;

/**
 * __useDeleteOfferWindowMutation__
 *
 * To run a mutation, you first call `useDeleteOfferWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferWindowMutation, { data, loading, error }] = useDeleteOfferWindowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfferWindowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfferWindowMutation, DeleteOfferWindowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfferWindowMutation, DeleteOfferWindowMutationVariables>(DeleteOfferWindowDocument, options);
      }
export type DeleteOfferWindowMutationHookResult = ReturnType<typeof useDeleteOfferWindowMutation>;
export type DeleteOfferWindowMutationResult = Apollo.MutationResult<DeleteOfferWindowMutation>;
export type DeleteOfferWindowMutationOptions = Apollo.BaseMutationOptions<DeleteOfferWindowMutation, DeleteOfferWindowMutationVariables>;
export const UpdateOfferWindowDocument = gql`
    mutation UpdateOfferWindow($id: Int!, $data: OfferWindowUpdateInput!) {
  updateOfferWindow(id: $id, data: $data) {
    id
    ...AdminOfferWindowOffers
  }
}
    ${AdminOfferWindowOffersFragmentDoc}`;
export type UpdateOfferWindowMutationFn = Apollo.MutationFunction<UpdateOfferWindowMutation, UpdateOfferWindowMutationVariables>;

/**
 * __useUpdateOfferWindowMutation__
 *
 * To run a mutation, you first call `useUpdateOfferWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferWindowMutation, { data, loading, error }] = useUpdateOfferWindowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOfferWindowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfferWindowMutation, UpdateOfferWindowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfferWindowMutation, UpdateOfferWindowMutationVariables>(UpdateOfferWindowDocument, options);
      }
export type UpdateOfferWindowMutationHookResult = ReturnType<typeof useUpdateOfferWindowMutation>;
export type UpdateOfferWindowMutationResult = Apollo.MutationResult<UpdateOfferWindowMutation>;
export type UpdateOfferWindowMutationOptions = Apollo.BaseMutationOptions<UpdateOfferWindowMutation, UpdateOfferWindowMutationVariables>;
export const AddOfferWindowDocument = gql`
    mutation AddOfferWindow($data: OfferWindowCreateInput!) {
  addOfferWindow(data: $data) {
    id
  }
}
    `;
export type AddOfferWindowMutationFn = Apollo.MutationFunction<AddOfferWindowMutation, AddOfferWindowMutationVariables>;

/**
 * __useAddOfferWindowMutation__
 *
 * To run a mutation, you first call `useAddOfferWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOfferWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOfferWindowMutation, { data, loading, error }] = useAddOfferWindowMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddOfferWindowMutation(baseOptions?: Apollo.MutationHookOptions<AddOfferWindowMutation, AddOfferWindowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOfferWindowMutation, AddOfferWindowMutationVariables>(AddOfferWindowDocument, options);
      }
export type AddOfferWindowMutationHookResult = ReturnType<typeof useAddOfferWindowMutation>;
export type AddOfferWindowMutationResult = Apollo.MutationResult<AddOfferWindowMutation>;
export type AddOfferWindowMutationOptions = Apollo.BaseMutationOptions<AddOfferWindowMutation, AddOfferWindowMutationVariables>;
export const AdminOfferWindowSearchDocument = gql`
    query AdminOfferWindowSearch($pagination: OffsetPaginationInput!, $filters: OfferWindowSearchFilters) {
  searchOfferWindows(pagination: $pagination, filters: $filters) {
    total
    results {
      ...AdminOfferWindowTableData
    }
  }
}
    ${AdminOfferWindowTableDataFragmentDoc}`;

/**
 * __useAdminOfferWindowSearchQuery__
 *
 * To run a query within a React component, call `useAdminOfferWindowSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOfferWindowSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOfferWindowSearchQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminOfferWindowSearchQuery(baseOptions: Apollo.QueryHookOptions<AdminOfferWindowSearchQuery, AdminOfferWindowSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOfferWindowSearchQuery, AdminOfferWindowSearchQueryVariables>(AdminOfferWindowSearchDocument, options);
      }
export function useAdminOfferWindowSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOfferWindowSearchQuery, AdminOfferWindowSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOfferWindowSearchQuery, AdminOfferWindowSearchQueryVariables>(AdminOfferWindowSearchDocument, options);
        }
export type AdminOfferWindowSearchQueryHookResult = ReturnType<typeof useAdminOfferWindowSearchQuery>;
export type AdminOfferWindowSearchLazyQueryHookResult = ReturnType<typeof useAdminOfferWindowSearchLazyQuery>;
export type AdminOfferWindowSearchQueryResult = Apollo.QueryResult<AdminOfferWindowSearchQuery, AdminOfferWindowSearchQueryVariables>;
export const CloneOfferWindowDocument = gql`
    mutation CloneOfferWindow($originalOfferWindowId: Int!, $data: OfferWindowCloneInput!) {
  cloneOfferWindow(originalOfferWindowId: $originalOfferWindowId, data: $data) {
    id
  }
}
    `;
export type CloneOfferWindowMutationFn = Apollo.MutationFunction<CloneOfferWindowMutation, CloneOfferWindowMutationVariables>;

/**
 * __useCloneOfferWindowMutation__
 *
 * To run a mutation, you first call `useCloneOfferWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneOfferWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneOfferWindowMutation, { data, loading, error }] = useCloneOfferWindowMutation({
 *   variables: {
 *      originalOfferWindowId: // value for 'originalOfferWindowId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCloneOfferWindowMutation(baseOptions?: Apollo.MutationHookOptions<CloneOfferWindowMutation, CloneOfferWindowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneOfferWindowMutation, CloneOfferWindowMutationVariables>(CloneOfferWindowDocument, options);
      }
export type CloneOfferWindowMutationHookResult = ReturnType<typeof useCloneOfferWindowMutation>;
export type CloneOfferWindowMutationResult = Apollo.MutationResult<CloneOfferWindowMutation>;
export type CloneOfferWindowMutationOptions = Apollo.BaseMutationOptions<CloneOfferWindowMutation, CloneOfferWindowMutationVariables>;
export const AdminPackagesDocument = gql`
    query AdminPackages {
  productPackageTypes {
    id
    displayName
    units
    containerLabel
    containerVolume
    containerVolumeUnit
    containerStreetName
    createdAt
    weight
    canDelete
  }
}
    `;

/**
 * __useAdminPackagesQuery__
 *
 * To run a query within a React component, call `useAdminPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPackagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminPackagesQuery(baseOptions?: Apollo.QueryHookOptions<AdminPackagesQuery, AdminPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPackagesQuery, AdminPackagesQueryVariables>(AdminPackagesDocument, options);
      }
export function useAdminPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPackagesQuery, AdminPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPackagesQuery, AdminPackagesQueryVariables>(AdminPackagesDocument, options);
        }
export type AdminPackagesQueryHookResult = ReturnType<typeof useAdminPackagesQuery>;
export type AdminPackagesLazyQueryHookResult = ReturnType<typeof useAdminPackagesLazyQuery>;
export type AdminPackagesQueryResult = Apollo.QueryResult<AdminPackagesQuery, AdminPackagesQueryVariables>;
export const AddProductDocument = gql`
    mutation AddProduct($data: ProductInput!) {
  addProduct(data: $data) {
    id
    name
  }
}
    `;
export type AddProductMutationFn = Apollo.MutationFunction<AddProductMutation, AddProductMutationVariables>;

/**
 * __useAddProductMutation__
 *
 * To run a mutation, you first call `useAddProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductMutation, { data, loading, error }] = useAddProductMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddProductMutation(baseOptions?: Apollo.MutationHookOptions<AddProductMutation, AddProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductMutation, AddProductMutationVariables>(AddProductDocument, options);
      }
export type AddProductMutationHookResult = ReturnType<typeof useAddProductMutation>;
export type AddProductMutationResult = Apollo.MutationResult<AddProductMutation>;
export type AddProductMutationOptions = Apollo.BaseMutationOptions<AddProductMutation, AddProductMutationVariables>;
export const AdminDeleteProductDocument = gql`
    mutation AdminDeleteProduct($productId: Int!) {
  deleteProduct(productId: $productId) {
    id
    name
  }
}
    `;
export type AdminDeleteProductMutationFn = Apollo.MutationFunction<AdminDeleteProductMutation, AdminDeleteProductMutationVariables>;

/**
 * __useAdminDeleteProductMutation__
 *
 * To run a mutation, you first call `useAdminDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteProductMutation, { data, loading, error }] = useAdminDeleteProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useAdminDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteProductMutation, AdminDeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteProductMutation, AdminDeleteProductMutationVariables>(AdminDeleteProductDocument, options);
      }
export type AdminDeleteProductMutationHookResult = ReturnType<typeof useAdminDeleteProductMutation>;
export type AdminDeleteProductMutationResult = Apollo.MutationResult<AdminDeleteProductMutation>;
export type AdminDeleteProductMutationOptions = Apollo.BaseMutationOptions<AdminDeleteProductMutation, AdminDeleteProductMutationVariables>;
export const AdminProductDocument = gql`
    query AdminProduct($productId: Int!) {
  product(id: $productId) {
    ...AdminProductDetails
    canOfferProduct {
      ...ValidationResult
    }
  }
}
    ${AdminProductDetailsFragmentDoc}
${ValidationResultFragmentDoc}`;

/**
 * __useAdminProductQuery__
 *
 * To run a query within a React component, call `useAdminProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useAdminProductQuery(baseOptions: Apollo.QueryHookOptions<AdminProductQuery, AdminProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProductQuery, AdminProductQueryVariables>(AdminProductDocument, options);
      }
export function useAdminProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProductQuery, AdminProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProductQuery, AdminProductQueryVariables>(AdminProductDocument, options);
        }
export type AdminProductQueryHookResult = ReturnType<typeof useAdminProductQuery>;
export type AdminProductLazyQueryHookResult = ReturnType<typeof useAdminProductLazyQuery>;
export type AdminProductQueryResult = Apollo.QueryResult<AdminProductQuery, AdminProductQueryVariables>;
export const AdminProductsDocument = gql`
    query AdminProducts($pagination: OffsetPaginationInput!, $filters: ProductsFilterData) {
  searchProducts(pagination: $pagination, filters: $filters) {
    results {
      ...AdminProductDetails
    }
    total
  }
}
    ${AdminProductDetailsFragmentDoc}`;

/**
 * __useAdminProductsQuery__
 *
 * To run a query within a React component, call `useAdminProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProductsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminProductsQuery(baseOptions: Apollo.QueryHookOptions<AdminProductsQuery, AdminProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProductsQuery, AdminProductsQueryVariables>(AdminProductsDocument, options);
      }
export function useAdminProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProductsQuery, AdminProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProductsQuery, AdminProductsQueryVariables>(AdminProductsDocument, options);
        }
export type AdminProductsQueryHookResult = ReturnType<typeof useAdminProductsQuery>;
export type AdminProductsLazyQueryHookResult = ReturnType<typeof useAdminProductsLazyQuery>;
export type AdminProductsQueryResult = Apollo.QueryResult<AdminProductsQuery, AdminProductsQueryVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($data: UpdateProductInput!) {
  editProduct(data: $data) {
    id
    name
    packageDate
    abv
    description
    breweryNetPrice
    beerStyle {
      name
      id
    }
    productImage {
      id
      rawUrl
      thumbnailUrl
    }
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const AddTransferForOrderDocument = gql`
    mutation AddTransferForOrder($data: AddTransferForOrderData!) {
  addTransferForOrder(data: $data) {
    ...FundsTransferFields
  }
}
    ${FundsTransferFieldsFragmentDoc}`;
export type AddTransferForOrderMutationFn = Apollo.MutationFunction<AddTransferForOrderMutation, AddTransferForOrderMutationVariables>;

/**
 * __useAddTransferForOrderMutation__
 *
 * To run a mutation, you first call `useAddTransferForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTransferForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTransferForOrderMutation, { data, loading, error }] = useAddTransferForOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddTransferForOrderMutation(baseOptions?: Apollo.MutationHookOptions<AddTransferForOrderMutation, AddTransferForOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTransferForOrderMutation, AddTransferForOrderMutationVariables>(AddTransferForOrderDocument, options);
      }
export type AddTransferForOrderMutationHookResult = ReturnType<typeof useAddTransferForOrderMutation>;
export type AddTransferForOrderMutationResult = Apollo.MutationResult<AddTransferForOrderMutation>;
export type AddTransferForOrderMutationOptions = Apollo.BaseMutationOptions<AddTransferForOrderMutation, AddTransferForOrderMutationVariables>;
export const AdminOrderBalanceTransfersDocument = gql`
    query AdminOrderBalanceTransfers($orderId: Int!) {
  order(id: $orderId) {
    id
    number
    balanceTransferStatus
    amountInCents
    ...OrderBalanceTransferBalances
    ... on ProducerPurchaseOrder {
      canSendBalanceTransfer {
        ...ValidationResult
      }
    }
    ... on DistributorPurchaseOrder {
      canSendBalanceTransfer {
        ...ValidationResult
      }
    }
  }
}
    ${OrderBalanceTransferBalancesFragmentDoc}
${ValidationResultFragmentDoc}`;

/**
 * __useAdminOrderBalanceTransfersQuery__
 *
 * To run a query within a React component, call `useAdminOrderBalanceTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderBalanceTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderBalanceTransfersQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminOrderBalanceTransfersQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderBalanceTransfersQuery, AdminOrderBalanceTransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderBalanceTransfersQuery, AdminOrderBalanceTransfersQueryVariables>(AdminOrderBalanceTransfersDocument, options);
      }
export function useAdminOrderBalanceTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderBalanceTransfersQuery, AdminOrderBalanceTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderBalanceTransfersQuery, AdminOrderBalanceTransfersQueryVariables>(AdminOrderBalanceTransfersDocument, options);
        }
export type AdminOrderBalanceTransfersQueryHookResult = ReturnType<typeof useAdminOrderBalanceTransfersQuery>;
export type AdminOrderBalanceTransfersLazyQueryHookResult = ReturnType<typeof useAdminOrderBalanceTransfersLazyQuery>;
export type AdminOrderBalanceTransfersQueryResult = Apollo.QueryResult<AdminOrderBalanceTransfersQuery, AdminOrderBalanceTransfersQueryVariables>;
export const SendBalanceTransferDocument = gql`
    mutation SendBalanceTransfer($orderId: Int!) {
  sendBalanceTransfer(orderId: $orderId) {
    order {
      id
      ...SendBalanceTransferDetails
    }
  }
}
    ${SendBalanceTransferDetailsFragmentDoc}`;
export type SendBalanceTransferMutationFn = Apollo.MutationFunction<SendBalanceTransferMutation, SendBalanceTransferMutationVariables>;

/**
 * __useSendBalanceTransferMutation__
 *
 * To run a mutation, you first call `useSendBalanceTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBalanceTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBalanceTransferMutation, { data, loading, error }] = useSendBalanceTransferMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendBalanceTransferMutation(baseOptions?: Apollo.MutationHookOptions<SendBalanceTransferMutation, SendBalanceTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBalanceTransferMutation, SendBalanceTransferMutationVariables>(SendBalanceTransferDocument, options);
      }
export type SendBalanceTransferMutationHookResult = ReturnType<typeof useSendBalanceTransferMutation>;
export type SendBalanceTransferMutationResult = Apollo.MutationResult<SendBalanceTransferMutation>;
export type SendBalanceTransferMutationOptions = Apollo.BaseMutationOptions<SendBalanceTransferMutation, SendBalanceTransferMutationVariables>;
export const SendBalanceTransferDataDocument = gql`
    query SendBalanceTransferData($orderId: Int!) {
  order(id: $orderId) {
    id
    ...SendBalanceTransferDetails
    ...SendDistributorBalanceTransferDetails
  }
}
    ${SendBalanceTransferDetailsFragmentDoc}
${SendDistributorBalanceTransferDetailsFragmentDoc}`;

/**
 * __useSendBalanceTransferDataQuery__
 *
 * To run a query within a React component, call `useSendBalanceTransferDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendBalanceTransferDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendBalanceTransferDataQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendBalanceTransferDataQuery(baseOptions: Apollo.QueryHookOptions<SendBalanceTransferDataQuery, SendBalanceTransferDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendBalanceTransferDataQuery, SendBalanceTransferDataQueryVariables>(SendBalanceTransferDataDocument, options);
      }
export function useSendBalanceTransferDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendBalanceTransferDataQuery, SendBalanceTransferDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendBalanceTransferDataQuery, SendBalanceTransferDataQueryVariables>(SendBalanceTransferDataDocument, options);
        }
export type SendBalanceTransferDataQueryHookResult = ReturnType<typeof useSendBalanceTransferDataQuery>;
export type SendBalanceTransferDataLazyQueryHookResult = ReturnType<typeof useSendBalanceTransferDataLazyQuery>;
export type SendBalanceTransferDataQueryResult = Apollo.QueryResult<SendBalanceTransferDataQuery, SendBalanceTransferDataQueryVariables>;
export const SendDistributorBalanceTransferDocument = gql`
    mutation SendDistributorBalanceTransfer($orderId: Int!) {
  sendDistributorBalanceTransfer(orderId: $orderId) {
    order {
      id
      ...SendDistributorBalanceTransferDetails
    }
  }
}
    ${SendDistributorBalanceTransferDetailsFragmentDoc}`;
export type SendDistributorBalanceTransferMutationFn = Apollo.MutationFunction<SendDistributorBalanceTransferMutation, SendDistributorBalanceTransferMutationVariables>;

/**
 * __useSendDistributorBalanceTransferMutation__
 *
 * To run a mutation, you first call `useSendDistributorBalanceTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDistributorBalanceTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDistributorBalanceTransferMutation, { data, loading, error }] = useSendDistributorBalanceTransferMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendDistributorBalanceTransferMutation(baseOptions?: Apollo.MutationHookOptions<SendDistributorBalanceTransferMutation, SendDistributorBalanceTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDistributorBalanceTransferMutation, SendDistributorBalanceTransferMutationVariables>(SendDistributorBalanceTransferDocument, options);
      }
export type SendDistributorBalanceTransferMutationHookResult = ReturnType<typeof useSendDistributorBalanceTransferMutation>;
export type SendDistributorBalanceTransferMutationResult = Apollo.MutationResult<SendDistributorBalanceTransferMutation>;
export type SendDistributorBalanceTransferMutationOptions = Apollo.BaseMutationOptions<SendDistributorBalanceTransferMutation, SendDistributorBalanceTransferMutationVariables>;
export const AddOrderDocumentDocument = gql`
    mutation AddOrderDocument($data: OrderDocumentCreateData!) {
  addOrderDocument(data: $data) {
    id
    order {
      id
      documents {
        ...OrderDocumentSummary
      }
    }
  }
}
    ${OrderDocumentSummaryFragmentDoc}`;
export type AddOrderDocumentMutationFn = Apollo.MutationFunction<AddOrderDocumentMutation, AddOrderDocumentMutationVariables>;

/**
 * __useAddOrderDocumentMutation__
 *
 * To run a mutation, you first call `useAddOrderDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderDocumentMutation, { data, loading, error }] = useAddOrderDocumentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddOrderDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddOrderDocumentMutation, AddOrderDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrderDocumentMutation, AddOrderDocumentMutationVariables>(AddOrderDocumentDocument, options);
      }
export type AddOrderDocumentMutationHookResult = ReturnType<typeof useAddOrderDocumentMutation>;
export type AddOrderDocumentMutationResult = Apollo.MutationResult<AddOrderDocumentMutation>;
export type AddOrderDocumentMutationOptions = Apollo.BaseMutationOptions<AddOrderDocumentMutation, AddOrderDocumentMutationVariables>;
export const AdminOrderDocumentsDocument = gql`
    query AdminOrderDocuments($orderId: Int!) {
  order(id: $orderId) {
    id
    ...AdminOrderSummary
    documents {
      ...OrderDocumentSummary
    }
  }
}
    ${AdminOrderSummaryFragmentDoc}
${OrderDocumentSummaryFragmentDoc}`;

/**
 * __useAdminOrderDocumentsQuery__
 *
 * To run a query within a React component, call `useAdminOrderDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderDocumentsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminOrderDocumentsQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderDocumentsQuery, AdminOrderDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderDocumentsQuery, AdminOrderDocumentsQueryVariables>(AdminOrderDocumentsDocument, options);
      }
export function useAdminOrderDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderDocumentsQuery, AdminOrderDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderDocumentsQuery, AdminOrderDocumentsQueryVariables>(AdminOrderDocumentsDocument, options);
        }
export type AdminOrderDocumentsQueryHookResult = ReturnType<typeof useAdminOrderDocumentsQuery>;
export type AdminOrderDocumentsLazyQueryHookResult = ReturnType<typeof useAdminOrderDocumentsLazyQuery>;
export type AdminOrderDocumentsQueryResult = Apollo.QueryResult<AdminOrderDocumentsQuery, AdminOrderDocumentsQueryVariables>;
export const DeleteOrderDocumentDocument = gql`
    mutation DeleteOrderDocument($id: Int!) {
  deleteOrderDocument(id: $id) {
    id
    order {
      id
      documents {
        ...OrderDocumentSummary
      }
    }
  }
}
    ${OrderDocumentSummaryFragmentDoc}`;
export type DeleteOrderDocumentMutationFn = Apollo.MutationFunction<DeleteOrderDocumentMutation, DeleteOrderDocumentMutationVariables>;

/**
 * __useDeleteOrderDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteOrderDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderDocumentMutation, { data, loading, error }] = useDeleteOrderDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderDocumentMutation, DeleteOrderDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderDocumentMutation, DeleteOrderDocumentMutationVariables>(DeleteOrderDocumentDocument, options);
      }
export type DeleteOrderDocumentMutationHookResult = ReturnType<typeof useDeleteOrderDocumentMutation>;
export type DeleteOrderDocumentMutationResult = Apollo.MutationResult<DeleteOrderDocumentMutation>;
export type DeleteOrderDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteOrderDocumentMutation, DeleteOrderDocumentMutationVariables>;
export const DeletePodDocumentDocument = gql`
    mutation DeletePODDocument($id: Int!) {
  deletePODDocument(id: $id) {
    id
    order {
      id
      documents {
        ...OrderDocumentSummary
      }
      ...AdminOrderSummary
    }
  }
}
    ${OrderDocumentSummaryFragmentDoc}
${AdminOrderSummaryFragmentDoc}`;
export type DeletePodDocumentMutationFn = Apollo.MutationFunction<DeletePodDocumentMutation, DeletePodDocumentMutationVariables>;

/**
 * __useDeletePodDocumentMutation__
 *
 * To run a mutation, you first call `useDeletePodDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePodDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePodDocumentMutation, { data, loading, error }] = useDeletePodDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePodDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePodDocumentMutation, DeletePodDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePodDocumentMutation, DeletePodDocumentMutationVariables>(DeletePodDocumentDocument, options);
      }
export type DeletePodDocumentMutationHookResult = ReturnType<typeof useDeletePodDocumentMutation>;
export type DeletePodDocumentMutationResult = Apollo.MutationResult<DeletePodDocumentMutation>;
export type DeletePodDocumentMutationOptions = Apollo.BaseMutationOptions<DeletePodDocumentMutation, DeletePodDocumentMutationVariables>;
export const AdminOrderAuditLogsDocument = gql`
    query AdminOrderAuditLogs($orderId: Int!) {
  order(id: $orderId) {
    id
    auditLogs {
      ...AuditLogDetails
    }
  }
}
    ${AuditLogDetailsFragmentDoc}`;

/**
 * __useAdminOrderAuditLogsQuery__
 *
 * To run a query within a React component, call `useAdminOrderAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderAuditLogsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminOrderAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderAuditLogsQuery, AdminOrderAuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderAuditLogsQuery, AdminOrderAuditLogsQueryVariables>(AdminOrderAuditLogsDocument, options);
      }
export function useAdminOrderAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderAuditLogsQuery, AdminOrderAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderAuditLogsQuery, AdminOrderAuditLogsQueryVariables>(AdminOrderAuditLogsDocument, options);
        }
export type AdminOrderAuditLogsQueryHookResult = ReturnType<typeof useAdminOrderAuditLogsQuery>;
export type AdminOrderAuditLogsLazyQueryHookResult = ReturnType<typeof useAdminOrderAuditLogsLazyQuery>;
export type AdminOrderAuditLogsQueryResult = Apollo.QueryResult<AdminOrderAuditLogsQuery, AdminOrderAuditLogsQueryVariables>;
export const AdjustmentReasonsDocument = gql`
    query AdjustmentReasons {
  adjustmentReasons {
    id
    label
  }
}
    `;

/**
 * __useAdjustmentReasonsQuery__
 *
 * To run a query within a React component, call `useAdjustmentReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdjustmentReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdjustmentReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdjustmentReasonsQuery(baseOptions?: Apollo.QueryHookOptions<AdjustmentReasonsQuery, AdjustmentReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdjustmentReasonsQuery, AdjustmentReasonsQueryVariables>(AdjustmentReasonsDocument, options);
      }
export function useAdjustmentReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdjustmentReasonsQuery, AdjustmentReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdjustmentReasonsQuery, AdjustmentReasonsQueryVariables>(AdjustmentReasonsDocument, options);
        }
export type AdjustmentReasonsQueryHookResult = ReturnType<typeof useAdjustmentReasonsQuery>;
export type AdjustmentReasonsLazyQueryHookResult = ReturnType<typeof useAdjustmentReasonsLazyQuery>;
export type AdjustmentReasonsQueryResult = Apollo.QueryResult<AdjustmentReasonsQuery, AdjustmentReasonsQueryVariables>;
export const AdminOrderItemsDocument = gql`
    query AdminOrderItems($orderId: Int!) {
  order(id: $orderId) {
    id
    number
    ...AdminOrderItemsData
    enabledFeatures {
      canEditOrderItems
      canEditAdjustmentItems
      canViewAdjustments
      canDeleteOrderItems
    }
  }
}
    ${AdminOrderItemsDataFragmentDoc}`;

/**
 * __useAdminOrderItemsQuery__
 *
 * To run a query within a React component, call `useAdminOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderItemsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminOrderItemsQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderItemsQuery, AdminOrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderItemsQuery, AdminOrderItemsQueryVariables>(AdminOrderItemsDocument, options);
      }
export function useAdminOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderItemsQuery, AdminOrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderItemsQuery, AdminOrderItemsQueryVariables>(AdminOrderItemsDocument, options);
        }
export type AdminOrderItemsQueryHookResult = ReturnType<typeof useAdminOrderItemsQuery>;
export type AdminOrderItemsLazyQueryHookResult = ReturnType<typeof useAdminOrderItemsLazyQuery>;
export type AdminOrderItemsQueryResult = Apollo.QueryResult<AdminOrderItemsQuery, AdminOrderItemsQueryVariables>;
export const DeleteProductFromPurchaseOrderDocument = gql`
    mutation DeleteProductFromPurchaseOrder($orderId: Int!, $productId: Int!) {
  deleteProductFromPurchaseOrder(orderId: $orderId, productId: $productId) {
    id
    ...AdminOrderItemsData
  }
}
    ${AdminOrderItemsDataFragmentDoc}`;
export type DeleteProductFromPurchaseOrderMutationFn = Apollo.MutationFunction<DeleteProductFromPurchaseOrderMutation, DeleteProductFromPurchaseOrderMutationVariables>;

/**
 * __useDeleteProductFromPurchaseOrderMutation__
 *
 * To run a mutation, you first call `useDeleteProductFromPurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductFromPurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductFromPurchaseOrderMutation, { data, loading, error }] = useDeleteProductFromPurchaseOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useDeleteProductFromPurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductFromPurchaseOrderMutation, DeleteProductFromPurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductFromPurchaseOrderMutation, DeleteProductFromPurchaseOrderMutationVariables>(DeleteProductFromPurchaseOrderDocument, options);
      }
export type DeleteProductFromPurchaseOrderMutationHookResult = ReturnType<typeof useDeleteProductFromPurchaseOrderMutation>;
export type DeleteProductFromPurchaseOrderMutationResult = Apollo.MutationResult<DeleteProductFromPurchaseOrderMutation>;
export type DeleteProductFromPurchaseOrderMutationOptions = Apollo.BaseMutationOptions<DeleteProductFromPurchaseOrderMutation, DeleteProductFromPurchaseOrderMutationVariables>;
export const AdminOrderItemsUpdateDocument = gql`
    mutation AdminOrderItemsUpdate($id: Int!, $data: OrderUpdateData!) {
  updateOrder(data: $data, id: $id) {
    id
    ...AdminOrderItemsData
  }
}
    ${AdminOrderItemsDataFragmentDoc}`;
export type AdminOrderItemsUpdateMutationFn = Apollo.MutationFunction<AdminOrderItemsUpdateMutation, AdminOrderItemsUpdateMutationVariables>;

/**
 * __useAdminOrderItemsUpdateMutation__
 *
 * To run a mutation, you first call `useAdminOrderItemsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderItemsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminOrderItemsUpdateMutation, { data, loading, error }] = useAdminOrderItemsUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminOrderItemsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminOrderItemsUpdateMutation, AdminOrderItemsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminOrderItemsUpdateMutation, AdminOrderItemsUpdateMutationVariables>(AdminOrderItemsUpdateDocument, options);
      }
export type AdminOrderItemsUpdateMutationHookResult = ReturnType<typeof useAdminOrderItemsUpdateMutation>;
export type AdminOrderItemsUpdateMutationResult = Apollo.MutationResult<AdminOrderItemsUpdateMutation>;
export type AdminOrderItemsUpdateMutationOptions = Apollo.BaseMutationOptions<AdminOrderItemsUpdateMutation, AdminOrderItemsUpdateMutationVariables>;
export const AddPodDocumentDocument = gql`
    mutation AddPODDocument($data: OrderPODDocumentCreateData!) {
  addPODDocument(data: $data) {
    id
    order {
      id
      documents {
        ...OrderDocumentSummary
      }
      ...AdminOrderSummary
    }
  }
}
    ${OrderDocumentSummaryFragmentDoc}
${AdminOrderSummaryFragmentDoc}`;
export type AddPodDocumentMutationFn = Apollo.MutationFunction<AddPodDocumentMutation, AddPodDocumentMutationVariables>;

/**
 * __useAddPodDocumentMutation__
 *
 * To run a mutation, you first call `useAddPodDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPodDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPodDocumentMutation, { data, loading, error }] = useAddPodDocumentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddPodDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddPodDocumentMutation, AddPodDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPodDocumentMutation, AddPodDocumentMutationVariables>(AddPodDocumentDocument, options);
      }
export type AddPodDocumentMutationHookResult = ReturnType<typeof useAddPodDocumentMutation>;
export type AddPodDocumentMutationResult = Apollo.MutationResult<AddPodDocumentMutation>;
export type AddPodDocumentMutationOptions = Apollo.BaseMutationOptions<AddPodDocumentMutation, AddPodDocumentMutationVariables>;
export const AdminOrderOverviewDocument = gql`
    query AdminOrderOverview($orderId: Int!) {
  order(id: $orderId) {
    id
    ...AdminOrderSummary
    ... on RetailerSalesOrder {
      canCancel {
        isValid
      }
    }
    ... on ProducerPurchaseOrder {
      canCancel {
        isValid
      }
    }
    ... on PreSaleOrder {
      canCancel {
        isValid
      }
    }
  }
}
    ${AdminOrderSummaryFragmentDoc}`;

/**
 * __useAdminOrderOverviewQuery__
 *
 * To run a query within a React component, call `useAdminOrderOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderOverviewQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminOrderOverviewQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderOverviewQuery, AdminOrderOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderOverviewQuery, AdminOrderOverviewQueryVariables>(AdminOrderOverviewDocument, options);
      }
export function useAdminOrderOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderOverviewQuery, AdminOrderOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderOverviewQuery, AdminOrderOverviewQueryVariables>(AdminOrderOverviewDocument, options);
        }
export type AdminOrderOverviewQueryHookResult = ReturnType<typeof useAdminOrderOverviewQuery>;
export type AdminOrderOverviewLazyQueryHookResult = ReturnType<typeof useAdminOrderOverviewLazyQuery>;
export type AdminOrderOverviewQueryResult = Apollo.QueryResult<AdminOrderOverviewQuery, AdminOrderOverviewQueryVariables>;
export const AdminOrderPaymentsDocument = gql`
    query AdminOrderPayments($orderId: Int!) {
  order(id: $orderId) {
    id
    number
    enabledFeatures {
      canMakePayment
    }
    amountInCents
    ...OrderPaymentBalances
    ...DistributorPaymentBalances
    ... on RetailerSalesOrder {
      canSendPayment {
        ...ValidationResult
      }
    }
    ... on ProducerPurchaseOrder {
      canSendAdjustmentsPayment {
        ...ValidationResult
      }
    }
  }
}
    ${OrderPaymentBalancesFragmentDoc}
${DistributorPaymentBalancesFragmentDoc}
${ValidationResultFragmentDoc}`;

/**
 * __useAdminOrderPaymentsQuery__
 *
 * To run a query within a React component, call `useAdminOrderPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderPaymentsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminOrderPaymentsQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderPaymentsQuery, AdminOrderPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderPaymentsQuery, AdminOrderPaymentsQueryVariables>(AdminOrderPaymentsDocument, options);
      }
export function useAdminOrderPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderPaymentsQuery, AdminOrderPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderPaymentsQuery, AdminOrderPaymentsQueryVariables>(AdminOrderPaymentsDocument, options);
        }
export type AdminOrderPaymentsQueryHookResult = ReturnType<typeof useAdminOrderPaymentsQuery>;
export type AdminOrderPaymentsLazyQueryHookResult = ReturnType<typeof useAdminOrderPaymentsLazyQuery>;
export type AdminOrderPaymentsQueryResult = Apollo.QueryResult<AdminOrderPaymentsQuery, AdminOrderPaymentsQueryVariables>;
export const SendAdjustmentsPaymentDocument = gql`
    mutation SendAdjustmentsPayment($orderId: Int!) {
  sendAdjustmentsPayment(orderId: $orderId) {
    order {
      id
      ...SendAdjustmentsPaymentDetails
    }
  }
}
    ${SendAdjustmentsPaymentDetailsFragmentDoc}`;
export type SendAdjustmentsPaymentMutationFn = Apollo.MutationFunction<SendAdjustmentsPaymentMutation, SendAdjustmentsPaymentMutationVariables>;

/**
 * __useSendAdjustmentsPaymentMutation__
 *
 * To run a mutation, you first call `useSendAdjustmentsPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAdjustmentsPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAdjustmentsPaymentMutation, { data, loading, error }] = useSendAdjustmentsPaymentMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendAdjustmentsPaymentMutation(baseOptions?: Apollo.MutationHookOptions<SendAdjustmentsPaymentMutation, SendAdjustmentsPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAdjustmentsPaymentMutation, SendAdjustmentsPaymentMutationVariables>(SendAdjustmentsPaymentDocument, options);
      }
export type SendAdjustmentsPaymentMutationHookResult = ReturnType<typeof useSendAdjustmentsPaymentMutation>;
export type SendAdjustmentsPaymentMutationResult = Apollo.MutationResult<SendAdjustmentsPaymentMutation>;
export type SendAdjustmentsPaymentMutationOptions = Apollo.BaseMutationOptions<SendAdjustmentsPaymentMutation, SendAdjustmentsPaymentMutationVariables>;
export const SendAdjustmentsPaymentDataDocument = gql`
    query SendAdjustmentsPaymentData($orderId: Int!) {
  producerPurchaseOrder(id: $orderId) {
    id
    ...SendAdjustmentsPaymentDetails
  }
}
    ${SendAdjustmentsPaymentDetailsFragmentDoc}`;

/**
 * __useSendAdjustmentsPaymentDataQuery__
 *
 * To run a query within a React component, call `useSendAdjustmentsPaymentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendAdjustmentsPaymentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendAdjustmentsPaymentDataQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendAdjustmentsPaymentDataQuery(baseOptions: Apollo.QueryHookOptions<SendAdjustmentsPaymentDataQuery, SendAdjustmentsPaymentDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendAdjustmentsPaymentDataQuery, SendAdjustmentsPaymentDataQueryVariables>(SendAdjustmentsPaymentDataDocument, options);
      }
export function useSendAdjustmentsPaymentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendAdjustmentsPaymentDataQuery, SendAdjustmentsPaymentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendAdjustmentsPaymentDataQuery, SendAdjustmentsPaymentDataQueryVariables>(SendAdjustmentsPaymentDataDocument, options);
        }
export type SendAdjustmentsPaymentDataQueryHookResult = ReturnType<typeof useSendAdjustmentsPaymentDataQuery>;
export type SendAdjustmentsPaymentDataLazyQueryHookResult = ReturnType<typeof useSendAdjustmentsPaymentDataLazyQuery>;
export type SendAdjustmentsPaymentDataQueryResult = Apollo.QueryResult<SendAdjustmentsPaymentDataQuery, SendAdjustmentsPaymentDataQueryVariables>;
export const SendDistributorPaymentDocument = gql`
    mutation SendDistributorPayment($orderId: Int!) {
  sendDistributorPayment(orderId: $orderId) {
    order {
      id
      ...SendDistributorPaymentDetails
    }
  }
}
    ${SendDistributorPaymentDetailsFragmentDoc}`;
export type SendDistributorPaymentMutationFn = Apollo.MutationFunction<SendDistributorPaymentMutation, SendDistributorPaymentMutationVariables>;

/**
 * __useSendDistributorPaymentMutation__
 *
 * To run a mutation, you first call `useSendDistributorPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDistributorPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDistributorPaymentMutation, { data, loading, error }] = useSendDistributorPaymentMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendDistributorPaymentMutation(baseOptions?: Apollo.MutationHookOptions<SendDistributorPaymentMutation, SendDistributorPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDistributorPaymentMutation, SendDistributorPaymentMutationVariables>(SendDistributorPaymentDocument, options);
      }
export type SendDistributorPaymentMutationHookResult = ReturnType<typeof useSendDistributorPaymentMutation>;
export type SendDistributorPaymentMutationResult = Apollo.MutationResult<SendDistributorPaymentMutation>;
export type SendDistributorPaymentMutationOptions = Apollo.BaseMutationOptions<SendDistributorPaymentMutation, SendDistributorPaymentMutationVariables>;
export const SendDistributorPaymentDataDocument = gql`
    query SendDistributorPaymentData($orderId: Int!) {
  order(id: $orderId) {
    id
    ...SendDistributorPaymentDetails
  }
}
    ${SendDistributorPaymentDetailsFragmentDoc}`;

/**
 * __useSendDistributorPaymentDataQuery__
 *
 * To run a query within a React component, call `useSendDistributorPaymentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendDistributorPaymentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendDistributorPaymentDataQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendDistributorPaymentDataQuery(baseOptions: Apollo.QueryHookOptions<SendDistributorPaymentDataQuery, SendDistributorPaymentDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendDistributorPaymentDataQuery, SendDistributorPaymentDataQueryVariables>(SendDistributorPaymentDataDocument, options);
      }
export function useSendDistributorPaymentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendDistributorPaymentDataQuery, SendDistributorPaymentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendDistributorPaymentDataQuery, SendDistributorPaymentDataQueryVariables>(SendDistributorPaymentDataDocument, options);
        }
export type SendDistributorPaymentDataQueryHookResult = ReturnType<typeof useSendDistributorPaymentDataQuery>;
export type SendDistributorPaymentDataLazyQueryHookResult = ReturnType<typeof useSendDistributorPaymentDataLazyQuery>;
export type SendDistributorPaymentDataQueryResult = Apollo.QueryResult<SendDistributorPaymentDataQuery, SendDistributorPaymentDataQueryVariables>;
export const SendRetailerPaymentDocument = gql`
    mutation SendRetailerPayment($orderId: Int!) {
  sendRetailerPayment(orderId: $orderId) {
    order {
      id
      ...SendRetailerPaymentDetails
    }
  }
}
    ${SendRetailerPaymentDetailsFragmentDoc}`;
export type SendRetailerPaymentMutationFn = Apollo.MutationFunction<SendRetailerPaymentMutation, SendRetailerPaymentMutationVariables>;

/**
 * __useSendRetailerPaymentMutation__
 *
 * To run a mutation, you first call `useSendRetailerPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRetailerPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRetailerPaymentMutation, { data, loading, error }] = useSendRetailerPaymentMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendRetailerPaymentMutation(baseOptions?: Apollo.MutationHookOptions<SendRetailerPaymentMutation, SendRetailerPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRetailerPaymentMutation, SendRetailerPaymentMutationVariables>(SendRetailerPaymentDocument, options);
      }
export type SendRetailerPaymentMutationHookResult = ReturnType<typeof useSendRetailerPaymentMutation>;
export type SendRetailerPaymentMutationResult = Apollo.MutationResult<SendRetailerPaymentMutation>;
export type SendRetailerPaymentMutationOptions = Apollo.BaseMutationOptions<SendRetailerPaymentMutation, SendRetailerPaymentMutationVariables>;
export const SendRetailerPaymentDataDocument = gql`
    query SendRetailerPaymentData($orderId: Int!) {
  order(id: $orderId) {
    id
    ...SendRetailerPaymentDetails
  }
}
    ${SendRetailerPaymentDetailsFragmentDoc}`;

/**
 * __useSendRetailerPaymentDataQuery__
 *
 * To run a query within a React component, call `useSendRetailerPaymentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendRetailerPaymentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendRetailerPaymentDataQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendRetailerPaymentDataQuery(baseOptions: Apollo.QueryHookOptions<SendRetailerPaymentDataQuery, SendRetailerPaymentDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendRetailerPaymentDataQuery, SendRetailerPaymentDataQueryVariables>(SendRetailerPaymentDataDocument, options);
      }
export function useSendRetailerPaymentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendRetailerPaymentDataQuery, SendRetailerPaymentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendRetailerPaymentDataQuery, SendRetailerPaymentDataQueryVariables>(SendRetailerPaymentDataDocument, options);
        }
export type SendRetailerPaymentDataQueryHookResult = ReturnType<typeof useSendRetailerPaymentDataQuery>;
export type SendRetailerPaymentDataLazyQueryHookResult = ReturnType<typeof useSendRetailerPaymentDataLazyQuery>;
export type SendRetailerPaymentDataQueryResult = Apollo.QueryResult<SendRetailerPaymentDataQuery, SendRetailerPaymentDataQueryVariables>;
export const AdminOrderRetailerOrdersDocument = gql`
    query AdminOrderRetailerOrders($orderId: Int!) {
  order(id: $orderId) {
    id
    ... on DistributorPurchaseOrder {
      retailerSalesOrders {
        ...AdminRetailerOrderSummary
      }
    }
    ... on ProducerPurchaseOrder {
      retailerSalesOrders {
        ...AdminRetailerOrderSummary
      }
    }
  }
}
    ${AdminRetailerOrderSummaryFragmentDoc}`;

/**
 * __useAdminOrderRetailerOrdersQuery__
 *
 * To run a query within a React component, call `useAdminOrderRetailerOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderRetailerOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderRetailerOrdersQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminOrderRetailerOrdersQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderRetailerOrdersQuery, AdminOrderRetailerOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderRetailerOrdersQuery, AdminOrderRetailerOrdersQueryVariables>(AdminOrderRetailerOrdersDocument, options);
      }
export function useAdminOrderRetailerOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderRetailerOrdersQuery, AdminOrderRetailerOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderRetailerOrdersQuery, AdminOrderRetailerOrdersQueryVariables>(AdminOrderRetailerOrdersDocument, options);
        }
export type AdminOrderRetailerOrdersQueryHookResult = ReturnType<typeof useAdminOrderRetailerOrdersQuery>;
export type AdminOrderRetailerOrdersLazyQueryHookResult = ReturnType<typeof useAdminOrderRetailerOrdersLazyQuery>;
export type AdminOrderRetailerOrdersQueryResult = Apollo.QueryResult<AdminOrderRetailerOrdersQuery, AdminOrderRetailerOrdersQueryVariables>;
export const AddRetailerSalesOrderDocument = gql`
    mutation AddRetailerSalesOrder($data: RetailerOrderAddData!) {
  addRetailerSalesOrder(data: $data) {
    id
    producerPurchaseOrder {
      id
      retailerSalesOrders {
        ...AdminRetailerOrderSummary
      }
      distributorPurchaseOrder {
        id
        retailerSalesOrders {
          ...AdminRetailerOrderSummary
        }
      }
    }
  }
}
    ${AdminRetailerOrderSummaryFragmentDoc}`;
export type AddRetailerSalesOrderMutationFn = Apollo.MutationFunction<AddRetailerSalesOrderMutation, AddRetailerSalesOrderMutationVariables>;

/**
 * __useAddRetailerSalesOrderMutation__
 *
 * To run a mutation, you first call `useAddRetailerSalesOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRetailerSalesOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRetailerSalesOrderMutation, { data, loading, error }] = useAddRetailerSalesOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddRetailerSalesOrderMutation(baseOptions?: Apollo.MutationHookOptions<AddRetailerSalesOrderMutation, AddRetailerSalesOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRetailerSalesOrderMutation, AddRetailerSalesOrderMutationVariables>(AddRetailerSalesOrderDocument, options);
      }
export type AddRetailerSalesOrderMutationHookResult = ReturnType<typeof useAddRetailerSalesOrderMutation>;
export type AddRetailerSalesOrderMutationResult = Apollo.MutationResult<AddRetailerSalesOrderMutation>;
export type AddRetailerSalesOrderMutationOptions = Apollo.BaseMutationOptions<AddRetailerSalesOrderMutation, AddRetailerSalesOrderMutationVariables>;
export const AdminOrderRouterDocument = gql`
    query AdminOrderRouter($orderId: Int!) {
  order(id: $orderId) {
    id
    type
    number
    amountInCents
    createdAt
    cancelledAt
    distributionModel
    regionV2 {
      id
      friendlyName
      deliveryPartner {
        id
        displayName
      }
    }
    ... on PreSaleOrder {
      preSale {
        id
        number
      }
      buyer {
        id
        displayName
      }
    }
    ... on ProducerPurchaseOrder {
      distributorPurchaseOrder {
        id
        number
      }
      seller {
        id
        displayName
      }
      invoice {
        id
        externalInvoiceId
      }
      platformFee
    }
    ... on RetailerSalesOrder {
      producerPurchaseOrder {
        id
        number
        distributorPurchaseOrder {
          id
          number
        }
        seller {
          id
          displayName
        }
      }
    }
    ... on DistributorPurchaseOrder {
      producerPurchaseOrder {
        id
        number
        seller {
          id
          displayName
        }
      }
    }
    enabledFeatures {
      canCreateChildRetailSaleOrder
    }
  }
}
    `;

/**
 * __useAdminOrderRouterQuery__
 *
 * To run a query within a React component, call `useAdminOrderRouterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderRouterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderRouterQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminOrderRouterQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderRouterQuery, AdminOrderRouterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderRouterQuery, AdminOrderRouterQueryVariables>(AdminOrderRouterDocument, options);
      }
export function useAdminOrderRouterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderRouterQuery, AdminOrderRouterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderRouterQuery, AdminOrderRouterQueryVariables>(AdminOrderRouterDocument, options);
        }
export type AdminOrderRouterQueryHookResult = ReturnType<typeof useAdminOrderRouterQuery>;
export type AdminOrderRouterLazyQueryHookResult = ReturnType<typeof useAdminOrderRouterLazyQuery>;
export type AdminOrderRouterQueryResult = Apollo.QueryResult<AdminOrderRouterQuery, AdminOrderRouterQueryVariables>;
export const AdminOrderShippingDocument = gql`
    query AdminOrderShipping($orderId: Int!) {
  order(id: $orderId) {
    id
    number
    enabledFeatures {
      canCreatePDF
    }
    seller {
      id
      address {
        ...Address
      }
      organization {
        email
      }
    }
    buyer {
      id
      organization {
        email
      }
    }
    shippingAddress {
      ...Address
    }
    trackingInformation {
      ...TrackingInformationDetails
    }
    packageSummary {
      ...AdminPackageSummaryTableData
    }
  }
}
    ${AddressFragmentDoc}
${TrackingInformationDetailsFragmentDoc}
${AdminPackageSummaryTableDataFragmentDoc}`;

/**
 * __useAdminOrderShippingQuery__
 *
 * To run a query within a React component, call `useAdminOrderShippingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderShippingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderShippingQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminOrderShippingQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderShippingQuery, AdminOrderShippingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderShippingQuery, AdminOrderShippingQueryVariables>(AdminOrderShippingDocument, options);
      }
export function useAdminOrderShippingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderShippingQuery, AdminOrderShippingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderShippingQuery, AdminOrderShippingQueryVariables>(AdminOrderShippingDocument, options);
        }
export type AdminOrderShippingQueryHookResult = ReturnType<typeof useAdminOrderShippingQuery>;
export type AdminOrderShippingLazyQueryHookResult = ReturnType<typeof useAdminOrderShippingLazyQuery>;
export type AdminOrderShippingQueryResult = Apollo.QueryResult<AdminOrderShippingQuery, AdminOrderShippingQueryVariables>;
export const CreateKuebixShipmentDocument = gql`
    mutation CreateKuebixShipment($orderId: Int!) {
  createKuebixShipment(orderId: $orderId) {
    id
    trackingInformation {
      id
      kuebixShipmentId
    }
  }
}
    `;
export type CreateKuebixShipmentMutationFn = Apollo.MutationFunction<CreateKuebixShipmentMutation, CreateKuebixShipmentMutationVariables>;

/**
 * __useCreateKuebixShipmentMutation__
 *
 * To run a mutation, you first call `useCreateKuebixShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKuebixShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKuebixShipmentMutation, { data, loading, error }] = useCreateKuebixShipmentMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCreateKuebixShipmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateKuebixShipmentMutation, CreateKuebixShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKuebixShipmentMutation, CreateKuebixShipmentMutationVariables>(CreateKuebixShipmentDocument, options);
      }
export type CreateKuebixShipmentMutationHookResult = ReturnType<typeof useCreateKuebixShipmentMutation>;
export type CreateKuebixShipmentMutationResult = Apollo.MutationResult<CreateKuebixShipmentMutation>;
export type CreateKuebixShipmentMutationOptions = Apollo.BaseMutationOptions<CreateKuebixShipmentMutation, CreateKuebixShipmentMutationVariables>;
export const UpdateOrderAddressDocument = gql`
    mutation UpdateOrderAddress($data: AddressUpdateData!, $orderId: Int!) {
  createOrUpdateAddress(data: $data, id: $orderId) {
    id
    shippingAddress {
      ...Address
    }
  }
}
    ${AddressFragmentDoc}`;
export type UpdateOrderAddressMutationFn = Apollo.MutationFunction<UpdateOrderAddressMutation, UpdateOrderAddressMutationVariables>;

/**
 * __useUpdateOrderAddressMutation__
 *
 * To run a mutation, you first call `useUpdateOrderAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderAddressMutation, { data, loading, error }] = useUpdateOrderAddressMutation({
 *   variables: {
 *      data: // value for 'data'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useUpdateOrderAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderAddressMutation, UpdateOrderAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderAddressMutation, UpdateOrderAddressMutationVariables>(UpdateOrderAddressDocument, options);
      }
export type UpdateOrderAddressMutationHookResult = ReturnType<typeof useUpdateOrderAddressMutation>;
export type UpdateOrderAddressMutationResult = Apollo.MutationResult<UpdateOrderAddressMutation>;
export type UpdateOrderAddressMutationOptions = Apollo.BaseMutationOptions<UpdateOrderAddressMutation, UpdateOrderAddressMutationVariables>;
export const AddFeePaymentForOrderDocument = gql`
    mutation AddFeePaymentForOrder($data: AddTransferForOrderData!) {
  addFeePaymentForOrder(data: $data) {
    ...FeePaymentFields
  }
}
    ${FeePaymentFieldsFragmentDoc}`;
export type AddFeePaymentForOrderMutationFn = Apollo.MutationFunction<AddFeePaymentForOrderMutation, AddFeePaymentForOrderMutationVariables>;

/**
 * __useAddFeePaymentForOrderMutation__
 *
 * To run a mutation, you first call `useAddFeePaymentForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeePaymentForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeePaymentForOrderMutation, { data, loading, error }] = useAddFeePaymentForOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddFeePaymentForOrderMutation(baseOptions?: Apollo.MutationHookOptions<AddFeePaymentForOrderMutation, AddFeePaymentForOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFeePaymentForOrderMutation, AddFeePaymentForOrderMutationVariables>(AddFeePaymentForOrderDocument, options);
      }
export type AddFeePaymentForOrderMutationHookResult = ReturnType<typeof useAddFeePaymentForOrderMutation>;
export type AddFeePaymentForOrderMutationResult = Apollo.MutationResult<AddFeePaymentForOrderMutation>;
export type AddFeePaymentForOrderMutationOptions = Apollo.BaseMutationOptions<AddFeePaymentForOrderMutation, AddFeePaymentForOrderMutationVariables>;
export const AdminOrderPlatformFeesDocument = gql`
    query AdminOrderPlatformFees($orderId: Int!) {
  order(id: $orderId) {
    id
    number
    enabledFeatures {
      canMakePayment
      canMakeFeePayment
    }
    amountInCents
    paymentStatus
    balanceTransferStatus
    regionV2 {
      id
      friendlyName
    }
    ... on ProducerPurchaseOrder {
      platformFeesBreakdown {
        productName
        packageTypeName
        finalQuantity
        producerPlatformFee
        globalPlatformFee
        platformFeesTotal
        finalTotal
      }
      ...AdminPlatformFeeFields
    }
  }
}
    ${AdminPlatformFeeFieldsFragmentDoc}`;

/**
 * __useAdminOrderPlatformFeesQuery__
 *
 * To run a query within a React component, call `useAdminOrderPlatformFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderPlatformFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderPlatformFeesQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminOrderPlatformFeesQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderPlatformFeesQuery, AdminOrderPlatformFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderPlatformFeesQuery, AdminOrderPlatformFeesQueryVariables>(AdminOrderPlatformFeesDocument, options);
      }
export function useAdminOrderPlatformFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderPlatformFeesQuery, AdminOrderPlatformFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderPlatformFeesQuery, AdminOrderPlatformFeesQueryVariables>(AdminOrderPlatformFeesDocument, options);
        }
export type AdminOrderPlatformFeesQueryHookResult = ReturnType<typeof useAdminOrderPlatformFeesQuery>;
export type AdminOrderPlatformFeesLazyQueryHookResult = ReturnType<typeof useAdminOrderPlatformFeesLazyQuery>;
export type AdminOrderPlatformFeesQueryResult = Apollo.QueryResult<AdminOrderPlatformFeesQuery, AdminOrderPlatformFeesQueryVariables>;
export const AdminRefreshPlatformFeeDocument = gql`
    mutation AdminRefreshPlatformFee($orderId: Int!) {
  refreshPlatformFee(id: $orderId) {
    id
    platformFee
    platformFeeCalculated
    platformFeeOverride
  }
}
    `;
export type AdminRefreshPlatformFeeMutationFn = Apollo.MutationFunction<AdminRefreshPlatformFeeMutation, AdminRefreshPlatformFeeMutationVariables>;

/**
 * __useAdminRefreshPlatformFeeMutation__
 *
 * To run a mutation, you first call `useAdminRefreshPlatformFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRefreshPlatformFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRefreshPlatformFeeMutation, { data, loading, error }] = useAdminRefreshPlatformFeeMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminRefreshPlatformFeeMutation(baseOptions?: Apollo.MutationHookOptions<AdminRefreshPlatformFeeMutation, AdminRefreshPlatformFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRefreshPlatformFeeMutation, AdminRefreshPlatformFeeMutationVariables>(AdminRefreshPlatformFeeDocument, options);
      }
export type AdminRefreshPlatformFeeMutationHookResult = ReturnType<typeof useAdminRefreshPlatformFeeMutation>;
export type AdminRefreshPlatformFeeMutationResult = Apollo.MutationResult<AdminRefreshPlatformFeeMutation>;
export type AdminRefreshPlatformFeeMutationOptions = Apollo.BaseMutationOptions<AdminRefreshPlatformFeeMutation, AdminRefreshPlatformFeeMutationVariables>;
export const CollectPlatformFeeDocument = gql`
    mutation CollectPlatformFee($orderId: Int!) {
  collectPlatformFee(id: $orderId) {
    order {
      id
      ...CollectPlatformFeeDetails
    }
  }
}
    ${CollectPlatformFeeDetailsFragmentDoc}`;
export type CollectPlatformFeeMutationFn = Apollo.MutationFunction<CollectPlatformFeeMutation, CollectPlatformFeeMutationVariables>;

/**
 * __useCollectPlatformFeeMutation__
 *
 * To run a mutation, you first call `useCollectPlatformFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectPlatformFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectPlatformFeeMutation, { data, loading, error }] = useCollectPlatformFeeMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCollectPlatformFeeMutation(baseOptions?: Apollo.MutationHookOptions<CollectPlatformFeeMutation, CollectPlatformFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CollectPlatformFeeMutation, CollectPlatformFeeMutationVariables>(CollectPlatformFeeDocument, options);
      }
export type CollectPlatformFeeMutationHookResult = ReturnType<typeof useCollectPlatformFeeMutation>;
export type CollectPlatformFeeMutationResult = Apollo.MutationResult<CollectPlatformFeeMutation>;
export type CollectPlatformFeeMutationOptions = Apollo.BaseMutationOptions<CollectPlatformFeeMutation, CollectPlatformFeeMutationVariables>;
export const CollectPlatformFeeDataDocument = gql`
    query CollectPlatformFeeData($orderId: Int!) {
  producerPurchaseOrder(id: $orderId) {
    id
    ...CollectPlatformFeeDetails
  }
}
    ${CollectPlatformFeeDetailsFragmentDoc}`;

/**
 * __useCollectPlatformFeeDataQuery__
 *
 * To run a query within a React component, call `useCollectPlatformFeeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectPlatformFeeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectPlatformFeeDataQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCollectPlatformFeeDataQuery(baseOptions: Apollo.QueryHookOptions<CollectPlatformFeeDataQuery, CollectPlatformFeeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectPlatformFeeDataQuery, CollectPlatformFeeDataQueryVariables>(CollectPlatformFeeDataDocument, options);
      }
export function useCollectPlatformFeeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectPlatformFeeDataQuery, CollectPlatformFeeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectPlatformFeeDataQuery, CollectPlatformFeeDataQueryVariables>(CollectPlatformFeeDataDocument, options);
        }
export type CollectPlatformFeeDataQueryHookResult = ReturnType<typeof useCollectPlatformFeeDataQuery>;
export type CollectPlatformFeeDataLazyQueryHookResult = ReturnType<typeof useCollectPlatformFeeDataLazyQuery>;
export type CollectPlatformFeeDataQueryResult = Apollo.QueryResult<CollectPlatformFeeDataQuery, CollectPlatformFeeDataQueryVariables>;
export const MarkPlatformFeePaidDocument = gql`
    mutation MarkPlatformFeePaid($orderId: Int!, $paymentDate: String!, $invoiceNumber: String!) {
  markPlatformFeePaid(
    orderId: $orderId
    paymentDate: $paymentDate
    invoiceNumber: $invoiceNumber
  ) {
    order {
      id
      ...CollectPlatformFeeDetails
    }
  }
}
    ${CollectPlatformFeeDetailsFragmentDoc}`;
export type MarkPlatformFeePaidMutationFn = Apollo.MutationFunction<MarkPlatformFeePaidMutation, MarkPlatformFeePaidMutationVariables>;

/**
 * __useMarkPlatformFeePaidMutation__
 *
 * To run a mutation, you first call `useMarkPlatformFeePaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPlatformFeePaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPlatformFeePaidMutation, { data, loading, error }] = useMarkPlatformFeePaidMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      paymentDate: // value for 'paymentDate'
 *      invoiceNumber: // value for 'invoiceNumber'
 *   },
 * });
 */
export function useMarkPlatformFeePaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkPlatformFeePaidMutation, MarkPlatformFeePaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPlatformFeePaidMutation, MarkPlatformFeePaidMutationVariables>(MarkPlatformFeePaidDocument, options);
      }
export type MarkPlatformFeePaidMutationHookResult = ReturnType<typeof useMarkPlatformFeePaidMutation>;
export type MarkPlatformFeePaidMutationResult = Apollo.MutationResult<MarkPlatformFeePaidMutation>;
export type MarkPlatformFeePaidMutationOptions = Apollo.BaseMutationOptions<MarkPlatformFeePaidMutation, MarkPlatformFeePaidMutationVariables>;
export const UpdatePlatformFeeDocument = gql`
    mutation UpdatePlatformFee($id: Int!, $platformFeeOverride: Int) {
  updateProducerPurchaseOrder(
    data: {platformFeeOverride: $platformFeeOverride}
    id: $id
  ) {
    id
    platformFee
    platformFeeCalculated
    platformFeeOverride
    ...PlatformFeeBalances
  }
}
    ${PlatformFeeBalancesFragmentDoc}`;
export type UpdatePlatformFeeMutationFn = Apollo.MutationFunction<UpdatePlatformFeeMutation, UpdatePlatformFeeMutationVariables>;

/**
 * __useUpdatePlatformFeeMutation__
 *
 * To run a mutation, you first call `useUpdatePlatformFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformFeeMutation, { data, loading, error }] = useUpdatePlatformFeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      platformFeeOverride: // value for 'platformFeeOverride'
 *   },
 * });
 */
export function useUpdatePlatformFeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformFeeMutation, UpdatePlatformFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformFeeMutation, UpdatePlatformFeeMutationVariables>(UpdatePlatformFeeDocument, options);
      }
export type UpdatePlatformFeeMutationHookResult = ReturnType<typeof useUpdatePlatformFeeMutation>;
export type UpdatePlatformFeeMutationResult = Apollo.MutationResult<UpdatePlatformFeeMutation>;
export type UpdatePlatformFeeMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformFeeMutation, UpdatePlatformFeeMutationVariables>;
export const CancelPreSaleOrderDocument = gql`
    mutation CancelPreSaleOrder($orderId: Int!) {
  cancelPreSaleOrder(orderId: $orderId) {
    id
    cancelledAt
    canCancel {
      ...ValidationResult
    }
  }
}
    ${ValidationResultFragmentDoc}`;
export type CancelPreSaleOrderMutationFn = Apollo.MutationFunction<CancelPreSaleOrderMutation, CancelPreSaleOrderMutationVariables>;

/**
 * __useCancelPreSaleOrderMutation__
 *
 * To run a mutation, you first call `useCancelPreSaleOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPreSaleOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPreSaleOrderMutation, { data, loading, error }] = useCancelPreSaleOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCancelPreSaleOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelPreSaleOrderMutation, CancelPreSaleOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPreSaleOrderMutation, CancelPreSaleOrderMutationVariables>(CancelPreSaleOrderDocument, options);
      }
export type CancelPreSaleOrderMutationHookResult = ReturnType<typeof useCancelPreSaleOrderMutation>;
export type CancelPreSaleOrderMutationResult = Apollo.MutationResult<CancelPreSaleOrderMutation>;
export type CancelPreSaleOrderMutationOptions = Apollo.BaseMutationOptions<CancelPreSaleOrderMutation, CancelPreSaleOrderMutationVariables>;
export const CancelProducerPurchaseOrderDocument = gql`
    mutation CancelProducerPurchaseOrder($orderId: Int!) {
  cancelProducerPurchaseOrder(id: $orderId) {
    id
    canCancel {
      ...ValidationResult
    }
  }
}
    ${ValidationResultFragmentDoc}`;
export type CancelProducerPurchaseOrderMutationFn = Apollo.MutationFunction<CancelProducerPurchaseOrderMutation, CancelProducerPurchaseOrderMutationVariables>;

/**
 * __useCancelProducerPurchaseOrderMutation__
 *
 * To run a mutation, you first call `useCancelProducerPurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelProducerPurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelProducerPurchaseOrderMutation, { data, loading, error }] = useCancelProducerPurchaseOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCancelProducerPurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelProducerPurchaseOrderMutation, CancelProducerPurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelProducerPurchaseOrderMutation, CancelProducerPurchaseOrderMutationVariables>(CancelProducerPurchaseOrderDocument, options);
      }
export type CancelProducerPurchaseOrderMutationHookResult = ReturnType<typeof useCancelProducerPurchaseOrderMutation>;
export type CancelProducerPurchaseOrderMutationResult = Apollo.MutationResult<CancelProducerPurchaseOrderMutation>;
export type CancelProducerPurchaseOrderMutationOptions = Apollo.BaseMutationOptions<CancelProducerPurchaseOrderMutation, CancelProducerPurchaseOrderMutationVariables>;
export const CancelSalesOrderDocument = gql`
    mutation CancelSalesOrder($orderId: Int!) {
  cancelRetailerSalesOrder(orderId: $orderId) {
    id
    cancelledAt
    canCancel {
      ...ValidationResult
    }
  }
}
    ${ValidationResultFragmentDoc}`;
export type CancelSalesOrderMutationFn = Apollo.MutationFunction<CancelSalesOrderMutation, CancelSalesOrderMutationVariables>;

/**
 * __useCancelSalesOrderMutation__
 *
 * To run a mutation, you first call `useCancelSalesOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSalesOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSalesOrderMutation, { data, loading, error }] = useCancelSalesOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCancelSalesOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelSalesOrderMutation, CancelSalesOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSalesOrderMutation, CancelSalesOrderMutationVariables>(CancelSalesOrderDocument, options);
      }
export type CancelSalesOrderMutationHookResult = ReturnType<typeof useCancelSalesOrderMutation>;
export type CancelSalesOrderMutationResult = Apollo.MutationResult<CancelSalesOrderMutation>;
export type CancelSalesOrderMutationOptions = Apollo.BaseMutationOptions<CancelSalesOrderMutation, CancelSalesOrderMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($id: Int!) {
  deleteOrder(id: $id) {
    id
  }
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const AdminOrderTransferDocument = gql`
    query AdminOrderTransfer($orderId: Int!) {
  order(id: $orderId) {
    ...AdminOrderTransferDetails
  }
}
    ${AdminOrderTransferDetailsFragmentDoc}`;

/**
 * __useAdminOrderTransferQuery__
 *
 * To run a query within a React component, call `useAdminOrderTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderTransferQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminOrderTransferQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderTransferQuery, AdminOrderTransferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderTransferQuery, AdminOrderTransferQueryVariables>(AdminOrderTransferDocument, options);
      }
export function useAdminOrderTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderTransferQuery, AdminOrderTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderTransferQuery, AdminOrderTransferQueryVariables>(AdminOrderTransferDocument, options);
        }
export type AdminOrderTransferQueryHookResult = ReturnType<typeof useAdminOrderTransferQuery>;
export type AdminOrderTransferLazyQueryHookResult = ReturnType<typeof useAdminOrderTransferLazyQuery>;
export type AdminOrderTransferQueryResult = Apollo.QueryResult<AdminOrderTransferQuery, AdminOrderTransferQueryVariables>;
export const BeverageAdvisorsDocument = gql`
    query BeverageAdvisors {
  beverageAdvisors {
    id
    displayName
    fein
    businessType
    dwollaCustomer {
      id
      type
      status
    }
    validBankAccount {
      id
      name
      institutionName
      mask
      dwollaFundingSource {
        id
      }
      plaidItem {
        id
        verificationStatus
      }
    }
    validBalanceAccount {
      id
      balance
    }
  }
}
    `;

/**
 * __useBeverageAdvisorsQuery__
 *
 * To run a query within a React component, call `useBeverageAdvisorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeverageAdvisorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeverageAdvisorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBeverageAdvisorsQuery(baseOptions?: Apollo.QueryHookOptions<BeverageAdvisorsQuery, BeverageAdvisorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeverageAdvisorsQuery, BeverageAdvisorsQueryVariables>(BeverageAdvisorsDocument, options);
      }
export function useBeverageAdvisorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeverageAdvisorsQuery, BeverageAdvisorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeverageAdvisorsQuery, BeverageAdvisorsQueryVariables>(BeverageAdvisorsDocument, options);
        }
export type BeverageAdvisorsQueryHookResult = ReturnType<typeof useBeverageAdvisorsQuery>;
export type BeverageAdvisorsLazyQueryHookResult = ReturnType<typeof useBeverageAdvisorsLazyQuery>;
export type BeverageAdvisorsQueryResult = Apollo.QueryResult<BeverageAdvisorsQuery, BeverageAdvisorsQueryVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($id: Int!, $data: OrderUpdateData!) {
  updateOrder(data: $data, id: $id) {
    ...AdminOrderSummary
  }
}
    ${AdminOrderSummaryFragmentDoc}`;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const UpdateOrderDataDocument = gql`
    query UpdateOrderData($id: Int!) {
  order(id: $id) {
    id
    type
    number
    cancelledAt
    deliveredAt
    placedOn
    invoice {
      externalInvoiceId
      externalAmountInCents
    }
  }
}
    `;

/**
 * __useUpdateOrderDataQuery__
 *
 * To run a query within a React component, call `useUpdateOrderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateOrderDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateOrderDataQuery(baseOptions: Apollo.QueryHookOptions<UpdateOrderDataQuery, UpdateOrderDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateOrderDataQuery, UpdateOrderDataQueryVariables>(UpdateOrderDataDocument, options);
      }
export function useUpdateOrderDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateOrderDataQuery, UpdateOrderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateOrderDataQuery, UpdateOrderDataQueryVariables>(UpdateOrderDataDocument, options);
        }
export type UpdateOrderDataQueryHookResult = ReturnType<typeof useUpdateOrderDataQuery>;
export type UpdateOrderDataLazyQueryHookResult = ReturnType<typeof useUpdateOrderDataLazyQuery>;
export type UpdateOrderDataQueryResult = Apollo.QueryResult<UpdateOrderDataQuery, UpdateOrderDataQueryVariables>;
export const AddTrackingDocument = gql`
    mutation AddTracking($data: TrackingInfoInput!, $orderId: Int!) {
  addTracking(data: $data, orderId: $orderId) {
    id
    trackingInformation {
      ...TrackingInformationDetails
    }
  }
}
    ${TrackingInformationDetailsFragmentDoc}`;
export type AddTrackingMutationFn = Apollo.MutationFunction<AddTrackingMutation, AddTrackingMutationVariables>;

/**
 * __useAddTrackingMutation__
 *
 * To run a mutation, you first call `useAddTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrackingMutation, { data, loading, error }] = useAddTrackingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAddTrackingMutation(baseOptions?: Apollo.MutationHookOptions<AddTrackingMutation, AddTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTrackingMutation, AddTrackingMutationVariables>(AddTrackingDocument, options);
      }
export type AddTrackingMutationHookResult = ReturnType<typeof useAddTrackingMutation>;
export type AddTrackingMutationResult = Apollo.MutationResult<AddTrackingMutation>;
export type AddTrackingMutationOptions = Apollo.BaseMutationOptions<AddTrackingMutation, AddTrackingMutationVariables>;
export const AllCarriersDocument = gql`
    query AllCarriers {
  allCarriers {
    displayName
    id
  }
}
    `;

/**
 * __useAllCarriersQuery__
 *
 * To run a query within a React component, call `useAllCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCarriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCarriersQuery(baseOptions?: Apollo.QueryHookOptions<AllCarriersQuery, AllCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCarriersQuery, AllCarriersQueryVariables>(AllCarriersDocument, options);
      }
export function useAllCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCarriersQuery, AllCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCarriersQuery, AllCarriersQueryVariables>(AllCarriersDocument, options);
        }
export type AllCarriersQueryHookResult = ReturnType<typeof useAllCarriersQuery>;
export type AllCarriersLazyQueryHookResult = ReturnType<typeof useAllCarriersLazyQuery>;
export type AllCarriersQueryResult = Apollo.QueryResult<AllCarriersQuery, AllCarriersQueryVariables>;
export const UpdateTrackingDocument = gql`
    mutation UpdateTracking($trackingId: Int!, $data: TrackingInfoInput!) {
  updateTracking(trackingId: $trackingId, data: $data) {
    trackingInformation {
      ...TrackingInformationDetails
    }
  }
}
    ${TrackingInformationDetailsFragmentDoc}`;
export type UpdateTrackingMutationFn = Apollo.MutationFunction<UpdateTrackingMutation, UpdateTrackingMutationVariables>;

/**
 * __useUpdateTrackingMutation__
 *
 * To run a mutation, you first call `useUpdateTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackingMutation, { data, loading, error }] = useUpdateTrackingMutation({
 *   variables: {
 *      trackingId: // value for 'trackingId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTrackingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackingMutation, UpdateTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackingMutation, UpdateTrackingMutationVariables>(UpdateTrackingDocument, options);
      }
export type UpdateTrackingMutationHookResult = ReturnType<typeof useUpdateTrackingMutation>;
export type UpdateTrackingMutationResult = Apollo.MutationResult<UpdateTrackingMutation>;
export type UpdateTrackingMutationOptions = Apollo.BaseMutationOptions<UpdateTrackingMutation, UpdateTrackingMutationVariables>;
export const PreSaleImportJobDocument = gql`
    query preSaleImportJob($id: Int!) {
  preSaleImportJob(id: $id) {
    id
    createdAt
    regionV2 {
      id
      friendlyName
    }
    start
    end
    status
    failureReason
  }
}
    `;

/**
 * __usePreSaleImportJobQuery__
 *
 * To run a query within a React component, call `usePreSaleImportJobQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreSaleImportJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreSaleImportJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePreSaleImportJobQuery(baseOptions: Apollo.QueryHookOptions<PreSaleImportJobQuery, PreSaleImportJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreSaleImportJobQuery, PreSaleImportJobQueryVariables>(PreSaleImportJobDocument, options);
      }
export function usePreSaleImportJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreSaleImportJobQuery, PreSaleImportJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreSaleImportJobQuery, PreSaleImportJobQueryVariables>(PreSaleImportJobDocument, options);
        }
export type PreSaleImportJobQueryHookResult = ReturnType<typeof usePreSaleImportJobQuery>;
export type PreSaleImportJobLazyQueryHookResult = ReturnType<typeof usePreSaleImportJobLazyQuery>;
export type PreSaleImportJobQueryResult = Apollo.QueryResult<PreSaleImportJobQuery, PreSaleImportJobQueryVariables>;
export const AdminAddPresaleImportJobsDocument = gql`
    mutation AdminAddPresaleImportJobs($regions: [Int!]!, $startDate: DateTime!, $endDate: DateTime!) {
  addPresaleImportJobs(
    regions: $regions
    startDate: $startDate
    endDate: $endDate
  ) {
    id
  }
}
    `;
export type AdminAddPresaleImportJobsMutationFn = Apollo.MutationFunction<AdminAddPresaleImportJobsMutation, AdminAddPresaleImportJobsMutationVariables>;

/**
 * __useAdminAddPresaleImportJobsMutation__
 *
 * To run a mutation, you first call `useAdminAddPresaleImportJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddPresaleImportJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddPresaleImportJobsMutation, { data, loading, error }] = useAdminAddPresaleImportJobsMutation({
 *   variables: {
 *      regions: // value for 'regions'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAdminAddPresaleImportJobsMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddPresaleImportJobsMutation, AdminAddPresaleImportJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddPresaleImportJobsMutation, AdminAddPresaleImportJobsMutationVariables>(AdminAddPresaleImportJobsDocument, options);
      }
export type AdminAddPresaleImportJobsMutationHookResult = ReturnType<typeof useAdminAddPresaleImportJobsMutation>;
export type AdminAddPresaleImportJobsMutationResult = Apollo.MutationResult<AdminAddPresaleImportJobsMutation>;
export type AdminAddPresaleImportJobsMutationOptions = Apollo.BaseMutationOptions<AdminAddPresaleImportJobsMutation, AdminAddPresaleImportJobsMutationVariables>;
export const PreSaleImportJobsDocument = gql`
    query preSaleImportJobs {
  preSaleImportJobs {
    ...PreSaleImportJobDetails
  }
}
    ${PreSaleImportJobDetailsFragmentDoc}`;

/**
 * __usePreSaleImportJobsQuery__
 *
 * To run a query within a React component, call `usePreSaleImportJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreSaleImportJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreSaleImportJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePreSaleImportJobsQuery(baseOptions?: Apollo.QueryHookOptions<PreSaleImportJobsQuery, PreSaleImportJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreSaleImportJobsQuery, PreSaleImportJobsQueryVariables>(PreSaleImportJobsDocument, options);
      }
export function usePreSaleImportJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreSaleImportJobsQuery, PreSaleImportJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreSaleImportJobsQuery, PreSaleImportJobsQueryVariables>(PreSaleImportJobsDocument, options);
        }
export type PreSaleImportJobsQueryHookResult = ReturnType<typeof usePreSaleImportJobsQuery>;
export type PreSaleImportJobsLazyQueryHookResult = ReturnType<typeof usePreSaleImportJobsLazyQuery>;
export type PreSaleImportJobsQueryResult = Apollo.QueryResult<PreSaleImportJobsQuery, PreSaleImportJobsQueryVariables>;
export const AddPreSaleOrderDocument = gql`
    mutation AddPreSaleOrder($preSaleId: Int!, $storeId: Int!) {
  createPreSaleOrder(preSaleId: $preSaleId, storeId: $storeId) {
    id
    preSale {
      id
      orders {
        ...PreSaleOrderTableData
      }
    }
  }
}
    ${PreSaleOrderTableDataFragmentDoc}`;
export type AddPreSaleOrderMutationFn = Apollo.MutationFunction<AddPreSaleOrderMutation, AddPreSaleOrderMutationVariables>;

/**
 * __useAddPreSaleOrderMutation__
 *
 * To run a mutation, you first call `useAddPreSaleOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPreSaleOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPreSaleOrderMutation, { data, loading, error }] = useAddPreSaleOrderMutation({
 *   variables: {
 *      preSaleId: // value for 'preSaleId'
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useAddPreSaleOrderMutation(baseOptions?: Apollo.MutationHookOptions<AddPreSaleOrderMutation, AddPreSaleOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPreSaleOrderMutation, AddPreSaleOrderMutationVariables>(AddPreSaleOrderDocument, options);
      }
export type AddPreSaleOrderMutationHookResult = ReturnType<typeof useAddPreSaleOrderMutation>;
export type AddPreSaleOrderMutationResult = Apollo.MutationResult<AddPreSaleOrderMutation>;
export type AddPreSaleOrderMutationOptions = Apollo.BaseMutationOptions<AddPreSaleOrderMutation, AddPreSaleOrderMutationVariables>;
export const AdminPreSaleOrdersDocument = gql`
    query AdminPreSaleOrders($id: Int!) {
  preSale(id: $id) {
    id
    ...PreSaleDisplay
    orders {
      id
      ...PreSaleOrderTableData
    }
  }
}
    ${PreSaleDisplayFragmentDoc}
${PreSaleOrderTableDataFragmentDoc}`;

/**
 * __useAdminPreSaleOrdersQuery__
 *
 * To run a query within a React component, call `useAdminPreSaleOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPreSaleOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPreSaleOrdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminPreSaleOrdersQuery(baseOptions: Apollo.QueryHookOptions<AdminPreSaleOrdersQuery, AdminPreSaleOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPreSaleOrdersQuery, AdminPreSaleOrdersQueryVariables>(AdminPreSaleOrdersDocument, options);
      }
export function useAdminPreSaleOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPreSaleOrdersQuery, AdminPreSaleOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPreSaleOrdersQuery, AdminPreSaleOrdersQueryVariables>(AdminPreSaleOrdersDocument, options);
        }
export type AdminPreSaleOrdersQueryHookResult = ReturnType<typeof useAdminPreSaleOrdersQuery>;
export type AdminPreSaleOrdersLazyQueryHookResult = ReturnType<typeof useAdminPreSaleOrdersLazyQuery>;
export type AdminPreSaleOrdersQueryResult = Apollo.QueryResult<AdminPreSaleOrdersQuery, AdminPreSaleOrdersQueryVariables>;
export const AdminPreSaleDocument = gql`
    query AdminPreSale($id: Int!) {
  preSale(id: $id) {
    ...PreSaleDisplay
  }
}
    ${PreSaleDisplayFragmentDoc}`;

/**
 * __useAdminPreSaleQuery__
 *
 * To run a query within a React component, call `useAdminPreSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPreSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPreSaleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminPreSaleQuery(baseOptions: Apollo.QueryHookOptions<AdminPreSaleQuery, AdminPreSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPreSaleQuery, AdminPreSaleQueryVariables>(AdminPreSaleDocument, options);
      }
export function useAdminPreSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPreSaleQuery, AdminPreSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPreSaleQuery, AdminPreSaleQueryVariables>(AdminPreSaleDocument, options);
        }
export type AdminPreSaleQueryHookResult = ReturnType<typeof useAdminPreSaleQuery>;
export type AdminPreSaleLazyQueryHookResult = ReturnType<typeof useAdminPreSaleLazyQuery>;
export type AdminPreSaleQueryResult = Apollo.QueryResult<AdminPreSaleQuery, AdminPreSaleQueryVariables>;
export const AdminPreSaleOrderItemsDocument = gql`
    query AdminPreSaleOrderItems($orderId: Int!, $preSaleId: Int!) {
  order(id: $orderId) {
    id
    number
    ...AdminPreSaleOrderItemsData
    enabledFeatures {
      canEditOrderItems
      canDeleteOrderItems
    }
  }
  preSale(id: $preSaleId) {
    ...PreSaleDisplay
  }
}
    ${AdminPreSaleOrderItemsDataFragmentDoc}
${PreSaleDisplayFragmentDoc}`;

/**
 * __useAdminPreSaleOrderItemsQuery__
 *
 * To run a query within a React component, call `useAdminPreSaleOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPreSaleOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPreSaleOrderItemsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      preSaleId: // value for 'preSaleId'
 *   },
 * });
 */
export function useAdminPreSaleOrderItemsQuery(baseOptions: Apollo.QueryHookOptions<AdminPreSaleOrderItemsQuery, AdminPreSaleOrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPreSaleOrderItemsQuery, AdminPreSaleOrderItemsQueryVariables>(AdminPreSaleOrderItemsDocument, options);
      }
export function useAdminPreSaleOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPreSaleOrderItemsQuery, AdminPreSaleOrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPreSaleOrderItemsQuery, AdminPreSaleOrderItemsQueryVariables>(AdminPreSaleOrderItemsDocument, options);
        }
export type AdminPreSaleOrderItemsQueryHookResult = ReturnType<typeof useAdminPreSaleOrderItemsQuery>;
export type AdminPreSaleOrderItemsLazyQueryHookResult = ReturnType<typeof useAdminPreSaleOrderItemsLazyQuery>;
export type AdminPreSaleOrderItemsQueryResult = Apollo.QueryResult<AdminPreSaleOrderItemsQuery, AdminPreSaleOrderItemsQueryVariables>;
export const AdminPreSaleOrderItemsUpdateDocument = gql`
    mutation AdminPreSaleOrderItemsUpdate($id: Int!, $data: OrderUpdateData!) {
  updateOrder(data: $data, id: $id) {
    id
    ...AdminOrderItemsData
  }
}
    ${AdminOrderItemsDataFragmentDoc}`;
export type AdminPreSaleOrderItemsUpdateMutationFn = Apollo.MutationFunction<AdminPreSaleOrderItemsUpdateMutation, AdminPreSaleOrderItemsUpdateMutationVariables>;

/**
 * __useAdminPreSaleOrderItemsUpdateMutation__
 *
 * To run a mutation, you first call `useAdminPreSaleOrderItemsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminPreSaleOrderItemsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminPreSaleOrderItemsUpdateMutation, { data, loading, error }] = useAdminPreSaleOrderItemsUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminPreSaleOrderItemsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminPreSaleOrderItemsUpdateMutation, AdminPreSaleOrderItemsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminPreSaleOrderItemsUpdateMutation, AdminPreSaleOrderItemsUpdateMutationVariables>(AdminPreSaleOrderItemsUpdateDocument, options);
      }
export type AdminPreSaleOrderItemsUpdateMutationHookResult = ReturnType<typeof useAdminPreSaleOrderItemsUpdateMutation>;
export type AdminPreSaleOrderItemsUpdateMutationResult = Apollo.MutationResult<AdminPreSaleOrderItemsUpdateMutation>;
export type AdminPreSaleOrderItemsUpdateMutationOptions = Apollo.BaseMutationOptions<AdminPreSaleOrderItemsUpdateMutation, AdminPreSaleOrderItemsUpdateMutationVariables>;
export const AdminPreSaleProducerSummaryDocument = gql`
    query AdminPreSaleProducerSummary($preSaleId: Int!) {
  preSale(id: $preSaleId) {
    id
    preSaleProducerSummary {
      ...AdminPreSaleProducerSummaryDisplay
    }
  }
}
    ${AdminPreSaleProducerSummaryDisplayFragmentDoc}`;

/**
 * __useAdminPreSaleProducerSummaryQuery__
 *
 * To run a query within a React component, call `useAdminPreSaleProducerSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPreSaleProducerSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPreSaleProducerSummaryQuery({
 *   variables: {
 *      preSaleId: // value for 'preSaleId'
 *   },
 * });
 */
export function useAdminPreSaleProducerSummaryQuery(baseOptions: Apollo.QueryHookOptions<AdminPreSaleProducerSummaryQuery, AdminPreSaleProducerSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPreSaleProducerSummaryQuery, AdminPreSaleProducerSummaryQueryVariables>(AdminPreSaleProducerSummaryDocument, options);
      }
export function useAdminPreSaleProducerSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPreSaleProducerSummaryQuery, AdminPreSaleProducerSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPreSaleProducerSummaryQuery, AdminPreSaleProducerSummaryQueryVariables>(AdminPreSaleProducerSummaryDocument, options);
        }
export type AdminPreSaleProducerSummaryQueryHookResult = ReturnType<typeof useAdminPreSaleProducerSummaryQuery>;
export type AdminPreSaleProducerSummaryLazyQueryHookResult = ReturnType<typeof useAdminPreSaleProducerSummaryLazyQuery>;
export type AdminPreSaleProducerSummaryQueryResult = Apollo.QueryResult<AdminPreSaleProducerSummaryQuery, AdminPreSaleProducerSummaryQueryVariables>;
export const AdminPreSaleProductsDocument = gql`
    query AdminPreSaleProducts($id: Int!) {
  preSale(id: $id) {
    id
    ...PreSaleDisplay
    preSaleProducts {
      ...PresaleProductDisplay
    }
  }
}
    ${PreSaleDisplayFragmentDoc}
${PresaleProductDisplayFragmentDoc}`;

/**
 * __useAdminPreSaleProductsQuery__
 *
 * To run a query within a React component, call `useAdminPreSaleProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPreSaleProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPreSaleProductsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminPreSaleProductsQuery(baseOptions: Apollo.QueryHookOptions<AdminPreSaleProductsQuery, AdminPreSaleProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPreSaleProductsQuery, AdminPreSaleProductsQueryVariables>(AdminPreSaleProductsDocument, options);
      }
export function useAdminPreSaleProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPreSaleProductsQuery, AdminPreSaleProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPreSaleProductsQuery, AdminPreSaleProductsQueryVariables>(AdminPreSaleProductsDocument, options);
        }
export type AdminPreSaleProductsQueryHookResult = ReturnType<typeof useAdminPreSaleProductsQuery>;
export type AdminPreSaleProductsLazyQueryHookResult = ReturnType<typeof useAdminPreSaleProductsLazyQuery>;
export type AdminPreSaleProductsQueryResult = Apollo.QueryResult<AdminPreSaleProductsQuery, AdminPreSaleProductsQueryVariables>;
export const AdminPreSalePurchaseOrdersDocument = gql`
    query AdminPreSalePurchaseOrders($id: Int!) {
  preSale(id: $id) {
    id
    ...PreSaleDisplay
    purchaseOrders {
      ...AdminProducerPurchaseOrderTableRow
    }
  }
}
    ${PreSaleDisplayFragmentDoc}
${AdminProducerPurchaseOrderTableRowFragmentDoc}`;

/**
 * __useAdminPreSalePurchaseOrdersQuery__
 *
 * To run a query within a React component, call `useAdminPreSalePurchaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPreSalePurchaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPreSalePurchaseOrdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminPreSalePurchaseOrdersQuery(baseOptions: Apollo.QueryHookOptions<AdminPreSalePurchaseOrdersQuery, AdminPreSalePurchaseOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPreSalePurchaseOrdersQuery, AdminPreSalePurchaseOrdersQueryVariables>(AdminPreSalePurchaseOrdersDocument, options);
      }
export function useAdminPreSalePurchaseOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPreSalePurchaseOrdersQuery, AdminPreSalePurchaseOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPreSalePurchaseOrdersQuery, AdminPreSalePurchaseOrdersQueryVariables>(AdminPreSalePurchaseOrdersDocument, options);
        }
export type AdminPreSalePurchaseOrdersQueryHookResult = ReturnType<typeof useAdminPreSalePurchaseOrdersQuery>;
export type AdminPreSalePurchaseOrdersLazyQueryHookResult = ReturnType<typeof useAdminPreSalePurchaseOrdersLazyQuery>;
export type AdminPreSalePurchaseOrdersQueryResult = Apollo.QueryResult<AdminPreSalePurchaseOrdersQuery, AdminPreSalePurchaseOrdersQueryVariables>;
export const GenerateFulfillmentOrdersDocument = gql`
    mutation GenerateFulfillmentOrders($preSaleId: Int!) {
  generateFulfillmentOrders(id: $preSaleId) {
    ...PreSaleDisplay
    purchaseOrders {
      ...AdminProducerPurchaseOrderTableRow
    }
  }
}
    ${PreSaleDisplayFragmentDoc}
${AdminProducerPurchaseOrderTableRowFragmentDoc}`;
export type GenerateFulfillmentOrdersMutationFn = Apollo.MutationFunction<GenerateFulfillmentOrdersMutation, GenerateFulfillmentOrdersMutationVariables>;

/**
 * __useGenerateFulfillmentOrdersMutation__
 *
 * To run a mutation, you first call `useGenerateFulfillmentOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFulfillmentOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFulfillmentOrdersMutation, { data, loading, error }] = useGenerateFulfillmentOrdersMutation({
 *   variables: {
 *      preSaleId: // value for 'preSaleId'
 *   },
 * });
 */
export function useGenerateFulfillmentOrdersMutation(baseOptions?: Apollo.MutationHookOptions<GenerateFulfillmentOrdersMutation, GenerateFulfillmentOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateFulfillmentOrdersMutation, GenerateFulfillmentOrdersMutationVariables>(GenerateFulfillmentOrdersDocument, options);
      }
export type GenerateFulfillmentOrdersMutationHookResult = ReturnType<typeof useGenerateFulfillmentOrdersMutation>;
export type GenerateFulfillmentOrdersMutationResult = Apollo.MutationResult<GenerateFulfillmentOrdersMutation>;
export type GenerateFulfillmentOrdersMutationOptions = Apollo.BaseMutationOptions<GenerateFulfillmentOrdersMutation, GenerateFulfillmentOrdersMutationVariables>;
export const PreSalesDocument = gql`
    query PreSales($pagination: OffsetPaginationInput!, $filters: PreSalesFilterData) {
  paginatedPreSales(pagination: $pagination, filters: $filters) {
    results {
      ...PreSalesDisplay
    }
    total
  }
}
    ${PreSalesDisplayFragmentDoc}`;

/**
 * __usePreSalesQuery__
 *
 * To run a query within a React component, call `usePreSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreSalesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePreSalesQuery(baseOptions: Apollo.QueryHookOptions<PreSalesQuery, PreSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreSalesQuery, PreSalesQueryVariables>(PreSalesDocument, options);
      }
export function usePreSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreSalesQuery, PreSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreSalesQuery, PreSalesQueryVariables>(PreSalesDocument, options);
        }
export type PreSalesQueryHookResult = ReturnType<typeof usePreSalesQuery>;
export type PreSalesLazyQueryHookResult = ReturnType<typeof usePreSalesLazyQuery>;
export type PreSalesQueryResult = Apollo.QueryResult<PreSalesQuery, PreSalesQueryVariables>;
export const AdminDeleteProducerDocument = gql`
    mutation AdminDeleteProducer($id: Int!) {
  deleteProducer(id: $id) {
    id
    name
  }
}
    `;
export type AdminDeleteProducerMutationFn = Apollo.MutationFunction<AdminDeleteProducerMutation, AdminDeleteProducerMutationVariables>;

/**
 * __useAdminDeleteProducerMutation__
 *
 * To run a mutation, you first call `useAdminDeleteProducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteProducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteProducerMutation, { data, loading, error }] = useAdminDeleteProducerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteProducerMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteProducerMutation, AdminDeleteProducerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteProducerMutation, AdminDeleteProducerMutationVariables>(AdminDeleteProducerDocument, options);
      }
export type AdminDeleteProducerMutationHookResult = ReturnType<typeof useAdminDeleteProducerMutation>;
export type AdminDeleteProducerMutationResult = Apollo.MutationResult<AdminDeleteProducerMutation>;
export type AdminDeleteProducerMutationOptions = Apollo.BaseMutationOptions<AdminDeleteProducerMutation, AdminDeleteProducerMutationVariables>;
export const AdminProducerDocument = gql`
    query AdminProducer($producerId: Int!) {
  producer(id: $producerId) {
    id
    displayName
    globalBreweryId
    fein
    organization {
      ...OrganizationFields
    }
    canDelete
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useAdminProducerQuery__
 *
 * To run a query within a React component, call `useAdminProducerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProducerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProducerQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useAdminProducerQuery(baseOptions: Apollo.QueryHookOptions<AdminProducerQuery, AdminProducerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProducerQuery, AdminProducerQueryVariables>(AdminProducerDocument, options);
      }
export function useAdminProducerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProducerQuery, AdminProducerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProducerQuery, AdminProducerQueryVariables>(AdminProducerDocument, options);
        }
export type AdminProducerQueryHookResult = ReturnType<typeof useAdminProducerQuery>;
export type AdminProducerLazyQueryHookResult = ReturnType<typeof useAdminProducerLazyQuery>;
export type AdminProducerQueryResult = Apollo.QueryResult<AdminProducerQuery, AdminProducerQueryVariables>;
export const AdminProducerDetailsDocument = gql`
    query AdminProducerDetails($producerId: Int!) {
  producer(id: $producerId) {
    ...AdminProducerDetails
  }
}
    ${AdminProducerDetailsFragmentDoc}`;

/**
 * __useAdminProducerDetailsQuery__
 *
 * To run a query within a React component, call `useAdminProducerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProducerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProducerDetailsQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useAdminProducerDetailsQuery(baseOptions: Apollo.QueryHookOptions<AdminProducerDetailsQuery, AdminProducerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProducerDetailsQuery, AdminProducerDetailsQueryVariables>(AdminProducerDetailsDocument, options);
      }
export function useAdminProducerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProducerDetailsQuery, AdminProducerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProducerDetailsQuery, AdminProducerDetailsQueryVariables>(AdminProducerDetailsDocument, options);
        }
export type AdminProducerDetailsQueryHookResult = ReturnType<typeof useAdminProducerDetailsQuery>;
export type AdminProducerDetailsLazyQueryHookResult = ReturnType<typeof useAdminProducerDetailsLazyQuery>;
export type AdminProducerDetailsQueryResult = Apollo.QueryResult<AdminProducerDetailsQuery, AdminProducerDetailsQueryVariables>;
export const AdminProducerDistributionDocument = gql`
    query AdminProducerDistribution($producerId: Int!) {
  producer(id: $producerId) {
    id
    distributorAssignments {
      ...DistributorProducerAssignment
    }
  }
}
    ${DistributorProducerAssignmentFragmentDoc}`;

/**
 * __useAdminProducerDistributionQuery__
 *
 * To run a query within a React component, call `useAdminProducerDistributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProducerDistributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProducerDistributionQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useAdminProducerDistributionQuery(baseOptions: Apollo.QueryHookOptions<AdminProducerDistributionQuery, AdminProducerDistributionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProducerDistributionQuery, AdminProducerDistributionQueryVariables>(AdminProducerDistributionDocument, options);
      }
export function useAdminProducerDistributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProducerDistributionQuery, AdminProducerDistributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProducerDistributionQuery, AdminProducerDistributionQueryVariables>(AdminProducerDistributionDocument, options);
        }
export type AdminProducerDistributionQueryHookResult = ReturnType<typeof useAdminProducerDistributionQuery>;
export type AdminProducerDistributionLazyQueryHookResult = ReturnType<typeof useAdminProducerDistributionLazyQuery>;
export type AdminProducerDistributionQueryResult = Apollo.QueryResult<AdminProducerDistributionQuery, AdminProducerDistributionQueryVariables>;
export const AdminProducerLicensesDocument = gql`
    query AdminProducerLicenses($producerId: Int!) {
  producer(id: $producerId) {
    id
    licenses {
      ...LicenseFields
    }
  }
}
    ${LicenseFieldsFragmentDoc}`;

/**
 * __useAdminProducerLicensesQuery__
 *
 * To run a query within a React component, call `useAdminProducerLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProducerLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProducerLicensesQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useAdminProducerLicensesQuery(baseOptions: Apollo.QueryHookOptions<AdminProducerLicensesQuery, AdminProducerLicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProducerLicensesQuery, AdminProducerLicensesQueryVariables>(AdminProducerLicensesDocument, options);
      }
export function useAdminProducerLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProducerLicensesQuery, AdminProducerLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProducerLicensesQuery, AdminProducerLicensesQueryVariables>(AdminProducerLicensesDocument, options);
        }
export type AdminProducerLicensesQueryHookResult = ReturnType<typeof useAdminProducerLicensesQuery>;
export type AdminProducerLicensesLazyQueryHookResult = ReturnType<typeof useAdminProducerLicensesLazyQuery>;
export type AdminProducerLicensesQueryResult = Apollo.QueryResult<AdminProducerLicensesQuery, AdminProducerLicensesQueryVariables>;
export const AdminAddProducerPlatformFeeDocument = gql`
    mutation AdminAddProducerPlatformFee($data: ProducerPlatformFeeCreateInput!) {
  addProducerPlatformFee(data: $data) {
    id
    amount
  }
}
    `;
export type AdminAddProducerPlatformFeeMutationFn = Apollo.MutationFunction<AdminAddProducerPlatformFeeMutation, AdminAddProducerPlatformFeeMutationVariables>;

/**
 * __useAdminAddProducerPlatformFeeMutation__
 *
 * To run a mutation, you first call `useAdminAddProducerPlatformFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddProducerPlatformFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddProducerPlatformFeeMutation, { data, loading, error }] = useAdminAddProducerPlatformFeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminAddProducerPlatformFeeMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddProducerPlatformFeeMutation, AdminAddProducerPlatformFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddProducerPlatformFeeMutation, AdminAddProducerPlatformFeeMutationVariables>(AdminAddProducerPlatformFeeDocument, options);
      }
export type AdminAddProducerPlatformFeeMutationHookResult = ReturnType<typeof useAdminAddProducerPlatformFeeMutation>;
export type AdminAddProducerPlatformFeeMutationResult = Apollo.MutationResult<AdminAddProducerPlatformFeeMutation>;
export type AdminAddProducerPlatformFeeMutationOptions = Apollo.BaseMutationOptions<AdminAddProducerPlatformFeeMutation, AdminAddProducerPlatformFeeMutationVariables>;
export const AdminProducerRegionPlatformFeesDocument = gql`
    query AdminProducerRegionPlatformFees($producerId: Int!, $regionId: Int!) {
  producerRegionPlatformFees(producerId: $producerId, regionId: $regionId) {
    packageType {
      id
      displayName
    }
    platformFee {
      ...ProducerPlatformFeeDetails
    }
  }
}
    ${ProducerPlatformFeeDetailsFragmentDoc}`;

/**
 * __useAdminProducerRegionPlatformFeesQuery__
 *
 * To run a query within a React component, call `useAdminProducerRegionPlatformFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProducerRegionPlatformFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProducerRegionPlatformFeesQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useAdminProducerRegionPlatformFeesQuery(baseOptions: Apollo.QueryHookOptions<AdminProducerRegionPlatformFeesQuery, AdminProducerRegionPlatformFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProducerRegionPlatformFeesQuery, AdminProducerRegionPlatformFeesQueryVariables>(AdminProducerRegionPlatformFeesDocument, options);
      }
export function useAdminProducerRegionPlatformFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProducerRegionPlatformFeesQuery, AdminProducerRegionPlatformFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProducerRegionPlatformFeesQuery, AdminProducerRegionPlatformFeesQueryVariables>(AdminProducerRegionPlatformFeesDocument, options);
        }
export type AdminProducerRegionPlatformFeesQueryHookResult = ReturnType<typeof useAdminProducerRegionPlatformFeesQuery>;
export type AdminProducerRegionPlatformFeesLazyQueryHookResult = ReturnType<typeof useAdminProducerRegionPlatformFeesLazyQuery>;
export type AdminProducerRegionPlatformFeesQueryResult = Apollo.QueryResult<AdminProducerRegionPlatformFeesQuery, AdminProducerRegionPlatformFeesQueryVariables>;
export const AdminUpdateProducerPlatformFeeDocument = gql`
    mutation AdminUpdateProducerPlatformFee($id: Int!, $data: ProducerPlatformFeeUpdateInput!) {
  updateProducerPlatformFee(id: $id, data: $data) {
    id
    amount
  }
}
    `;
export type AdminUpdateProducerPlatformFeeMutationFn = Apollo.MutationFunction<AdminUpdateProducerPlatformFeeMutation, AdminUpdateProducerPlatformFeeMutationVariables>;

/**
 * __useAdminUpdateProducerPlatformFeeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateProducerPlatformFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateProducerPlatformFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateProducerPlatformFeeMutation, { data, loading, error }] = useAdminUpdateProducerPlatformFeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminUpdateProducerPlatformFeeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateProducerPlatformFeeMutation, AdminUpdateProducerPlatformFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateProducerPlatformFeeMutation, AdminUpdateProducerPlatformFeeMutationVariables>(AdminUpdateProducerPlatformFeeDocument, options);
      }
export type AdminUpdateProducerPlatformFeeMutationHookResult = ReturnType<typeof useAdminUpdateProducerPlatformFeeMutation>;
export type AdminUpdateProducerPlatformFeeMutationResult = Apollo.MutationResult<AdminUpdateProducerPlatformFeeMutation>;
export type AdminUpdateProducerPlatformFeeMutationOptions = Apollo.BaseMutationOptions<AdminUpdateProducerPlatformFeeMutation, AdminUpdateProducerPlatformFeeMutationVariables>;
export const AssignDistributorToProducerDocument = gql`
    mutation AssignDistributorToProducer($data: AssignDistributorToProducerInput!) {
  assignDistributorToProducer(data: $data) {
    ...DistributorProducerAssignment
  }
}
    ${DistributorProducerAssignmentFragmentDoc}`;
export type AssignDistributorToProducerMutationFn = Apollo.MutationFunction<AssignDistributorToProducerMutation, AssignDistributorToProducerMutationVariables>;

/**
 * __useAssignDistributorToProducerMutation__
 *
 * To run a mutation, you first call `useAssignDistributorToProducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDistributorToProducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDistributorToProducerMutation, { data, loading, error }] = useAssignDistributorToProducerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAssignDistributorToProducerMutation(baseOptions?: Apollo.MutationHookOptions<AssignDistributorToProducerMutation, AssignDistributorToProducerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignDistributorToProducerMutation, AssignDistributorToProducerMutationVariables>(AssignDistributorToProducerDocument, options);
      }
export type AssignDistributorToProducerMutationHookResult = ReturnType<typeof useAssignDistributorToProducerMutation>;
export type AssignDistributorToProducerMutationResult = Apollo.MutationResult<AssignDistributorToProducerMutation>;
export type AssignDistributorToProducerMutationOptions = Apollo.BaseMutationOptions<AssignDistributorToProducerMutation, AssignDistributorToProducerMutationVariables>;
export const DeleteDistributorProducerAssignmentDocument = gql`
    mutation DeleteDistributorProducerAssignment($data: DeleteDistributorFromProducerInput!) {
  deleteDistributorProducerAssignment(data: $data) {
    ...DistributorProducerAssignment
  }
}
    ${DistributorProducerAssignmentFragmentDoc}`;
export type DeleteDistributorProducerAssignmentMutationFn = Apollo.MutationFunction<DeleteDistributorProducerAssignmentMutation, DeleteDistributorProducerAssignmentMutationVariables>;

/**
 * __useDeleteDistributorProducerAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteDistributorProducerAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDistributorProducerAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDistributorProducerAssignmentMutation, { data, loading, error }] = useDeleteDistributorProducerAssignmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteDistributorProducerAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDistributorProducerAssignmentMutation, DeleteDistributorProducerAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDistributorProducerAssignmentMutation, DeleteDistributorProducerAssignmentMutationVariables>(DeleteDistributorProducerAssignmentDocument, options);
      }
export type DeleteDistributorProducerAssignmentMutationHookResult = ReturnType<typeof useDeleteDistributorProducerAssignmentMutation>;
export type DeleteDistributorProducerAssignmentMutationResult = Apollo.MutationResult<DeleteDistributorProducerAssignmentMutation>;
export type DeleteDistributorProducerAssignmentMutationOptions = Apollo.BaseMutationOptions<DeleteDistributorProducerAssignmentMutation, DeleteDistributorProducerAssignmentMutationVariables>;
export const UpdateDistributorProducerAssignmentDocument = gql`
    mutation UpdateDistributorProducerAssignment($data: UpdateDistributorToProducerInput!) {
  updateDistributorProducerAssignment(data: $data) {
    ...DistributorProducerAssignment
  }
}
    ${DistributorProducerAssignmentFragmentDoc}`;
export type UpdateDistributorProducerAssignmentMutationFn = Apollo.MutationFunction<UpdateDistributorProducerAssignmentMutation, UpdateDistributorProducerAssignmentMutationVariables>;

/**
 * __useUpdateDistributorProducerAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateDistributorProducerAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDistributorProducerAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDistributorProducerAssignmentMutation, { data, loading, error }] = useUpdateDistributorProducerAssignmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDistributorProducerAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDistributorProducerAssignmentMutation, UpdateDistributorProducerAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDistributorProducerAssignmentMutation, UpdateDistributorProducerAssignmentMutationVariables>(UpdateDistributorProducerAssignmentDocument, options);
      }
export type UpdateDistributorProducerAssignmentMutationHookResult = ReturnType<typeof useUpdateDistributorProducerAssignmentMutation>;
export type UpdateDistributorProducerAssignmentMutationResult = Apollo.MutationResult<UpdateDistributorProducerAssignmentMutation>;
export type UpdateDistributorProducerAssignmentMutationOptions = Apollo.BaseMutationOptions<UpdateDistributorProducerAssignmentMutation, UpdateDistributorProducerAssignmentMutationVariables>;
export const AdminProducersDocument = gql`
    query AdminProducers($pagination: OffsetPaginationInput!, $filters: ProducersFilterData) {
  paginatedProducers(pagination: $pagination, filters: $filters) {
    results {
      ...AdminProducersTableData
    }
    total
  }
}
    ${AdminProducersTableDataFragmentDoc}`;

/**
 * __useAdminProducersQuery__
 *
 * To run a query within a React component, call `useAdminProducersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProducersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProducersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminProducersQuery(baseOptions: Apollo.QueryHookOptions<AdminProducersQuery, AdminProducersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProducersQuery, AdminProducersQueryVariables>(AdminProducersDocument, options);
      }
export function useAdminProducersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProducersQuery, AdminProducersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProducersQuery, AdminProducersQueryVariables>(AdminProducersDocument, options);
        }
export type AdminProducersQueryHookResult = ReturnType<typeof useAdminProducersQuery>;
export type AdminProducersLazyQueryHookResult = ReturnType<typeof useAdminProducersLazyQuery>;
export type AdminProducersQueryResult = Apollo.QueryResult<AdminProducersQuery, AdminProducersQueryVariables>;
export const AdminPurchaseOrdersDocument = gql`
    query AdminPurchaseOrders($pagination: OffsetPaginationInput!, $filters: ProducerPurchaseOrdersFilterInput, $sort: ProducerPurchaseOrdersSortInput) {
  paginatedProducerPurchaseOrders(
    pagination: $pagination
    filters: $filters
    sort: $sort
  ) {
    results {
      ...AdminProducerPurchaseOrderTableRow
    }
    total
  }
}
    ${AdminProducerPurchaseOrderTableRowFragmentDoc}`;

/**
 * __useAdminPurchaseOrdersQuery__
 *
 * To run a query within a React component, call `useAdminPurchaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPurchaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPurchaseOrdersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAdminPurchaseOrdersQuery(baseOptions: Apollo.QueryHookOptions<AdminPurchaseOrdersQuery, AdminPurchaseOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPurchaseOrdersQuery, AdminPurchaseOrdersQueryVariables>(AdminPurchaseOrdersDocument, options);
      }
export function useAdminPurchaseOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPurchaseOrdersQuery, AdminPurchaseOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPurchaseOrdersQuery, AdminPurchaseOrdersQueryVariables>(AdminPurchaseOrdersDocument, options);
        }
export type AdminPurchaseOrdersQueryHookResult = ReturnType<typeof useAdminPurchaseOrdersQuery>;
export type AdminPurchaseOrdersLazyQueryHookResult = ReturnType<typeof useAdminPurchaseOrdersLazyQuery>;
export type AdminPurchaseOrdersQueryResult = Apollo.QueryResult<AdminPurchaseOrdersQuery, AdminPurchaseOrdersQueryVariables>;
export const DeliveryAgingReportDocument = gql`
    query DeliveryAgingReport($pagination: OffsetPaginationInput!, $filters: DeliveryAgingReportFilterInput) {
  deliveryAgingReport(pagination: $pagination, filters: $filters) {
    results {
      ...DeliveryAgingReportResult
    }
    total
  }
  deliverySLT {
    ...ServiceLevelTargetDetails
  }
  deliveryStepSLT {
    ...ServiceLevelTargetDetails
  }
}
    ${DeliveryAgingReportResultFragmentDoc}
${ServiceLevelTargetDetailsFragmentDoc}`;

/**
 * __useDeliveryAgingReportQuery__
 *
 * To run a query within a React component, call `useDeliveryAgingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryAgingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryAgingReportQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDeliveryAgingReportQuery(baseOptions: Apollo.QueryHookOptions<DeliveryAgingReportQuery, DeliveryAgingReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryAgingReportQuery, DeliveryAgingReportQueryVariables>(DeliveryAgingReportDocument, options);
      }
export function useDeliveryAgingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryAgingReportQuery, DeliveryAgingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryAgingReportQuery, DeliveryAgingReportQueryVariables>(DeliveryAgingReportDocument, options);
        }
export type DeliveryAgingReportQueryHookResult = ReturnType<typeof useDeliveryAgingReportQuery>;
export type DeliveryAgingReportLazyQueryHookResult = ReturnType<typeof useDeliveryAgingReportLazyQuery>;
export type DeliveryAgingReportQueryResult = Apollo.QueryResult<DeliveryAgingReportQuery, DeliveryAgingReportQueryVariables>;
export const FreightAgingReportDocument = gql`
    query FreightAgingReport($pagination: OffsetPaginationInput!, $filters: FreightAgingReportFilterInput) {
  freightAgingReport(pagination: $pagination, filters: $filters) {
    results {
      ...FreightAgingReportResult
    }
    total
  }
  freightSLT {
    ...ServiceLevelTargetDetails
  }
  freightStepSLT {
    ...ServiceLevelTargetDetails
  }
}
    ${FreightAgingReportResultFragmentDoc}
${ServiceLevelTargetDetailsFragmentDoc}`;

/**
 * __useFreightAgingReportQuery__
 *
 * To run a query within a React component, call `useFreightAgingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFreightAgingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFreightAgingReportQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFreightAgingReportQuery(baseOptions: Apollo.QueryHookOptions<FreightAgingReportQuery, FreightAgingReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FreightAgingReportQuery, FreightAgingReportQueryVariables>(FreightAgingReportDocument, options);
      }
export function useFreightAgingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FreightAgingReportQuery, FreightAgingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FreightAgingReportQuery, FreightAgingReportQueryVariables>(FreightAgingReportDocument, options);
        }
export type FreightAgingReportQueryHookResult = ReturnType<typeof useFreightAgingReportQuery>;
export type FreightAgingReportLazyQueryHookResult = ReturnType<typeof useFreightAgingReportLazyQuery>;
export type FreightAgingReportQueryResult = Apollo.QueryResult<FreightAgingReportQuery, FreightAgingReportQueryVariables>;
export const PaymentAgingReportDocument = gql`
    query PaymentAgingReport($pagination: OffsetPaginationInput!, $filters: PaymentAgingReportFilterInput) {
  paymentAgingReport(pagination: $pagination, filters: $filters) {
    results {
      ...PaymentAgingReportResult
    }
    total
  }
}
    ${PaymentAgingReportResultFragmentDoc}`;

/**
 * __usePaymentAgingReportQuery__
 *
 * To run a query within a React component, call `usePaymentAgingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentAgingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentAgingReportQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePaymentAgingReportQuery(baseOptions: Apollo.QueryHookOptions<PaymentAgingReportQuery, PaymentAgingReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentAgingReportQuery, PaymentAgingReportQueryVariables>(PaymentAgingReportDocument, options);
      }
export function usePaymentAgingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentAgingReportQuery, PaymentAgingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentAgingReportQuery, PaymentAgingReportQueryVariables>(PaymentAgingReportDocument, options);
        }
export type PaymentAgingReportQueryHookResult = ReturnType<typeof usePaymentAgingReportQuery>;
export type PaymentAgingReportLazyQueryHookResult = ReturnType<typeof usePaymentAgingReportLazyQuery>;
export type PaymentAgingReportQueryResult = Apollo.QueryResult<PaymentAgingReportQuery, PaymentAgingReportQueryVariables>;
export const RetailerSalesOrderDeliveryAgingReportDocument = gql`
    query RetailerSalesOrderDeliveryAgingReport($pagination: OffsetPaginationInput!, $filters: RetailerOrderDeliveryAgingReportFilterInput) {
  retailerSalesOrderQueries {
    deliveryAgingReport(pagination: $pagination, filters: $filters) {
      results {
        ...RetailerSalesOrderDeliveryAgingReportResult
      }
      total
    }
  }
  deliverySLT {
    ...ServiceLevelTargetDetails
  }
  deliveryStepSLT {
    ...ServiceLevelTargetDetails
  }
}
    ${RetailerSalesOrderDeliveryAgingReportResultFragmentDoc}
${ServiceLevelTargetDetailsFragmentDoc}`;

/**
 * __useRetailerSalesOrderDeliveryAgingReportQuery__
 *
 * To run a query within a React component, call `useRetailerSalesOrderDeliveryAgingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerSalesOrderDeliveryAgingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerSalesOrderDeliveryAgingReportQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRetailerSalesOrderDeliveryAgingReportQuery(baseOptions: Apollo.QueryHookOptions<RetailerSalesOrderDeliveryAgingReportQuery, RetailerSalesOrderDeliveryAgingReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerSalesOrderDeliveryAgingReportQuery, RetailerSalesOrderDeliveryAgingReportQueryVariables>(RetailerSalesOrderDeliveryAgingReportDocument, options);
      }
export function useRetailerSalesOrderDeliveryAgingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerSalesOrderDeliveryAgingReportQuery, RetailerSalesOrderDeliveryAgingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerSalesOrderDeliveryAgingReportQuery, RetailerSalesOrderDeliveryAgingReportQueryVariables>(RetailerSalesOrderDeliveryAgingReportDocument, options);
        }
export type RetailerSalesOrderDeliveryAgingReportQueryHookResult = ReturnType<typeof useRetailerSalesOrderDeliveryAgingReportQuery>;
export type RetailerSalesOrderDeliveryAgingReportLazyQueryHookResult = ReturnType<typeof useRetailerSalesOrderDeliveryAgingReportLazyQuery>;
export type RetailerSalesOrderDeliveryAgingReportQueryResult = Apollo.QueryResult<RetailerSalesOrderDeliveryAgingReportQuery, RetailerSalesOrderDeliveryAgingReportQueryVariables>;
export const AdminDeleteRetailerDocument = gql`
    mutation AdminDeleteRetailer($id: Int!) {
  deleteRetailer(id: $id) {
    id
    name
  }
}
    `;
export type AdminDeleteRetailerMutationFn = Apollo.MutationFunction<AdminDeleteRetailerMutation, AdminDeleteRetailerMutationVariables>;

/**
 * __useAdminDeleteRetailerMutation__
 *
 * To run a mutation, you first call `useAdminDeleteRetailerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteRetailerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteRetailerMutation, { data, loading, error }] = useAdminDeleteRetailerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteRetailerMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteRetailerMutation, AdminDeleteRetailerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteRetailerMutation, AdminDeleteRetailerMutationVariables>(AdminDeleteRetailerDocument, options);
      }
export type AdminDeleteRetailerMutationHookResult = ReturnType<typeof useAdminDeleteRetailerMutation>;
export type AdminDeleteRetailerMutationResult = Apollo.MutationResult<AdminDeleteRetailerMutation>;
export type AdminDeleteRetailerMutationOptions = Apollo.BaseMutationOptions<AdminDeleteRetailerMutation, AdminDeleteRetailerMutationVariables>;
export const AdminRetailerDocument = gql`
    query AdminRetailer($retailerId: Int!) {
  retailer(id: $retailerId) {
    ...AdminRetailerDetails
  }
}
    ${AdminRetailerDetailsFragmentDoc}`;

/**
 * __useAdminRetailerQuery__
 *
 * To run a query within a React component, call `useAdminRetailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRetailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRetailerQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useAdminRetailerQuery(baseOptions: Apollo.QueryHookOptions<AdminRetailerQuery, AdminRetailerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRetailerQuery, AdminRetailerQueryVariables>(AdminRetailerDocument, options);
      }
export function useAdminRetailerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRetailerQuery, AdminRetailerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRetailerQuery, AdminRetailerQueryVariables>(AdminRetailerDocument, options);
        }
export type AdminRetailerQueryHookResult = ReturnType<typeof useAdminRetailerQuery>;
export type AdminRetailerLazyQueryHookResult = ReturnType<typeof useAdminRetailerLazyQuery>;
export type AdminRetailerQueryResult = Apollo.QueryResult<AdminRetailerQuery, AdminRetailerQueryVariables>;
export const AdminRetailerDetailsDocument = gql`
    query AdminRetailerDetails($retailerId: Int!) {
  retailer(id: $retailerId) {
    ...AdminRetailerDetails
  }
}
    ${AdminRetailerDetailsFragmentDoc}`;

/**
 * __useAdminRetailerDetailsQuery__
 *
 * To run a query within a React component, call `useAdminRetailerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRetailerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRetailerDetailsQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useAdminRetailerDetailsQuery(baseOptions: Apollo.QueryHookOptions<AdminRetailerDetailsQuery, AdminRetailerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRetailerDetailsQuery, AdminRetailerDetailsQueryVariables>(AdminRetailerDetailsDocument, options);
      }
export function useAdminRetailerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRetailerDetailsQuery, AdminRetailerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRetailerDetailsQuery, AdminRetailerDetailsQueryVariables>(AdminRetailerDetailsDocument, options);
        }
export type AdminRetailerDetailsQueryHookResult = ReturnType<typeof useAdminRetailerDetailsQuery>;
export type AdminRetailerDetailsLazyQueryHookResult = ReturnType<typeof useAdminRetailerDetailsLazyQuery>;
export type AdminRetailerDetailsQueryResult = Apollo.QueryResult<AdminRetailerDetailsQuery, AdminRetailerDetailsQueryVariables>;
export const AdminRetailerSalesOrdersDocument = gql`
    query AdminRetailerSalesOrders($pagination: OffsetPaginationInput!, $filters: RetailerSalesOrdersFilters!) {
  getRetailerSalesOrders(pagination: $pagination, filters: $filters) {
    results {
      ...AdminRetailerSalesOrdersTableData
    }
    total
  }
}
    ${AdminRetailerSalesOrdersTableDataFragmentDoc}`;

/**
 * __useAdminRetailerSalesOrdersQuery__
 *
 * To run a query within a React component, call `useAdminRetailerSalesOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRetailerSalesOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRetailerSalesOrdersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminRetailerSalesOrdersQuery(baseOptions: Apollo.QueryHookOptions<AdminRetailerSalesOrdersQuery, AdminRetailerSalesOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRetailerSalesOrdersQuery, AdminRetailerSalesOrdersQueryVariables>(AdminRetailerSalesOrdersDocument, options);
      }
export function useAdminRetailerSalesOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRetailerSalesOrdersQuery, AdminRetailerSalesOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRetailerSalesOrdersQuery, AdminRetailerSalesOrdersQueryVariables>(AdminRetailerSalesOrdersDocument, options);
        }
export type AdminRetailerSalesOrdersQueryHookResult = ReturnType<typeof useAdminRetailerSalesOrdersQuery>;
export type AdminRetailerSalesOrdersLazyQueryHookResult = ReturnType<typeof useAdminRetailerSalesOrdersLazyQuery>;
export type AdminRetailerSalesOrdersQueryResult = Apollo.QueryResult<AdminRetailerSalesOrdersQuery, AdminRetailerSalesOrdersQueryVariables>;
export const AdminRetailersDocument = gql`
    query AdminRetailers($pagination: OffsetPaginationInput!, $filters: RetailersFilterData) {
  paginatedRetailers(pagination: $pagination, filters: $filters) {
    results {
      ...AdminRetailerDetails
    }
    total
  }
}
    ${AdminRetailerDetailsFragmentDoc}`;

/**
 * __useAdminRetailersQuery__
 *
 * To run a query within a React component, call `useAdminRetailersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRetailersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRetailersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminRetailersQuery(baseOptions: Apollo.QueryHookOptions<AdminRetailersQuery, AdminRetailersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRetailersQuery, AdminRetailersQueryVariables>(AdminRetailersDocument, options);
      }
export function useAdminRetailersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRetailersQuery, AdminRetailersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRetailersQuery, AdminRetailersQueryVariables>(AdminRetailersDocument, options);
        }
export type AdminRetailersQueryHookResult = ReturnType<typeof useAdminRetailersQuery>;
export type AdminRetailersLazyQueryHookResult = ReturnType<typeof useAdminRetailersLazyQuery>;
export type AdminRetailersQueryResult = Apollo.QueryResult<AdminRetailersQuery, AdminRetailersQueryVariables>;
export const UpdateShippingCostFromCsvDocument = gql`
    mutation updateShippingCostFromCSV($remoteFileId: Int!) {
  updateShippingCostFromCSV(remoteFileId: $remoteFileId) {
    ...ImportReportDisplay
  }
}
    ${ImportReportDisplayFragmentDoc}`;
export type UpdateShippingCostFromCsvMutationFn = Apollo.MutationFunction<UpdateShippingCostFromCsvMutation, UpdateShippingCostFromCsvMutationVariables>;

/**
 * __useUpdateShippingCostFromCsvMutation__
 *
 * To run a mutation, you first call `useUpdateShippingCostFromCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingCostFromCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingCostFromCsvMutation, { data, loading, error }] = useUpdateShippingCostFromCsvMutation({
 *   variables: {
 *      remoteFileId: // value for 'remoteFileId'
 *   },
 * });
 */
export function useUpdateShippingCostFromCsvMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShippingCostFromCsvMutation, UpdateShippingCostFromCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShippingCostFromCsvMutation, UpdateShippingCostFromCsvMutationVariables>(UpdateShippingCostFromCsvDocument, options);
      }
export type UpdateShippingCostFromCsvMutationHookResult = ReturnType<typeof useUpdateShippingCostFromCsvMutation>;
export type UpdateShippingCostFromCsvMutationResult = Apollo.MutationResult<UpdateShippingCostFromCsvMutation>;
export type UpdateShippingCostFromCsvMutationOptions = Apollo.BaseMutationOptions<UpdateShippingCostFromCsvMutation, UpdateShippingCostFromCsvMutationVariables>;
export const UpdateTrackingInfoFromCsvDocument = gql`
    mutation updateTrackingInfoFromCSV($remoteFileId: Int!, $company: ImportCSVCarrier!) {
  updateTrackingInfoFromCSV(remoteFileId: $remoteFileId, company: $company) {
    ...ImportReportDisplay
  }
}
    ${ImportReportDisplayFragmentDoc}`;
export type UpdateTrackingInfoFromCsvMutationFn = Apollo.MutationFunction<UpdateTrackingInfoFromCsvMutation, UpdateTrackingInfoFromCsvMutationVariables>;

/**
 * __useUpdateTrackingInfoFromCsvMutation__
 *
 * To run a mutation, you first call `useUpdateTrackingInfoFromCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackingInfoFromCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackingInfoFromCsvMutation, { data, loading, error }] = useUpdateTrackingInfoFromCsvMutation({
 *   variables: {
 *      remoteFileId: // value for 'remoteFileId'
 *      company: // value for 'company'
 *   },
 * });
 */
export function useUpdateTrackingInfoFromCsvMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackingInfoFromCsvMutation, UpdateTrackingInfoFromCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackingInfoFromCsvMutation, UpdateTrackingInfoFromCsvMutationVariables>(UpdateTrackingInfoFromCsvDocument, options);
      }
export type UpdateTrackingInfoFromCsvMutationHookResult = ReturnType<typeof useUpdateTrackingInfoFromCsvMutation>;
export type UpdateTrackingInfoFromCsvMutationResult = Apollo.MutationResult<UpdateTrackingInfoFromCsvMutation>;
export type UpdateTrackingInfoFromCsvMutationOptions = Apollo.BaseMutationOptions<UpdateTrackingInfoFromCsvMutation, UpdateTrackingInfoFromCsvMutationVariables>;
export const AdminTransactionsDocument = gql`
    query AdminTransactions($offset: Int!, $limit: Int!, $monthFilter: String!) {
  fundsTransfers(take: $limit, skip: $offset, monthFilter: $monthFilter) {
    ...AdminFundsTransferFields
  }
}
    ${AdminFundsTransferFieldsFragmentDoc}`;

/**
 * __useAdminTransactionsQuery__
 *
 * To run a query within a React component, call `useAdminTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTransactionsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      monthFilter: // value for 'monthFilter'
 *   },
 * });
 */
export function useAdminTransactionsQuery(baseOptions: Apollo.QueryHookOptions<AdminTransactionsQuery, AdminTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminTransactionsQuery, AdminTransactionsQueryVariables>(AdminTransactionsDocument, options);
      }
export function useAdminTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminTransactionsQuery, AdminTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminTransactionsQuery, AdminTransactionsQueryVariables>(AdminTransactionsDocument, options);
        }
export type AdminTransactionsQueryHookResult = ReturnType<typeof useAdminTransactionsQuery>;
export type AdminTransactionsLazyQueryHookResult = ReturnType<typeof useAdminTransactionsLazyQuery>;
export type AdminTransactionsQueryResult = Apollo.QueryResult<AdminTransactionsQuery, AdminTransactionsQueryVariables>;
export const AdminTransferDocument = gql`
    query AdminTransfer($id: Int!) {
  fundsTransfer(id: $id) {
    ...AdminFundsTransferFields
  }
}
    ${AdminFundsTransferFieldsFragmentDoc}`;

/**
 * __useAdminTransferQuery__
 *
 * To run a query within a React component, call `useAdminTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTransferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminTransferQuery(baseOptions: Apollo.QueryHookOptions<AdminTransferQuery, AdminTransferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminTransferQuery, AdminTransferQueryVariables>(AdminTransferDocument, options);
      }
export function useAdminTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminTransferQuery, AdminTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminTransferQuery, AdminTransferQueryVariables>(AdminTransferDocument, options);
        }
export type AdminTransferQueryHookResult = ReturnType<typeof useAdminTransferQuery>;
export type AdminTransferLazyQueryHookResult = ReturnType<typeof useAdminTransferLazyQuery>;
export type AdminTransferQueryResult = Apollo.QueryResult<AdminTransferQuery, AdminTransferQueryVariables>;
export const SyncFundsTransferDocument = gql`
    mutation SyncFundsTransfer($fundsTransferId: Int!) {
  syncFundsTransfer(fundsTransferId: $fundsTransferId) {
    ...FundsTransferFields
  }
}
    ${FundsTransferFieldsFragmentDoc}`;
export type SyncFundsTransferMutationFn = Apollo.MutationFunction<SyncFundsTransferMutation, SyncFundsTransferMutationVariables>;

/**
 * __useSyncFundsTransferMutation__
 *
 * To run a mutation, you first call `useSyncFundsTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncFundsTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncFundsTransferMutation, { data, loading, error }] = useSyncFundsTransferMutation({
 *   variables: {
 *      fundsTransferId: // value for 'fundsTransferId'
 *   },
 * });
 */
export function useSyncFundsTransferMutation(baseOptions?: Apollo.MutationHookOptions<SyncFundsTransferMutation, SyncFundsTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncFundsTransferMutation, SyncFundsTransferMutationVariables>(SyncFundsTransferDocument, options);
      }
export type SyncFundsTransferMutationHookResult = ReturnType<typeof useSyncFundsTransferMutation>;
export type SyncFundsTransferMutationResult = Apollo.MutationResult<SyncFundsTransferMutation>;
export type SyncFundsTransferMutationOptions = Apollo.BaseMutationOptions<SyncFundsTransferMutation, SyncFundsTransferMutationVariables>;
export const AddFundsTransferDocument = gql`
    mutation AddFundsTransfer($data: AddFundsTransferData!) {
  addFundsTransfer(data: $data) {
    ...FundsTransferFields
  }
}
    ${FundsTransferFieldsFragmentDoc}`;
export type AddFundsTransferMutationFn = Apollo.MutationFunction<AddFundsTransferMutation, AddFundsTransferMutationVariables>;

/**
 * __useAddFundsTransferMutation__
 *
 * To run a mutation, you first call `useAddFundsTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFundsTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFundsTransferMutation, { data, loading, error }] = useAddFundsTransferMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddFundsTransferMutation(baseOptions?: Apollo.MutationHookOptions<AddFundsTransferMutation, AddFundsTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFundsTransferMutation, AddFundsTransferMutationVariables>(AddFundsTransferDocument, options);
      }
export type AddFundsTransferMutationHookResult = ReturnType<typeof useAddFundsTransferMutation>;
export type AddFundsTransferMutationResult = Apollo.MutationResult<AddFundsTransferMutation>;
export type AddFundsTransferMutationOptions = Apollo.BaseMutationOptions<AddFundsTransferMutation, AddFundsTransferMutationVariables>;
export const AutocompleteFromFundsAccountsDocument = gql`
    query AutocompleteFromFundsAccounts {
  fundsAccountsEligibleToSend {
    ...AutocompleteFundsAccount
  }
}
    ${AutocompleteFundsAccountFragmentDoc}`;

/**
 * __useAutocompleteFromFundsAccountsQuery__
 *
 * To run a query within a React component, call `useAutocompleteFromFundsAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteFromFundsAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteFromFundsAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutocompleteFromFundsAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteFromFundsAccountsQuery, AutocompleteFromFundsAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteFromFundsAccountsQuery, AutocompleteFromFundsAccountsQueryVariables>(AutocompleteFromFundsAccountsDocument, options);
      }
export function useAutocompleteFromFundsAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteFromFundsAccountsQuery, AutocompleteFromFundsAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteFromFundsAccountsQuery, AutocompleteFromFundsAccountsQueryVariables>(AutocompleteFromFundsAccountsDocument, options);
        }
export type AutocompleteFromFundsAccountsQueryHookResult = ReturnType<typeof useAutocompleteFromFundsAccountsQuery>;
export type AutocompleteFromFundsAccountsLazyQueryHookResult = ReturnType<typeof useAutocompleteFromFundsAccountsLazyQuery>;
export type AutocompleteFromFundsAccountsQueryResult = Apollo.QueryResult<AutocompleteFromFundsAccountsQuery, AutocompleteFromFundsAccountsQueryVariables>;
export const AutocompleteToFundsAccountsDocument = gql`
    query AutocompleteToFundsAccounts {
  fundsAccountsEligibleToReceive {
    ...AutocompleteFundsAccount
  }
}
    ${AutocompleteFundsAccountFragmentDoc}`;

/**
 * __useAutocompleteToFundsAccountsQuery__
 *
 * To run a query within a React component, call `useAutocompleteToFundsAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteToFundsAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteToFundsAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutocompleteToFundsAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteToFundsAccountsQuery, AutocompleteToFundsAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteToFundsAccountsQuery, AutocompleteToFundsAccountsQueryVariables>(AutocompleteToFundsAccountsDocument, options);
      }
export function useAutocompleteToFundsAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteToFundsAccountsQuery, AutocompleteToFundsAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteToFundsAccountsQuery, AutocompleteToFundsAccountsQueryVariables>(AutocompleteToFundsAccountsDocument, options);
        }
export type AutocompleteToFundsAccountsQueryHookResult = ReturnType<typeof useAutocompleteToFundsAccountsQuery>;
export type AutocompleteToFundsAccountsLazyQueryHookResult = ReturnType<typeof useAutocompleteToFundsAccountsLazyQuery>;
export type AutocompleteToFundsAccountsQueryResult = Apollo.QueryResult<AutocompleteToFundsAccountsQuery, AutocompleteToFundsAccountsQueryVariables>;
export const AddSandboxProducerDocument = gql`
    mutation AddSandboxProducer($type: SandboxProducerType!) {
  addSandboxProducer(type: $type) {
    id
    organization {
      id
    }
  }
}
    `;
export type AddSandboxProducerMutationFn = Apollo.MutationFunction<AddSandboxProducerMutation, AddSandboxProducerMutationVariables>;

/**
 * __useAddSandboxProducerMutation__
 *
 * To run a mutation, you first call `useAddSandboxProducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSandboxProducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSandboxProducerMutation, { data, loading, error }] = useAddSandboxProducerMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAddSandboxProducerMutation(baseOptions?: Apollo.MutationHookOptions<AddSandboxProducerMutation, AddSandboxProducerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSandboxProducerMutation, AddSandboxProducerMutationVariables>(AddSandboxProducerDocument, options);
      }
export type AddSandboxProducerMutationHookResult = ReturnType<typeof useAddSandboxProducerMutation>;
export type AddSandboxProducerMutationResult = Apollo.MutationResult<AddSandboxProducerMutation>;
export type AddSandboxProducerMutationOptions = Apollo.BaseMutationOptions<AddSandboxProducerMutation, AddSandboxProducerMutationVariables>;
export const AddSandboxRetailerDocument = gql`
    mutation AddSandboxRetailer($type: SandboxRetailerType!) {
  addSandboxRetailer(type: $type) {
    id
    organization {
      id
    }
  }
}
    `;
export type AddSandboxRetailerMutationFn = Apollo.MutationFunction<AddSandboxRetailerMutation, AddSandboxRetailerMutationVariables>;

/**
 * __useAddSandboxRetailerMutation__
 *
 * To run a mutation, you first call `useAddSandboxRetailerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSandboxRetailerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSandboxRetailerMutation, { data, loading, error }] = useAddSandboxRetailerMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAddSandboxRetailerMutation(baseOptions?: Apollo.MutationHookOptions<AddSandboxRetailerMutation, AddSandboxRetailerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSandboxRetailerMutation, AddSandboxRetailerMutationVariables>(AddSandboxRetailerDocument, options);
      }
export type AddSandboxRetailerMutationHookResult = ReturnType<typeof useAddSandboxRetailerMutation>;
export type AddSandboxRetailerMutationResult = Apollo.MutationResult<AddSandboxRetailerMutation>;
export type AddSandboxRetailerMutationOptions = Apollo.BaseMutationOptions<AddSandboxRetailerMutation, AddSandboxRetailerMutationVariables>;
export const RunDwollaSandboxSimulationsDocument = gql`
    mutation RunDwollaSandboxSimulations {
  runSandboxSimulations {
    total
  }
}
    `;
export type RunDwollaSandboxSimulationsMutationFn = Apollo.MutationFunction<RunDwollaSandboxSimulationsMutation, RunDwollaSandboxSimulationsMutationVariables>;

/**
 * __useRunDwollaSandboxSimulationsMutation__
 *
 * To run a mutation, you first call `useRunDwollaSandboxSimulationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunDwollaSandboxSimulationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runDwollaSandboxSimulationsMutation, { data, loading, error }] = useRunDwollaSandboxSimulationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRunDwollaSandboxSimulationsMutation(baseOptions?: Apollo.MutationHookOptions<RunDwollaSandboxSimulationsMutation, RunDwollaSandboxSimulationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunDwollaSandboxSimulationsMutation, RunDwollaSandboxSimulationsMutationVariables>(RunDwollaSandboxSimulationsDocument, options);
      }
export type RunDwollaSandboxSimulationsMutationHookResult = ReturnType<typeof useRunDwollaSandboxSimulationsMutation>;
export type RunDwollaSandboxSimulationsMutationResult = Apollo.MutationResult<RunDwollaSandboxSimulationsMutation>;
export type RunDwollaSandboxSimulationsMutationOptions = Apollo.BaseMutationOptions<RunDwollaSandboxSimulationsMutation, RunDwollaSandboxSimulationsMutationVariables>;
export const DwollaWebhooksDocument = gql`
    query DwollaWebhooks {
  dwollaWebhooks {
    id
    createdAt
    receivedAt
    updatedAt
    topic
    status
    resourceId
    resourceType
  }
}
    `;

/**
 * __useDwollaWebhooksQuery__
 *
 * To run a query within a React component, call `useDwollaWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDwollaWebhooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDwollaWebhooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useDwollaWebhooksQuery(baseOptions?: Apollo.QueryHookOptions<DwollaWebhooksQuery, DwollaWebhooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DwollaWebhooksQuery, DwollaWebhooksQueryVariables>(DwollaWebhooksDocument, options);
      }
export function useDwollaWebhooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DwollaWebhooksQuery, DwollaWebhooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DwollaWebhooksQuery, DwollaWebhooksQueryVariables>(DwollaWebhooksDocument, options);
        }
export type DwollaWebhooksQueryHookResult = ReturnType<typeof useDwollaWebhooksQuery>;
export type DwollaWebhooksLazyQueryHookResult = ReturnType<typeof useDwollaWebhooksLazyQuery>;
export type DwollaWebhooksQueryResult = Apollo.QueryResult<DwollaWebhooksQuery, DwollaWebhooksQueryVariables>;
export const ProductDocument = gql`
    query product($id: Int!) {
  product(id: $id) {
    ...ProductDisplay
  }
}
    ${ProductDisplayFragmentDoc}`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const AdminSyncDwollaCustomerDocument = gql`
    mutation AdminSyncDwollaCustomer($dwollaCustomerId: String!) {
  syncDwollaCustomer(dwollaCustomerId: $dwollaCustomerId) {
    id
    ...AdminDwollaCustomerDetails
  }
}
    ${AdminDwollaCustomerDetailsFragmentDoc}`;
export type AdminSyncDwollaCustomerMutationFn = Apollo.MutationFunction<AdminSyncDwollaCustomerMutation, AdminSyncDwollaCustomerMutationVariables>;

/**
 * __useAdminSyncDwollaCustomerMutation__
 *
 * To run a mutation, you first call `useAdminSyncDwollaCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSyncDwollaCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSyncDwollaCustomerMutation, { data, loading, error }] = useAdminSyncDwollaCustomerMutation({
 *   variables: {
 *      dwollaCustomerId: // value for 'dwollaCustomerId'
 *   },
 * });
 */
export function useAdminSyncDwollaCustomerMutation(baseOptions?: Apollo.MutationHookOptions<AdminSyncDwollaCustomerMutation, AdminSyncDwollaCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSyncDwollaCustomerMutation, AdminSyncDwollaCustomerMutationVariables>(AdminSyncDwollaCustomerDocument, options);
      }
export type AdminSyncDwollaCustomerMutationHookResult = ReturnType<typeof useAdminSyncDwollaCustomerMutation>;
export type AdminSyncDwollaCustomerMutationResult = Apollo.MutationResult<AdminSyncDwollaCustomerMutation>;
export type AdminSyncDwollaCustomerMutationOptions = Apollo.BaseMutationOptions<AdminSyncDwollaCustomerMutation, AdminSyncDwollaCustomerMutationVariables>;
export const AutoCompleteBeerStylesDocument = gql`
    query AutoCompleteBeerStyles {
  beerStyles {
    ...AutoCompleteBeerStyles
  }
}
    ${AutoCompleteBeerStylesFragmentDoc}`;

/**
 * __useAutoCompleteBeerStylesQuery__
 *
 * To run a query within a React component, call `useAutoCompleteBeerStylesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoCompleteBeerStylesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoCompleteBeerStylesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutoCompleteBeerStylesQuery(baseOptions?: Apollo.QueryHookOptions<AutoCompleteBeerStylesQuery, AutoCompleteBeerStylesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutoCompleteBeerStylesQuery, AutoCompleteBeerStylesQueryVariables>(AutoCompleteBeerStylesDocument, options);
      }
export function useAutoCompleteBeerStylesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutoCompleteBeerStylesQuery, AutoCompleteBeerStylesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutoCompleteBeerStylesQuery, AutoCompleteBeerStylesQueryVariables>(AutoCompleteBeerStylesDocument, options);
        }
export type AutoCompleteBeerStylesQueryHookResult = ReturnType<typeof useAutoCompleteBeerStylesQuery>;
export type AutoCompleteBeerStylesLazyQueryHookResult = ReturnType<typeof useAutoCompleteBeerStylesLazyQuery>;
export type AutoCompleteBeerStylesQueryResult = Apollo.QueryResult<AutoCompleteBeerStylesQuery, AutoCompleteBeerStylesQueryVariables>;
export const InviteUserToOrganizationDocument = gql`
    mutation InviteUserToOrganization($email: String!, $fullName: String!, $organizationId: Int!) {
  inviteUser(email: $email, fullName: $fullName, organizationId: $organizationId) {
    id
    createdAt
    isGlobalAdmin
  }
}
    `;
export type InviteUserToOrganizationMutationFn = Apollo.MutationFunction<InviteUserToOrganizationMutation, InviteUserToOrganizationMutationVariables>;

/**
 * __useInviteUserToOrganizationMutation__
 *
 * To run a mutation, you first call `useInviteUserToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserToOrganizationMutation, { data, loading, error }] = useInviteUserToOrganizationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      fullName: // value for 'fullName'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInviteUserToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserToOrganizationMutation, InviteUserToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserToOrganizationMutation, InviteUserToOrganizationMutationVariables>(InviteUserToOrganizationDocument, options);
      }
export type InviteUserToOrganizationMutationHookResult = ReturnType<typeof useInviteUserToOrganizationMutation>;
export type InviteUserToOrganizationMutationResult = Apollo.MutationResult<InviteUserToOrganizationMutation>;
export type InviteUserToOrganizationMutationOptions = Apollo.BaseMutationOptions<InviteUserToOrganizationMutation, InviteUserToOrganizationMutationVariables>;
export const DistributorBalanceAccountDocument = gql`
    query DistributorBalanceAccount($businessEntityId: Int!) {
  business(id: $businessEntityId) {
    id
    balanceAccount {
      id
      balance
    }
  }
}
    `;

/**
 * __useDistributorBalanceAccountQuery__
 *
 * To run a query within a React component, call `useDistributorBalanceAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributorBalanceAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributorBalanceAccountQuery({
 *   variables: {
 *      businessEntityId: // value for 'businessEntityId'
 *   },
 * });
 */
export function useDistributorBalanceAccountQuery(baseOptions: Apollo.QueryHookOptions<DistributorBalanceAccountQuery, DistributorBalanceAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DistributorBalanceAccountQuery, DistributorBalanceAccountQueryVariables>(DistributorBalanceAccountDocument, options);
      }
export function useDistributorBalanceAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DistributorBalanceAccountQuery, DistributorBalanceAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DistributorBalanceAccountQuery, DistributorBalanceAccountQueryVariables>(DistributorBalanceAccountDocument, options);
        }
export type DistributorBalanceAccountQueryHookResult = ReturnType<typeof useDistributorBalanceAccountQuery>;
export type DistributorBalanceAccountLazyQueryHookResult = ReturnType<typeof useDistributorBalanceAccountLazyQuery>;
export type DistributorBalanceAccountQueryResult = Apollo.QueryResult<DistributorBalanceAccountQuery, DistributorBalanceAccountQueryVariables>;
export const DistributorTransactionsDocument = gql`
    query DistributorTransactions($businessId: Int!) {
  business(id: $businessId) {
    id
    fundsTransfers {
      ...DistributorFundsTransferFields
    }
  }
}
    ${DistributorFundsTransferFieldsFragmentDoc}`;

/**
 * __useDistributorTransactionsQuery__
 *
 * To run a query within a React component, call `useDistributorTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributorTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributorTransactionsQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useDistributorTransactionsQuery(baseOptions: Apollo.QueryHookOptions<DistributorTransactionsQuery, DistributorTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DistributorTransactionsQuery, DistributorTransactionsQueryVariables>(DistributorTransactionsDocument, options);
      }
export function useDistributorTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DistributorTransactionsQuery, DistributorTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DistributorTransactionsQuery, DistributorTransactionsQueryVariables>(DistributorTransactionsDocument, options);
        }
export type DistributorTransactionsQueryHookResult = ReturnType<typeof useDistributorTransactionsQuery>;
export type DistributorTransactionsLazyQueryHookResult = ReturnType<typeof useDistributorTransactionsLazyQuery>;
export type DistributorTransactionsQueryResult = Apollo.QueryResult<DistributorTransactionsQuery, DistributorTransactionsQueryVariables>;
export const BusinessActiveBankAccountsDocument = gql`
    query BusinessActiveBankAccounts($businessEntityId: Int!) {
  business(id: $businessEntityId) {
    id
    bankAccount {
      id
      name
      mask
      institutionName
      hasOnDemandAuthorization
      isVerified
      needsReverification
      business {
        id
      }
      plaidItem {
        id
        verificationStatus
      }
    }
  }
}
    `;

/**
 * __useBusinessActiveBankAccountsQuery__
 *
 * To run a query within a React component, call `useBusinessActiveBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessActiveBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessActiveBankAccountsQuery({
 *   variables: {
 *      businessEntityId: // value for 'businessEntityId'
 *   },
 * });
 */
export function useBusinessActiveBankAccountsQuery(baseOptions: Apollo.QueryHookOptions<BusinessActiveBankAccountsQuery, BusinessActiveBankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessActiveBankAccountsQuery, BusinessActiveBankAccountsQueryVariables>(BusinessActiveBankAccountsDocument, options);
      }
export function useBusinessActiveBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessActiveBankAccountsQuery, BusinessActiveBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessActiveBankAccountsQuery, BusinessActiveBankAccountsQueryVariables>(BusinessActiveBankAccountsDocument, options);
        }
export type BusinessActiveBankAccountsQueryHookResult = ReturnType<typeof useBusinessActiveBankAccountsQuery>;
export type BusinessActiveBankAccountsLazyQueryHookResult = ReturnType<typeof useBusinessActiveBankAccountsLazyQuery>;
export type BusinessActiveBankAccountsQueryResult = Apollo.QueryResult<BusinessActiveBankAccountsQuery, BusinessActiveBankAccountsQueryVariables>;
export const RemoveBankAccountDocument = gql`
    mutation RemoveBankAccount($id: Int!, $force: Boolean) {
  removeBankAccount(id: $id, force: $force) {
    id
    removedAt
    business {
      bankAccount {
        id
        removedAt
      }
    }
  }
}
    `;
export type RemoveBankAccountMutationFn = Apollo.MutationFunction<RemoveBankAccountMutation, RemoveBankAccountMutationVariables>;

/**
 * __useRemoveBankAccountMutation__
 *
 * To run a mutation, you first call `useRemoveBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBankAccountMutation, { data, loading, error }] = useRemoveBankAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useRemoveBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBankAccountMutation, RemoveBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBankAccountMutation, RemoveBankAccountMutationVariables>(RemoveBankAccountDocument, options);
      }
export type RemoveBankAccountMutationHookResult = ReturnType<typeof useRemoveBankAccountMutation>;
export type RemoveBankAccountMutationResult = Apollo.MutationResult<RemoveBankAccountMutation>;
export type RemoveBankAccountMutationOptions = Apollo.BaseMutationOptions<RemoveBankAccountMutation, RemoveBankAccountMutationVariables>;
export const OnboardingAuthorizeOnDemandTransfersDocument = gql`
    mutation OnboardingAuthorizeOnDemandTransfers($bankAccountId: Int!) {
  authorizeOnDemandTransfers(bankAccountId: $bankAccountId) {
    id
    hasOnDemandAuthorization
    business {
      id
      completedOnboardingAt
      onboarding {
        ...OnboardingFields
      }
    }
  }
}
    ${OnboardingFieldsFragmentDoc}`;
export type OnboardingAuthorizeOnDemandTransfersMutationFn = Apollo.MutationFunction<OnboardingAuthorizeOnDemandTransfersMutation, OnboardingAuthorizeOnDemandTransfersMutationVariables>;

/**
 * __useOnboardingAuthorizeOnDemandTransfersMutation__
 *
 * To run a mutation, you first call `useOnboardingAuthorizeOnDemandTransfersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingAuthorizeOnDemandTransfersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingAuthorizeOnDemandTransfersMutation, { data, loading, error }] = useOnboardingAuthorizeOnDemandTransfersMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *   },
 * });
 */
export function useOnboardingAuthorizeOnDemandTransfersMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingAuthorizeOnDemandTransfersMutation, OnboardingAuthorizeOnDemandTransfersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingAuthorizeOnDemandTransfersMutation, OnboardingAuthorizeOnDemandTransfersMutationVariables>(OnboardingAuthorizeOnDemandTransfersDocument, options);
      }
export type OnboardingAuthorizeOnDemandTransfersMutationHookResult = ReturnType<typeof useOnboardingAuthorizeOnDemandTransfersMutation>;
export type OnboardingAuthorizeOnDemandTransfersMutationResult = Apollo.MutationResult<OnboardingAuthorizeOnDemandTransfersMutation>;
export type OnboardingAuthorizeOnDemandTransfersMutationOptions = Apollo.BaseMutationOptions<OnboardingAuthorizeOnDemandTransfersMutation, OnboardingAuthorizeOnDemandTransfersMutationVariables>;
export const CertifyBeneficialOwnershipDocument = gql`
    mutation CertifyBeneficialOwnership($dwollaCustomerId: String!) {
  certifyBeneficialOwnership(dwollaCustomerId: $dwollaCustomerId) {
    id
    status
    createdAt
    beneficialOwnerCertificationStatus
    business {
      id
      completedOnboardingAt
      onboarding {
        ...OnboardingFields
      }
    }
  }
}
    ${OnboardingFieldsFragmentDoc}`;
export type CertifyBeneficialOwnershipMutationFn = Apollo.MutationFunction<CertifyBeneficialOwnershipMutation, CertifyBeneficialOwnershipMutationVariables>;

/**
 * __useCertifyBeneficialOwnershipMutation__
 *
 * To run a mutation, you first call `useCertifyBeneficialOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCertifyBeneficialOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [certifyBeneficialOwnershipMutation, { data, loading, error }] = useCertifyBeneficialOwnershipMutation({
 *   variables: {
 *      dwollaCustomerId: // value for 'dwollaCustomerId'
 *   },
 * });
 */
export function useCertifyBeneficialOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<CertifyBeneficialOwnershipMutation, CertifyBeneficialOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CertifyBeneficialOwnershipMutation, CertifyBeneficialOwnershipMutationVariables>(CertifyBeneficialOwnershipDocument, options);
      }
export type CertifyBeneficialOwnershipMutationHookResult = ReturnType<typeof useCertifyBeneficialOwnershipMutation>;
export type CertifyBeneficialOwnershipMutationResult = Apollo.MutationResult<CertifyBeneficialOwnershipMutation>;
export type CertifyBeneficialOwnershipMutationOptions = Apollo.BaseMutationOptions<CertifyBeneficialOwnershipMutation, CertifyBeneficialOwnershipMutationVariables>;
export const OnboardingSyncDwollaCustomerDocument = gql`
    mutation OnboardingSyncDwollaCustomer($dwollaCustomerId: String!) {
  syncDwollaCustomer(dwollaCustomerId: $dwollaCustomerId) {
    id
    business {
      id
      onboarding {
        ...OnboardingFields
      }
    }
  }
}
    ${OnboardingFieldsFragmentDoc}`;
export type OnboardingSyncDwollaCustomerMutationFn = Apollo.MutationFunction<OnboardingSyncDwollaCustomerMutation, OnboardingSyncDwollaCustomerMutationVariables>;

/**
 * __useOnboardingSyncDwollaCustomerMutation__
 *
 * To run a mutation, you first call `useOnboardingSyncDwollaCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingSyncDwollaCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingSyncDwollaCustomerMutation, { data, loading, error }] = useOnboardingSyncDwollaCustomerMutation({
 *   variables: {
 *      dwollaCustomerId: // value for 'dwollaCustomerId'
 *   },
 * });
 */
export function useOnboardingSyncDwollaCustomerMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingSyncDwollaCustomerMutation, OnboardingSyncDwollaCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingSyncDwollaCustomerMutation, OnboardingSyncDwollaCustomerMutationVariables>(OnboardingSyncDwollaCustomerDocument, options);
      }
export type OnboardingSyncDwollaCustomerMutationHookResult = ReturnType<typeof useOnboardingSyncDwollaCustomerMutation>;
export type OnboardingSyncDwollaCustomerMutationResult = Apollo.MutationResult<OnboardingSyncDwollaCustomerMutation>;
export type OnboardingSyncDwollaCustomerMutationOptions = Apollo.BaseMutationOptions<OnboardingSyncDwollaCustomerMutation, OnboardingSyncDwollaCustomerMutationVariables>;
export const SkipBeneficialOwnerStepDocument = gql`
    mutation SkipBeneficialOwnerStep($businessId: Int!) {
  skipBeneficialOwnersStep(businessId: $businessId) {
    id
  }
}
    `;
export type SkipBeneficialOwnerStepMutationFn = Apollo.MutationFunction<SkipBeneficialOwnerStepMutation, SkipBeneficialOwnerStepMutationVariables>;

/**
 * __useSkipBeneficialOwnerStepMutation__
 *
 * To run a mutation, you first call `useSkipBeneficialOwnerStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipBeneficialOwnerStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipBeneficialOwnerStepMutation, { data, loading, error }] = useSkipBeneficialOwnerStepMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useSkipBeneficialOwnerStepMutation(baseOptions?: Apollo.MutationHookOptions<SkipBeneficialOwnerStepMutation, SkipBeneficialOwnerStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipBeneficialOwnerStepMutation, SkipBeneficialOwnerStepMutationVariables>(SkipBeneficialOwnerStepDocument, options);
      }
export type SkipBeneficialOwnerStepMutationHookResult = ReturnType<typeof useSkipBeneficialOwnerStepMutation>;
export type SkipBeneficialOwnerStepMutationResult = Apollo.MutationResult<SkipBeneficialOwnerStepMutation>;
export type SkipBeneficialOwnerStepMutationOptions = Apollo.BaseMutationOptions<SkipBeneficialOwnerStepMutation, SkipBeneficialOwnerStepMutationVariables>;
export const ResetSkipBeneficialOwnersStepDocument = gql`
    mutation ResetSkipBeneficialOwnersStep($businessId: Int!) {
  resetSkipBeneficialOwnersStep(businessId: $businessId) {
    id
  }
}
    `;
export type ResetSkipBeneficialOwnersStepMutationFn = Apollo.MutationFunction<ResetSkipBeneficialOwnersStepMutation, ResetSkipBeneficialOwnersStepMutationVariables>;

/**
 * __useResetSkipBeneficialOwnersStepMutation__
 *
 * To run a mutation, you first call `useResetSkipBeneficialOwnersStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSkipBeneficialOwnersStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSkipBeneficialOwnersStepMutation, { data, loading, error }] = useResetSkipBeneficialOwnersStepMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useResetSkipBeneficialOwnersStepMutation(baseOptions?: Apollo.MutationHookOptions<ResetSkipBeneficialOwnersStepMutation, ResetSkipBeneficialOwnersStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetSkipBeneficialOwnersStepMutation, ResetSkipBeneficialOwnersStepMutationVariables>(ResetSkipBeneficialOwnersStepDocument, options);
      }
export type ResetSkipBeneficialOwnersStepMutationHookResult = ReturnType<typeof useResetSkipBeneficialOwnersStepMutation>;
export type ResetSkipBeneficialOwnersStepMutationResult = Apollo.MutationResult<ResetSkipBeneficialOwnersStepMutation>;
export type ResetSkipBeneficialOwnersStepMutationOptions = Apollo.BaseMutationOptions<ResetSkipBeneficialOwnersStepMutation, ResetSkipBeneficialOwnersStepMutationVariables>;
export const OnboardingDocument = gql`
    query Onboarding($id: Int!) {
  business(id: $id) {
    id
    completedOnboardingAt
    organizationId
    businessType
    onboarding {
      ...OnboardingFields
    }
  }
}
    ${OnboardingFieldsFragmentDoc}`;

/**
 * __useOnboardingQuery__
 *
 * To run a query within a React component, call `useOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnboardingQuery(baseOptions: Apollo.QueryHookOptions<OnboardingQuery, OnboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingQuery, OnboardingQueryVariables>(OnboardingDocument, options);
      }
export function useOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingQuery, OnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingQuery, OnboardingQueryVariables>(OnboardingDocument, options);
        }
export type OnboardingQueryHookResult = ReturnType<typeof useOnboardingQuery>;
export type OnboardingLazyQueryHookResult = ReturnType<typeof useOnboardingLazyQuery>;
export type OnboardingQueryResult = Apollo.QueryResult<OnboardingQuery, OnboardingQueryVariables>;
export const CompleteOnboardingDocument = gql`
    mutation CompleteOnboarding($businessEntityId: Int!) {
  completeOnboarding(id: $businessEntityId) {
    id
    completedOnboardingAt
    organizationId
  }
}
    `;
export type CompleteOnboardingMutationFn = Apollo.MutationFunction<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>;

/**
 * __useCompleteOnboardingMutation__
 *
 * To run a mutation, you first call `useCompleteOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOnboardingMutation, { data, loading, error }] = useCompleteOnboardingMutation({
 *   variables: {
 *      businessEntityId: // value for 'businessEntityId'
 *   },
 * });
 */
export function useCompleteOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>(CompleteOnboardingDocument, options);
      }
export type CompleteOnboardingMutationHookResult = ReturnType<typeof useCompleteOnboardingMutation>;
export type CompleteOnboardingMutationResult = Apollo.MutationResult<CompleteOnboardingMutation>;
export type CompleteOnboardingMutationOptions = Apollo.BaseMutationOptions<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>;
export const ProducerDashboardDataDocument = gql`
    query ProducerDashboardData($producerId: Int!) {
  producerPreSaleUnitsSold(producerId: $producerId) {
    date
    producer
    friendlyName
    units
  }
}
    `;

/**
 * __useProducerDashboardDataQuery__
 *
 * To run a query within a React component, call `useProducerDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerDashboardDataQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useProducerDashboardDataQuery(baseOptions: Apollo.QueryHookOptions<ProducerDashboardDataQuery, ProducerDashboardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerDashboardDataQuery, ProducerDashboardDataQueryVariables>(ProducerDashboardDataDocument, options);
      }
export function useProducerDashboardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerDashboardDataQuery, ProducerDashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerDashboardDataQuery, ProducerDashboardDataQueryVariables>(ProducerDashboardDataDocument, options);
        }
export type ProducerDashboardDataQueryHookResult = ReturnType<typeof useProducerDashboardDataQuery>;
export type ProducerDashboardDataLazyQueryHookResult = ReturnType<typeof useProducerDashboardDataLazyQuery>;
export type ProducerDashboardDataQueryResult = Apollo.QueryResult<ProducerDashboardDataQuery, ProducerDashboardDataQueryVariables>;
export const ProducerPreSaleUnitsSoldDocument = gql`
    query ProducerPreSaleUnitsSold($producerId: Int!) {
  producerPreSaleUnitsSold(producerId: $producerId) {
    date
    producer
    friendlyName
    units
  }
}
    `;

/**
 * __useProducerPreSaleUnitsSoldQuery__
 *
 * To run a query within a React component, call `useProducerPreSaleUnitsSoldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerPreSaleUnitsSoldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerPreSaleUnitsSoldQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useProducerPreSaleUnitsSoldQuery(baseOptions: Apollo.QueryHookOptions<ProducerPreSaleUnitsSoldQuery, ProducerPreSaleUnitsSoldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerPreSaleUnitsSoldQuery, ProducerPreSaleUnitsSoldQueryVariables>(ProducerPreSaleUnitsSoldDocument, options);
      }
export function useProducerPreSaleUnitsSoldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerPreSaleUnitsSoldQuery, ProducerPreSaleUnitsSoldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerPreSaleUnitsSoldQuery, ProducerPreSaleUnitsSoldQueryVariables>(ProducerPreSaleUnitsSoldDocument, options);
        }
export type ProducerPreSaleUnitsSoldQueryHookResult = ReturnType<typeof useProducerPreSaleUnitsSoldQuery>;
export type ProducerPreSaleUnitsSoldLazyQueryHookResult = ReturnType<typeof useProducerPreSaleUnitsSoldLazyQuery>;
export type ProducerPreSaleUnitsSoldQueryResult = Apollo.QueryResult<ProducerPreSaleUnitsSoldQuery, ProducerPreSaleUnitsSoldQueryVariables>;
export const PaginatedProducerSalesByRegionDocument = gql`
    query PaginatedProducerSalesByRegion($pagination: OffsetPaginationInput!, $filters: ProducerSalesByRegionFilters!) {
  paginatedProducerSalesByRegion(pagination: $pagination, filters: $filters) {
    results {
      ...ProducerSalesByRegion
    }
    total
  }
}
    ${ProducerSalesByRegionFragmentDoc}`;

/**
 * __usePaginatedProducerSalesByRegionQuery__
 *
 * To run a query within a React component, call `usePaginatedProducerSalesByRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedProducerSalesByRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedProducerSalesByRegionQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePaginatedProducerSalesByRegionQuery(baseOptions: Apollo.QueryHookOptions<PaginatedProducerSalesByRegionQuery, PaginatedProducerSalesByRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedProducerSalesByRegionQuery, PaginatedProducerSalesByRegionQueryVariables>(PaginatedProducerSalesByRegionDocument, options);
      }
export function usePaginatedProducerSalesByRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedProducerSalesByRegionQuery, PaginatedProducerSalesByRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedProducerSalesByRegionQuery, PaginatedProducerSalesByRegionQueryVariables>(PaginatedProducerSalesByRegionDocument, options);
        }
export type PaginatedProducerSalesByRegionQueryHookResult = ReturnType<typeof usePaginatedProducerSalesByRegionQuery>;
export type PaginatedProducerSalesByRegionLazyQueryHookResult = ReturnType<typeof usePaginatedProducerSalesByRegionLazyQuery>;
export type PaginatedProducerSalesByRegionQueryResult = Apollo.QueryResult<PaginatedProducerSalesByRegionQuery, PaginatedProducerSalesByRegionQueryVariables>;
export const ProducerSalesOrderUnitsFulfilledDocument = gql`
    query ProducerSalesOrderUnitsFulfilled($producerId: Int!) {
  producerSalesOrderUnitsFulfilled(producerId: $producerId) {
    date
    producer
    friendlyName
    units
  }
}
    `;

/**
 * __useProducerSalesOrderUnitsFulfilledQuery__
 *
 * To run a query within a React component, call `useProducerSalesOrderUnitsFulfilledQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerSalesOrderUnitsFulfilledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerSalesOrderUnitsFulfilledQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useProducerSalesOrderUnitsFulfilledQuery(baseOptions: Apollo.QueryHookOptions<ProducerSalesOrderUnitsFulfilledQuery, ProducerSalesOrderUnitsFulfilledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerSalesOrderUnitsFulfilledQuery, ProducerSalesOrderUnitsFulfilledQueryVariables>(ProducerSalesOrderUnitsFulfilledDocument, options);
      }
export function useProducerSalesOrderUnitsFulfilledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerSalesOrderUnitsFulfilledQuery, ProducerSalesOrderUnitsFulfilledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerSalesOrderUnitsFulfilledQuery, ProducerSalesOrderUnitsFulfilledQueryVariables>(ProducerSalesOrderUnitsFulfilledDocument, options);
        }
export type ProducerSalesOrderUnitsFulfilledQueryHookResult = ReturnType<typeof useProducerSalesOrderUnitsFulfilledQuery>;
export type ProducerSalesOrderUnitsFulfilledLazyQueryHookResult = ReturnType<typeof useProducerSalesOrderUnitsFulfilledLazyQuery>;
export type ProducerSalesOrderUnitsFulfilledQueryResult = Apollo.QueryResult<ProducerSalesOrderUnitsFulfilledQuery, ProducerSalesOrderUnitsFulfilledQueryVariables>;
export const ProducerLicensesDocument = gql`
    query ProducerLicenses($producerId: Int!) {
  producer(id: $producerId) {
    licenses {
      ...ProducerLicenseFields
    }
  }
}
    ${ProducerLicenseFieldsFragmentDoc}`;

/**
 * __useProducerLicensesQuery__
 *
 * To run a query within a React component, call `useProducerLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerLicensesQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useProducerLicensesQuery(baseOptions: Apollo.QueryHookOptions<ProducerLicensesQuery, ProducerLicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerLicensesQuery, ProducerLicensesQueryVariables>(ProducerLicensesDocument, options);
      }
export function useProducerLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerLicensesQuery, ProducerLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerLicensesQuery, ProducerLicensesQueryVariables>(ProducerLicensesDocument, options);
        }
export type ProducerLicensesQueryHookResult = ReturnType<typeof useProducerLicensesQuery>;
export type ProducerLicensesLazyQueryHookResult = ReturnType<typeof useProducerLicensesLazyQuery>;
export type ProducerLicensesQueryResult = Apollo.QueryResult<ProducerLicensesQuery, ProducerLicensesQueryVariables>;
export const ProducerOfferSearchDocument = gql`
    query ProducerOfferSearch($pagination: OffsetPaginationInput!, $filters: OfferSearchFilters) {
  searchOffers(pagination: $pagination, filters: $filters) {
    total
    results {
      ...ProducerOfferTableData
    }
  }
}
    ${ProducerOfferTableDataFragmentDoc}`;

/**
 * __useProducerOfferSearchQuery__
 *
 * To run a query within a React component, call `useProducerOfferSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerOfferSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerOfferSearchQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProducerOfferSearchQuery(baseOptions: Apollo.QueryHookOptions<ProducerOfferSearchQuery, ProducerOfferSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerOfferSearchQuery, ProducerOfferSearchQueryVariables>(ProducerOfferSearchDocument, options);
      }
export function useProducerOfferSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerOfferSearchQuery, ProducerOfferSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerOfferSearchQuery, ProducerOfferSearchQueryVariables>(ProducerOfferSearchDocument, options);
        }
export type ProducerOfferSearchQueryHookResult = ReturnType<typeof useProducerOfferSearchQuery>;
export type ProducerOfferSearchLazyQueryHookResult = ReturnType<typeof useProducerOfferSearchLazyQuery>;
export type ProducerOfferSearchQueryResult = Apollo.QueryResult<ProducerOfferSearchQuery, ProducerOfferSearchQueryVariables>;
export const ProducerPurchaseOrderDocumentsDocument = gql`
    query ProducerPurchaseOrderDocuments($orderId: Int!) {
  order(id: $orderId) {
    id
    ...ProducerPurchaseOrderSummary
    documents {
      ...OrderDocumentSummary
    }
  }
}
    ${ProducerPurchaseOrderSummaryFragmentDoc}
${OrderDocumentSummaryFragmentDoc}`;

/**
 * __useProducerPurchaseOrderDocumentsQuery__
 *
 * To run a query within a React component, call `useProducerPurchaseOrderDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerPurchaseOrderDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerPurchaseOrderDocumentsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useProducerPurchaseOrderDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ProducerPurchaseOrderDocumentsQuery, ProducerPurchaseOrderDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerPurchaseOrderDocumentsQuery, ProducerPurchaseOrderDocumentsQueryVariables>(ProducerPurchaseOrderDocumentsDocument, options);
      }
export function useProducerPurchaseOrderDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerPurchaseOrderDocumentsQuery, ProducerPurchaseOrderDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerPurchaseOrderDocumentsQuery, ProducerPurchaseOrderDocumentsQueryVariables>(ProducerPurchaseOrderDocumentsDocument, options);
        }
export type ProducerPurchaseOrderDocumentsQueryHookResult = ReturnType<typeof useProducerPurchaseOrderDocumentsQuery>;
export type ProducerPurchaseOrderDocumentsLazyQueryHookResult = ReturnType<typeof useProducerPurchaseOrderDocumentsLazyQuery>;
export type ProducerPurchaseOrderDocumentsQueryResult = Apollo.QueryResult<ProducerPurchaseOrderDocumentsQuery, ProducerPurchaseOrderDocumentsQueryVariables>;
export const ProducerPurchaseOrderItemsDocument = gql`
    query ProducerPurchaseOrderItems($orderId: Int!) {
  order(id: $orderId) {
    id
    number
    ...ProducerPurchaseOrderItemsData
  }
}
    ${ProducerPurchaseOrderItemsDataFragmentDoc}`;

/**
 * __useProducerPurchaseOrderItemsQuery__
 *
 * To run a query within a React component, call `useProducerPurchaseOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerPurchaseOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerPurchaseOrderItemsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useProducerPurchaseOrderItemsQuery(baseOptions: Apollo.QueryHookOptions<ProducerPurchaseOrderItemsQuery, ProducerPurchaseOrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerPurchaseOrderItemsQuery, ProducerPurchaseOrderItemsQueryVariables>(ProducerPurchaseOrderItemsDocument, options);
      }
export function useProducerPurchaseOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerPurchaseOrderItemsQuery, ProducerPurchaseOrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerPurchaseOrderItemsQuery, ProducerPurchaseOrderItemsQueryVariables>(ProducerPurchaseOrderItemsDocument, options);
        }
export type ProducerPurchaseOrderItemsQueryHookResult = ReturnType<typeof useProducerPurchaseOrderItemsQuery>;
export type ProducerPurchaseOrderItemsLazyQueryHookResult = ReturnType<typeof useProducerPurchaseOrderItemsLazyQuery>;
export type ProducerPurchaseOrderItemsQueryResult = Apollo.QueryResult<ProducerPurchaseOrderItemsQuery, ProducerPurchaseOrderItemsQueryVariables>;
export const ProducerPurchaseOrderOverviewDocument = gql`
    query ProducerPurchaseOrderOverview($orderId: Int!) {
  order(id: $orderId) {
    id
    ...ProducerPurchaseOrderSummary
  }
}
    ${ProducerPurchaseOrderSummaryFragmentDoc}`;

/**
 * __useProducerPurchaseOrderOverviewQuery__
 *
 * To run a query within a React component, call `useProducerPurchaseOrderOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerPurchaseOrderOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerPurchaseOrderOverviewQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useProducerPurchaseOrderOverviewQuery(baseOptions: Apollo.QueryHookOptions<ProducerPurchaseOrderOverviewQuery, ProducerPurchaseOrderOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerPurchaseOrderOverviewQuery, ProducerPurchaseOrderOverviewQueryVariables>(ProducerPurchaseOrderOverviewDocument, options);
      }
export function useProducerPurchaseOrderOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerPurchaseOrderOverviewQuery, ProducerPurchaseOrderOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerPurchaseOrderOverviewQuery, ProducerPurchaseOrderOverviewQueryVariables>(ProducerPurchaseOrderOverviewDocument, options);
        }
export type ProducerPurchaseOrderOverviewQueryHookResult = ReturnType<typeof useProducerPurchaseOrderOverviewQuery>;
export type ProducerPurchaseOrderOverviewLazyQueryHookResult = ReturnType<typeof useProducerPurchaseOrderOverviewLazyQuery>;
export type ProducerPurchaseOrderOverviewQueryResult = Apollo.QueryResult<ProducerPurchaseOrderOverviewQuery, ProducerPurchaseOrderOverviewQueryVariables>;
export const ProducerPurchaseOrderShippingDocument = gql`
    query ProducerPurchaseOrderShipping($orderId: Int!) {
  order(id: $orderId) {
    id
    number
    enabledFeatures {
      canCreatePDF
    }
    seller {
      id
      address {
        ...Address
      }
    }
    shippingAddress {
      ...Address
    }
    trackingInformation {
      ...TrackingInformationDetails
    }
    packageSummary {
      ...AdminPackageSummaryTableData
    }
  }
}
    ${AddressFragmentDoc}
${TrackingInformationDetailsFragmentDoc}
${AdminPackageSummaryTableDataFragmentDoc}`;

/**
 * __useProducerPurchaseOrderShippingQuery__
 *
 * To run a query within a React component, call `useProducerPurchaseOrderShippingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerPurchaseOrderShippingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerPurchaseOrderShippingQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useProducerPurchaseOrderShippingQuery(baseOptions: Apollo.QueryHookOptions<ProducerPurchaseOrderShippingQuery, ProducerPurchaseOrderShippingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerPurchaseOrderShippingQuery, ProducerPurchaseOrderShippingQueryVariables>(ProducerPurchaseOrderShippingDocument, options);
      }
export function useProducerPurchaseOrderShippingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerPurchaseOrderShippingQuery, ProducerPurchaseOrderShippingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerPurchaseOrderShippingQuery, ProducerPurchaseOrderShippingQueryVariables>(ProducerPurchaseOrderShippingDocument, options);
        }
export type ProducerPurchaseOrderShippingQueryHookResult = ReturnType<typeof useProducerPurchaseOrderShippingQuery>;
export type ProducerPurchaseOrderShippingLazyQueryHookResult = ReturnType<typeof useProducerPurchaseOrderShippingLazyQuery>;
export type ProducerPurchaseOrderShippingQueryResult = Apollo.QueryResult<ProducerPurchaseOrderShippingQuery, ProducerPurchaseOrderShippingQueryVariables>;
export const ProducerPurchaseOrdersDocument = gql`
    query ProducerPurchaseOrders($id: Int!, $filters: ProducerPurchaseOrdersFilterInput!, $sort: ProducerPurchaseOrdersSortInput!, $pagination: OffsetPaginationInput!) {
  producer(id: $id) {
    id
    organizationId
    purchaseOrders(filters: $filters, sort: $sort, pagination: $pagination) {
      results {
        ...ProducerPurchaseOrderTableRow
      }
      total
    }
  }
}
    ${ProducerPurchaseOrderTableRowFragmentDoc}`;

/**
 * __useProducerPurchaseOrdersQuery__
 *
 * To run a query within a React component, call `useProducerPurchaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerPurchaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerPurchaseOrdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useProducerPurchaseOrdersQuery(baseOptions: Apollo.QueryHookOptions<ProducerPurchaseOrdersQuery, ProducerPurchaseOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerPurchaseOrdersQuery, ProducerPurchaseOrdersQueryVariables>(ProducerPurchaseOrdersDocument, options);
      }
export function useProducerPurchaseOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerPurchaseOrdersQuery, ProducerPurchaseOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerPurchaseOrdersQuery, ProducerPurchaseOrdersQueryVariables>(ProducerPurchaseOrdersDocument, options);
        }
export type ProducerPurchaseOrdersQueryHookResult = ReturnType<typeof useProducerPurchaseOrdersQuery>;
export type ProducerPurchaseOrdersLazyQueryHookResult = ReturnType<typeof useProducerPurchaseOrdersLazyQuery>;
export type ProducerPurchaseOrdersQueryResult = Apollo.QueryResult<ProducerPurchaseOrdersQuery, ProducerPurchaseOrdersQueryVariables>;
export const ProducerBalanceAccountDocument = gql`
    query ProducerBalanceAccount($businessEntityId: Int!) {
  business(id: $businessEntityId) {
    id
    balanceAccount {
      id
      balance
    }
  }
}
    `;

/**
 * __useProducerBalanceAccountQuery__
 *
 * To run a query within a React component, call `useProducerBalanceAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerBalanceAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerBalanceAccountQuery({
 *   variables: {
 *      businessEntityId: // value for 'businessEntityId'
 *   },
 * });
 */
export function useProducerBalanceAccountQuery(baseOptions: Apollo.QueryHookOptions<ProducerBalanceAccountQuery, ProducerBalanceAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerBalanceAccountQuery, ProducerBalanceAccountQueryVariables>(ProducerBalanceAccountDocument, options);
      }
export function useProducerBalanceAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerBalanceAccountQuery, ProducerBalanceAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerBalanceAccountQuery, ProducerBalanceAccountQueryVariables>(ProducerBalanceAccountDocument, options);
        }
export type ProducerBalanceAccountQueryHookResult = ReturnType<typeof useProducerBalanceAccountQuery>;
export type ProducerBalanceAccountLazyQueryHookResult = ReturnType<typeof useProducerBalanceAccountLazyQuery>;
export type ProducerBalanceAccountQueryResult = Apollo.QueryResult<ProducerBalanceAccountQuery, ProducerBalanceAccountQueryVariables>;
export const ProducerTransactionsDocument = gql`
    query ProducerTransactions($businessId: Int!) {
  business(id: $businessId) {
    id
    fundsTransfers {
      ...ProducerFundsTransferFields
    }
  }
}
    ${ProducerFundsTransferFieldsFragmentDoc}`;

/**
 * __useProducerTransactionsQuery__
 *
 * To run a query within a React component, call `useProducerTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerTransactionsQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useProducerTransactionsQuery(baseOptions: Apollo.QueryHookOptions<ProducerTransactionsQuery, ProducerTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerTransactionsQuery, ProducerTransactionsQueryVariables>(ProducerTransactionsDocument, options);
      }
export function useProducerTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerTransactionsQuery, ProducerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerTransactionsQuery, ProducerTransactionsQueryVariables>(ProducerTransactionsDocument, options);
        }
export type ProducerTransactionsQueryHookResult = ReturnType<typeof useProducerTransactionsQuery>;
export type ProducerTransactionsLazyQueryHookResult = ReturnType<typeof useProducerTransactionsLazyQuery>;
export type ProducerTransactionsQueryResult = Apollo.QueryResult<ProducerTransactionsQuery, ProducerTransactionsQueryVariables>;
export const RegisterRetailerDocument = gql`
    mutation RegisterRetailer($data: RegisterRetailerOrganizationData!) {
  registerRetailerOrganization(data: $data) {
    id
    businessType
  }
}
    `;
export type RegisterRetailerMutationFn = Apollo.MutationFunction<RegisterRetailerMutation, RegisterRetailerMutationVariables>;

/**
 * __useRegisterRetailerMutation__
 *
 * To run a mutation, you first call `useRegisterRetailerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterRetailerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerRetailerMutation, { data, loading, error }] = useRegisterRetailerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRegisterRetailerMutation(baseOptions?: Apollo.MutationHookOptions<RegisterRetailerMutation, RegisterRetailerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterRetailerMutation, RegisterRetailerMutationVariables>(RegisterRetailerDocument, options);
      }
export type RegisterRetailerMutationHookResult = ReturnType<typeof useRegisterRetailerMutation>;
export type RegisterRetailerMutationResult = Apollo.MutationResult<RegisterRetailerMutation>;
export type RegisterRetailerMutationOptions = Apollo.BaseMutationOptions<RegisterRetailerMutation, RegisterRetailerMutationVariables>;
export const RetailerAppRootDocument = gql`
    query RetailerAppRoot($organizationId: Int!) {
  organization(id: $organizationId) {
    id
    name
    locations {
      id
      name
    }
  }
}
    `;

/**
 * __useRetailerAppRootQuery__
 *
 * To run a query within a React component, call `useRetailerAppRootQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerAppRootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerAppRootQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRetailerAppRootQuery(baseOptions: Apollo.QueryHookOptions<RetailerAppRootQuery, RetailerAppRootQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerAppRootQuery, RetailerAppRootQueryVariables>(RetailerAppRootDocument, options);
      }
export function useRetailerAppRootLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerAppRootQuery, RetailerAppRootQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerAppRootQuery, RetailerAppRootQueryVariables>(RetailerAppRootDocument, options);
        }
export type RetailerAppRootQueryHookResult = ReturnType<typeof useRetailerAppRootQuery>;
export type RetailerAppRootLazyQueryHookResult = ReturnType<typeof useRetailerAppRootLazyQuery>;
export type RetailerAppRootQueryResult = Apollo.QueryResult<RetailerAppRootQuery, RetailerAppRootQueryVariables>;
export const StorePreSaleOrderDocument = gql`
    query StorePreSaleOrder($orderId: Int!) {
  preSaleOrder(id: $orderId) {
    id
    number
    placedOn
    amountInCents
    cancelledAt
    cancelledTotal
    estimatedFulfillmentTotal
    shippingAddress {
      ...Address
    }
    items {
      ...StorePreSaleOrderItem
    }
    cancelledItems {
      ...StorePreSaleOrderCancelledItem
    }
  }
}
    ${AddressFragmentDoc}
${StorePreSaleOrderItemFragmentDoc}
${StorePreSaleOrderCancelledItemFragmentDoc}`;

/**
 * __useStorePreSaleOrderQuery__
 *
 * To run a query within a React component, call `useStorePreSaleOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorePreSaleOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorePreSaleOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useStorePreSaleOrderQuery(baseOptions: Apollo.QueryHookOptions<StorePreSaleOrderQuery, StorePreSaleOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorePreSaleOrderQuery, StorePreSaleOrderQueryVariables>(StorePreSaleOrderDocument, options);
      }
export function useStorePreSaleOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorePreSaleOrderQuery, StorePreSaleOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorePreSaleOrderQuery, StorePreSaleOrderQueryVariables>(StorePreSaleOrderDocument, options);
        }
export type StorePreSaleOrderQueryHookResult = ReturnType<typeof useStorePreSaleOrderQuery>;
export type StorePreSaleOrderLazyQueryHookResult = ReturnType<typeof useStorePreSaleOrderLazyQuery>;
export type StorePreSaleOrderQueryResult = Apollo.QueryResult<StorePreSaleOrderQuery, StorePreSaleOrderQueryVariables>;
export const StorePreSaleOrdersDocument = gql`
    query StorePreSaleOrders($storeId: Int!, $pagination: OffsetPaginationInput!) {
  retailer(id: $storeId) {
    id
    name
    preSaleOrders(pagination: $pagination) {
      total
      results {
        ...StorePreSaleOrderSummary
      }
    }
  }
}
    ${StorePreSaleOrderSummaryFragmentDoc}`;

/**
 * __useStorePreSaleOrdersQuery__
 *
 * To run a query within a React component, call `useStorePreSaleOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorePreSaleOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorePreSaleOrdersQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useStorePreSaleOrdersQuery(baseOptions: Apollo.QueryHookOptions<StorePreSaleOrdersQuery, StorePreSaleOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorePreSaleOrdersQuery, StorePreSaleOrdersQueryVariables>(StorePreSaleOrdersDocument, options);
      }
export function useStorePreSaleOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorePreSaleOrdersQuery, StorePreSaleOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorePreSaleOrdersQuery, StorePreSaleOrdersQueryVariables>(StorePreSaleOrdersDocument, options);
        }
export type StorePreSaleOrdersQueryHookResult = ReturnType<typeof useStorePreSaleOrdersQuery>;
export type StorePreSaleOrdersLazyQueryHookResult = ReturnType<typeof useStorePreSaleOrdersLazyQuery>;
export type StorePreSaleOrdersQueryResult = Apollo.QueryResult<StorePreSaleOrdersQuery, StorePreSaleOrdersQueryVariables>;
export const StoreRouterDocument = gql`
    query StoreRouter($storeId: Int!) {
  retailer(id: $storeId) {
    id
    name
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useStoreRouterQuery__
 *
 * To run a query within a React component, call `useStoreRouterQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreRouterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreRouterQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useStoreRouterQuery(baseOptions: Apollo.QueryHookOptions<StoreRouterQuery, StoreRouterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreRouterQuery, StoreRouterQueryVariables>(StoreRouterDocument, options);
      }
export function useStoreRouterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreRouterQuery, StoreRouterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreRouterQuery, StoreRouterQueryVariables>(StoreRouterDocument, options);
        }
export type StoreRouterQueryHookResult = ReturnType<typeof useStoreRouterQuery>;
export type StoreRouterLazyQueryHookResult = ReturnType<typeof useStoreRouterLazyQuery>;
export type StoreRouterQueryResult = Apollo.QueryResult<StoreRouterQuery, StoreRouterQueryVariables>;
export const StoreSalesOrderDocument = gql`
    query StoreSalesOrder($orderId: Int!) {
  retailerSalesOrder(id: $orderId) {
    id
    number
    placedOn
    cancelledAt
    amountInCents
    adjustmentTotalInCents
    finalOrderTotalInCents
    ...StoreSalesOrderPaymentBalances
    shippingAddress {
      ...Address
    }
    items {
      ...StoreSalesOrderItem
    }
  }
}
    ${StoreSalesOrderPaymentBalancesFragmentDoc}
${AddressFragmentDoc}
${StoreSalesOrderItemFragmentDoc}`;

/**
 * __useStoreSalesOrderQuery__
 *
 * To run a query within a React component, call `useStoreSalesOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreSalesOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreSalesOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useStoreSalesOrderQuery(baseOptions: Apollo.QueryHookOptions<StoreSalesOrderQuery, StoreSalesOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreSalesOrderQuery, StoreSalesOrderQueryVariables>(StoreSalesOrderDocument, options);
      }
export function useStoreSalesOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreSalesOrderQuery, StoreSalesOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreSalesOrderQuery, StoreSalesOrderQueryVariables>(StoreSalesOrderDocument, options);
        }
export type StoreSalesOrderQueryHookResult = ReturnType<typeof useStoreSalesOrderQuery>;
export type StoreSalesOrderLazyQueryHookResult = ReturnType<typeof useStoreSalesOrderLazyQuery>;
export type StoreSalesOrderQueryResult = Apollo.QueryResult<StoreSalesOrderQuery, StoreSalesOrderQueryVariables>;
export const StoreSalesOrdersDocument = gql`
    query StoreSalesOrders($storeId: Int!, $pagination: OffsetPaginationInput!) {
  retailer(id: $storeId) {
    id
    name
    salesOrders(pagination: $pagination) {
      total
      results {
        ...StoreSalesOrderSummary
      }
    }
  }
}
    ${StoreSalesOrderSummaryFragmentDoc}`;

/**
 * __useStoreSalesOrdersQuery__
 *
 * To run a query within a React component, call `useStoreSalesOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreSalesOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreSalesOrdersQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useStoreSalesOrdersQuery(baseOptions: Apollo.QueryHookOptions<StoreSalesOrdersQuery, StoreSalesOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreSalesOrdersQuery, StoreSalesOrdersQueryVariables>(StoreSalesOrdersDocument, options);
      }
export function useStoreSalesOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreSalesOrdersQuery, StoreSalesOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreSalesOrdersQuery, StoreSalesOrdersQueryVariables>(StoreSalesOrdersDocument, options);
        }
export type StoreSalesOrdersQueryHookResult = ReturnType<typeof useStoreSalesOrdersQuery>;
export type StoreSalesOrdersLazyQueryHookResult = ReturnType<typeof useStoreSalesOrdersLazyQuery>;
export type StoreSalesOrdersQueryResult = Apollo.QueryResult<StoreSalesOrdersQuery, StoreSalesOrdersQueryVariables>;
export const StoreSettingsDocument = gql`
    query StoreSettings($storeId: Int!) {
  retailer(id: $storeId) {
    id
    name
    completedOnboardingAt
    dwollaCustomer {
      id
      email
      status
    }
    bankAccount {
      id
      mask
      institutionName
      name
      hasOnDemandAuthorization
      removedAt
      plaidItem {
        id
        verificationStatus
      }
      needsReverification
    }
  }
}
    `;

/**
 * __useStoreSettingsQuery__
 *
 * To run a query within a React component, call `useStoreSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreSettingsQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useStoreSettingsQuery(baseOptions: Apollo.QueryHookOptions<StoreSettingsQuery, StoreSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreSettingsQuery, StoreSettingsQueryVariables>(StoreSettingsDocument, options);
      }
export function useStoreSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreSettingsQuery, StoreSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreSettingsQuery, StoreSettingsQueryVariables>(StoreSettingsDocument, options);
        }
export type StoreSettingsQueryHookResult = ReturnType<typeof useStoreSettingsQuery>;
export type StoreSettingsLazyQueryHookResult = ReturnType<typeof useStoreSettingsLazyQuery>;
export type StoreSettingsQueryResult = Apollo.QueryResult<StoreSettingsQuery, StoreSettingsQueryVariables>;
export const StoresPageDocument = gql`
    query StoresPage($organizationId: Int!) {
  organization(id: $organizationId) {
    id
    locations {
      id
      name
      regionV2 {
        id
        friendlyName
      }
    }
  }
}
    `;

/**
 * __useStoresPageQuery__
 *
 * To run a query within a React component, call `useStoresPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoresPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoresPageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStoresPageQuery(baseOptions: Apollo.QueryHookOptions<StoresPageQuery, StoresPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoresPageQuery, StoresPageQueryVariables>(StoresPageDocument, options);
      }
export function useStoresPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoresPageQuery, StoresPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoresPageQuery, StoresPageQueryVariables>(StoresPageDocument, options);
        }
export type StoresPageQueryHookResult = ReturnType<typeof useStoresPageQuery>;
export type StoresPageLazyQueryHookResult = ReturnType<typeof useStoresPageLazyQuery>;
export type StoresPageQueryResult = Apollo.QueryResult<StoresPageQuery, StoresPageQueryVariables>;
export const RetailerTransactionsDocument = gql`
    query RetailerTransactions($organizationEntityId: Int!, $monthFilter: String!) {
  organization(id: $organizationEntityId) {
    fundsTransfers(monthFilter: $monthFilter) {
      ...RetailerFundsTransferFields
    }
  }
}
    ${RetailerFundsTransferFieldsFragmentDoc}`;

/**
 * __useRetailerTransactionsQuery__
 *
 * To run a query within a React component, call `useRetailerTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerTransactionsQuery({
 *   variables: {
 *      organizationEntityId: // value for 'organizationEntityId'
 *      monthFilter: // value for 'monthFilter'
 *   },
 * });
 */
export function useRetailerTransactionsQuery(baseOptions: Apollo.QueryHookOptions<RetailerTransactionsQuery, RetailerTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerTransactionsQuery, RetailerTransactionsQueryVariables>(RetailerTransactionsDocument, options);
      }
export function useRetailerTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerTransactionsQuery, RetailerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerTransactionsQuery, RetailerTransactionsQueryVariables>(RetailerTransactionsDocument, options);
        }
export type RetailerTransactionsQueryHookResult = ReturnType<typeof useRetailerTransactionsQuery>;
export type RetailerTransactionsLazyQueryHookResult = ReturnType<typeof useRetailerTransactionsLazyQuery>;
export type RetailerTransactionsQueryResult = Apollo.QueryResult<RetailerTransactionsQuery, RetailerTransactionsQueryVariables>;
export const AuthorizeOnDemandTransfersDocument = gql`
    mutation AuthorizeOnDemandTransfers($bankAccountId: Int!) {
  authorizeOnDemandTransfers(bankAccountId: $bankAccountId) {
    id
    hasOnDemandAuthorization
  }
}
    `;
export type AuthorizeOnDemandTransfersMutationFn = Apollo.MutationFunction<AuthorizeOnDemandTransfersMutation, AuthorizeOnDemandTransfersMutationVariables>;

/**
 * __useAuthorizeOnDemandTransfersMutation__
 *
 * To run a mutation, you first call `useAuthorizeOnDemandTransfersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizeOnDemandTransfersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authorizeOnDemandTransfersMutation, { data, loading, error }] = useAuthorizeOnDemandTransfersMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *   },
 * });
 */
export function useAuthorizeOnDemandTransfersMutation(baseOptions?: Apollo.MutationHookOptions<AuthorizeOnDemandTransfersMutation, AuthorizeOnDemandTransfersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthorizeOnDemandTransfersMutation, AuthorizeOnDemandTransfersMutationVariables>(AuthorizeOnDemandTransfersDocument, options);
      }
export type AuthorizeOnDemandTransfersMutationHookResult = ReturnType<typeof useAuthorizeOnDemandTransfersMutation>;
export type AuthorizeOnDemandTransfersMutationResult = Apollo.MutationResult<AuthorizeOnDemandTransfersMutation>;
export type AuthorizeOnDemandTransfersMutationOptions = Apollo.BaseMutationOptions<AuthorizeOnDemandTransfersMutation, AuthorizeOnDemandTransfersMutationVariables>;
export const AddBankAccountViaPlaidDocument = gql`
    mutation AddBankAccountViaPlaid($businessId: Int!, $plaidPublicToken: String!, $selectedAccountId: String!) {
  addBankAccountViaPlaid(
    businessEntityId: $businessId
    plaidPublicToken: $plaidPublicToken
    selectedAccountId: $selectedAccountId
  ) {
    ...BankAccountFields
  }
}
    ${BankAccountFieldsFragmentDoc}`;
export type AddBankAccountViaPlaidMutationFn = Apollo.MutationFunction<AddBankAccountViaPlaidMutation, AddBankAccountViaPlaidMutationVariables>;

/**
 * __useAddBankAccountViaPlaidMutation__
 *
 * To run a mutation, you first call `useAddBankAccountViaPlaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBankAccountViaPlaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBankAccountViaPlaidMutation, { data, loading, error }] = useAddBankAccountViaPlaidMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      plaidPublicToken: // value for 'plaidPublicToken'
 *      selectedAccountId: // value for 'selectedAccountId'
 *   },
 * });
 */
export function useAddBankAccountViaPlaidMutation(baseOptions?: Apollo.MutationHookOptions<AddBankAccountViaPlaidMutation, AddBankAccountViaPlaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBankAccountViaPlaidMutation, AddBankAccountViaPlaidMutationVariables>(AddBankAccountViaPlaidDocument, options);
      }
export type AddBankAccountViaPlaidMutationHookResult = ReturnType<typeof useAddBankAccountViaPlaidMutation>;
export type AddBankAccountViaPlaidMutationResult = Apollo.MutationResult<AddBankAccountViaPlaidMutation>;
export type AddBankAccountViaPlaidMutationOptions = Apollo.BaseMutationOptions<AddBankAccountViaPlaidMutation, AddBankAccountViaPlaidMutationVariables>;
export const BillingInfoDocument = gql`
    query BillingInfo($organizationId: Int!) {
  organization(id: $organizationId) {
    businesses {
      id
      dwollaCustomer {
        ...DwollaCustomerBillingInfo
      }
    }
  }
}
    ${DwollaCustomerBillingInfoFragmentDoc}`;

/**
 * __useBillingInfoQuery__
 *
 * To run a query within a React component, call `useBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useBillingInfoQuery(baseOptions: Apollo.QueryHookOptions<BillingInfoQuery, BillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingInfoQuery, BillingInfoQueryVariables>(BillingInfoDocument, options);
      }
export function useBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingInfoQuery, BillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingInfoQuery, BillingInfoQueryVariables>(BillingInfoDocument, options);
        }
export type BillingInfoQueryHookResult = ReturnType<typeof useBillingInfoQuery>;
export type BillingInfoLazyQueryHookResult = ReturnType<typeof useBillingInfoLazyQuery>;
export type BillingInfoQueryResult = Apollo.QueryResult<BillingInfoQuery, BillingInfoQueryVariables>;
export const AdminAddProducerDocument = gql`
    mutation AdminAddProducer($data: AddProducerData!) {
  addProducer(data: $data) {
    id
    name
    createdAt
  }
}
    `;
export type AdminAddProducerMutationFn = Apollo.MutationFunction<AdminAddProducerMutation, AdminAddProducerMutationVariables>;

/**
 * __useAdminAddProducerMutation__
 *
 * To run a mutation, you first call `useAdminAddProducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddProducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddProducerMutation, { data, loading, error }] = useAdminAddProducerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminAddProducerMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddProducerMutation, AdminAddProducerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddProducerMutation, AdminAddProducerMutationVariables>(AdminAddProducerDocument, options);
      }
export type AdminAddProducerMutationHookResult = ReturnType<typeof useAdminAddProducerMutation>;
export type AdminAddProducerMutationResult = Apollo.MutationResult<AdminAddProducerMutation>;
export type AdminAddProducerMutationOptions = Apollo.BaseMutationOptions<AdminAddProducerMutation, AdminAddProducerMutationVariables>;
export const AdminUpdateProducerDocument = gql`
    mutation AdminUpdateProducer($id: Int!, $data: UpdateProducerData!) {
  updateProducer(id: $id, data: $data) {
    id
    displayName
    globalBreweryId
    fein
    rating
  }
}
    `;
export type AdminUpdateProducerMutationFn = Apollo.MutationFunction<AdminUpdateProducerMutation, AdminUpdateProducerMutationVariables>;

/**
 * __useAdminUpdateProducerMutation__
 *
 * To run a mutation, you first call `useAdminUpdateProducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateProducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateProducerMutation, { data, loading, error }] = useAdminUpdateProducerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminUpdateProducerMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateProducerMutation, AdminUpdateProducerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateProducerMutation, AdminUpdateProducerMutationVariables>(AdminUpdateProducerDocument, options);
      }
export type AdminUpdateProducerMutationHookResult = ReturnType<typeof useAdminUpdateProducerMutation>;
export type AdminUpdateProducerMutationResult = Apollo.MutationResult<AdminUpdateProducerMutation>;
export type AdminUpdateProducerMutationOptions = Apollo.BaseMutationOptions<AdminUpdateProducerMutation, AdminUpdateProducerMutationVariables>;
export const UpdateProducerDataDocument = gql`
    query UpdateProducerData($producerId: Int!) {
  producer(id: $producerId) {
    id
    name
    globalBreweryId
    rating
    fein
  }
}
    `;

/**
 * __useUpdateProducerDataQuery__
 *
 * To run a query within a React component, call `useUpdateProducerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateProducerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateProducerDataQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useUpdateProducerDataQuery(baseOptions: Apollo.QueryHookOptions<UpdateProducerDataQuery, UpdateProducerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateProducerDataQuery, UpdateProducerDataQueryVariables>(UpdateProducerDataDocument, options);
      }
export function useUpdateProducerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateProducerDataQuery, UpdateProducerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateProducerDataQuery, UpdateProducerDataQueryVariables>(UpdateProducerDataDocument, options);
        }
export type UpdateProducerDataQueryHookResult = ReturnType<typeof useUpdateProducerDataQuery>;
export type UpdateProducerDataLazyQueryHookResult = ReturnType<typeof useUpdateProducerDataLazyQuery>;
export type UpdateProducerDataQueryResult = Apollo.QueryResult<UpdateProducerDataQuery, UpdateProducerDataQueryVariables>;
export const AdminUpdateBusinessEntityDocument = gql`
    mutation AdminUpdateBusinessEntity($id: Int!, $data: UpdateBusinessEntityData!) {
  updateBusinessEntity(id: $id, data: $data) {
    id
    displayName
    fein
  }
}
    `;
export type AdminUpdateBusinessEntityMutationFn = Apollo.MutationFunction<AdminUpdateBusinessEntityMutation, AdminUpdateBusinessEntityMutationVariables>;

/**
 * __useAdminUpdateBusinessEntityMutation__
 *
 * To run a mutation, you first call `useAdminUpdateBusinessEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateBusinessEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateBusinessEntityMutation, { data, loading, error }] = useAdminUpdateBusinessEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminUpdateBusinessEntityMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateBusinessEntityMutation, AdminUpdateBusinessEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateBusinessEntityMutation, AdminUpdateBusinessEntityMutationVariables>(AdminUpdateBusinessEntityDocument, options);
      }
export type AdminUpdateBusinessEntityMutationHookResult = ReturnType<typeof useAdminUpdateBusinessEntityMutation>;
export type AdminUpdateBusinessEntityMutationResult = Apollo.MutationResult<AdminUpdateBusinessEntityMutation>;
export type AdminUpdateBusinessEntityMutationOptions = Apollo.BaseMutationOptions<AdminUpdateBusinessEntityMutation, AdminUpdateBusinessEntityMutationVariables>;
export const UpdateBusinessAddressDocument = gql`
    mutation UpdateBusinessAddress($data: AddressUpdateData!, $businessEntityId: Int!) {
  createOrUpdateBusinessAddress(data: $data, id: $businessEntityId) {
    id
    address {
      ...Address
    }
  }
}
    ${AddressFragmentDoc}`;
export type UpdateBusinessAddressMutationFn = Apollo.MutationFunction<UpdateBusinessAddressMutation, UpdateBusinessAddressMutationVariables>;

/**
 * __useUpdateBusinessAddressMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessAddressMutation, { data, loading, error }] = useUpdateBusinessAddressMutation({
 *   variables: {
 *      data: // value for 'data'
 *      businessEntityId: // value for 'businessEntityId'
 *   },
 * });
 */
export function useUpdateBusinessAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessAddressMutation, UpdateBusinessAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessAddressMutation, UpdateBusinessAddressMutationVariables>(UpdateBusinessAddressDocument, options);
      }
export type UpdateBusinessAddressMutationHookResult = ReturnType<typeof useUpdateBusinessAddressMutation>;
export type UpdateBusinessAddressMutationResult = Apollo.MutationResult<UpdateBusinessAddressMutation>;
export type UpdateBusinessAddressMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessAddressMutation, UpdateBusinessAddressMutationVariables>;
export const AdminAddOrganizationAndDistributorDocument = gql`
    mutation AdminAddOrganizationAndDistributor($data: AddOrganizationAndDistributorData!) {
  addOrganizationAndDistributor(data: $data) {
    id
  }
}
    `;
export type AdminAddOrganizationAndDistributorMutationFn = Apollo.MutationFunction<AdminAddOrganizationAndDistributorMutation, AdminAddOrganizationAndDistributorMutationVariables>;

/**
 * __useAdminAddOrganizationAndDistributorMutation__
 *
 * To run a mutation, you first call `useAdminAddOrganizationAndDistributorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddOrganizationAndDistributorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddOrganizationAndDistributorMutation, { data, loading, error }] = useAdminAddOrganizationAndDistributorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminAddOrganizationAndDistributorMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddOrganizationAndDistributorMutation, AdminAddOrganizationAndDistributorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddOrganizationAndDistributorMutation, AdminAddOrganizationAndDistributorMutationVariables>(AdminAddOrganizationAndDistributorDocument, options);
      }
export type AdminAddOrganizationAndDistributorMutationHookResult = ReturnType<typeof useAdminAddOrganizationAndDistributorMutation>;
export type AdminAddOrganizationAndDistributorMutationResult = Apollo.MutationResult<AdminAddOrganizationAndDistributorMutation>;
export type AdminAddOrganizationAndDistributorMutationOptions = Apollo.BaseMutationOptions<AdminAddOrganizationAndDistributorMutation, AdminAddOrganizationAndDistributorMutationVariables>;
export const AdminUpdateDistributorDetailsDocument = gql`
    mutation AdminUpdateDistributorDetails($id: Int!, $data: UpdateDistributorDetailsData!) {
  UpdateDistributorDetails(id: $id, data: $data) {
    id
    feePerPackageInCents
  }
}
    `;
export type AdminUpdateDistributorDetailsMutationFn = Apollo.MutationFunction<AdminUpdateDistributorDetailsMutation, AdminUpdateDistributorDetailsMutationVariables>;

/**
 * __useAdminUpdateDistributorDetailsMutation__
 *
 * To run a mutation, you first call `useAdminUpdateDistributorDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateDistributorDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateDistributorDetailsMutation, { data, loading, error }] = useAdminUpdateDistributorDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminUpdateDistributorDetailsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateDistributorDetailsMutation, AdminUpdateDistributorDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateDistributorDetailsMutation, AdminUpdateDistributorDetailsMutationVariables>(AdminUpdateDistributorDetailsDocument, options);
      }
export type AdminUpdateDistributorDetailsMutationHookResult = ReturnType<typeof useAdminUpdateDistributorDetailsMutation>;
export type AdminUpdateDistributorDetailsMutationResult = Apollo.MutationResult<AdminUpdateDistributorDetailsMutation>;
export type AdminUpdateDistributorDetailsMutationOptions = Apollo.BaseMutationOptions<AdminUpdateDistributorDetailsMutation, AdminUpdateDistributorDetailsMutationVariables>;
export const AutocompleteDistributorsDocument = gql`
    query AutocompleteDistributors {
  distributors {
    ...AutocompleteDistributor
  }
}
    ${AutocompleteDistributorFragmentDoc}`;

/**
 * __useAutocompleteDistributorsQuery__
 *
 * To run a query within a React component, call `useAutocompleteDistributorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteDistributorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteDistributorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutocompleteDistributorsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteDistributorsQuery, AutocompleteDistributorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteDistributorsQuery, AutocompleteDistributorsQueryVariables>(AutocompleteDistributorsDocument, options);
      }
export function useAutocompleteDistributorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteDistributorsQuery, AutocompleteDistributorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteDistributorsQuery, AutocompleteDistributorsQueryVariables>(AutocompleteDistributorsDocument, options);
        }
export type AutocompleteDistributorsQueryHookResult = ReturnType<typeof useAutocompleteDistributorsQuery>;
export type AutocompleteDistributorsLazyQueryHookResult = ReturnType<typeof useAutocompleteDistributorsLazyQuery>;
export type AutocompleteDistributorsQueryResult = Apollo.QueryResult<AutocompleteDistributorsQuery, AutocompleteDistributorsQueryVariables>;
export const InvoiceDocument = gql`
    query Invoice($id: Int!) {
  invoice(id: $id) {
    ...InvoiceDisplay
  }
}
    ${InvoiceDisplayFragmentDoc}`;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>;
export const AdminAddLicenseDocument = gql`
    mutation AdminAddLicense($producerId: Int!, $data: LicenseAndLicensePeriodInput!) {
  addLicenseAndCurrentPeriod(producerId: $producerId, data: $data) {
    id
    title
    createdAt
  }
}
    `;
export type AdminAddLicenseMutationFn = Apollo.MutationFunction<AdminAddLicenseMutation, AdminAddLicenseMutationVariables>;

/**
 * __useAdminAddLicenseMutation__
 *
 * To run a mutation, you first call `useAdminAddLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddLicenseMutation, { data, loading, error }] = useAdminAddLicenseMutation({
 *   variables: {
 *      producerId: // value for 'producerId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminAddLicenseMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddLicenseMutation, AdminAddLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddLicenseMutation, AdminAddLicenseMutationVariables>(AdminAddLicenseDocument, options);
      }
export type AdminAddLicenseMutationHookResult = ReturnType<typeof useAdminAddLicenseMutation>;
export type AdminAddLicenseMutationResult = Apollo.MutationResult<AdminAddLicenseMutation>;
export type AdminAddLicenseMutationOptions = Apollo.BaseMutationOptions<AdminAddLicenseMutation, AdminAddLicenseMutationVariables>;
export const AdminDeleteLicenseDocument = gql`
    mutation AdminDeleteLicense($licenseId: Int!) {
  deleteLicense(licenseId: $licenseId) {
    title
  }
}
    `;
export type AdminDeleteLicenseMutationFn = Apollo.MutationFunction<AdminDeleteLicenseMutation, AdminDeleteLicenseMutationVariables>;

/**
 * __useAdminDeleteLicenseMutation__
 *
 * To run a mutation, you first call `useAdminDeleteLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteLicenseMutation, { data, loading, error }] = useAdminDeleteLicenseMutation({
 *   variables: {
 *      licenseId: // value for 'licenseId'
 *   },
 * });
 */
export function useAdminDeleteLicenseMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteLicenseMutation, AdminDeleteLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteLicenseMutation, AdminDeleteLicenseMutationVariables>(AdminDeleteLicenseDocument, options);
      }
export type AdminDeleteLicenseMutationHookResult = ReturnType<typeof useAdminDeleteLicenseMutation>;
export type AdminDeleteLicenseMutationResult = Apollo.MutationResult<AdminDeleteLicenseMutation>;
export type AdminDeleteLicenseMutationOptions = Apollo.BaseMutationOptions<AdminDeleteLicenseMutation, AdminDeleteLicenseMutationVariables>;
export const AdminRenewLicenseDocument = gql`
    mutation AdminRenewLicense($licenseId: Int!, $data: LicensePeriodInput!) {
  addLicensePeriod(licenseId: $licenseId, data: $data) {
    id
    license {
      title
    }
  }
}
    `;
export type AdminRenewLicenseMutationFn = Apollo.MutationFunction<AdminRenewLicenseMutation, AdminRenewLicenseMutationVariables>;

/**
 * __useAdminRenewLicenseMutation__
 *
 * To run a mutation, you first call `useAdminRenewLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRenewLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRenewLicenseMutation, { data, loading, error }] = useAdminRenewLicenseMutation({
 *   variables: {
 *      licenseId: // value for 'licenseId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminRenewLicenseMutation(baseOptions?: Apollo.MutationHookOptions<AdminRenewLicenseMutation, AdminRenewLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRenewLicenseMutation, AdminRenewLicenseMutationVariables>(AdminRenewLicenseDocument, options);
      }
export type AdminRenewLicenseMutationHookResult = ReturnType<typeof useAdminRenewLicenseMutation>;
export type AdminRenewLicenseMutationResult = Apollo.MutationResult<AdminRenewLicenseMutation>;
export type AdminRenewLicenseMutationOptions = Apollo.BaseMutationOptions<AdminRenewLicenseMutation, AdminRenewLicenseMutationVariables>;
export const AdminLicenseDocument = gql`
    query AdminLicense($licenseId: Int!) {
  license(licenseId: $licenseId) {
    id
    title
    number
    createdAt
    documentUrl
    stateV2 {
      name
      id
    }
    createdAt
    currentLicensePeriod {
      startDate
      endDate
    }
  }
}
    `;

/**
 * __useAdminLicenseQuery__
 *
 * To run a query within a React component, call `useAdminLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLicenseQuery({
 *   variables: {
 *      licenseId: // value for 'licenseId'
 *   },
 * });
 */
export function useAdminLicenseQuery(baseOptions: Apollo.QueryHookOptions<AdminLicenseQuery, AdminLicenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLicenseQuery, AdminLicenseQueryVariables>(AdminLicenseDocument, options);
      }
export function useAdminLicenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLicenseQuery, AdminLicenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLicenseQuery, AdminLicenseQueryVariables>(AdminLicenseDocument, options);
        }
export type AdminLicenseQueryHookResult = ReturnType<typeof useAdminLicenseQuery>;
export type AdminLicenseLazyQueryHookResult = ReturnType<typeof useAdminLicenseLazyQuery>;
export type AdminLicenseQueryResult = Apollo.QueryResult<AdminLicenseQuery, AdminLicenseQueryVariables>;
export const AdminUpdateLicenseDocument = gql`
    mutation AdminUpdateLicense($licenseId: Int!, $data: LicenseAndLicensePeriodInput!) {
  updateLicenseAndCurrentPeriod(licenseId: $licenseId, data: $data) {
    id
    title
  }
}
    `;
export type AdminUpdateLicenseMutationFn = Apollo.MutationFunction<AdminUpdateLicenseMutation, AdminUpdateLicenseMutationVariables>;

/**
 * __useAdminUpdateLicenseMutation__
 *
 * To run a mutation, you first call `useAdminUpdateLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateLicenseMutation, { data, loading, error }] = useAdminUpdateLicenseMutation({
 *   variables: {
 *      licenseId: // value for 'licenseId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminUpdateLicenseMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateLicenseMutation, AdminUpdateLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateLicenseMutation, AdminUpdateLicenseMutationVariables>(AdminUpdateLicenseDocument, options);
      }
export type AdminUpdateLicenseMutationHookResult = ReturnType<typeof useAdminUpdateLicenseMutation>;
export type AdminUpdateLicenseMutationResult = Apollo.MutationResult<AdminUpdateLicenseMutation>;
export type AdminUpdateLicenseMutationOptions = Apollo.BaseMutationOptions<AdminUpdateLicenseMutation, AdminUpdateLicenseMutationVariables>;
export const AdminAddOrganizationAndLogisticsPartnerDocument = gql`
    mutation AdminAddOrganizationAndLogisticsPartner($data: AddOrganizationAndLogisticsPartnerData!) {
  addOrganizationAndLogisticsPartner(data: $data) {
    id
  }
}
    `;
export type AdminAddOrganizationAndLogisticsPartnerMutationFn = Apollo.MutationFunction<AdminAddOrganizationAndLogisticsPartnerMutation, AdminAddOrganizationAndLogisticsPartnerMutationVariables>;

/**
 * __useAdminAddOrganizationAndLogisticsPartnerMutation__
 *
 * To run a mutation, you first call `useAdminAddOrganizationAndLogisticsPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddOrganizationAndLogisticsPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddOrganizationAndLogisticsPartnerMutation, { data, loading, error }] = useAdminAddOrganizationAndLogisticsPartnerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminAddOrganizationAndLogisticsPartnerMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddOrganizationAndLogisticsPartnerMutation, AdminAddOrganizationAndLogisticsPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddOrganizationAndLogisticsPartnerMutation, AdminAddOrganizationAndLogisticsPartnerMutationVariables>(AdminAddOrganizationAndLogisticsPartnerDocument, options);
      }
export type AdminAddOrganizationAndLogisticsPartnerMutationHookResult = ReturnType<typeof useAdminAddOrganizationAndLogisticsPartnerMutation>;
export type AdminAddOrganizationAndLogisticsPartnerMutationResult = Apollo.MutationResult<AdminAddOrganizationAndLogisticsPartnerMutation>;
export type AdminAddOrganizationAndLogisticsPartnerMutationOptions = Apollo.BaseMutationOptions<AdminAddOrganizationAndLogisticsPartnerMutation, AdminAddOrganizationAndLogisticsPartnerMutationVariables>;
export const AutocompleteLogisticsPartnersDocument = gql`
    query AutocompleteLogisticsPartners {
  logisticsPartners {
    ...AutocompleteLogisticsPartner
  }
}
    ${AutocompleteLogisticsPartnerFragmentDoc}`;

/**
 * __useAutocompleteLogisticsPartnersQuery__
 *
 * To run a query within a React component, call `useAutocompleteLogisticsPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteLogisticsPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteLogisticsPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutocompleteLogisticsPartnersQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteLogisticsPartnersQuery, AutocompleteLogisticsPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteLogisticsPartnersQuery, AutocompleteLogisticsPartnersQueryVariables>(AutocompleteLogisticsPartnersDocument, options);
      }
export function useAutocompleteLogisticsPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteLogisticsPartnersQuery, AutocompleteLogisticsPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteLogisticsPartnersQuery, AutocompleteLogisticsPartnersQueryVariables>(AutocompleteLogisticsPartnersDocument, options);
        }
export type AutocompleteLogisticsPartnersQueryHookResult = ReturnType<typeof useAutocompleteLogisticsPartnersQuery>;
export type AutocompleteLogisticsPartnersLazyQueryHookResult = ReturnType<typeof useAutocompleteLogisticsPartnersLazyQuery>;
export type AutocompleteLogisticsPartnersQueryResult = Apollo.QueryResult<AutocompleteLogisticsPartnersQuery, AutocompleteLogisticsPartnersQueryVariables>;
export const AdminOrganizationDocument = gql`
    query AdminOrganization($id: Int!) {
  organization(id: $id) {
    id
    name
    createdAt
    businesses {
      id
      displayName
      fein
      businessType
      dwollaCustomer {
        id
        type
        status
      }
      bankAccount {
        id
        name
        institutionName
        mask
        dwollaFundingSource {
          id
        }
        plaidItem {
          id
          verificationStatus
        }
      }
      balanceAccount {
        id
        balance
      }
    }
  }
}
    `;

/**
 * __useAdminOrganizationQuery__
 *
 * To run a query within a React component, call `useAdminOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminOrganizationQuery(baseOptions: Apollo.QueryHookOptions<AdminOrganizationQuery, AdminOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrganizationQuery, AdminOrganizationQueryVariables>(AdminOrganizationDocument, options);
      }
export function useAdminOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrganizationQuery, AdminOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrganizationQuery, AdminOrganizationQueryVariables>(AdminOrganizationDocument, options);
        }
export type AdminOrganizationQueryHookResult = ReturnType<typeof useAdminOrganizationQuery>;
export type AdminOrganizationLazyQueryHookResult = ReturnType<typeof useAdminOrganizationLazyQuery>;
export type AdminOrganizationQueryResult = Apollo.QueryResult<AdminOrganizationQuery, AdminOrganizationQueryVariables>;
export const AdminUpdateOrganizationDocument = gql`
    mutation AdminUpdateOrganization($id: Int!, $name: String!) {
  updateOrganization(id: $id, data: {name: $name}) {
    id
    name
  }
}
    `;
export type AdminUpdateOrganizationMutationFn = Apollo.MutationFunction<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;

/**
 * __useAdminUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useAdminUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateOrganizationMutation, { data, loading, error }] = useAdminUpdateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAdminUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>(AdminUpdateOrganizationDocument, options);
      }
export type AdminUpdateOrganizationMutationHookResult = ReturnType<typeof useAdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationResult = Apollo.MutationResult<AdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;
export const AddPackageTypeDocument = gql`
    mutation AddPackageType($data: ProductPackageTypeInput!) {
  createProductPackageType(data: $data) {
    id
  }
}
    `;
export type AddPackageTypeMutationFn = Apollo.MutationFunction<AddPackageTypeMutation, AddPackageTypeMutationVariables>;

/**
 * __useAddPackageTypeMutation__
 *
 * To run a mutation, you first call `useAddPackageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackageTypeMutation, { data, loading, error }] = useAddPackageTypeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddPackageTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddPackageTypeMutation, AddPackageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackageTypeMutation, AddPackageTypeMutationVariables>(AddPackageTypeDocument, options);
      }
export type AddPackageTypeMutationHookResult = ReturnType<typeof useAddPackageTypeMutation>;
export type AddPackageTypeMutationResult = Apollo.MutationResult<AddPackageTypeMutation>;
export type AddPackageTypeMutationOptions = Apollo.BaseMutationOptions<AddPackageTypeMutation, AddPackageTypeMutationVariables>;
export const DeletePackageTypeDocument = gql`
    mutation DeletePackageType($id: Int!) {
  deleteProductPackageType(id: $id) {
    id
  }
}
    `;
export type DeletePackageTypeMutationFn = Apollo.MutationFunction<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>;

/**
 * __useDeletePackageTypeMutation__
 *
 * To run a mutation, you first call `useDeletePackageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageTypeMutation, { data, loading, error }] = useDeletePackageTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePackageTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>(DeletePackageTypeDocument, options);
      }
export type DeletePackageTypeMutationHookResult = ReturnType<typeof useDeletePackageTypeMutation>;
export type DeletePackageTypeMutationResult = Apollo.MutationResult<DeletePackageTypeMutation>;
export type DeletePackageTypeMutationOptions = Apollo.BaseMutationOptions<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>;
export const ProductFulfillmentExclusionReasonsDocument = gql`
    query ProductFulfillmentExclusionReasons {
  ProductFulfillmentExclusionReasons {
    label
    id
  }
}
    `;

/**
 * __useProductFulfillmentExclusionReasonsQuery__
 *
 * To run a query within a React component, call `useProductFulfillmentExclusionReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFulfillmentExclusionReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFulfillmentExclusionReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductFulfillmentExclusionReasonsQuery(baseOptions?: Apollo.QueryHookOptions<ProductFulfillmentExclusionReasonsQuery, ProductFulfillmentExclusionReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFulfillmentExclusionReasonsQuery, ProductFulfillmentExclusionReasonsQueryVariables>(ProductFulfillmentExclusionReasonsDocument, options);
      }
export function useProductFulfillmentExclusionReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFulfillmentExclusionReasonsQuery, ProductFulfillmentExclusionReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFulfillmentExclusionReasonsQuery, ProductFulfillmentExclusionReasonsQueryVariables>(ProductFulfillmentExclusionReasonsDocument, options);
        }
export type ProductFulfillmentExclusionReasonsQueryHookResult = ReturnType<typeof useProductFulfillmentExclusionReasonsQuery>;
export type ProductFulfillmentExclusionReasonsLazyQueryHookResult = ReturnType<typeof useProductFulfillmentExclusionReasonsLazyQuery>;
export type ProductFulfillmentExclusionReasonsQueryResult = Apollo.QueryResult<ProductFulfillmentExclusionReasonsQuery, ProductFulfillmentExclusionReasonsQueryVariables>;
export const UpdatePreSaleProducerFulfillmentExclusionDocument = gql`
    mutation UpdatePreSaleProducerFulfillmentExclusion($data: UpdatePreSaleProducerFulfillmentExclusionInput!) {
  updatePreSaleProducerFulfillmentExclusion(data: $data) {
    preSaleId
    producerId
    excludeFromFulfillment
    exclusionReasonId
  }
}
    `;
export type UpdatePreSaleProducerFulfillmentExclusionMutationFn = Apollo.MutationFunction<UpdatePreSaleProducerFulfillmentExclusionMutation, UpdatePreSaleProducerFulfillmentExclusionMutationVariables>;

/**
 * __useUpdatePreSaleProducerFulfillmentExclusionMutation__
 *
 * To run a mutation, you first call `useUpdatePreSaleProducerFulfillmentExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreSaleProducerFulfillmentExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreSaleProducerFulfillmentExclusionMutation, { data, loading, error }] = useUpdatePreSaleProducerFulfillmentExclusionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePreSaleProducerFulfillmentExclusionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePreSaleProducerFulfillmentExclusionMutation, UpdatePreSaleProducerFulfillmentExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePreSaleProducerFulfillmentExclusionMutation, UpdatePreSaleProducerFulfillmentExclusionMutationVariables>(UpdatePreSaleProducerFulfillmentExclusionDocument, options);
      }
export type UpdatePreSaleProducerFulfillmentExclusionMutationHookResult = ReturnType<typeof useUpdatePreSaleProducerFulfillmentExclusionMutation>;
export type UpdatePreSaleProducerFulfillmentExclusionMutationResult = Apollo.MutationResult<UpdatePreSaleProducerFulfillmentExclusionMutation>;
export type UpdatePreSaleProducerFulfillmentExclusionMutationOptions = Apollo.BaseMutationOptions<UpdatePreSaleProducerFulfillmentExclusionMutation, UpdatePreSaleProducerFulfillmentExclusionMutationVariables>;
export const UpdatePreSaleProductFulfillmentExclusionDocument = gql`
    mutation UpdatePreSaleProductFulfillmentExclusion($data: UpdatePreSaleProductFulfillmentExclusionInput!) {
  updatePreSaleProductFulfillmentExclusion(data: $data) {
    preSaleId
    productId
    excludeFromFulfillment
    exclusionReasonId
  }
}
    `;
export type UpdatePreSaleProductFulfillmentExclusionMutationFn = Apollo.MutationFunction<UpdatePreSaleProductFulfillmentExclusionMutation, UpdatePreSaleProductFulfillmentExclusionMutationVariables>;

/**
 * __useUpdatePreSaleProductFulfillmentExclusionMutation__
 *
 * To run a mutation, you first call `useUpdatePreSaleProductFulfillmentExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreSaleProductFulfillmentExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreSaleProductFulfillmentExclusionMutation, { data, loading, error }] = useUpdatePreSaleProductFulfillmentExclusionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePreSaleProductFulfillmentExclusionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePreSaleProductFulfillmentExclusionMutation, UpdatePreSaleProductFulfillmentExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePreSaleProductFulfillmentExclusionMutation, UpdatePreSaleProductFulfillmentExclusionMutationVariables>(UpdatePreSaleProductFulfillmentExclusionDocument, options);
      }
export type UpdatePreSaleProductFulfillmentExclusionMutationHookResult = ReturnType<typeof useUpdatePreSaleProductFulfillmentExclusionMutation>;
export type UpdatePreSaleProductFulfillmentExclusionMutationResult = Apollo.MutationResult<UpdatePreSaleProductFulfillmentExclusionMutation>;
export type UpdatePreSaleProductFulfillmentExclusionMutationOptions = Apollo.BaseMutationOptions<UpdatePreSaleProductFulfillmentExclusionMutation, UpdatePreSaleProductFulfillmentExclusionMutationVariables>;
export const AutocompleteProducersDocument = gql`
    query AutocompleteProducers {
  producers {
    ...AutocompleteProducer
  }
}
    ${AutocompleteProducerFragmentDoc}`;

/**
 * __useAutocompleteProducersQuery__
 *
 * To run a query within a React component, call `useAutocompleteProducersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteProducersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteProducersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutocompleteProducersQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteProducersQuery, AutocompleteProducersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteProducersQuery, AutocompleteProducersQueryVariables>(AutocompleteProducersDocument, options);
      }
export function useAutocompleteProducersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteProducersQuery, AutocompleteProducersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteProducersQuery, AutocompleteProducersQueryVariables>(AutocompleteProducersDocument, options);
        }
export type AutocompleteProducersQueryHookResult = ReturnType<typeof useAutocompleteProducersQuery>;
export type AutocompleteProducersLazyQueryHookResult = ReturnType<typeof useAutocompleteProducersLazyQuery>;
export type AutocompleteProducersQueryResult = Apollo.QueryResult<AutocompleteProducersQuery, AutocompleteProducersQueryVariables>;
export const RedirectToOrganizationDocument = gql`
    query RedirectToOrganization($organizationId: Int!) {
  organization(id: $organizationId) {
    id
    businessType
  }
}
    `;

/**
 * __useRedirectToOrganizationQuery__
 *
 * To run a query within a React component, call `useRedirectToOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedirectToOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedirectToOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRedirectToOrganizationQuery(baseOptions: Apollo.QueryHookOptions<RedirectToOrganizationQuery, RedirectToOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedirectToOrganizationQuery, RedirectToOrganizationQueryVariables>(RedirectToOrganizationDocument, options);
      }
export function useRedirectToOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedirectToOrganizationQuery, RedirectToOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedirectToOrganizationQuery, RedirectToOrganizationQueryVariables>(RedirectToOrganizationDocument, options);
        }
export type RedirectToOrganizationQueryHookResult = ReturnType<typeof useRedirectToOrganizationQuery>;
export type RedirectToOrganizationLazyQueryHookResult = ReturnType<typeof useRedirectToOrganizationLazyQuery>;
export type RedirectToOrganizationQueryResult = Apollo.QueryResult<RedirectToOrganizationQuery, RedirectToOrganizationQueryVariables>;
export const AdminAddFirstRetailerLocationDocument = gql`
    mutation AdminAddFirstRetailerLocation($organizationName: String!, $locationName: String!, $region: Int!, $forceDwollaBusinessCustomer: Boolean!) {
  addFirstRetailerLocation(
    organizationName: $organizationName
    locationName: $locationName
    region: $region
    forceDwollaBusinessCustomer: $forceDwollaBusinessCustomer
  ) {
    id
    name
    businessType
    createdAt
  }
}
    `;
export type AdminAddFirstRetailerLocationMutationFn = Apollo.MutationFunction<AdminAddFirstRetailerLocationMutation, AdminAddFirstRetailerLocationMutationVariables>;

/**
 * __useAdminAddFirstRetailerLocationMutation__
 *
 * To run a mutation, you first call `useAdminAddFirstRetailerLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddFirstRetailerLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddFirstRetailerLocationMutation, { data, loading, error }] = useAdminAddFirstRetailerLocationMutation({
 *   variables: {
 *      organizationName: // value for 'organizationName'
 *      locationName: // value for 'locationName'
 *      region: // value for 'region'
 *      forceDwollaBusinessCustomer: // value for 'forceDwollaBusinessCustomer'
 *   },
 * });
 */
export function useAdminAddFirstRetailerLocationMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddFirstRetailerLocationMutation, AdminAddFirstRetailerLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddFirstRetailerLocationMutation, AdminAddFirstRetailerLocationMutationVariables>(AdminAddFirstRetailerLocationDocument, options);
      }
export type AdminAddFirstRetailerLocationMutationHookResult = ReturnType<typeof useAdminAddFirstRetailerLocationMutation>;
export type AdminAddFirstRetailerLocationMutationResult = Apollo.MutationResult<AdminAddFirstRetailerLocationMutation>;
export type AdminAddFirstRetailerLocationMutationOptions = Apollo.BaseMutationOptions<AdminAddFirstRetailerLocationMutation, AdminAddFirstRetailerLocationMutationVariables>;
export const AutocompleteRetailersDocument = gql`
    query AutocompleteRetailers {
  retailers {
    ...AutocompleteRetailer
  }
}
    ${AutocompleteRetailerFragmentDoc}`;

/**
 * __useAutocompleteRetailersQuery__
 *
 * To run a query within a React component, call `useAutocompleteRetailersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteRetailersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteRetailersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutocompleteRetailersQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteRetailersQuery, AutocompleteRetailersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteRetailersQuery, AutocompleteRetailersQueryVariables>(AutocompleteRetailersDocument, options);
      }
export function useAutocompleteRetailersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteRetailersQuery, AutocompleteRetailersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteRetailersQuery, AutocompleteRetailersQueryVariables>(AutocompleteRetailersDocument, options);
        }
export type AutocompleteRetailersQueryHookResult = ReturnType<typeof useAutocompleteRetailersQuery>;
export type AutocompleteRetailersLazyQueryHookResult = ReturnType<typeof useAutocompleteRetailersLazyQuery>;
export type AutocompleteRetailersQueryResult = Apollo.QueryResult<AutocompleteRetailersQuery, AutocompleteRetailersQueryVariables>;
export const AddLocationDocument = gql`
    mutation AddLocation($data: RetailLocationInput!) {
  addLocation(data: $data) {
    id
    organization {
      businesses {
        ...BusinessShort
      }
    }
  }
}
    ${BusinessShortFragmentDoc}`;
export type AddLocationMutationFn = Apollo.MutationFunction<AddLocationMutation, AddLocationMutationVariables>;

/**
 * __useAddLocationMutation__
 *
 * To run a mutation, you first call `useAddLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocationMutation, { data, loading, error }] = useAddLocationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddLocationMutation(baseOptions?: Apollo.MutationHookOptions<AddLocationMutation, AddLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLocationMutation, AddLocationMutationVariables>(AddLocationDocument, options);
      }
export type AddLocationMutationHookResult = ReturnType<typeof useAddLocationMutation>;
export type AddLocationMutationResult = Apollo.MutationResult<AddLocationMutation>;
export type AddLocationMutationOptions = Apollo.BaseMutationOptions<AddLocationMutation, AddLocationMutationVariables>;
export const AddLocationFormDataDocument = gql`
    query AddLocationFormData($organizationId: Int!) {
  organization(id: $organizationId) {
    name
  }
}
    `;

/**
 * __useAddLocationFormDataQuery__
 *
 * To run a query within a React component, call `useAddLocationFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddLocationFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddLocationFormDataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAddLocationFormDataQuery(baseOptions: Apollo.QueryHookOptions<AddLocationFormDataQuery, AddLocationFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddLocationFormDataQuery, AddLocationFormDataQueryVariables>(AddLocationFormDataDocument, options);
      }
export function useAddLocationFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddLocationFormDataQuery, AddLocationFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddLocationFormDataQuery, AddLocationFormDataQueryVariables>(AddLocationFormDataDocument, options);
        }
export type AddLocationFormDataQueryHookResult = ReturnType<typeof useAddLocationFormDataQuery>;
export type AddLocationFormDataLazyQueryHookResult = ReturnType<typeof useAddLocationFormDataLazyQuery>;
export type AddLocationFormDataQueryResult = Apollo.QueryResult<AddLocationFormDataQuery, AddLocationFormDataQueryVariables>;
export const UpdateDwollaCustomerDocument = gql`
    mutation UpdateDwollaCustomer($data: UpdateDwollaCustomerInput!) {
  updateDwollaCustomer(data: $data) {
    id
    email
  }
}
    `;
export type UpdateDwollaCustomerMutationFn = Apollo.MutationFunction<UpdateDwollaCustomerMutation, UpdateDwollaCustomerMutationVariables>;

/**
 * __useUpdateDwollaCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateDwollaCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDwollaCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDwollaCustomerMutation, { data, loading, error }] = useUpdateDwollaCustomerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDwollaCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDwollaCustomerMutation, UpdateDwollaCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDwollaCustomerMutation, UpdateDwollaCustomerMutationVariables>(UpdateDwollaCustomerDocument, options);
      }
export type UpdateDwollaCustomerMutationHookResult = ReturnType<typeof useUpdateDwollaCustomerMutation>;
export type UpdateDwollaCustomerMutationResult = Apollo.MutationResult<UpdateDwollaCustomerMutation>;
export type UpdateDwollaCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateDwollaCustomerMutation, UpdateDwollaCustomerMutationVariables>;
export const UpsertDwollaCustomerDocument = gql`
    mutation UpsertDwollaCustomer($customerId: String!, $businessEntityId: Int!) {
  upsertDwollaCustomer(
    customerId: $customerId
    businessEntityId: $businessEntityId
  ) {
    id
    status
    createdAt
    business {
      id
      completedOnboardingAt
      onboarding {
        ...OnboardingFields
      }
    }
  }
}
    ${OnboardingFieldsFragmentDoc}`;
export type UpsertDwollaCustomerMutationFn = Apollo.MutationFunction<UpsertDwollaCustomerMutation, UpsertDwollaCustomerMutationVariables>;

/**
 * __useUpsertDwollaCustomerMutation__
 *
 * To run a mutation, you first call `useUpsertDwollaCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDwollaCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDwollaCustomerMutation, { data, loading, error }] = useUpsertDwollaCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      businessEntityId: // value for 'businessEntityId'
 *   },
 * });
 */
export function useUpsertDwollaCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDwollaCustomerMutation, UpsertDwollaCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDwollaCustomerMutation, UpsertDwollaCustomerMutationVariables>(UpsertDwollaCustomerDocument, options);
      }
export type UpsertDwollaCustomerMutationHookResult = ReturnType<typeof useUpsertDwollaCustomerMutation>;
export type UpsertDwollaCustomerMutationResult = Apollo.MutationResult<UpsertDwollaCustomerMutation>;
export type UpsertDwollaCustomerMutationOptions = Apollo.BaseMutationOptions<UpsertDwollaCustomerMutation, UpsertDwollaCustomerMutationVariables>;
export const RefreshPlaidItemDocument = gql`
    mutation RefreshPlaidItem($id: Int!) {
  refreshPlaidItem(id: $id) {
    id
    verificationStatus
    bankAccount {
      business {
        id
        completedOnboardingAt
        onboarding {
          ...OnboardingFields
        }
      }
    }
  }
}
    ${OnboardingFieldsFragmentDoc}`;
export type RefreshPlaidItemMutationFn = Apollo.MutationFunction<RefreshPlaidItemMutation, RefreshPlaidItemMutationVariables>;

/**
 * __useRefreshPlaidItemMutation__
 *
 * To run a mutation, you first call `useRefreshPlaidItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshPlaidItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshPlaidItemMutation, { data, loading, error }] = useRefreshPlaidItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshPlaidItemMutation(baseOptions?: Apollo.MutationHookOptions<RefreshPlaidItemMutation, RefreshPlaidItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshPlaidItemMutation, RefreshPlaidItemMutationVariables>(RefreshPlaidItemDocument, options);
      }
export type RefreshPlaidItemMutationHookResult = ReturnType<typeof useRefreshPlaidItemMutation>;
export type RefreshPlaidItemMutationResult = Apollo.MutationResult<RefreshPlaidItemMutation>;
export type RefreshPlaidItemMutationOptions = Apollo.BaseMutationOptions<RefreshPlaidItemMutation, RefreshPlaidItemMutationVariables>;
export const PlaidItemLinkTokenDocument = gql`
    query PlaidItemLinkToken($id: Int!) {
  plaidItem(id: $id) {
    id
    linkToken {
      linkToken
      expiration
    }
  }
}
    `;

/**
 * __usePlaidItemLinkTokenQuery__
 *
 * To run a query within a React component, call `usePlaidItemLinkTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaidItemLinkTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaidItemLinkTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaidItemLinkTokenQuery(baseOptions: Apollo.QueryHookOptions<PlaidItemLinkTokenQuery, PlaidItemLinkTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaidItemLinkTokenQuery, PlaidItemLinkTokenQueryVariables>(PlaidItemLinkTokenDocument, options);
      }
export function usePlaidItemLinkTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaidItemLinkTokenQuery, PlaidItemLinkTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaidItemLinkTokenQuery, PlaidItemLinkTokenQueryVariables>(PlaidItemLinkTokenDocument, options);
        }
export type PlaidItemLinkTokenQueryHookResult = ReturnType<typeof usePlaidItemLinkTokenQuery>;
export type PlaidItemLinkTokenLazyQueryHookResult = ReturnType<typeof usePlaidItemLinkTokenLazyQuery>;
export type PlaidItemLinkTokenQueryResult = Apollo.QueryResult<PlaidItemLinkTokenQuery, PlaidItemLinkTokenQueryVariables>;
export const PlaidLinkTokenDocument = gql`
    query PlaidLinkToken {
  plaidLinkToken {
    linkToken
    expiration
  }
}
    `;

/**
 * __usePlaidLinkTokenQuery__
 *
 * To run a query within a React component, call `usePlaidLinkTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaidLinkTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaidLinkTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlaidLinkTokenQuery(baseOptions?: Apollo.QueryHookOptions<PlaidLinkTokenQuery, PlaidLinkTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaidLinkTokenQuery, PlaidLinkTokenQueryVariables>(PlaidLinkTokenDocument, options);
      }
export function usePlaidLinkTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaidLinkTokenQuery, PlaidLinkTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaidLinkTokenQuery, PlaidLinkTokenQueryVariables>(PlaidLinkTokenDocument, options);
        }
export type PlaidLinkTokenQueryHookResult = ReturnType<typeof usePlaidLinkTokenQuery>;
export type PlaidLinkTokenLazyQueryHookResult = ReturnType<typeof usePlaidLinkTokenLazyQuery>;
export type PlaidLinkTokenQueryResult = Apollo.QueryResult<PlaidLinkTokenQuery, PlaidLinkTokenQueryVariables>;
export const AutocompleteDocument = gql`
    query autocomplete($model: Models!, $query: String!, $field: String) {
  autocomplete(query: $query, field: $field, model: $model) {
    id
    name
  }
}
    `;

/**
 * __useAutocompleteQuery__
 *
 * To run a query within a React component, call `useAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteQuery({
 *   variables: {
 *      model: // value for 'model'
 *      query: // value for 'query'
 *      field: // value for 'field'
 *   },
 * });
 */
export function useAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<AutocompleteQuery, AutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteQuery, AutocompleteQueryVariables>(AutocompleteDocument, options);
      }
export function useAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteQuery, AutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteQuery, AutocompleteQueryVariables>(AutocompleteDocument, options);
        }
export type AutocompleteQueryHookResult = ReturnType<typeof useAutocompleteQuery>;
export type AutocompleteLazyQueryHookResult = ReturnType<typeof useAutocompleteLazyQuery>;
export type AutocompleteQueryResult = Apollo.QueryResult<AutocompleteQuery, AutocompleteQueryVariables>;
export const OfferAutocompleteDocument = gql`
    query offerAutocomplete($filters: OfferSearchFilters) {
  searchOffers(filters: $filters, pagination: {skip: 0, take: 200}) {
    results {
      id
      product {
        ...ProductDisplay
      }
    }
  }
}
    ${ProductDisplayFragmentDoc}`;

/**
 * __useOfferAutocompleteQuery__
 *
 * To run a query within a React component, call `useOfferAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferAutocompleteQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOfferAutocompleteQuery(baseOptions?: Apollo.QueryHookOptions<OfferAutocompleteQuery, OfferAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferAutocompleteQuery, OfferAutocompleteQueryVariables>(OfferAutocompleteDocument, options);
      }
export function useOfferAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferAutocompleteQuery, OfferAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferAutocompleteQuery, OfferAutocompleteQueryVariables>(OfferAutocompleteDocument, options);
        }
export type OfferAutocompleteQueryHookResult = ReturnType<typeof useOfferAutocompleteQuery>;
export type OfferAutocompleteLazyQueryHookResult = ReturnType<typeof useOfferAutocompleteLazyQuery>;
export type OfferAutocompleteQueryResult = Apollo.QueryResult<OfferAutocompleteQuery, OfferAutocompleteQueryVariables>;
export const ProductAutocompleteDocument = gql`
    query productAutocomplete($filters: ProductsFilterData) {
  searchProducts(filters: $filters, pagination: {skip: 0, take: 200}) {
    results {
      ...ProductDisplay
    }
  }
}
    ${ProductDisplayFragmentDoc}`;

/**
 * __useProductAutocompleteQuery__
 *
 * To run a query within a React component, call `useProductAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductAutocompleteQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProductAutocompleteQuery(baseOptions?: Apollo.QueryHookOptions<ProductAutocompleteQuery, ProductAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductAutocompleteQuery, ProductAutocompleteQueryVariables>(ProductAutocompleteDocument, options);
      }
export function useProductAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductAutocompleteQuery, ProductAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductAutocompleteQuery, ProductAutocompleteQueryVariables>(ProductAutocompleteDocument, options);
        }
export type ProductAutocompleteQueryHookResult = ReturnType<typeof useProductAutocompleteQuery>;
export type ProductAutocompleteLazyQueryHookResult = ReturnType<typeof useProductAutocompleteLazyQuery>;
export type ProductAutocompleteQueryResult = Apollo.QueryResult<ProductAutocompleteQuery, ProductAutocompleteQueryVariables>;
export const BusinessOnboardingStatusDocument = gql`
    query BusinessOnboardingStatus($businessId: Int!) {
  business(id: $businessId) {
    id
    completedOnboardingAt
  }
}
    `;

/**
 * __useBusinessOnboardingStatusQuery__
 *
 * To run a query within a React component, call `useBusinessOnboardingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessOnboardingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessOnboardingStatusQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useBusinessOnboardingStatusQuery(baseOptions: Apollo.QueryHookOptions<BusinessOnboardingStatusQuery, BusinessOnboardingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessOnboardingStatusQuery, BusinessOnboardingStatusQueryVariables>(BusinessOnboardingStatusDocument, options);
      }
export function useBusinessOnboardingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessOnboardingStatusQuery, BusinessOnboardingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessOnboardingStatusQuery, BusinessOnboardingStatusQueryVariables>(BusinessOnboardingStatusDocument, options);
        }
export type BusinessOnboardingStatusQueryHookResult = ReturnType<typeof useBusinessOnboardingStatusQuery>;
export type BusinessOnboardingStatusLazyQueryHookResult = ReturnType<typeof useBusinessOnboardingStatusLazyQuery>;
export type BusinessOnboardingStatusQueryResult = Apollo.QueryResult<BusinessOnboardingStatusQuery, BusinessOnboardingStatusQueryVariables>;
export const GetShopifyUrlWithLoginTokenDocument = gql`
    query GetShopifyUrlWithLoginToken($organizationId: Int!, $path: String) {
  getShopifyUrlWithLoginToken(organizationId: $organizationId, path: $path) {
    shopifyUrlWithLoginToken
  }
}
    `;

/**
 * __useGetShopifyUrlWithLoginTokenQuery__
 *
 * To run a query within a React component, call `useGetShopifyUrlWithLoginTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopifyUrlWithLoginTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopifyUrlWithLoginTokenQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetShopifyUrlWithLoginTokenQuery(baseOptions: Apollo.QueryHookOptions<GetShopifyUrlWithLoginTokenQuery, GetShopifyUrlWithLoginTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopifyUrlWithLoginTokenQuery, GetShopifyUrlWithLoginTokenQueryVariables>(GetShopifyUrlWithLoginTokenDocument, options);
      }
export function useGetShopifyUrlWithLoginTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopifyUrlWithLoginTokenQuery, GetShopifyUrlWithLoginTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopifyUrlWithLoginTokenQuery, GetShopifyUrlWithLoginTokenQueryVariables>(GetShopifyUrlWithLoginTokenDocument, options);
        }
export type GetShopifyUrlWithLoginTokenQueryHookResult = ReturnType<typeof useGetShopifyUrlWithLoginTokenQuery>;
export type GetShopifyUrlWithLoginTokenLazyQueryHookResult = ReturnType<typeof useGetShopifyUrlWithLoginTokenLazyQuery>;
export type GetShopifyUrlWithLoginTokenQueryResult = Apollo.QueryResult<GetShopifyUrlWithLoginTokenQuery, GetShopifyUrlWithLoginTokenQueryVariables>;
export const BreweryDocument = gql`
    query Brewery($breweryId: Int!) {
  organization(id: $breweryId) {
    ...BreweryFields
  }
}
    ${BreweryFieldsFragmentDoc}`;

/**
 * __useBreweryQuery__
 *
 * To run a query within a React component, call `useBreweryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBreweryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBreweryQuery({
 *   variables: {
 *      breweryId: // value for 'breweryId'
 *   },
 * });
 */
export function useBreweryQuery(baseOptions: Apollo.QueryHookOptions<BreweryQuery, BreweryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BreweryQuery, BreweryQueryVariables>(BreweryDocument, options);
      }
export function useBreweryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BreweryQuery, BreweryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BreweryQuery, BreweryQueryVariables>(BreweryDocument, options);
        }
export type BreweryQueryHookResult = ReturnType<typeof useBreweryQuery>;
export type BreweryLazyQueryHookResult = ReturnType<typeof useBreweryLazyQuery>;
export type BreweryQueryResult = Apollo.QueryResult<BreweryQuery, BreweryQueryVariables>;
export const DistributorDocument = gql`
    query Distributor($distributorId: Int!) {
  organization(id: $distributorId) {
    ...DistributorFields
  }
}
    ${DistributorFieldsFragmentDoc}`;

/**
 * __useDistributorQuery__
 *
 * To run a query within a React component, call `useDistributorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributorQuery({
 *   variables: {
 *      distributorId: // value for 'distributorId'
 *   },
 * });
 */
export function useDistributorQuery(baseOptions: Apollo.QueryHookOptions<DistributorQuery, DistributorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DistributorQuery, DistributorQueryVariables>(DistributorDocument, options);
      }
export function useDistributorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DistributorQuery, DistributorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DistributorQuery, DistributorQueryVariables>(DistributorDocument, options);
        }
export type DistributorQueryHookResult = ReturnType<typeof useDistributorQuery>;
export type DistributorLazyQueryHookResult = ReturnType<typeof useDistributorLazyQuery>;
export type DistributorQueryResult = Apollo.QueryResult<DistributorQuery, DistributorQueryVariables>;
export const RetailerDocument = gql`
    query Retailer($retailerId: Int!) {
  organization(id: $retailerId) {
    ...RetailerFields
  }
}
    ${RetailerFieldsFragmentDoc}`;

/**
 * __useRetailerQuery__
 *
 * To run a query within a React component, call `useRetailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useRetailerQuery(baseOptions: Apollo.QueryHookOptions<RetailerQuery, RetailerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetailerQuery, RetailerQueryVariables>(RetailerDocument, options);
      }
export function useRetailerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetailerQuery, RetailerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetailerQuery, RetailerQueryVariables>(RetailerDocument, options);
        }
export type RetailerQueryHookResult = ReturnType<typeof useRetailerQuery>;
export type RetailerLazyQueryHookResult = ReturnType<typeof useRetailerLazyQuery>;
export type RetailerQueryResult = Apollo.QueryResult<RetailerQuery, RetailerQueryVariables>;
export const DeliveryPartnersDocument = gql`
    query DeliveryPartners {
  logisticsPartners {
    id
    displayName
  }
  distributors {
    id
    displayName
  }
}
    `;

/**
 * __useDeliveryPartnersQuery__
 *
 * To run a query within a React component, call `useDeliveryPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeliveryPartnersQuery(baseOptions?: Apollo.QueryHookOptions<DeliveryPartnersQuery, DeliveryPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryPartnersQuery, DeliveryPartnersQueryVariables>(DeliveryPartnersDocument, options);
      }
export function useDeliveryPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryPartnersQuery, DeliveryPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryPartnersQuery, DeliveryPartnersQueryVariables>(DeliveryPartnersDocument, options);
        }
export type DeliveryPartnersQueryHookResult = ReturnType<typeof useDeliveryPartnersQuery>;
export type DeliveryPartnersLazyQueryHookResult = ReturnType<typeof useDeliveryPartnersLazyQuery>;
export type DeliveryPartnersQueryResult = Apollo.QueryResult<DeliveryPartnersQuery, DeliveryPartnersQueryVariables>;
export const PackageTypesDocument = gql`
    query PackageTypes {
  productPackageTypes {
    id
    displayName
  }
}
    `;

/**
 * __usePackageTypesQuery__
 *
 * To run a query within a React component, call `usePackageTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePackageTypesQuery(baseOptions?: Apollo.QueryHookOptions<PackageTypesQuery, PackageTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageTypesQuery, PackageTypesQueryVariables>(PackageTypesDocument, options);
      }
export function usePackageTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageTypesQuery, PackageTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageTypesQuery, PackageTypesQueryVariables>(PackageTypesDocument, options);
        }
export type PackageTypesQueryHookResult = ReturnType<typeof usePackageTypesQuery>;
export type PackageTypesLazyQueryHookResult = ReturnType<typeof usePackageTypesLazyQuery>;
export type PackageTypesQueryResult = Apollo.QueryResult<PackageTypesQuery, PackageTypesQueryVariables>;
export const RegionsDocument = gql`
    query Regions {
  regions {
    id
    friendlyName
  }
}
    `;

/**
 * __useRegionsQuery__
 *
 * To run a query within a React component, call `useRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegionsQuery(baseOptions?: Apollo.QueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
      }
export function useRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
        }
export type RegionsQueryHookResult = ReturnType<typeof useRegionsQuery>;
export type RegionsLazyQueryHookResult = ReturnType<typeof useRegionsLazyQuery>;
export type RegionsQueryResult = Apollo.QueryResult<RegionsQuery, RegionsQueryVariables>;
export const StatesDocument = gql`
    query States {
  statesWhereRegionExists {
    id
    name
  }
}
    `;

/**
 * __useStatesQuery__
 *
 * To run a query within a React component, call `useStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatesQuery(baseOptions?: Apollo.QueryHookOptions<StatesQuery, StatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatesQuery, StatesQueryVariables>(StatesDocument, options);
      }
export function useStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatesQuery, StatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatesQuery, StatesQueryVariables>(StatesDocument, options);
        }
export type StatesQueryHookResult = ReturnType<typeof useStatesQuery>;
export type StatesLazyQueryHookResult = ReturnType<typeof useStatesLazyQuery>;
export type StatesQueryResult = Apollo.QueryResult<StatesQuery, StatesQueryVariables>;
export const WhoAmIDocument = gql`
    query WhoAmI {
  whoAmI {
    ...UserAuthFields
  }
}
    ${UserAuthFieldsFragmentDoc}`;

/**
 * __useWhoAmIQuery__
 *
 * To run a query within a React component, call `useWhoAmIQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoAmIQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoAmIQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoAmIQuery(baseOptions?: Apollo.QueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
      }
export function useWhoAmILazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export type WhoAmIQueryHookResult = ReturnType<typeof useWhoAmIQuery>;
export type WhoAmILazyQueryHookResult = ReturnType<typeof useWhoAmILazyQuery>;
export type WhoAmIQueryResult = Apollo.QueryResult<WhoAmIQuery, WhoAmIQueryVariables>;